import { a as ys, c as xs, d as vs, e as gi, f as ws, g as Cs } from "./variables-dP5qqrAo.js";
import { i as Ye, x as ne, B as ks, n as jt, r as As } from "./abstract-base-CdeHT0x1.js";
import { e as Ss } from "./query-Brcoqn5X.js";
import { e as fi } from "./class-map-Ckx5HLrM.js";
import { a as Ts, p as Ms } from "./lifecycle-decorators-VlFt_asj.js";
import { q as Es } from "./query-assigned-DiX8lRAH.js";
import { s as Ne } from "./showIfUsed-DHyCbsIU.js";
import { BeaconTable as Ps } from "../beacon-table/index.js";
import "./unsafe-svg-BCSzTTw5.js";
var Ls = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Xi(S) {
  return S && S.__esModule && Object.prototype.hasOwnProperty.call(S, "default") ? S.default : S;
}
var _i = { exports: {} };
(function(S) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * (c) 2009-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(j, i) {
    S.exports ? (i.default = i, S.exports = j && j.document ? i(j) : i) : (j.Highcharts && j.Highcharts.error(16, !0), j.Highcharts = i(j));
  })(typeof window < "u" ? window : Ls, function(j) {
    var i = {};
    function ot(U, _, K, Z) {
      !U.hasOwnProperty(_) && (U[_] = Z.apply(null, K), j && typeof CustomEvent == "function" && j.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: _, module: U[_] } })));
    }
    return ot(i, "Core/Globals.js", [], function() {
      var U, _;
      return (_ = U || (U = {})).SVG_NS = "http://www.w3.org/2000/svg", _.product = "Highcharts", _.version = "11.4.8", _.win = j !== void 0 ? j : {}, _.doc = _.win.document, _.svg = _.doc && _.doc.createElementNS && !!_.doc.createElementNS(_.SVG_NS, "svg").createSVGRect, _.userAgent = _.win.navigator && _.win.navigator.userAgent || "", _.isChrome = _.win.chrome, _.isFirefox = _.userAgent.indexOf("Firefox") !== -1, _.isMS = /(edge|msie|trident)/i.test(_.userAgent) && !_.win.opera, _.isSafari = !_.isChrome && _.userAgent.indexOf("Safari") !== -1, _.isTouchDevice = /(Mobile|Android|Windows Phone)/.test(_.userAgent), _.isWebKit = _.userAgent.indexOf("AppleWebKit") !== -1, _.deg2rad = 2 * Math.PI / 360, _.hasBidiBug = _.isFirefox && 4 > parseInt(_.userAgent.split("Firefox/")[1], 10), _.marginNames = ["plotTop", "marginRight", "marginBottom", "plotLeft"], _.noop = function() {
      }, _.supportsPassiveEvents = function() {
        let K = !1;
        if (!_.isMS) {
          let Z = Object.defineProperty({}, "passive", { get: function() {
            K = !0;
          } });
          _.win.addEventListener && _.win.removeEventListener && (_.win.addEventListener("testPassive", _.noop, Z), _.win.removeEventListener("testPassive", _.noop, Z));
        }
        return K;
      }(), _.charts = [], _.composed = [], _.dateFormats = {}, _.seriesTypes = {}, _.symbolSizes = {}, _.chartCount = 0, U;
    }), ot(i, "Core/Utilities.js", [i["Core/Globals.js"]], function(U) {
      let _, { charts: K, doc: Z, win: J } = U;
      function q(e, t, h, b) {
        let r = t ? "Highcharts error" : "Highcharts warning";
        e === 32 && (e = `${r}: Deprecated member`);
        let g = f(e), d = g ? `${r} #${e}: www.highcharts.com/errors/${e}/` : e.toString();
        if (b !== void 0) {
          let M = "";
          g && (d += "?"), T(b, function(H, A) {
            M += `
 - ${A}: ${H}`, g && (d += encodeURI(A) + "=" + encodeURI(H));
          }), d += M;
        }
        u(U, "displayError", { chart: h, code: e, message: d, params: b }, function() {
          if (t) throw Error(d);
          J.console && q.messages.indexOf(d) === -1 && console.warn(d);
        }), q.messages.push(d);
      }
      function tt(e, t) {
        return parseInt(e, t || 10);
      }
      function X(e) {
        return typeof e == "string";
      }
      function I(e) {
        let t = Object.prototype.toString.call(e);
        return t === "[object Array]" || t === "[object Array Iterator]";
      }
      function O(e, t) {
        return !!e && typeof e == "object" && (!t || !I(e));
      }
      function y(e) {
        return O(e) && typeof e.nodeType == "number";
      }
      function w(e) {
        let t = e && e.constructor;
        return !!(O(e, !0) && !y(e) && t && t.name && t.name !== "Object");
      }
      function f(e) {
        return typeof e == "number" && !isNaN(e) && e < 1 / 0 && e > -1 / 0;
      }
      function x(e) {
        return e != null;
      }
      function s(e, t, h) {
        let b, r = X(t) && !x(h), g = (d, M) => {
          x(d) ? e.setAttribute(M, d) : r ? (b = e.getAttribute(M)) || M !== "class" || (b = e.getAttribute(M + "Name")) : e.removeAttribute(M);
        };
        return X(t) ? g(h, t) : T(t, g), b;
      }
      function l(e) {
        return I(e) ? e : [e];
      }
      function p(e, t) {
        let h;
        for (h in e || (e = {}), t) e[h] = t[h];
        return e;
      }
      function n() {
        let e = arguments, t = e.length;
        for (let h = 0; h < t; h++) {
          let b = e[h];
          if (b != null) return b;
        }
      }
      function a(e, t) {
        p(e.style, t);
      }
      function v(e) {
        return Math.pow(10, Math.floor(Math.log(e) / Math.LN10));
      }
      function N(e, t) {
        return e > 1e14 ? e : parseFloat(e.toPrecision(t || 14));
      }
      (q || (q = {})).messages = [], Math.easeInOutSine = function(e) {
        return -0.5 * (Math.cos(Math.PI * e) - 1);
      };
      let B = Array.prototype.find ? function(e, t) {
        return e.find(t);
      } : function(e, t) {
        let h, b = e.length;
        for (h = 0; h < b; h++) if (t(e[h], h)) return e[h];
      };
      function T(e, t, h) {
        for (let b in e) Object.hasOwnProperty.call(e, b) && t.call(h || e[b], e[b], b, e);
      }
      function o(e, t, h) {
        function b(d, M) {
          let H = e.removeEventListener;
          H && H.call(e, d, M, !1);
        }
        function r(d) {
          let M, H;
          e.nodeName && (t ? (M = {})[t] = !0 : M = d, T(M, function(A, D) {
            if (d[D]) for (H = d[D].length; H--; ) b(D, d[D][H].fn);
          }));
        }
        let g = typeof e == "function" && e.prototype || e;
        if (Object.hasOwnProperty.call(g, "hcEvents")) {
          let d = g.hcEvents;
          if (t) {
            let M = d[t] || [];
            h ? (d[t] = M.filter(function(H) {
              return h !== H.fn;
            }), b(t, h)) : (r(d), d[t] = []);
          } else r(d), delete g.hcEvents;
        }
      }
      function u(e, t, h, b) {
        if (h = h || {}, Z.createEvent && (e.dispatchEvent || e.fireEvent && e !== U)) {
          let r = Z.createEvent("Events");
          r.initEvent(t, !0, !0), h = p(r, h), e.dispatchEvent ? e.dispatchEvent(h) : e.fireEvent(t, h);
        } else if (e.hcEvents) {
          h.target || p(h, { preventDefault: function() {
            h.defaultPrevented = !0;
          }, target: e, type: t });
          let r = [], g = e, d = !1;
          for (; g.hcEvents; ) Object.hasOwnProperty.call(g, "hcEvents") && g.hcEvents[t] && (r.length && (d = !0), r.unshift.apply(r, g.hcEvents[t])), g = Object.getPrototypeOf(g);
          d && r.sort((M, H) => M.order - H.order), r.forEach((M) => {
            M.fn.call(e, h) === !1 && h.preventDefault();
          });
        }
        b && !h.defaultPrevented && b.call(e, h);
      }
      T({ map: "map", each: "forEach", grep: "filter", reduce: "reduce", some: "some" }, function(e, t) {
        U[t] = function(h) {
          return q(32, !1, void 0, { [`Highcharts.${t}`]: `use Array.${e}` }), Array.prototype[e].apply(h, [].slice.call(arguments, 1));
        };
      });
      let c = function() {
        let e = Math.random().toString(36).substring(2, 9) + "-", t = 0;
        return function() {
          return "highcharts-" + (_ ? "" : e) + t++;
        };
      }();
      return J.jQuery && (J.jQuery.fn.highcharts = function() {
        let e = [].slice.call(arguments);
        if (this[0]) return e[0] ? (new U[X(e[0]) ? e.shift() : "Chart"](this[0], e[0], e[1]), this) : K[s(this[0], "data-highcharts-chart")];
      }), { addEvent: function(e, t, h, b = {}) {
        let r = typeof e == "function" && e.prototype || e;
        Object.hasOwnProperty.call(r, "hcEvents") || (r.hcEvents = {});
        let g = r.hcEvents;
        U.Point && e instanceof U.Point && e.series && e.series.chart && (e.series.chart.runTrackerClick = !0);
        let d = e.addEventListener;
        d && d.call(e, t, h, !!U.supportsPassiveEvents && { passive: b.passive === void 0 ? t.indexOf("touch") !== -1 : b.passive, capture: !1 }), g[t] || (g[t] = []);
        let M = { fn: h, order: typeof b.order == "number" ? b.order : 1 / 0 };
        return g[t].push(M), g[t].sort((H, A) => H.order - A.order), function() {
          o(e, t, h);
        };
      }, arrayMax: function(e) {
        let t = e.length, h = e[0];
        for (; t--; ) e[t] > h && (h = e[t]);
        return h;
      }, arrayMin: function(e) {
        let t = e.length, h = e[0];
        for (; t--; ) e[t] < h && (h = e[t]);
        return h;
      }, attr: s, clamp: function(e, t, h) {
        return e > t ? e < h ? e : h : t;
      }, clearTimeout: function(e) {
        x(e) && clearTimeout(e);
      }, correctFloat: N, createElement: function(e, t, h, b, r) {
        let g = Z.createElement(e);
        return t && p(g, t), r && a(g, { padding: "0", border: "none", margin: "0" }), h && a(g, h), b && b.appendChild(g), g;
      }, crisp: (e, t = 0, h) => {
        let b = t % 2 / 2, r = h ? -1 : 1;
        return (Math.round(e * r - b) + b) * r;
      }, css: a, defined: x, destroyObjectProperties: function(e, t, h) {
        T(e, function(b, r) {
          b !== t && (b != null && b.destroy) && b.destroy(), (b != null && b.destroy || !h) && delete e[r];
        });
      }, diffObjects: function(e, t, h, b) {
        let r = {};
        return function g(d, M, H, A) {
          let D = h ? M : d;
          T(d, function(W, G) {
            if (!A && b && b.indexOf(G) > -1 && M[G]) {
              W = l(W), H[G] = [];
              for (let it = 0; it < Math.max(W.length, M[G].length); it++) M[G][it] && (W[it] === void 0 ? H[G][it] = M[G][it] : (H[G][it] = {}, g(W[it], M[G][it], H[G][it], A + 1)));
            } else O(W, !0) && !W.nodeType ? (H[G] = I(W) ? [] : {}, g(W, M[G] || {}, H[G], A + 1), Object.keys(H[G]).length !== 0 || G === "colorAxis" && A === 0 || delete H[G]) : (d[G] !== M[G] || G in d && !(G in M)) && G !== "__proto__" && G !== "constructor" && (H[G] = D[G]);
          });
        }(e, t, r, 0), r;
      }, discardElement: function(e) {
        e && e.parentElement && e.parentElement.removeChild(e);
      }, erase: function(e, t) {
        let h = e.length;
        for (; h--; ) if (e[h] === t) {
          e.splice(h, 1);
          break;
        }
      }, error: q, extend: p, extendClass: function(e, t) {
        let h = function() {
        };
        return h.prototype = new e(), p(h.prototype, t), h;
      }, find: B, fireEvent: u, getClosestDistance: function(e, t) {
        let h, b, r, g = !t;
        return e.forEach((d) => {
          if (d.length > 1) for (r = d.length - 1; r > 0; r--) (b = d[r] - d[r - 1]) < 0 && !g ? (t == null || t(), t = void 0) : b && (h === void 0 || b < h) && (h = b);
        }), h;
      }, getMagnitude: v, getNestedProperty: function(e, t) {
        let h = e.split(".");
        for (; h.length && x(t); ) {
          let b = h.shift();
          if (b === void 0 || b === "__proto__") return;
          if (b === "this") {
            let g;
            return O(t) && (g = t["@this"]), g != null ? g : t;
          }
          let r = t[b];
          if (!x(r) || typeof r == "function" || typeof r.nodeType == "number" || r === J) return;
          t = r;
        }
        return t;
      }, getStyle: function e(t, h, b) {
        let r;
        if (h === "width") {
          let d = Math.min(t.offsetWidth, t.scrollWidth), M = t.getBoundingClientRect && t.getBoundingClientRect().width;
          return M < d && M >= d - 1 && (d = Math.floor(M)), Math.max(0, d - (e(t, "padding-left", !0) || 0) - (e(t, "padding-right", !0) || 0));
        }
        if (h === "height") return Math.max(0, Math.min(t.offsetHeight, t.scrollHeight) - (e(t, "padding-top", !0) || 0) - (e(t, "padding-bottom", !0) || 0));
        let g = J.getComputedStyle(t, void 0);
        return g && (r = g.getPropertyValue(h), n(b, h !== "opacity") && (r = tt(r))), r;
      }, inArray: function(e, t, h) {
        return q(32, !1, void 0, { "Highcharts.inArray": "use Array.indexOf" }), t.indexOf(e, h);
      }, insertItem: function(e, t) {
        let h, b = e.options.index, r = t.length;
        for (h = e.options.isInternal ? r : 0; h < r + 1; h++) if (!t[h] || f(b) && b < n(t[h].options.index, t[h]._i) || t[h].options.isInternal) {
          t.splice(h, 0, e);
          break;
        }
        return h;
      }, isArray: I, isClass: w, isDOMElement: y, isFunction: function(e) {
        return typeof e == "function";
      }, isNumber: f, isObject: O, isString: X, keys: function(e) {
        return q(32, !1, void 0, { "Highcharts.keys": "use Object.keys" }), Object.keys(e);
      }, merge: function() {
        let e, t = arguments, h = {}, b = function(g, d) {
          return typeof g != "object" && (g = {}), T(d, function(M, H) {
            H !== "__proto__" && H !== "constructor" && (!O(M, !0) || w(M) || y(M) ? g[H] = d[H] : g[H] = b(g[H] || {}, M));
          }), g;
        };
        t[0] === !0 && (h = t[1], t = Array.prototype.slice.call(t, 2));
        let r = t.length;
        for (e = 0; e < r; e++) h = b(h, t[e]);
        return h;
      }, normalizeTickInterval: function(e, t, h, b, r) {
        let g, d = e;
        h = n(h, v(e));
        let M = e / h;
        for (!t && (t = r ? [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10] : [1, 2, 2.5, 5, 10], b === !1 && (h === 1 ? t = t.filter(function(H) {
          return H % 1 == 0;
        }) : h <= 0.1 && (t = [1 / h]))), g = 0; g < t.length && (d = t[g], (!r || !(d * h >= e)) && (r || !(M <= (t[g] + (t[g + 1] || t[g])) / 2))); g++) ;
        return N(d * h, -Math.round(Math.log(1e-3) / Math.LN10));
      }, objectEach: T, offset: function(e) {
        let t = Z.documentElement, h = e.parentElement || e.parentNode ? e.getBoundingClientRect() : { top: 0, left: 0, width: 0, height: 0 };
        return { top: h.top + (J.pageYOffset || t.scrollTop) - (t.clientTop || 0), left: h.left + (J.pageXOffset || t.scrollLeft) - (t.clientLeft || 0), width: h.width, height: h.height };
      }, pad: function(e, t, h) {
        return Array((t || 2) + 1 - String(e).replace("-", "").length).join(h || "0") + e;
      }, pick: n, pInt: tt, pushUnique: function(e, t) {
        return 0 > e.indexOf(t) && !!e.push(t);
      }, relativeLength: function(e, t, h) {
        return /%$/.test(e) ? t * parseFloat(e) / 100 + (h || 0) : parseFloat(e);
      }, removeEvent: o, replaceNested: function(e, ...t) {
        let h, b;
        do
          for (b of (h = e, t)) e = e.replace(b[0], b[1]);
        while (e !== h);
        return e;
      }, splat: l, stableSort: function(e, t) {
        let h, b, r = e.length;
        for (b = 0; b < r; b++) e[b].safeI = b;
        for (e.sort(function(g, d) {
          return (h = t(g, d)) === 0 ? g.safeI - d.safeI : h;
        }), b = 0; b < r; b++) delete e[b].safeI;
      }, syncTimeout: function(e, t, h) {
        return t > 0 ? setTimeout(e, t, h) : (e.call(0, h), -1);
      }, timeUnits: { millisecond: 1, second: 1e3, minute: 6e4, hour: 36e5, day: 864e5, week: 6048e5, month: 24192e5, year: 314496e5 }, uniqueKey: c, useSerialIds: function(e) {
        return _ = n(e, _);
      }, wrap: function(e, t, h) {
        let b = e[t];
        e[t] = function() {
          let r = arguments, g = this;
          return h.apply(this, [function() {
            return b.apply(g, arguments.length ? arguments : r);
          }].concat([].slice.call(arguments)));
        };
      } };
    }), ot(i, "Core/Chart/ChartDefaults.js", [], function() {
      return { alignThresholds: !1, panning: { enabled: !1, type: "x" }, styledMode: !1, borderRadius: 0, colorCount: 10, allowMutatingData: !0, ignoreHiddenSeries: !0, spacing: [10, 10, 15, 10], resetZoomButton: { theme: {}, position: {} }, reflow: !0, type: "line", zooming: { singleTouch: !1, resetButton: { theme: { zIndex: 6 }, position: { align: "right", x: -10, y: 10 } } }, width: null, height: null, borderColor: "#334eff", backgroundColor: "#ffffff", plotBorderColor: "#cccccc" };
    }), ot(i, "Core/Color/Palettes.js", [], function() {
      return { colors: ["#2caffe", "#544fc5", "#00e272", "#fe6a35", "#6b8abc", "#d568fb", "#2ee0ca", "#fa4b42", "#feb56a", "#91e8e1"] };
    }), ot(i, "Core/Time.js", [i["Core/Globals.js"], i["Core/Utilities.js"]], function(U, _) {
      let { win: K } = U, { defined: Z, error: J, extend: q, isNumber: tt, isObject: X, merge: I, objectEach: O, pad: y, pick: w, splat: f, timeUnits: x } = _, s = U.isSafari && K.Intl && K.Intl.DateTimeFormat.prototype.formatRange, l = U.isSafari && K.Intl && !K.Intl.DateTimeFormat.prototype.formatRange;
      class p {
        constructor(a) {
          this.options = {}, this.useUTC = !1, this.variableTimezone = !1, this.Date = K.Date, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.update(a);
        }
        get(a, v) {
          if (this.variableTimezone || this.timezoneOffset) {
            let N = v.getTime(), B = N - this.getTimezoneOffset(v);
            v.setTime(B);
            let T = v["getUTC" + a]();
            return v.setTime(N), T;
          }
          return this.useUTC ? v["getUTC" + a]() : v["get" + a]();
        }
        set(a, v, N) {
          if (this.variableTimezone || this.timezoneOffset) {
            if (a === "Milliseconds" || a === "Seconds" || a === "Minutes" && this.getTimezoneOffset(v) % 36e5 == 0) return v["setUTC" + a](N);
            let B = this.getTimezoneOffset(v), T = v.getTime() - B;
            v.setTime(T), v["setUTC" + a](N);
            let o = this.getTimezoneOffset(v);
            return T = v.getTime() + o, v.setTime(T);
          }
          return this.useUTC || s && a === "FullYear" ? v["setUTC" + a](N) : v["set" + a](N);
        }
        update(a = {}) {
          let v = w(a.useUTC, !0);
          this.options = a = I(!0, this.options, a), this.Date = a.Date || K.Date || Date, this.useUTC = v, this.timezoneOffset = v && a.timezoneOffset || void 0, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.variableTimezone = v && !!(a.getTimezoneOffset || a.timezone);
        }
        makeTime(a, v, N, B, T, o) {
          let u, c, e;
          return this.useUTC ? (u = this.Date.UTC.apply(0, arguments), c = this.getTimezoneOffset(u), u += c, c !== (e = this.getTimezoneOffset(u)) ? u += e - c : c - 36e5 !== this.getTimezoneOffset(u - 36e5) || l || (u -= 36e5)) : u = new this.Date(a, v, w(N, 1), w(B, 0), w(T, 0), w(o, 0)).getTime(), u;
        }
        timezoneOffsetFunction() {
          let a = this, v = this.options, N = v.getTimezoneOffset;
          return this.useUTC ? v.timezone ? (B) => {
            try {
              let T = `shortOffset,${v.timezone || ""}`, [o, u, c, e, t = 0] = (p.formatCache[T] = p.formatCache[T] || Intl.DateTimeFormat("en", { timeZone: v.timezone, timeZoneName: "shortOffset" })).format(B).split(/(GMT|:)/).map(Number), h = -(36e5 * (c + t / 60));
              if (tt(h)) return h;
            } catch {
              J(34);
            }
            return 0;
          } : this.useUTC && N ? (B) => 6e4 * N(B.valueOf()) : () => 6e4 * (a.timezoneOffset || 0) : (B) => 6e4 * new Date(B.toString()).getTimezoneOffset();
        }
        dateFormat(a, v, N) {
          if (!Z(v) || isNaN(v)) return U.defaultOptions.lang && U.defaultOptions.lang.invalidDate || "";
          a = w(a, "%Y-%m-%d %H:%M:%S");
          let B = this, T = new this.Date(v), o = this.get("Hours", T), u = this.get("Day", T), c = this.get("Date", T), e = this.get("Month", T), t = this.get("FullYear", T), h = U.defaultOptions.lang, b = h && h.weekdays, r = h && h.shortWeekdays;
          return O(q({ a: r ? r[u] : b[u].substr(0, 3), A: b[u], d: y(c), e: y(c, 2, " "), w: u, b: h.shortMonths[e], B: h.months[e], m: y(e + 1), o: e + 1, y: t.toString().substr(2, 2), Y: t, H: y(o), k: o, I: y(o % 12 || 12), l: o % 12 || 12, M: y(this.get("Minutes", T)), p: o < 12 ? "AM" : "PM", P: o < 12 ? "am" : "pm", S: y(this.get("Seconds", T)), L: y(Math.floor(v % 1e3), 3) }, U.dateFormats), function(g, d) {
            for (; a.indexOf("%" + d) !== -1; ) a = a.replace("%" + d, typeof g == "function" ? g.call(B, v) : g);
          }), N ? a.substr(0, 1).toUpperCase() + a.substr(1) : a;
        }
        resolveDTLFormat(a) {
          return X(a, !0) ? a : { main: (a = f(a))[0], from: a[1], to: a[2] };
        }
        getTimeTicks(a, v, N, B) {
          let T, o, u, c, e = this, t = e.Date, h = [], b = {}, r = new t(v), g = a.unitRange, d = a.count || 1;
          if (B = w(B, 1), Z(v)) {
            e.set("Milliseconds", r, g >= x.second ? 0 : d * Math.floor(e.get("Milliseconds", r) / d)), g >= x.second && e.set("Seconds", r, g >= x.minute ? 0 : d * Math.floor(e.get("Seconds", r) / d)), g >= x.minute && e.set("Minutes", r, g >= x.hour ? 0 : d * Math.floor(e.get("Minutes", r) / d)), g >= x.hour && e.set("Hours", r, g >= x.day ? 0 : d * Math.floor(e.get("Hours", r) / d)), g >= x.day && e.set("Date", r, g >= x.month ? 1 : Math.max(1, d * Math.floor(e.get("Date", r) / d))), g >= x.month && (e.set("Month", r, g >= x.year ? 0 : d * Math.floor(e.get("Month", r) / d)), o = e.get("FullYear", r)), g >= x.year && (o -= o % d, e.set("FullYear", r, o)), g === x.week && (c = e.get("Day", r), e.set("Date", r, e.get("Date", r) - c + B + (c < B ? -7 : 0))), o = e.get("FullYear", r);
            let M = e.get("Month", r), H = e.get("Date", r), A = e.get("Hours", r);
            v = r.getTime(), (e.variableTimezone || !e.useUTC) && Z(N) && (u = N - v > 4 * x.month || e.getTimezoneOffset(v) !== e.getTimezoneOffset(N));
            let D = r.getTime();
            for (T = 1; D < N; ) h.push(D), g === x.year ? D = e.makeTime(o + T * d, 0) : g === x.month ? D = e.makeTime(o, M + T * d) : u && (g === x.day || g === x.week) ? D = e.makeTime(o, M, H + T * d * (g === x.day ? 1 : 7)) : u && g === x.hour && d > 1 ? D = e.makeTime(o, M, H, A + T * d) : D += g * d, T++;
            h.push(D), g <= x.hour && h.length < 1e4 && h.forEach(function(W) {
              W % 18e5 == 0 && e.dateFormat("%H%M%S%L", W) === "000000000" && (b[W] = "day");
            });
          }
          return h.info = q(a, { higherRanks: b, totalRange: g * d }), h;
        }
        getDateFormat(a, v, N, B) {
          let T = this.dateFormat("%m-%d %H:%M:%S.%L", v), o = "01-01 00:00:00.000", u = { millisecond: 15, second: 12, minute: 9, hour: 6, day: 3 }, c = "millisecond", e = c;
          for (c in x) {
            if (a === x.week && +this.dateFormat("%w", v) === N && T.substr(6) === o.substr(6)) {
              c = "week";
              break;
            }
            if (x[c] > a) {
              c = e;
              break;
            }
            if (u[c] && T.substr(u[c]) !== o.substr(u[c])) break;
            c !== "week" && (e = c);
          }
          return this.resolveDTLFormat(B[c]).main;
        }
      }
      return p.formatCache = {}, p;
    }), ot(i, "Core/Defaults.js", [i["Core/Chart/ChartDefaults.js"], i["Core/Globals.js"], i["Core/Color/Palettes.js"], i["Core/Time.js"], i["Core/Utilities.js"]], function(U, _, K, Z, J) {
      let { isTouchDevice: q } = _, { fireEvent: tt, merge: X } = J, I = { colors: K.colors, symbols: ["circle", "diamond", "square", "triangle", "triangle-down"], lang: { loading: "Loading...", months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], decimalPoint: ".", numericSymbols: ["k", "M", "G", "T", "P", "E"], resetZoom: "Reset zoom", resetZoomTitle: "Reset zoom level 1:1", thousandsSep: " " }, global: { buttonTheme: { fill: "#f7f7f7", padding: 8, r: 2, stroke: "#cccccc", "stroke-width": 1, style: { color: "#333333", cursor: "pointer", fontSize: "0.8em", fontWeight: "normal" }, states: { hover: { fill: "#e6e6e6" }, select: { fill: "#e6e9ff", style: { color: "#000000", fontWeight: "bold" } }, disabled: { style: { color: "#cccccc" } } } } }, time: { Date: void 0, getTimezoneOffset: void 0, timezone: void 0, timezoneOffset: 0, useUTC: !0 }, chart: U, title: { style: { color: "#333333", fontWeight: "bold" }, text: "Chart title", align: "center", margin: 15, widthAdjust: -44 }, subtitle: { style: { color: "#666666", fontSize: "0.8em" }, text: "", align: "center", widthAdjust: -44 }, caption: { margin: 15, style: { color: "#666666", fontSize: "0.8em" }, text: "", align: "left", verticalAlign: "bottom" }, plotOptions: {}, legend: { enabled: !0, align: "center", alignColumns: !0, className: "highcharts-no-tooltip", events: {}, layout: "horizontal", itemMarginBottom: 2, itemMarginTop: 2, labelFormatter: function() {
        return this.name;
      }, borderColor: "#999999", borderRadius: 0, navigation: { style: { fontSize: "0.8em" }, activeColor: "#0022ff", inactiveColor: "#cccccc" }, itemStyle: { color: "#333333", cursor: "pointer", fontSize: "0.8em", textDecoration: "none", textOverflow: "ellipsis" }, itemHoverStyle: { color: "#000000" }, itemHiddenStyle: { color: "#666666", textDecoration: "line-through" }, shadow: !1, itemCheckboxStyle: { position: "absolute", width: "13px", height: "13px" }, squareSymbol: !0, symbolPadding: 5, verticalAlign: "bottom", x: 0, y: 0, title: { style: { fontSize: "0.8em", fontWeight: "bold" } } }, loading: { labelStyle: { fontWeight: "bold", position: "relative", top: "45%" }, style: { position: "absolute", backgroundColor: "#ffffff", opacity: 0.5, textAlign: "center" } }, tooltip: { enabled: !0, animation: { duration: 300, easing: (y) => Math.sqrt(1 - Math.pow(y - 1, 2)) }, borderRadius: 3, dateTimeLabelFormats: { millisecond: "%A, %e %b, %H:%M:%S.%L", second: "%A, %e %b, %H:%M:%S", minute: "%A, %e %b, %H:%M", hour: "%A, %e %b, %H:%M", day: "%A, %e %b %Y", week: "Week from %A, %e %b %Y", month: "%B %Y", year: "%Y" }, footerFormat: "", headerShape: "callout", hideDelay: 500, padding: 8, shape: "callout", shared: !1, snap: q ? 25 : 10, headerFormat: '<span style="font-size: 0.8em">{point.key}</span><br/>', pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.y}</b><br/>', backgroundColor: "#ffffff", borderWidth: void 0, shadow: !0, stickOnContact: !1, style: { color: "#333333", cursor: "default", fontSize: "0.8em" }, useHTML: !1 }, credits: { enabled: !0, href: "https://www.highcharts.com?credits", position: { align: "right", x: -10, verticalAlign: "bottom", y: -5 }, style: { cursor: "pointer", color: "#999999", fontSize: "0.6em" }, text: "Highcharts.com" } };
      I.chart.styledMode = !1;
      let O = new Z(I.time);
      return { defaultOptions: I, defaultTime: O, getOptions: function() {
        return I;
      }, setOptions: function(y) {
        return tt(_, "setOptions", { options: y }), X(!0, I, y), (y.time || y.global) && (_.time ? _.time.update(X(I.global, I.time, y.global, y.time)) : _.time = O), I;
      } };
    }), ot(i, "Core/Color/Color.js", [i["Core/Globals.js"], i["Core/Utilities.js"]], function(U, _) {
      let { isNumber: K, merge: Z, pInt: J } = _;
      class q {
        static parse(X) {
          return X ? new q(X) : q.None;
        }
        constructor(X) {
          let I, O, y, w;
          this.rgba = [NaN, NaN, NaN, NaN], this.input = X;
          let f = U.Color;
          if (f && f !== q) return new f(X);
          if (typeof X == "object" && X.stops !== void 0) this.stops = X.stops.map((x) => new q(x[1]));
          else if (typeof X == "string") {
            if (this.input = X = q.names[X.toLowerCase()] || X, X.charAt(0) === "#") {
              let x = X.length, s = parseInt(X.substr(1), 16);
              x === 7 ? O = [(16711680 & s) >> 16, (65280 & s) >> 8, 255 & s, 1] : x === 4 && (O = [(3840 & s) >> 4 | (3840 & s) >> 8, (240 & s) >> 4 | 240 & s, (15 & s) << 4 | 15 & s, 1]);
            }
            if (!O) for (y = q.parsers.length; y-- && !O; ) (I = (w = q.parsers[y]).regex.exec(X)) && (O = w.parse(I));
          }
          O && (this.rgba = O);
        }
        get(X) {
          let I = this.input, O = this.rgba;
          if (typeof I == "object" && this.stops !== void 0) {
            let y = Z(I);
            return y.stops = [].slice.call(y.stops), this.stops.forEach((w, f) => {
              y.stops[f] = [y.stops[f][0], w.get(X)];
            }), y;
          }
          return O && K(O[0]) ? X !== "rgb" && (X || O[3] !== 1) ? X === "a" ? `${O[3]}` : "rgba(" + O.join(",") + ")" : "rgb(" + O[0] + "," + O[1] + "," + O[2] + ")" : I;
        }
        brighten(X) {
          let I = this.rgba;
          if (this.stops) this.stops.forEach(function(O) {
            O.brighten(X);
          });
          else if (K(X) && X !== 0) for (let O = 0; O < 3; O++) I[O] += J(255 * X), I[O] < 0 && (I[O] = 0), I[O] > 255 && (I[O] = 255);
          return this;
        }
        setOpacity(X) {
          return this.rgba[3] = X, this;
        }
        tweenTo(X, I) {
          let O = this.rgba, y = X.rgba;
          if (!K(O[0]) || !K(y[0])) return X.input || "none";
          let w = y[3] !== 1 || O[3] !== 1;
          return (w ? "rgba(" : "rgb(") + Math.round(y[0] + (O[0] - y[0]) * (1 - I)) + "," + Math.round(y[1] + (O[1] - y[1]) * (1 - I)) + "," + Math.round(y[2] + (O[2] - y[2]) * (1 - I)) + (w ? "," + (y[3] + (O[3] - y[3]) * (1 - I)) : "") + ")";
        }
      }
      return q.names = { white: "#ffffff", black: "#000000" }, q.parsers = [{ regex: /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?(?:\.\d+)?)\s*\)/, parse: function(tt) {
        return [J(tt[1]), J(tt[2]), J(tt[3]), parseFloat(tt[4], 10)];
      } }, { regex: /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)/, parse: function(tt) {
        return [J(tt[1]), J(tt[2]), J(tt[3]), 1];
      } }], q.None = new q(""), q;
    }), ot(i, "Core/Animation/Fx.js", [i["Core/Color/Color.js"], i["Core/Globals.js"], i["Core/Utilities.js"]], function(U, _, K) {
      let { parse: Z } = U, { win: J } = _, { isNumber: q, objectEach: tt } = K;
      class X {
        constructor(O, y, w) {
          this.pos = NaN, this.options = y, this.elem = O, this.prop = w;
        }
        dSetter() {
          let O = this.paths, y = O && O[0], w = O && O[1], f = this.now || 0, x = [];
          if (f !== 1 && y && w)
            if (y.length === w.length && f < 1) for (let s = 0; s < w.length; s++) {
              let l = y[s], p = w[s], n = [];
              for (let a = 0; a < p.length; a++) {
                let v = l[a], N = p[a];
                q(v) && q(N) && !(p[0] === "A" && (a === 4 || a === 5)) ? n[a] = v + f * (N - v) : n[a] = N;
              }
              x.push(n);
            }
            else x = w;
          else x = this.toD || [];
          this.elem.attr("d", x, void 0, !0);
        }
        update() {
          let O = this.elem, y = this.prop, w = this.now, f = this.options.step;
          this[y + "Setter"] ? this[y + "Setter"]() : O.attr ? O.element && O.attr(y, w, null, !0) : O.style[y] = w + this.unit, f && f.call(O, w, this);
        }
        run(O, y, w) {
          let f = this, x = f.options, s = function(n) {
            return !s.stopped && f.step(n);
          }, l = J.requestAnimationFrame || function(n) {
            setTimeout(n, 13);
          }, p = function() {
            for (let n = 0; n < X.timers.length; n++) X.timers[n]() || X.timers.splice(n--, 1);
            X.timers.length && l(p);
          };
          O !== y || this.elem["forceAnimate:" + this.prop] ? (this.startTime = +/* @__PURE__ */ new Date(), this.start = O, this.end = y, this.unit = w, this.now = this.start, this.pos = 0, s.elem = this.elem, s.prop = this.prop, s() && X.timers.push(s) === 1 && l(p)) : (delete x.curAnim[this.prop], x.complete && Object.keys(x.curAnim).length === 0 && x.complete.call(this.elem));
        }
        step(O) {
          let y, w, f = +/* @__PURE__ */ new Date(), x = this.options, s = this.elem, l = x.complete, p = x.duration, n = x.curAnim;
          return s.attr && !s.element ? y = !1 : O || f >= p + this.startTime ? (this.now = this.end, this.pos = 1, this.update(), n[this.prop] = !0, w = !0, tt(n, function(a) {
            a !== !0 && (w = !1);
          }), w && l && l.call(s), y = !1) : (this.pos = x.easing((f - this.startTime) / p), this.now = this.start + (this.end - this.start) * this.pos, this.update(), y = !0), y;
        }
        initPath(O, y, w) {
          let f = O.startX, x = O.endX, s = w.slice(), l = O.isArea, p = l ? 2 : 1, n = y && w.length > y.length && w.hasStackedCliffs, a, v, N, B, T = y && y.slice();
          if (!T || n) return [s, s];
          function o(c, e) {
            for (; c.length < v; ) {
              let t = c[0], h = e[v - c.length];
              if (h && t[0] === "M" && (h[0] === "C" ? c[0] = ["C", t[1], t[2], t[1], t[2], t[1], t[2]] : c[0] = ["L", t[1], t[2]]), c.unshift(t), l) {
                let b = c.pop();
                c.push(c[c.length - 1], b);
              }
            }
          }
          function u(c) {
            for (; c.length < v; ) {
              let e = c[Math.floor(c.length / p) - 1].slice();
              if (e[0] === "C" && (e[1] = e[5], e[2] = e[6]), l) {
                let t = c[Math.floor(c.length / p)].slice();
                c.splice(c.length / 2, 0, e, t);
              } else c.push(e);
            }
          }
          if (f && x && x.length) {
            for (N = 0; N < f.length; N++) {
              if (f[N] === x[0]) {
                a = N;
                break;
              }
              if (f[0] === x[x.length - f.length + N]) {
                a = N, B = !0;
                break;
              }
              if (f[f.length - 1] === x[x.length - f.length + N]) {
                a = f.length - N;
                break;
              }
            }
            a === void 0 && (T = []);
          }
          return T.length && q(a) && (v = s.length + a * p, B ? (o(T, s), u(s)) : (o(s, T), u(T))), [T, s];
        }
        fillSetter() {
          X.prototype.strokeSetter.apply(this, arguments);
        }
        strokeSetter() {
          this.elem.attr(this.prop, Z(this.start).tweenTo(Z(this.end), this.pos), void 0, !0);
        }
      }
      return X.timers = [], X;
    }), ot(i, "Core/Animation/AnimationUtilities.js", [i["Core/Animation/Fx.js"], i["Core/Utilities.js"]], function(U, _) {
      let { defined: K, getStyle: Z, isArray: J, isNumber: q, isObject: tt, merge: X, objectEach: I, pick: O } = _;
      function y(f) {
        return tt(f) ? X({ duration: 500, defer: 0 }, f) : { duration: f ? 500 : 0, defer: 0 };
      }
      function w(f, x) {
        let s = U.timers.length;
        for (; s--; ) U.timers[s].elem !== f || x && x !== U.timers[s].prop || (U.timers[s].stopped = !0);
      }
      return { animate: function(f, x, s) {
        let l, p = "", n, a, v;
        tt(s) || (v = arguments, s = { duration: v[2], easing: v[3], complete: v[4] }), q(s.duration) || (s.duration = 400), s.easing = typeof s.easing == "function" ? s.easing : Math[s.easing] || Math.easeInOutSine, s.curAnim = X(x), I(x, function(N, B) {
          w(f, B), a = new U(f, s, B), n = void 0, B === "d" && J(x.d) ? (a.paths = a.initPath(f, f.pathArray, x.d), a.toD = x.d, l = 0, n = 1) : f.attr ? l = f.attr(B) : (l = parseFloat(Z(f, B)) || 0, B !== "opacity" && (p = "px")), n || (n = N), typeof n == "string" && n.match("px") && (n = n.replace(/px/g, "")), a.run(l, n, p);
        });
      }, animObject: y, getDeferredAnimation: function(f, x, s) {
        let l = y(x), p = s ? [s] : f.series, n = 0, a = 0;
        return p.forEach((v) => {
          let N = y(v.options.animation);
          n = tt(x) && K(x.defer) ? l.defer : Math.max(n, N.duration + N.defer), a = Math.min(l.duration, N.duration);
        }), f.renderer.forExport && (n = 0), { defer: Math.max(0, n - a), duration: Math.min(n, a) };
      }, setAnimation: function(f, x) {
        x.renderer.globalAnimation = O(f, x.options.chart.animation, !0);
      }, stop: w };
    }), ot(i, "Core/Renderer/HTML/AST.js", [i["Core/Globals.js"], i["Core/Utilities.js"]], function(U, _) {
      let { SVG_NS: K, win: Z } = U, { attr: J, createElement: q, css: tt, error: X, isFunction: I, isString: O, objectEach: y, splat: w } = _, { trustedTypes: f } = Z, x = f && I(f.createPolicy) && f.createPolicy("highcharts", { createHTML: (n) => n }), s = x ? x.createHTML("") : "", l = function() {
        try {
          return !!new DOMParser().parseFromString(s, "text/html");
        } catch {
          return !1;
        }
      }();
      class p {
        static filterUserAttributes(a) {
          return y(a, (v, N) => {
            let B = !0;
            p.allowedAttributes.indexOf(N) === -1 && (B = !1), ["background", "dynsrc", "href", "lowsrc", "src"].indexOf(N) !== -1 && (B = O(v) && p.allowedReferences.some((T) => v.indexOf(T) === 0)), B || (X(33, !1, void 0, { "Invalid attribute in config": `${N}` }), delete a[N]), O(v) && a[N] && (a[N] = v.replace(/</g, "&lt;"));
          }), a;
        }
        static parseStyle(a) {
          return a.split(";").reduce((v, N) => {
            let B = N.split(":").map((o) => o.trim()), T = B.shift();
            return T && B.length && (v[T.replace(/-([a-z])/g, (o) => o[1].toUpperCase())] = B.join(":")), v;
          }, {});
        }
        static setElementHTML(a, v) {
          a.innerHTML = p.emptyHTML, v && new p(v).addToDOM(a);
        }
        constructor(a) {
          this.nodes = typeof a == "string" ? this.parseMarkup(a) : a;
        }
        addToDOM(a) {
          return function v(N, B) {
            let T;
            return w(N).forEach(function(o) {
              let u, c = o.tagName, e = o.textContent ? U.doc.createTextNode(o.textContent) : void 0, t = p.bypassHTMLFiltering;
              if (c)
                if (c === "#text") u = e;
                else if (p.allowedTags.indexOf(c) !== -1 || t) {
                  let h = c === "svg" ? K : B.namespaceURI || K, b = U.doc.createElementNS(h, c), r = o.attributes || {};
                  y(o, function(g, d) {
                    d !== "tagName" && d !== "attributes" && d !== "children" && d !== "style" && d !== "textContent" && (r[d] = g);
                  }), J(b, t ? r : p.filterUserAttributes(r)), o.style && tt(b, o.style), e && b.appendChild(e), v(o.children || [], b), u = b;
                } else X(33, !1, void 0, { "Invalid tagName in config": c });
              u && B.appendChild(u), T = u;
            }), T;
          }(this.nodes, a);
        }
        parseMarkup(a) {
          let v, N = [];
          if (a = a.trim().replace(/ style=(["'])/g, " data-style=$1"), l) v = new DOMParser().parseFromString(x ? x.createHTML(a) : a, "text/html");
          else {
            let T = q("div");
            T.innerHTML = a, v = { body: T };
          }
          let B = (T, o) => {
            let u = T.nodeName.toLowerCase(), c = { tagName: u };
            u === "#text" && (c.textContent = T.textContent || "");
            let e = T.attributes;
            if (e) {
              let t = {};
              [].forEach.call(e, (h) => {
                h.name === "data-style" ? c.style = p.parseStyle(h.value) : t[h.name] = h.value;
              }), c.attributes = t;
            }
            if (T.childNodes.length) {
              let t = [];
              [].forEach.call(T.childNodes, (h) => {
                B(h, t);
              }), t.length && (c.children = t);
            }
            o.push(c);
          };
          return [].forEach.call(v.body.childNodes, (T) => B(T, N)), N;
        }
      }
      return p.allowedAttributes = ["alt", "aria-controls", "aria-describedby", "aria-expanded", "aria-haspopup", "aria-hidden", "aria-label", "aria-labelledby", "aria-live", "aria-pressed", "aria-readonly", "aria-roledescription", "aria-selected", "class", "clip-path", "color", "colspan", "cx", "cy", "d", "dx", "dy", "disabled", "fill", "filterUnits", "flood-color", "flood-opacity", "height", "href", "id", "in", "in2", "markerHeight", "markerWidth", "offset", "opacity", "operator", "orient", "padding", "paddingLeft", "paddingRight", "patternUnits", "r", "radius", "refX", "refY", "role", "scope", "slope", "src", "startOffset", "stdDeviation", "stroke", "stroke-linecap", "stroke-width", "style", "tableValues", "result", "rowspan", "summary", "target", "tabindex", "text-align", "text-anchor", "textAnchor", "textLength", "title", "type", "valign", "width", "x", "x1", "x2", "xlink:href", "y", "y1", "y2", "zIndex"], p.allowedReferences = ["https://", "http://", "mailto:", "/", "../", "./", "#"], p.allowedTags = ["a", "abbr", "b", "br", "button", "caption", "circle", "clipPath", "code", "dd", "defs", "div", "dl", "dt", "em", "feComponentTransfer", "feComposite", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feMorphology", "feOffset", "feMerge", "feMergeNode", "filter", "h1", "h2", "h3", "h4", "h5", "h6", "hr", "i", "img", "li", "linearGradient", "marker", "ol", "p", "path", "pattern", "pre", "rect", "small", "span", "stop", "strong", "style", "sub", "sup", "svg", "table", "text", "textPath", "thead", "title", "tbody", "tspan", "td", "th", "tr", "u", "ul", "#text"], p.emptyHTML = s, p.bypassHTMLFiltering = !1, p;
    }), ot(i, "Core/Templating.js", [i["Core/Defaults.js"], i["Core/Utilities.js"]], function(U, _) {
      let { defaultOptions: K, defaultTime: Z } = U, { extend: J, getNestedProperty: q, isArray: tt, isNumber: X, isObject: I, pick: O, pInt: y } = _, w = { add: (s, l) => s + l, divide: (s, l) => l !== 0 ? s / l : "", eq: (s, l) => s == l, each: function(s) {
        let l = arguments[arguments.length - 1];
        return !!tt(s) && s.map((p, n) => f(l.body, J(I(p) ? p : { "@this": p }, { "@index": n, "@first": n === 0, "@last": n === s.length - 1 }))).join("");
      }, ge: (s, l) => s >= l, gt: (s, l) => s > l, if: (s) => !!s, le: (s, l) => s <= l, lt: (s, l) => s < l, multiply: (s, l) => s * l, ne: (s, l) => s != l, subtract: (s, l) => s - l, unless: (s) => !s };
      function f(s = "", l, p) {
        let n = /\{([\w\:\.\,;\-\/<>%@"'’= #\(\)]+)\}/g, a = /\(([\w\:\.\,;\-\/<>%@"'= ]+)\)/g, v = [], N = /f$/, B = /\.(\d)/, T = K.lang, o = p && p.time || Z, u = p && p.numberFormatter || x, c = (r = "") => {
          let g;
          return r === "true" || r !== "false" && ((g = Number(r)).toString() === r ? g : q(r, l));
        }, e, t, h = 0, b;
        for (; (e = n.exec(s)) !== null; ) {
          let r = a.exec(e[1]);
          r && (e = r, b = !0), t && t.isBlock || (t = { ctx: l, expression: e[1], find: e[0], isBlock: e[1].charAt(0) === "#", start: e.index, startInner: e.index + e[0].length, length: e[0].length });
          let g = e[1].split(" ")[0].replace("#", "");
          w[g] && (t.isBlock && g === t.fn && h++, t.fn || (t.fn = g));
          let d = e[1] === "else";
          if (t.isBlock && t.fn && (e[1] === `/${t.fn}` || d))
            if (h) !d && h--;
            else {
              let M = t.startInner, H = s.substr(M, e.index - M);
              t.body === void 0 ? (t.body = H, t.startInner = e.index + e[0].length) : t.elseBody = H, t.find += H + e[0], d || (v.push(t), t = void 0);
            }
          else t.isBlock || v.push(t);
          if (r && !(t != null && t.isBlock)) break;
        }
        return v.forEach((r) => {
          let g, d, { body: M, elseBody: H, expression: A, fn: D } = r;
          if (D) {
            let W = [r], G = A.split(" ");
            for (d = w[D].length; d--; ) W.unshift(c(G[d + 1]));
            g = w[D].apply(l, W), r.isBlock && typeof g == "boolean" && (g = f(g ? M : H, l, p));
          } else {
            let W = A.split(":");
            if (g = c(W.shift() || ""), W.length && typeof g == "number") {
              let G = W.join(":");
              if (N.test(G)) {
                let it = parseInt((G.match(B) || ["", "-1"])[1], 10);
                g !== null && (g = u(g, it, T.decimalPoint, G.indexOf(",") > -1 ? T.thousandsSep : ""));
              } else g = o.dateFormat(G, g);
            }
          }
          s = s.replace(r.find, O(g, ""));
        }), b ? f(s, l, p) : s;
      }
      function x(s, l, p, n) {
        let a, v;
        s = +s || 0, l = +l;
        let N = K.lang, B = (s.toString().split(".")[1] || "").split("e")[0].length, T = s.toString().split("e"), o = l;
        l === -1 ? l = Math.min(B, 20) : X(l) ? l && T[1] && T[1] < 0 && ((v = l + +T[1]) >= 0 ? (T[0] = (+T[0]).toExponential(v).split("e")[0], l = v) : (T[0] = T[0].split(".")[0] || 0, s = l < 20 ? (T[0] * Math.pow(10, T[1])).toFixed(l) : 0, T[1] = 0)) : l = 2;
        let u = (Math.abs(T[1] ? T[0] : s) + Math.pow(10, -Math.max(l, B) - 1)).toFixed(l), c = String(y(u)), e = c.length > 3 ? c.length % 3 : 0;
        return p = O(p, N.decimalPoint), n = O(n, N.thousandsSep), a = (s < 0 ? "-" : "") + (e ? c.substr(0, e) + n : ""), 0 > +T[1] && !o ? a = "0" : a += c.substr(e).replace(/(\d{3})(?=\d)/g, "$1" + n), l ? a += p + u.slice(-l) : +a == 0 && (a = "0"), T[1] && +a != 0 && (a += "e" + T[1]), a;
      }
      return { dateFormat: function(s, l, p) {
        return Z.dateFormat(s, l, p);
      }, format: f, helpers: w, numberFormat: x };
    }), ot(i, "Core/Renderer/RendererRegistry.js", [i["Core/Globals.js"]], function(U) {
      var _, K;
      let Z;
      return (K = _ || (_ = {})).rendererTypes = {}, K.getRendererType = function(J = Z) {
        return K.rendererTypes[J] || K.rendererTypes[Z];
      }, K.registerRendererType = function(J, q, tt) {
        K.rendererTypes[J] = q, (!Z || tt) && (Z = J, U.Renderer = q);
      }, _;
    }), ot(i, "Core/Renderer/RendererUtilities.js", [i["Core/Utilities.js"]], function(U) {
      var _;
      let { clamp: K, pick: Z, pushUnique: J, stableSort: q } = U;
      return (_ || (_ = {})).distribute = function tt(X, I, O) {
        let y = X, w = y.reducedLen || I, f = (c, e) => c.target - e.target, x = [], s = X.length, l = [], p = x.push, n, a, v, N = !0, B, T, o = 0, u;
        for (n = s; n--; ) o += X[n].size;
        if (o > w) {
          for (q(X, (c, e) => (e.rank || 0) - (c.rank || 0)), v = (u = X[0].rank === X[X.length - 1].rank) ? s / 2 : -1, a = u ? v : s - 1; v && o > w; ) B = X[n = Math.floor(a)], J(l, n) && (o -= B.size), a += v, u && a >= X.length && (v /= 2, a = v);
          l.sort((c, e) => e - c).forEach((c) => p.apply(x, X.splice(c, 1)));
        }
        for (q(X, f), X = X.map((c) => ({ size: c.size, targets: [c.target], align: Z(c.align, 0.5) })); N; ) {
          for (n = X.length; n--; ) B = X[n], T = (Math.min.apply(0, B.targets) + Math.max.apply(0, B.targets)) / 2, B.pos = K(T - B.size * B.align, 0, I - B.size);
          for (n = X.length, N = !1; n--; ) n > 0 && X[n - 1].pos + X[n - 1].size > X[n].pos && (X[n - 1].size += X[n].size, X[n - 1].targets = X[n - 1].targets.concat(X[n].targets), X[n - 1].align = 0.5, X[n - 1].pos + X[n - 1].size > I && (X[n - 1].pos = I - X[n - 1].size), X.splice(n, 1), N = !0);
        }
        return p.apply(y, x), n = 0, X.some((c) => {
          let e = 0;
          return (c.targets || []).some(() => (y[n].pos = c.pos + e, O !== void 0 && Math.abs(y[n].pos - y[n].target) > O ? (y.slice(0, n + 1).forEach((t) => delete t.pos), y.reducedLen = (y.reducedLen || I) - 0.1 * I, y.reducedLen > 0.1 * I && tt(y, I, O), !0) : (e += y[n].size, n++, !1)));
        }), q(y, f), y;
      }, _;
    }), ot(i, "Core/Renderer/SVG/SVGElement.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Color/Color.js"], i["Core/Globals.js"], i["Core/Utilities.js"]], function(U, _, K, Z) {
      let { animate: J, animObject: q, stop: tt } = U, { deg2rad: X, doc: I, svg: O, SVG_NS: y, win: w } = K, { addEvent: f, attr: x, createElement: s, crisp: l, css: p, defined: n, erase: a, extend: v, fireEvent: N, isArray: B, isFunction: T, isObject: o, isString: u, merge: c, objectEach: e, pick: t, pInt: h, pushUnique: b, replaceNested: r, syncTimeout: g, uniqueKey: d } = Z;
      class M {
        _defaultGetter(A) {
          let D = t(this[A + "Value"], this[A], this.element ? this.element.getAttribute(A) : null, 0);
          return /^-?[\d\.]+$/.test(D) && (D = parseFloat(D)), D;
        }
        _defaultSetter(A, D, W) {
          W.setAttribute(D, A);
        }
        add(A) {
          let D, W = this.renderer, G = this.element;
          return A && (this.parentGroup = A), this.textStr !== void 0 && this.element.nodeName === "text" && W.buildText(this), this.added = !0, (!A || A.handleZ || this.zIndex) && (D = this.zIndexSetter()), D || (A ? A.element : W.box).appendChild(G), this.onAdd && this.onAdd(), this;
        }
        addClass(A, D) {
          let W = D ? "" : this.attr("class") || "";
          return (A = (A || "").split(/ /g).reduce(function(G, it) {
            return W.indexOf(it) === -1 && G.push(it), G;
          }, W ? [W] : []).join(" ")) !== W && this.attr("class", A), this;
        }
        afterSetters() {
          this.doTransform && (this.updateTransform(), this.doTransform = !1);
        }
        align(A, D, W, G = !0) {
          let it, C, k, L, F = {}, m = this.renderer, E = m.alignedObjects, P = !!A;
          A ? (this.alignOptions = A, this.alignByTranslate = D, this.alignTo = W) : (A = this.alignOptions || {}, D = this.alignByTranslate, W = this.alignTo);
          let R = !W || u(W) ? W || "renderer" : void 0;
          R && (P && b(E, this), W = void 0);
          let z = t(W, m[R], m), $ = A.align, et = A.verticalAlign;
          return it = (z.x || 0) + (A.x || 0), C = (z.y || 0) + (A.y || 0), $ === "right" ? k = 1 : $ === "center" && (k = 2), k && (it += ((z.width || 0) - (A.width || 0)) / k), F[D ? "translateX" : "x"] = Math.round(it), et === "bottom" ? L = 1 : et === "middle" && (L = 2), L && (C += ((z.height || 0) - (A.height || 0)) / L), F[D ? "translateY" : "y"] = Math.round(C), G && (this[this.placed ? "animate" : "attr"](F), this.placed = !0), this.alignAttr = F, this;
        }
        alignSetter(A) {
          let D = { left: "start", center: "middle", right: "end" };
          D[A] && (this.alignValue = A, this.element.setAttribute("text-anchor", D[A]));
        }
        animate(A, D, W) {
          let G = q(t(D, this.renderer.globalAnimation, !0)), it = G.defer;
          return I.hidden && (G.duration = 0), G.duration !== 0 ? (W && (G.complete = W), g(() => {
            this.element && J(this, A, G);
          }, it)) : (this.attr(A, void 0, W || G.complete), e(A, function(C, k) {
            G.step && G.step.call(this, C, { prop: k, pos: 1, elem: this });
          }, this)), this;
        }
        applyTextOutline(A) {
          let D = this.element;
          A.indexOf("contrast") !== -1 && (A = A.replace(/contrast/g, this.renderer.getContrast(D.style.fill)));
          let W = A.split(" "), G = W[W.length - 1], it = W[0];
          if (it && it !== "none" && K.svg) {
            this.fakeTS = !0, it = it.replace(/(^[\d\.]+)(.*?)$/g, function(m, E, P) {
              return 2 * Number(E) + P;
            }), this.removeTextOutline();
            let C = I.createElementNS(y, "tspan");
            x(C, { class: "highcharts-text-outline", fill: G, stroke: G, "stroke-width": it, "stroke-linejoin": "round" });
            let k = D.querySelector("textPath") || D;
            [].forEach.call(k.childNodes, (m) => {
              let E = m.cloneNode(!0);
              E.removeAttribute && ["fill", "stroke", "stroke-width", "stroke"].forEach((P) => E.removeAttribute(P)), C.appendChild(E);
            });
            let L = 0;
            [].forEach.call(k.querySelectorAll("text tspan"), (m) => {
              L += Number(m.getAttribute("dy"));
            });
            let F = I.createElementNS(y, "tspan");
            F.textContent = "​", x(F, { x: Number(D.getAttribute("x")), dy: -L }), C.appendChild(F), k.insertBefore(C, k.firstChild);
          }
        }
        attr(A, D, W, G) {
          let { element: it } = this, C = M.symbolCustomAttribs, k, L, F = this, m;
          return typeof A == "string" && D !== void 0 && (k = A, (A = {})[k] = D), typeof A == "string" ? F = (this[A + "Getter"] || this._defaultGetter).call(this, A, it) : (e(A, function(E, P) {
            m = !1, G || tt(this, P), this.symbolName && C.indexOf(P) !== -1 && (L || (this.symbolAttr(A), L = !0), m = !0), this.rotation && (P === "x" || P === "y") && (this.doTransform = !0), m || (this[P + "Setter"] || this._defaultSetter).call(this, E, P, it);
          }, this), this.afterSetters()), W && W.call(this), F;
        }
        clip(A) {
          if (A && !A.clipPath) {
            let D = d() + "-", W = this.renderer.createElement("clipPath").attr({ id: D }).add(this.renderer.defs);
            v(A, { clipPath: W, id: D, count: 0 }), A.add(W);
          }
          return this.attr("clip-path", A ? `url(${this.renderer.url}#${A.id})` : "none");
        }
        crisp(A, D) {
          D = Math.round(D || A.strokeWidth || 0);
          let W = A.x || this.x || 0, G = A.y || this.y || 0, it = (A.width || this.width || 0) + W, C = (A.height || this.height || 0) + G, k = l(W, D), L = l(G, D);
          return v(A, { x: k, y: L, width: l(it, D) - k, height: l(C, D) - L }), n(A.strokeWidth) && (A.strokeWidth = D), A;
        }
        complexColor(A, D, W) {
          let G = this.renderer, it, C, k, L, F, m, E, P, R, z, $ = [], et;
          N(this.renderer, "complexColor", { args: arguments }, function() {
            if (A.radialGradient ? C = "radialGradient" : A.linearGradient && (C = "linearGradient"), C) {
              if (k = A[C], F = G.gradients, m = A.stops, R = W.radialReference, B(k) && (A[C] = k = { x1: k[0], y1: k[1], x2: k[2], y2: k[3], gradientUnits: "userSpaceOnUse" }), C === "radialGradient" && R && !n(k.gradientUnits) && (L = k, k = c(k, G.getRadialAttr(R, L), { gradientUnits: "userSpaceOnUse" })), e(k, function(rt, nt) {
                nt !== "id" && $.push(nt, rt);
              }), e(m, function(rt) {
                $.push(rt);
              }), F[$ = $.join(",")]) z = F[$].attr("id");
              else {
                k.id = z = d();
                let rt = F[$] = G.createElement(C).attr(k).add(G.defs);
                rt.radAttr = L, rt.stops = [], m.forEach(function(nt) {
                  nt[1].indexOf("rgba") === 0 ? (E = (it = _.parse(nt[1])).get("rgb"), P = it.get("a")) : (E = nt[1], P = 1);
                  let dt = G.createElement("stop").attr({ offset: nt[0], "stop-color": E, "stop-opacity": P }).add(rt);
                  rt.stops.push(dt);
                });
              }
              et = "url(" + G.url + "#" + z + ")", W.setAttribute(D, et), W.gradient = $, A.toString = function() {
                return et;
              };
            }
          });
        }
        css(A) {
          let D = this.styles, W = {}, G = this.element, it, C = !D;
          if (D && e(A, function(k, L) {
            D && D[L] !== k && (W[L] = k, C = !0);
          }), C) {
            D && (A = v(D, W)), A.width === null || A.width === "auto" ? delete this.textWidth : G.nodeName.toLowerCase() === "text" && A.width && (it = this.textWidth = h(A.width)), v(this.styles, A), it && !O && this.renderer.forExport && delete A.width;
            let k = c(A);
            G.namespaceURI === this.SVG_NS && (["textOutline", "textOverflow", "width"].forEach((L) => k && delete k[L]), k.color && (k.fill = k.color)), p(G, k);
          }
          return this.added && (this.element.nodeName === "text" && this.renderer.buildText(this), A.textOutline && this.applyTextOutline(A.textOutline)), this;
        }
        dashstyleSetter(A) {
          let D, W = this["stroke-width"];
          if (W === "inherit" && (W = 1), A = A && A.toLowerCase()) {
            let G = A.replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");
            for (D = G.length; D--; ) G[D] = "" + h(G[D]) * t(W, NaN);
            A = G.join(",").replace(/NaN/g, "none"), this.element.setAttribute("stroke-dasharray", A);
          }
        }
        destroy() {
          var L;
          let A = this, D = A.element || {}, W = A.renderer, G = D.ownerSVGElement, it = D.nodeName === "SPAN" && A.parentGroup || void 0, C, k;
          if (D.onclick = D.onmouseout = D.onmouseover = D.onmousemove = D.point = null, tt(A), A.clipPath && G) {
            let F = A.clipPath;
            [].forEach.call(G.querySelectorAll("[clip-path],[CLIP-PATH]"), function(m) {
              m.getAttribute("clip-path").indexOf(F.element.id) > -1 && m.removeAttribute("clip-path");
            }), A.clipPath = F.destroy();
          }
          if (A.connector = (L = A.connector) == null ? void 0 : L.destroy(), A.stops) {
            for (k = 0; k < A.stops.length; k++) A.stops[k].destroy();
            A.stops.length = 0, A.stops = void 0;
          }
          for (A.safeRemoveChild(D); it && it.div && it.div.childNodes.length === 0; ) C = it.parentGroup, A.safeRemoveChild(it.div), delete it.div, it = C;
          A.alignOptions && a(W.alignedObjects, A), e(A, function(F, m) {
            A[m] && A[m].parentGroup === A && A[m].destroy && A[m].destroy(), delete A[m];
          });
        }
        dSetter(A, D, W) {
          B(A) && (typeof A[0] == "string" && (A = this.renderer.pathToSegments(A)), this.pathArray = A, A = A.reduce((G, it, C) => it && it.join ? (C ? G + " " : "") + it.join(" ") : (it || "").toString(), "")), /(NaN| {2}|^$)/.test(A) && (A = "M 0 0"), this[D] !== A && (W.setAttribute(D, A), this[D] = A);
        }
        fillSetter(A, D, W) {
          typeof A == "string" ? W.setAttribute(D, A) : A && this.complexColor(A, D, W);
        }
        hrefSetter(A, D, W) {
          W.setAttributeNS("http://www.w3.org/1999/xlink", D, A);
        }
        getBBox(A, D) {
          let W, G, it, C, { alignValue: k, element: L, renderer: F, styles: m, textStr: E } = this, { cache: P, cacheKeys: R } = F, z = L.namespaceURI === this.SVG_NS, $ = t(D, this.rotation, 0), et = F.styledMode ? L && M.prototype.getStyle.call(L, "font-size") : m.fontSize;
          if (n(E) && ((C = E.toString()).indexOf("<") === -1 && (C = C.replace(/\d/g, "0")), C += ["", F.rootFontSize, et, $, this.textWidth, k, m.textOverflow, m.fontWeight].join(",")), C && !A && (W = P[C]), !W || W.polygon) {
            if (z || F.forExport) {
              try {
                it = this.fakeTS && function(nt) {
                  let dt = L.querySelector(".highcharts-text-outline");
                  dt && p(dt, { display: nt });
                }, T(it) && it("none"), W = L.getBBox ? v({}, L.getBBox()) : { width: L.offsetWidth, height: L.offsetHeight, x: 0, y: 0 }, T(it) && it("");
              } catch {
              }
              (!W || W.width < 0) && (W = { x: 0, y: 0, width: 0, height: 0 });
            } else W = this.htmlGetBBox();
            G = W.height, z && (W.height = G = { "11px,17": 14, "13px,20": 16 }[`${et || ""},${Math.round(G)}`] || G), $ && (W = this.getRotatedBox(W, $));
            let rt = { bBox: W };
            N(this, "afterGetBBox", rt), W = rt.bBox;
          }
          if (C && (E === "" || W.height > 0)) {
            for (; R.length > 250; ) delete P[R.shift()];
            P[C] || R.push(C), P[C] = W;
          }
          return W;
        }
        getRotatedBox(A, D) {
          let { x: W, y: G, width: it, height: C } = A, { alignValue: k, translateY: L, rotationOriginX: F = 0, rotationOriginY: m = 0 } = this, E = { right: 1, center: 0.5 }[k || 0] || 0, P = Number(this.element.getAttribute("y") || 0) - (L ? 0 : G), R = D * X, z = (D - 90) * X, $ = Math.cos(R), et = Math.sin(R), rt = it * $, nt = it * et, dt = Math.cos(z), ct = Math.sin(z), [[V, Y], [Q, st]] = [F, m].map((Ct) => [Ct - Ct * $, Ct * et]), at = W + E * (it - rt) + V + st + P * dt, ht = at + rt, lt = ht - C * dt, ut = lt - rt, pt = G + P - E * nt - Y + Q + P * ct, ft = pt + nt, gt = ft - C * ct, mt = gt - nt, yt = Math.min(at, ht, lt, ut), wt = Math.min(pt, ft, gt, mt), xt = Math.max(at, ht, lt, ut) - yt, bt = Math.max(pt, ft, gt, mt) - wt;
          return { x: yt, y: wt, width: xt, height: bt, polygon: [[at, pt], [ht, ft], [lt, gt], [ut, mt]] };
        }
        getStyle(A) {
          return w.getComputedStyle(this.element || this, "").getPropertyValue(A);
        }
        hasClass(A) {
          return ("" + this.attr("class")).split(" ").indexOf(A) !== -1;
        }
        hide() {
          return this.attr({ visibility: "hidden" });
        }
        htmlGetBBox() {
          return { height: 0, width: 0, x: 0, y: 0 };
        }
        constructor(A, D) {
          this.onEvents = {}, this.opacity = 1, this.SVG_NS = y, this.element = D === "span" || D === "body" ? s(D) : I.createElementNS(this.SVG_NS, D), this.renderer = A, this.styles = {}, N(this, "afterInit");
        }
        on(A, D) {
          let { onEvents: W } = this;
          return W[A] && W[A](), W[A] = f(this.element, A, D), this;
        }
        opacitySetter(A, D, W) {
          let G = Number(Number(A).toFixed(3));
          this.opacity = G, W.setAttribute(D, G);
        }
        reAlign() {
          var A;
          (A = this.alignOptions) != null && A.width && this.alignOptions.align !== "left" && (this.alignOptions.width = this.getBBox().width, this.placed = !1, this.align());
        }
        removeClass(A) {
          return this.attr("class", ("" + this.attr("class")).replace(u(A) ? RegExp(`(^| )${A}( |$)`) : A, " ").replace(/ +/g, " ").trim());
        }
        removeTextOutline() {
          let A = this.element.querySelector("tspan.highcharts-text-outline");
          A && this.safeRemoveChild(A);
        }
        safeRemoveChild(A) {
          let D = A.parentNode;
          D && D.removeChild(A);
        }
        setRadialReference(A) {
          let D = this.element.gradient && this.renderer.gradients[this.element.gradient];
          return this.element.radialReference = A, D && D.radAttr && D.animate(this.renderer.getRadialAttr(A, D.radAttr)), this;
        }
        shadow(A) {
          var it;
          let { renderer: D } = this, W = c(((it = this.parentGroup) == null ? void 0 : it.rotation) === 90 ? { offsetX: -1, offsetY: -1 } : {}, o(A) ? A : {}), G = D.shadowDefinition(W);
          return this.attr({ filter: A ? `url(${D.url}#${G})` : "none" });
        }
        show(A = !0) {
          return this.attr({ visibility: A ? "inherit" : "visible" });
        }
        "stroke-widthSetter"(A, D, W) {
          this[D] = A, W.setAttribute(D, A);
        }
        strokeWidth() {
          if (!this.renderer.styledMode) return this["stroke-width"] || 0;
          let A = this.getStyle("stroke-width"), D = 0, W;
          return /px$/.test(A) ? D = h(A) : A !== "" && (x(W = I.createElementNS(y, "rect"), { width: A, "stroke-width": 0 }), this.element.parentNode.appendChild(W), D = W.getBBox().width, W.parentNode.removeChild(W)), D;
        }
        symbolAttr(A) {
          let D = this;
          M.symbolCustomAttribs.forEach(function(W) {
            D[W] = t(A[W], D[W]);
          }), D.attr({ d: D.renderer.symbols[D.symbolName](D.x, D.y, D.width, D.height, D) });
        }
        textSetter(A) {
          A !== this.textStr && (delete this.textPxLength, this.textStr = A, this.added && this.renderer.buildText(this), this.reAlign());
        }
        titleSetter(A) {
          let D = this.element, W = D.getElementsByTagName("title")[0] || I.createElementNS(this.SVG_NS, "title");
          D.insertBefore ? D.insertBefore(W, D.firstChild) : D.appendChild(W), W.textContent = r(t(A, ""), [/<[^>]*>/g, ""]).replace(/&lt;/g, "<").replace(/&gt;/g, ">");
        }
        toFront() {
          let A = this.element;
          return A.parentNode.appendChild(A), this;
        }
        translate(A, D) {
          return this.attr({ translateX: A, translateY: D });
        }
        updateTransform(A = "transform") {
          var P;
          let { element: D, matrix: W, rotation: G = 0, rotationOriginX: it, rotationOriginY: C, scaleX: k, scaleY: L, translateX: F = 0, translateY: m = 0 } = this, E = ["translate(" + F + "," + m + ")"];
          n(W) && E.push("matrix(" + W.join(",") + ")"), G && (E.push("rotate(" + G + " " + t(it, D.getAttribute("x"), 0) + " " + t(C, D.getAttribute("y") || 0) + ")"), ((P = this.text) == null ? void 0 : P.element.tagName) === "SPAN" && this.text.attr({ rotation: G, rotationOriginX: (it || 0) - this.padding, rotationOriginY: (C || 0) - this.padding })), (n(k) || n(L)) && E.push("scale(" + t(k, 1) + " " + t(L, 1) + ")"), E.length && !(this.text || this).textPath && D.setAttribute(A, E.join(" "));
        }
        visibilitySetter(A, D, W) {
          A === "inherit" ? W.removeAttribute(D) : this[D] !== A && W.setAttribute(D, A), this[D] = A;
        }
        xGetter(A) {
          return this.element.nodeName === "circle" && (A === "x" ? A = "cx" : A === "y" && (A = "cy")), this._defaultGetter(A);
        }
        zIndexSetter(A, D) {
          let W = this.renderer, G = this.parentGroup, it = (G || W).element || W.box, C = this.element, k = it === W.box, L, F, m, E = !1, P, R = this.added, z;
          if (n(A) ? (C.setAttribute("data-z-index", A), A = +A, this[D] === A && (R = !1)) : n(this[D]) && C.removeAttribute("data-z-index"), this[D] = A, R) {
            for ((A = this.zIndex) && G && (G.handleZ = !0), z = (L = it.childNodes).length - 1; z >= 0 && !E; z--) P = !n(m = (F = L[z]).getAttribute("data-z-index")), F !== C && (A < 0 && P && !k && !z ? (it.insertBefore(C, L[z]), E = !0) : (h(m) <= A || P && (!n(A) || A >= 0)) && (it.insertBefore(C, L[z + 1]), E = !0));
            E || (it.insertBefore(C, L[k ? 3 : 0]), E = !0);
          }
          return E;
        }
      }
      return M.symbolCustomAttribs = ["anchorX", "anchorY", "clockwise", "end", "height", "innerR", "r", "start", "width", "x", "y"], M.prototype.strokeSetter = M.prototype.fillSetter, M.prototype.yGetter = M.prototype.xGetter, M.prototype.matrixSetter = M.prototype.rotationOriginXSetter = M.prototype.rotationOriginYSetter = M.prototype.rotationSetter = M.prototype.scaleXSetter = M.prototype.scaleYSetter = M.prototype.translateXSetter = M.prototype.translateYSetter = M.prototype.verticalAlignSetter = function(H, A) {
        this[A] = H, this.doTransform = !0;
      }, M;
    }), ot(i, "Core/Renderer/SVG/SVGLabel.js", [i["Core/Renderer/SVG/SVGElement.js"], i["Core/Utilities.js"]], function(U, _) {
      let { defined: K, extend: Z, isNumber: J, merge: q, pick: tt, removeEvent: X } = _;
      class I extends U {
        constructor(y, w, f, x, s, l, p, n, a, v) {
          let N;
          super(y, "g"), this.paddingLeftSetter = this.paddingSetter, this.paddingRightSetter = this.paddingSetter, this.doUpdate = !1, this.textStr = w, this.x = f, this.y = x, this.anchorX = l, this.anchorY = p, this.baseline = a, this.className = v, this.addClass(v === "button" ? "highcharts-no-tooltip" : "highcharts-label"), v && this.addClass("highcharts-" + v), this.text = y.text(void 0, 0, 0, n).attr({ zIndex: 1 }), typeof s == "string" && ((N = /^url\((.*?)\)$/.test(s)) || this.renderer.symbols[s]) && (this.symbolKey = s), this.bBox = I.emptyBBox, this.padding = 3, this.baselineOffset = 0, this.needsBox = y.styledMode || N, this.deferredAttr = {}, this.alignFactor = 0;
        }
        alignSetter(y) {
          let w = { left: 0, center: 0.5, right: 1 }[y];
          w !== this.alignFactor && (this.alignFactor = w, this.bBox && J(this.xSetting) && this.attr({ x: this.xSetting }));
        }
        anchorXSetter(y, w) {
          this.anchorX = y, this.boxAttr(w, Math.round(y) - this.getCrispAdjust() - this.xSetting);
        }
        anchorYSetter(y, w) {
          this.anchorY = y, this.boxAttr(w, y - this.ySetting);
        }
        boxAttr(y, w) {
          this.box ? this.box.attr(y, w) : this.deferredAttr[y] = w;
        }
        css(y) {
          if (y) {
            let w = {};
            y = q(y), I.textProps.forEach((f) => {
              y[f] !== void 0 && (w[f] = y[f], delete y[f]);
            }), this.text.css(w), "fontSize" in w || "fontWeight" in w ? this.updateTextPadding() : ("width" in w || "textOverflow" in w) && this.updateBoxSize();
          }
          return U.prototype.css.call(this, y);
        }
        destroy() {
          X(this.element, "mouseenter"), X(this.element, "mouseleave"), this.text && this.text.destroy(), this.box && (this.box = this.box.destroy()), U.prototype.destroy.call(this);
        }
        fillSetter(y, w) {
          y && (this.needsBox = !0), this.fill = y, this.boxAttr(w, y);
        }
        getBBox(y, w) {
          this.textStr && this.bBox.width === 0 && this.bBox.height === 0 && this.updateBoxSize();
          let { padding: f, height: x = 0, translateX: s = 0, translateY: l = 0, width: p = 0 } = this, n = tt(this.paddingLeft, f), a = w != null ? w : this.rotation || 0, v = { width: p, height: x, x: s + this.bBox.x - n, y: l + this.bBox.y - f + this.baselineOffset };
          return a && (v = this.getRotatedBox(v, a)), v;
        }
        getCrispAdjust() {
          return (this.renderer.styledMode && this.box ? this.box.strokeWidth() : this["stroke-width"] ? parseInt(this["stroke-width"], 10) : 0) % 2 / 2;
        }
        heightSetter(y) {
          this.heightSetting = y, this.doUpdate = !0;
        }
        afterSetters() {
          super.afterSetters(), this.doUpdate && (this.updateBoxSize(), this.doUpdate = !1);
        }
        onAdd() {
          this.text.add(this), this.attr({ text: tt(this.textStr, ""), x: this.x || 0, y: this.y || 0 }), this.box && K(this.anchorX) && this.attr({ anchorX: this.anchorX, anchorY: this.anchorY });
        }
        paddingSetter(y, w) {
          J(y) ? y !== this[w] && (this[w] = y, this.updateTextPadding()) : this[w] = void 0;
        }
        rSetter(y, w) {
          this.boxAttr(w, y);
        }
        strokeSetter(y, w) {
          this.stroke = y, this.boxAttr(w, y);
        }
        "stroke-widthSetter"(y, w) {
          y && (this.needsBox = !0), this["stroke-width"] = y, this.boxAttr(w, y);
        }
        "text-alignSetter"(y) {
          this.textAlign = y;
        }
        textSetter(y) {
          y !== void 0 && this.text.attr({ text: y }), this.updateTextPadding(), this.reAlign();
        }
        updateBoxSize() {
          let y, w = this.text, f = {}, x = this.padding, s = this.bBox = (!J(this.widthSetting) || !J(this.heightSetting) || this.textAlign) && K(w.textStr) ? w.getBBox(void 0, 0) : I.emptyBBox;
          this.width = this.getPaddedWidth(), this.height = (this.heightSetting || s.height || 0) + 2 * x;
          let l = this.renderer.fontMetrics(w);
          if (this.baselineOffset = x + Math.min((this.text.firstLineMetrics || l).b, s.height || 1 / 0), this.heightSetting && (this.baselineOffset += (this.heightSetting - l.h) / 2), this.needsBox && !w.textPath) {
            if (!this.box) {
              let p = this.box = this.symbolKey ? this.renderer.symbol(this.symbolKey) : this.renderer.rect();
              p.addClass((this.className === "button" ? "" : "highcharts-label-box") + (this.className ? " highcharts-" + this.className + "-box" : "")), p.add(this);
            }
            y = this.getCrispAdjust(), f.x = y, f.y = (this.baseline ? -this.baselineOffset : 0) + y, f.width = Math.round(this.width), f.height = Math.round(this.height), this.box.attr(Z(f, this.deferredAttr)), this.deferredAttr = {};
          }
        }
        updateTextPadding() {
          let y = this.text;
          if (!y.textPath) {
            this.updateBoxSize();
            let w = this.baseline ? 0 : this.baselineOffset, f = tt(this.paddingLeft, this.padding);
            K(this.widthSetting) && this.bBox && (this.textAlign === "center" || this.textAlign === "right") && (f += { center: 0.5, right: 1 }[this.textAlign] * (this.widthSetting - this.bBox.width)), (f !== y.x || w !== y.y) && (y.attr("x", f), y.hasBoxWidthChanged && (this.bBox = y.getBBox(!0)), w !== void 0 && y.attr("y", w)), y.x = f, y.y = w;
          }
        }
        widthSetter(y) {
          this.widthSetting = J(y) ? y : void 0, this.doUpdate = !0;
        }
        getPaddedWidth() {
          let y = this.padding, w = tt(this.paddingLeft, y), f = tt(this.paddingRight, y);
          return (this.widthSetting || this.bBox.width || 0) + w + f;
        }
        xSetter(y) {
          this.x = y, this.alignFactor && (y -= this.alignFactor * this.getPaddedWidth(), this["forceAnimate:x"] = !0), this.xSetting = Math.round(y), this.attr("translateX", this.xSetting);
        }
        ySetter(y) {
          this.ySetting = this.y = Math.round(y), this.attr("translateY", this.ySetting);
        }
      }
      return I.emptyBBox = { width: 0, height: 0, x: 0, y: 0 }, I.textProps = ["color", "direction", "fontFamily", "fontSize", "fontStyle", "fontWeight", "lineHeight", "textAlign", "textDecoration", "textOutline", "textOverflow", "whiteSpace", "width"], I;
    }), ot(i, "Core/Renderer/SVG/Symbols.js", [i["Core/Utilities.js"]], function(U) {
      let { defined: _, isNumber: K, pick: Z } = U;
      function J(X, I, O, y, w) {
        let f = [];
        if (w) {
          let x = w.start || 0, s = Z(w.r, O), l = Z(w.r, y || O), p = 2e-4 / (w.borderRadius ? 1 : Math.max(s, 1)), n = Math.abs((w.end || 0) - x - 2 * Math.PI) < p, a = (w.end || 0) - (n ? p : 0), v = w.innerR, N = Z(w.open, n), B = Math.cos(x), T = Math.sin(x), o = Math.cos(a), u = Math.sin(a), c = Z(w.longArc, a - x - Math.PI < p ? 0 : 1), e = ["A", s, l, 0, c, Z(w.clockwise, 1), X + s * o, I + l * u];
          e.params = { start: x, end: a, cx: X, cy: I }, f.push(["M", X + s * B, I + l * T], e), _(v) && ((e = ["A", v, v, 0, c, _(w.clockwise) ? 1 - w.clockwise : 0, X + v * B, I + v * T]).params = { start: a, end: x, cx: X, cy: I }, f.push(N ? ["M", X + v * o, I + v * u] : ["L", X + v * o, I + v * u], e)), N || f.push(["Z"]);
        }
        return f;
      }
      function q(X, I, O, y, w) {
        return w && w.r ? tt(X, I, O, y, w) : [["M", X, I], ["L", X + O, I], ["L", X + O, I + y], ["L", X, I + y], ["Z"]];
      }
      function tt(X, I, O, y, w) {
        let f = (w == null ? void 0 : w.r) || 0;
        return [["M", X + f, I], ["L", X + O - f, I], ["A", f, f, 0, 0, 1, X + O, I + f], ["L", X + O, I + y - f], ["A", f, f, 0, 0, 1, X + O - f, I + y], ["L", X + f, I + y], ["A", f, f, 0, 0, 1, X, I + y - f], ["L", X, I + f], ["A", f, f, 0, 0, 1, X + f, I], ["Z"]];
      }
      return { arc: J, callout: function(X, I, O, y, w) {
        let f = Math.min(w && w.r || 0, O, y), x = f + 6, s = w && w.anchorX, l = w && w.anchorY || 0, p = tt(X, I, O, y, { r: f });
        if (!K(s) || s < O && s > 0 && l < y && l > 0) return p;
        if (X + s > O - x)
          if (l > I + x && l < I + y - x) p.splice(3, 1, ["L", X + O, l - 6], ["L", X + O + 6, l], ["L", X + O, l + 6], ["L", X + O, I + y - f]);
          else if (s < O) {
            let n = l < I + x, a = n ? I : I + y;
            p.splice(n ? 2 : 5, 0, ["L", s, l], ["L", X + O - f, a]);
          } else p.splice(3, 1, ["L", X + O, y / 2], ["L", s, l], ["L", X + O, y / 2], ["L", X + O, I + y - f]);
        else if (X + s < x)
          if (l > I + x && l < I + y - x) p.splice(7, 1, ["L", X, l + 6], ["L", X - 6, l], ["L", X, l - 6], ["L", X, I + f]);
          else if (s > 0) {
            let n = l < I + x, a = n ? I : I + y;
            p.splice(n ? 1 : 6, 0, ["L", s, l], ["L", X + f, a]);
          } else p.splice(7, 1, ["L", X, y / 2], ["L", s, l], ["L", X, y / 2], ["L", X, I + f]);
        else l > y && s < O - x ? p.splice(5, 1, ["L", s + 6, I + y], ["L", s, I + y + 6], ["L", s - 6, I + y], ["L", X + f, I + y]) : l < 0 && s > x && p.splice(1, 1, ["L", s - 6, I], ["L", s, I - 6], ["L", s + 6, I], ["L", O - f, I]);
        return p;
      }, circle: function(X, I, O, y) {
        return J(X + O / 2, I + y / 2, O / 2, y / 2, { start: 0.5 * Math.PI, end: 2.5 * Math.PI, open: !1 });
      }, diamond: function(X, I, O, y) {
        return [["M", X + O / 2, I], ["L", X + O, I + y / 2], ["L", X + O / 2, I + y], ["L", X, I + y / 2], ["Z"]];
      }, rect: q, roundedRect: tt, square: q, triangle: function(X, I, O, y) {
        return [["M", X + O / 2, I], ["L", X + O, I + y], ["L", X, I + y], ["Z"]];
      }, "triangle-down": function(X, I, O, y) {
        return [["M", X, I], ["L", X + O, I], ["L", X + O / 2, I + y], ["Z"]];
      } };
    }), ot(i, "Core/Renderer/SVG/TextBuilder.js", [i["Core/Renderer/HTML/AST.js"], i["Core/Globals.js"], i["Core/Utilities.js"]], function(U, _, K) {
      let { doc: Z, SVG_NS: J, win: q } = _, { attr: tt, extend: X, fireEvent: I, isString: O, objectEach: y, pick: w } = K;
      return class {
        constructor(f) {
          let x = f.styles;
          this.renderer = f.renderer, this.svgElement = f, this.width = f.textWidth, this.textLineHeight = x && x.lineHeight, this.textOutline = x && x.textOutline, this.ellipsis = !!(x && x.textOverflow === "ellipsis"), this.noWrap = !!(x && x.whiteSpace === "nowrap");
        }
        buildSVG() {
          let f = this.svgElement, x = f.element, s = f.renderer, l = w(f.textStr, "").toString(), p = l.indexOf("<") !== -1, n = x.childNodes, a = !f.added && s.box, v = [l, this.ellipsis, this.noWrap, this.textLineHeight, this.textOutline, f.getStyle("font-size"), this.width].join(",");
          if (v !== f.textCache) {
            f.textCache = v, delete f.actualWidth;
            for (let N = n.length; N--; ) x.removeChild(n[N]);
            if (p || this.ellipsis || this.width || f.textPath || l.indexOf(" ") !== -1 && (!this.noWrap || /<br.*?>/g.test(l))) {
              if (l !== "") {
                a && a.appendChild(x);
                let N = new U(l);
                this.modifyTree(N.nodes), N.addToDOM(x), this.modifyDOM(), this.ellipsis && (x.textContent || "").indexOf("…") !== -1 && f.attr("title", this.unescapeEntities(f.textStr || "", ["&lt;", "&gt;"])), a && a.removeChild(x);
              }
            } else x.appendChild(Z.createTextNode(this.unescapeEntities(l)));
            O(this.textOutline) && f.applyTextOutline && f.applyTextOutline(this.textOutline);
          }
        }
        modifyDOM() {
          let f, x = this.svgElement, s = tt(x.element, "x");
          for (x.firstLineMetrics = void 0; (f = x.element.firstChild) && /^[\s\u200B]*$/.test(f.textContent || " "); ) x.element.removeChild(f);
          [].forEach.call(x.element.querySelectorAll("tspan.highcharts-br"), (a, v) => {
            a.nextSibling && a.previousSibling && (v === 0 && a.previousSibling.nodeType === 1 && (x.firstLineMetrics = x.renderer.fontMetrics(a.previousSibling)), tt(a, { dy: this.getLineHeight(a.nextSibling), x: s }));
          });
          let l = this.width || 0;
          if (!l) return;
          let p = (a, v) => {
            let N = a.textContent || "", B = N.replace(/([^\^])-/g, "$1- ").split(" "), T = !this.noWrap && (B.length > 1 || x.element.childNodes.length > 1), o = this.getLineHeight(v), u = 0, c = x.actualWidth;
            if (this.ellipsis) N && this.truncate(a, N, void 0, 0, Math.max(0, l - 0.8 * o), (e, t) => e.substring(0, t) + "…");
            else if (T) {
              let e = [], t = [];
              for (; v.firstChild && v.firstChild !== a; ) t.push(v.firstChild), v.removeChild(v.firstChild);
              for (; B.length; ) B.length && !this.noWrap && u > 0 && (e.push(a.textContent || ""), a.textContent = B.join(" ").replace(/- /g, "-")), this.truncate(a, void 0, B, u === 0 && c || 0, l, (h, b) => B.slice(0, b).join(" ").replace(/- /g, "-")), c = x.actualWidth, u++;
              t.forEach((h) => {
                v.insertBefore(h, a);
              }), e.forEach((h) => {
                v.insertBefore(Z.createTextNode(h), a);
                let b = Z.createElementNS(J, "tspan");
                b.textContent = "​", tt(b, { dy: o, x: s }), v.insertBefore(b, a);
              });
            }
          }, n = (a) => {
            [].slice.call(a.childNodes).forEach((v) => {
              v.nodeType === q.Node.TEXT_NODE ? p(v, a) : (v.className.baseVal.indexOf("highcharts-br") !== -1 && (x.actualWidth = 0), n(v));
            });
          };
          n(x.element);
        }
        getLineHeight(f) {
          let x = f.nodeType === q.Node.TEXT_NODE ? f.parentElement : f;
          return this.textLineHeight ? parseInt(this.textLineHeight.toString(), 10) : this.renderer.fontMetrics(x || this.svgElement.element).h;
        }
        modifyTree(f) {
          let x = (s, l) => {
            let { attributes: p = {}, children: n, style: a = {}, tagName: v } = s, N = this.renderer.styledMode;
            if (v === "b" || v === "strong" ? N ? p.class = "highcharts-strong" : a.fontWeight = "bold" : (v === "i" || v === "em") && (N ? p.class = "highcharts-emphasized" : a.fontStyle = "italic"), a && a.color && (a.fill = a.color), v === "br") {
              p.class = "highcharts-br", s.textContent = "​";
              let B = f[l + 1];
              B && B.textContent && (B.textContent = B.textContent.replace(/^ +/gm, ""));
            } else v === "a" && n && n.some((B) => B.tagName === "#text") && (s.children = [{ children: n, tagName: "tspan" }]);
            v !== "#text" && v !== "a" && (s.tagName = "tspan"), X(s, { attributes: p, style: a }), n && n.filter((B) => B.tagName !== "#text").forEach(x);
          };
          f.forEach(x), I(this.svgElement, "afterModifyTree", { nodes: f });
        }
        truncate(f, x, s, l, p, n) {
          let a, v, N = this.svgElement, { rotation: B } = N, T = [], o = s ? 1 : 0, u = (x || s || "").length, c = u, e = function(t, h) {
            let b = h || t, r = f.parentNode;
            if (r && T[b] === void 0 && r.getSubStringLength) try {
              T[b] = l + r.getSubStringLength(0, s ? b + 1 : b);
            } catch {
            }
            return T[b];
          };
          if (N.rotation = 0, l + (v = e(f.textContent.length)) > p) {
            for (; o <= u; ) c = Math.ceil((o + u) / 2), s && (a = n(s, c)), v = e(c, a && a.length - 1), o === u ? o = u + 1 : v > p ? u = c - 1 : o = c;
            u === 0 ? f.textContent = "" : x && u === x.length - 1 || (f.textContent = a || n(x || s, c));
          }
          s && s.splice(0, c), N.actualWidth = v, N.rotation = B;
        }
        unescapeEntities(f, x) {
          return y(this.renderer.escapes, function(s, l) {
            x && x.indexOf(s) !== -1 || (f = f.toString().replace(RegExp(s, "g"), l));
          }), f;
        }
      };
    }), ot(i, "Core/Renderer/SVG/SVGRenderer.js", [i["Core/Renderer/HTML/AST.js"], i["Core/Defaults.js"], i["Core/Color/Color.js"], i["Core/Globals.js"], i["Core/Renderer/RendererRegistry.js"], i["Core/Renderer/SVG/SVGElement.js"], i["Core/Renderer/SVG/SVGLabel.js"], i["Core/Renderer/SVG/Symbols.js"], i["Core/Renderer/SVG/TextBuilder.js"], i["Core/Utilities.js"]], function(U, _, K, Z, J, q, tt, X, I, O) {
      let y, { defaultOptions: w } = _, { charts: f, deg2rad: x, doc: s, isFirefox: l, isMS: p, isWebKit: n, noop: a, SVG_NS: v, symbolSizes: N, win: B } = Z, { addEvent: T, attr: o, createElement: u, crisp: c, css: e, defined: t, destroyObjectProperties: h, extend: b, isArray: r, isNumber: g, isObject: d, isString: M, merge: H, pick: A, pInt: D, replaceNested: W, uniqueKey: G } = O;
      class it {
        constructor(k, L, F, m, E, P, R) {
          let z, $, et = this.createElement("svg").attr({ version: "1.1", class: "highcharts-root" }), rt = et.element;
          R || et.css(this.getStyle(m || {})), k.appendChild(rt), o(k, "dir", "ltr"), k.innerHTML.indexOf("xmlns") === -1 && o(rt, "xmlns", this.SVG_NS), this.box = rt, this.boxWrapper = et, this.alignedObjects = [], this.url = this.getReferenceURL(), this.createElement("desc").add().element.appendChild(s.createTextNode("Created with Highcharts 11.4.8")), this.defs = this.createElement("defs").add(), this.allowHTML = P, this.forExport = E, this.styledMode = R, this.gradients = {}, this.cache = {}, this.cacheKeys = [], this.imgCount = 0, this.rootFontSize = et.getStyle("font-size"), this.setSize(L, F, !1), l && k.getBoundingClientRect && ((z = function() {
            e(k, { left: 0, top: 0 }), $ = k.getBoundingClientRect(), e(k, { left: Math.ceil($.left) - $.left + "px", top: Math.ceil($.top) - $.top + "px" });
          })(), this.unSubPixelFix = T(B, "resize", z));
        }
        definition(k) {
          return new U([k]).addToDOM(this.defs.element);
        }
        getReferenceURL() {
          if ((l || n) && s.getElementsByTagName("base").length) {
            if (!t(y)) {
              let k = G(), L = new U([{ tagName: "svg", attributes: { width: 8, height: 8 }, children: [{ tagName: "defs", children: [{ tagName: "clipPath", attributes: { id: k }, children: [{ tagName: "rect", attributes: { width: 4, height: 4 } }] }] }, { tagName: "rect", attributes: { id: "hitme", width: 8, height: 8, "clip-path": `url(#${k})`, fill: "rgba(0,0,0,0.001)" } }] }]).addToDOM(s.body);
              e(L, { position: "fixed", top: 0, left: 0, zIndex: 9e5 });
              let F = s.elementFromPoint(6, 6);
              y = (F && F.id) === "hitme", s.body.removeChild(L);
            }
            if (y) return W(B.location.href.split("#")[0], [/<[^>]*>/g, ""], [/([\('\)])/g, "\\$1"], [/ /g, "%20"]);
          }
          return "";
        }
        getStyle(k) {
          return this.style = b({ fontFamily: "Helvetica, Arial, sans-serif", fontSize: "1rem" }, k), this.style;
        }
        setStyle(k) {
          this.boxWrapper.css(this.getStyle(k));
        }
        isHidden() {
          return !this.boxWrapper.getBBox().width;
        }
        destroy() {
          let k = this.defs;
          return this.box = null, this.boxWrapper = this.boxWrapper.destroy(), h(this.gradients || {}), this.gradients = null, this.defs = k.destroy(), this.unSubPixelFix && this.unSubPixelFix(), this.alignedObjects = null, null;
        }
        createElement(k) {
          return new this.Element(this, k);
        }
        getRadialAttr(k, L) {
          return { cx: k[0] - k[2] / 2 + (L.cx || 0) * k[2], cy: k[1] - k[2] / 2 + (L.cy || 0) * k[2], r: (L.r || 0) * k[2] };
        }
        shadowDefinition(k) {
          let L = [`highcharts-drop-shadow-${this.chartIndex}`, ...Object.keys(k).map((m) => `${m}-${k[m]}`)].join("-").toLowerCase().replace(/[^a-z\d\-]/g, ""), F = H({ color: "#000000", offsetX: 1, offsetY: 1, opacity: 0.15, width: 5 }, k);
          return this.defs.element.querySelector(`#${L}`) || this.definition({ tagName: "filter", attributes: { id: L, filterUnits: F.filterUnits }, children: this.getShadowFilterContent(F) }), L;
        }
        getShadowFilterContent(k) {
          return [{ tagName: "feDropShadow", attributes: { dx: k.offsetX, dy: k.offsetY, "flood-color": k.color, "flood-opacity": Math.min(5 * k.opacity, 1), stdDeviation: k.width / 2 } }];
        }
        buildText(k) {
          new I(k).buildSVG();
        }
        getContrast(k) {
          let L = K.parse(k).rgba.map((m) => {
            let E = m / 255;
            return E <= 0.03928 ? E / 12.92 : Math.pow((E + 0.055) / 1.055, 2.4);
          }), F = 0.2126 * L[0] + 0.7152 * L[1] + 0.0722 * L[2];
          return 1.05 / (F + 0.05) > (F + 0.05) / 0.05 ? "#FFFFFF" : "#000000";
        }
        button(k, L, F, m, E = {}, P, R, z, $, et) {
          let rt = this.label(k, L, F, $, void 0, void 0, et, void 0, "button"), nt = this.styledMode, dt = arguments, ct = 0;
          E = H(w.global.buttonTheme, E), nt && (delete E.fill, delete E.stroke, delete E["stroke-width"]);
          let V = E.states || {}, Y = E.style || {};
          delete E.states, delete E.style;
          let Q = [U.filterUserAttributes(E)], st = [Y];
          return nt || ["hover", "select", "disabled"].forEach((at, ht) => {
            Q.push(H(Q[0], U.filterUserAttributes(dt[ht + 5] || V[at] || {}))), st.push(Q[ht + 1].style), delete Q[ht + 1].style;
          }), T(rt.element, p ? "mouseover" : "mouseenter", function() {
            ct !== 3 && rt.setState(1);
          }), T(rt.element, p ? "mouseout" : "mouseleave", function() {
            ct !== 3 && rt.setState(ct);
          }), rt.setState = (at = 0) => {
            if (at !== 1 && (rt.state = ct = at), rt.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + ["normal", "hover", "pressed", "disabled"][at]), !nt) {
              rt.attr(Q[at]);
              let ht = st[at];
              d(ht) && rt.css(ht);
            }
          }, rt.attr(Q[0]), !nt && (rt.css(b({ cursor: "default" }, Y)), et && rt.text.css({ pointerEvents: "none" })), rt.on("touchstart", (at) => at.stopPropagation()).on("click", function(at) {
            ct !== 3 && m.call(rt, at);
          });
        }
        crispLine(k, L) {
          let [F, m] = k;
          return t(F[1]) && F[1] === m[1] && (F[1] = m[1] = c(F[1], L)), t(F[2]) && F[2] === m[2] && (F[2] = m[2] = c(F[2], L)), k;
        }
        path(k) {
          let L = this.styledMode ? {} : { fill: "none" };
          return r(k) ? L.d = k : d(k) && b(L, k), this.createElement("path").attr(L);
        }
        circle(k, L, F) {
          let m = d(k) ? k : k === void 0 ? {} : { x: k, y: L, r: F }, E = this.createElement("circle");
          return E.xSetter = E.ySetter = function(P, R, z) {
            z.setAttribute("c" + R, P);
          }, E.attr(m);
        }
        arc(k, L, F, m, E, P) {
          let R;
          d(k) ? (L = (R = k).y, F = R.r, m = R.innerR, E = R.start, P = R.end, k = R.x) : R = { innerR: m, start: E, end: P };
          let z = this.symbol("arc", k, L, F, F, R);
          return z.r = F, z;
        }
        rect(k, L, F, m, E, P) {
          let R = d(k) ? k : k === void 0 ? {} : { x: k, y: L, r: E, width: Math.max(F || 0, 0), height: Math.max(m || 0, 0) }, z = this.createElement("rect");
          return this.styledMode || (P !== void 0 && (R["stroke-width"] = P, b(R, z.crisp(R))), R.fill = "none"), z.rSetter = function($, et, rt) {
            z.r = $, o(rt, { rx: $, ry: $ });
          }, z.rGetter = function() {
            return z.r || 0;
          }, z.attr(R);
        }
        roundedRect(k) {
          return this.symbol("roundedRect").attr(k);
        }
        setSize(k, L, F) {
          this.width = k, this.height = L, this.boxWrapper.animate({ width: k, height: L }, { step: function() {
            this.attr({ viewBox: "0 0 " + this.attr("width") + " " + this.attr("height") });
          }, duration: A(F, !0) ? void 0 : 0 }), this.alignElements();
        }
        g(k) {
          let L = this.createElement("g");
          return k ? L.attr({ class: "highcharts-" + k }) : L;
        }
        image(k, L, F, m, E, P) {
          let R = { preserveAspectRatio: "none" };
          g(L) && (R.x = L), g(F) && (R.y = F), g(m) && (R.width = m), g(E) && (R.height = E);
          let z = this.createElement("image").attr(R), $ = function(et) {
            z.attr({ href: k }), P.call(z, et);
          };
          if (P) {
            z.attr({ href: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" });
            let et = new B.Image();
            T(et, "load", $), et.src = k, et.complete && $({});
          } else z.attr({ href: k });
          return z;
        }
        symbol(k, L, F, m, E, P) {
          let R, z, $, et, rt = this, nt = /^url\((.*?)\)$/, dt = nt.test(k), ct = !dt && (this.symbols[k] ? k : "circle"), V = ct && this.symbols[ct];
          if (V) typeof L == "number" && (z = V.call(this.symbols, L || 0, F || 0, m || 0, E || 0, P)), R = this.path(z), rt.styledMode || R.attr("fill", "none"), b(R, { symbolName: ct || void 0, x: L, y: F, width: m, height: E }), P && b(R, P);
          else if (dt) {
            $ = k.match(nt)[1];
            let Y = R = this.image($);
            Y.imgwidth = A(P && P.width, N[$] && N[$].width), Y.imgheight = A(P && P.height, N[$] && N[$].height), et = (Q) => Q.attr({ width: Q.width, height: Q.height }), ["width", "height"].forEach((Q) => {
              Y[`${Q}Setter`] = function(st, at) {
                this[at] = st;
                let { alignByTranslate: ht, element: lt, width: ut, height: pt, imgwidth: ft, imgheight: gt } = this, mt = at === "width" ? ft : gt, yt = 1;
                P && P.backgroundSize === "within" && ut && pt && ft && gt ? (yt = Math.min(ut / ft, pt / gt), o(lt, { width: Math.round(ft * yt), height: Math.round(gt * yt) })) : lt && mt && lt.setAttribute(at, mt), !ht && ft && gt && this.translate(((ut || 0) - ft * yt) / 2, ((pt || 0) - gt * yt) / 2);
              };
            }), t(L) && Y.attr({ x: L, y: F }), Y.isImg = !0, Y.symbolUrl = k, t(Y.imgwidth) && t(Y.imgheight) ? et(Y) : (Y.attr({ width: 0, height: 0 }), u("img", { onload: function() {
              let Q = f[rt.chartIndex];
              this.width === 0 && (e(this, { position: "absolute", top: "-999em" }), s.body.appendChild(this)), N[$] = { width: this.width, height: this.height }, Y.imgwidth = this.width, Y.imgheight = this.height, Y.element && et(Y), this.parentNode && this.parentNode.removeChild(this), rt.imgCount--, rt.imgCount || !Q || Q.hasLoaded || Q.onload();
            }, src: $ }), this.imgCount++);
          }
          return R;
        }
        clipRect(k, L, F, m) {
          return this.rect(k, L, F, m, 0);
        }
        text(k, L, F, m) {
          let E = {};
          if (m && (this.allowHTML || !this.forExport)) return this.html(k, L, F);
          E.x = Math.round(L || 0), F && (E.y = Math.round(F)), t(k) && (E.text = k);
          let P = this.createElement("text").attr(E);
          return m && (!this.forExport || this.allowHTML) || (P.xSetter = function(R, z, $) {
            let et = $.getElementsByTagName("tspan"), rt = $.getAttribute(z);
            for (let nt = 0, dt; nt < et.length; nt++) (dt = et[nt]).getAttribute(z) === rt && dt.setAttribute(z, R);
            $.setAttribute(z, R);
          }), P;
        }
        fontMetrics(k) {
          let L = D(q.prototype.getStyle.call(k, "font-size") || 0), F = L < 24 ? L + 3 : Math.round(1.2 * L), m = Math.round(0.8 * F);
          return { h: F, b: m, f: L };
        }
        rotCorr(k, L, F) {
          let m = k;
          return L && F && (m = Math.max(m * Math.cos(L * x), 4)), { x: -k / 3 * Math.sin(L * x), y: m };
        }
        pathToSegments(k) {
          let L = [], F = [], m = { A: 8, C: 7, H: 2, L: 3, M: 3, Q: 5, S: 5, T: 3, V: 2 };
          for (let E = 0; E < k.length; E++) M(F[0]) && g(k[E]) && F.length === m[F[0].toUpperCase()] && k.splice(E, 0, F[0].replace("M", "L").replace("m", "l")), typeof k[E] == "string" && (F.length && L.push(F.slice(0)), F.length = 0), F.push(k[E]);
          return L.push(F.slice(0)), L;
        }
        label(k, L, F, m, E, P, R, z, $) {
          return new tt(this, k, L, F, m, E, P, R, z, $);
        }
        alignElements() {
          this.alignedObjects.forEach((k) => k.align());
        }
      }
      return b(it.prototype, { Element: q, SVG_NS: v, escapes: { "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" }, symbols: X, draw: a }), J.registerRendererType("svg", it, !0), it;
    }), ot(i, "Core/Renderer/HTML/HTMLElement.js", [i["Core/Renderer/HTML/AST.js"], i["Core/Globals.js"], i["Core/Renderer/SVG/SVGElement.js"], i["Core/Utilities.js"]], function(U, _, K, Z) {
      let { composed: J } = _, { attr: q, css: tt, createElement: X, defined: I, extend: O, pInt: y, pushUnique: w } = Z;
      function f(p, n, a) {
        var N;
        let v = ((N = this.div) == null ? void 0 : N.style) || a.style;
        K.prototype[`${n}Setter`].call(this, p, n, a), v && (v[n] = p);
      }
      let x = (p, n) => {
        var a;
        if (!p.div) {
          let v = q(p.element, "class"), N = p.css, B = X("div", v ? { className: v } : void 0, { position: "absolute", left: `${p.translateX || 0}px`, top: `${p.translateY || 0}px`, ...p.styles, display: p.display, opacity: p.opacity, visibility: p.visibility }, ((a = p.parentGroup) == null ? void 0 : a.div) || n);
          p.classSetter = (T, o, u) => {
            u.setAttribute("class", T), B.className = T;
          }, p.translateXSetter = p.translateYSetter = (T, o) => {
            p[o] = T, B.style[o === "translateX" ? "left" : "top"] = `${T}px`, p.doTransform = !0;
          }, p.opacitySetter = p.visibilitySetter = f, p.css = (T) => (N.call(p, T), T.cursor && (B.style.cursor = T.cursor), T.pointerEvents && (B.style.pointerEvents = T.pointerEvents), p), p.on = function() {
            return K.prototype.on.apply({ element: B, onEvents: p.onEvents }, arguments), p;
          }, p.div = B;
        }
        return p.div;
      };
      class s extends K {
        static compose(n) {
          w(J, this.compose) && (n.prototype.html = function(a, v, N) {
            return new s(this, "span").attr({ text: a, x: Math.round(v), y: Math.round(N) });
          });
        }
        constructor(n, a) {
          super(n, a), this.css({ position: "absolute", ...n.styledMode ? {} : { fontFamily: n.style.fontFamily, fontSize: n.style.fontSize } }), this.element.style.whiteSpace = "nowrap";
        }
        getSpanCorrection(n, a, v) {
          this.xCorr = -n * v, this.yCorr = -a;
        }
        css(n) {
          let a, { element: v } = this, N = v.tagName === "SPAN" && n && "width" in n, B = N && n.width;
          return N && (delete n.width, this.textWidth = y(B) || void 0, a = !0), (n == null ? void 0 : n.textOverflow) === "ellipsis" && (n.whiteSpace = "nowrap", n.overflow = "hidden"), O(this.styles, n), tt(v, n), a && this.updateTransform(), this;
        }
        htmlGetBBox() {
          let { element: n } = this;
          return { x: n.offsetLeft, y: n.offsetTop, width: n.offsetWidth, height: n.offsetHeight };
        }
        updateTransform() {
          var g;
          if (!this.added) {
            this.alignOnAdd = !0;
            return;
          }
          let { element: n, renderer: a, rotation: v, rotationOriginX: N, rotationOriginY: B, styles: T, textAlign: o = "left", textWidth: u, translateX: c = 0, translateY: e = 0, x: t = 0, y: h = 0 } = this, b = { left: 0, center: 0.5, right: 1 }[o], r = T.whiteSpace;
          if (tt(n, { marginLeft: `${c}px`, marginTop: `${e}px` }), n.tagName === "SPAN") {
            let d = [v, o, n.innerHTML, u, this.textAlign].join(","), M = -(((g = this.parentGroup) == null ? void 0 : g.padding) * 1) || 0, H, A = !1;
            if (u !== this.oldTextWidth) {
              let C = this.textPxLength ? this.textPxLength : (tt(n, { width: "", whiteSpace: r || "nowrap" }), n.offsetWidth), k = u || 0;
              (k > this.oldTextWidth || C > k) && (/[ \-]/.test(n.textContent || n.innerText) || n.style.textOverflow === "ellipsis") && (tt(n, { width: C > k || v ? u + "px" : "auto", display: "block", whiteSpace: r || "normal" }), this.oldTextWidth = u, A = !0);
            }
            this.hasBoxWidthChanged = A, d !== this.cTT && (H = a.fontMetrics(n).b, I(v) && (v !== (this.oldRotation || 0) || o !== this.oldAlign) && this.setSpanRotation(v, M, M), this.getSpanCorrection(!I(v) && this.textPxLength || n.offsetWidth, H, b));
            let { xCorr: D = 0, yCorr: W = 0 } = this, G = (N != null ? N : t) - D - t - M, it = (B != null ? B : h) - W - h - M;
            tt(n, { left: `${t + D}px`, top: `${h + W}px`, transformOrigin: `${G}px ${it}px` }), this.cTT = d, this.oldRotation = v, this.oldAlign = o;
          }
        }
        setSpanRotation(n, a, v) {
          tt(this.element, { transform: `rotate(${n}deg)`, transformOrigin: `${a}% ${v}px` });
        }
        add(n) {
          let a, v = this.renderer.box.parentNode, N = [];
          if (this.parentGroup = n, n && !(a = n.div)) {
            let B = n;
            for (; B; ) N.push(B), B = B.parentGroup;
            for (let T of N.reverse()) a = x(T, v);
          }
          return (a || v).appendChild(this.element), this.added = !0, this.alignOnAdd && this.updateTransform(), this;
        }
        textSetter(n) {
          n !== this.textStr && (delete this.bBox, delete this.oldTextWidth, U.setElementHTML(this.element, n != null ? n : ""), this.textStr = n, this.doTransform = !0);
        }
        alignSetter(n) {
          this.alignValue = this.textAlign = n, this.doTransform = !0;
        }
        xSetter(n, a) {
          this[a] = n, this.doTransform = !0;
        }
      }
      let l = s.prototype;
      return l.visibilitySetter = l.opacitySetter = f, l.ySetter = l.rotationSetter = l.rotationOriginXSetter = l.rotationOriginYSetter = l.xSetter, s;
    }), ot(i, "Core/Axis/AxisDefaults.js", [], function() {
      var U, _;
      return (_ = U || (U = {})).xAxis = { alignTicks: !0, allowDecimals: void 0, panningEnabled: !0, zIndex: 2, zoomEnabled: !0, dateTimeLabelFormats: { millisecond: { main: "%H:%M:%S.%L", range: !1 }, second: { main: "%H:%M:%S", range: !1 }, minute: { main: "%H:%M", range: !1 }, hour: { main: "%H:%M", range: !1 }, day: { main: "%e %b" }, week: { main: "%e %b" }, month: { main: "%b '%y" }, year: { main: "%Y" } }, endOnTick: !1, gridLineDashStyle: "Solid", gridZIndex: 1, labels: { autoRotationLimit: 80, distance: 15, enabled: !0, indentation: 10, overflow: "justify", reserveSpace: void 0, rotation: void 0, staggerLines: 0, step: 0, useHTML: !1, zIndex: 7, style: { color: "#333333", cursor: "default", fontSize: "0.8em" } }, maxPadding: 0.01, minorGridLineDashStyle: "Solid", minorTickLength: 2, minorTickPosition: "outside", minorTicksPerMajor: 5, minPadding: 0.01, offset: void 0, reversed: void 0, reversedStacks: !1, showEmpty: !0, showFirstLabel: !0, showLastLabel: !0, startOfWeek: 1, startOnTick: !1, tickLength: 10, tickPixelInterval: 100, tickmarkPlacement: "between", tickPosition: "outside", title: { align: "middle", useHTML: !1, x: 0, y: 0, style: { color: "#666666", fontSize: "0.8em" } }, visible: !0, minorGridLineColor: "#f2f2f2", minorGridLineWidth: 1, minorTickColor: "#999999", lineColor: "#333333", lineWidth: 1, gridLineColor: "#e6e6e6", gridLineWidth: void 0, tickColor: "#333333" }, _.yAxis = { reversedStacks: !0, endOnTick: !0, maxPadding: 0.05, minPadding: 0.05, tickPixelInterval: 72, showLastLabel: !0, labels: { x: void 0 }, startOnTick: !0, title: { text: "Values" }, stackLabels: { animation: {}, allowOverlap: !1, enabled: !1, crop: !0, overflow: "justify", formatter: function() {
        let { numberFormatter: K } = this.axis.chart;
        return K(this.total || 0, -1);
      }, style: { color: "#000000", fontSize: "0.7em", fontWeight: "bold", textOutline: "1px contrast" } }, gridLineWidth: 1, lineWidth: 0 }, U;
    }), ot(i, "Core/Foundation.js", [i["Core/Utilities.js"]], function(U) {
      var _;
      let { addEvent: K, isFunction: Z, objectEach: J, removeEvent: q } = U;
      return (_ || (_ = {})).registerEventOptions = function(tt, X) {
        tt.eventOptions = tt.eventOptions || {}, J(X.events, function(I, O) {
          tt.eventOptions[O] !== I && (tt.eventOptions[O] && (q(tt, O, tt.eventOptions[O]), delete tt.eventOptions[O]), Z(I) && (tt.eventOptions[O] = I, K(tt, O, I, { order: 0 })));
        });
      }, _;
    }), ot(i, "Core/Axis/Tick.js", [i["Core/Templating.js"], i["Core/Globals.js"], i["Core/Utilities.js"]], function(U, _, K) {
      let { deg2rad: Z } = _, { clamp: J, correctFloat: q, defined: tt, destroyObjectProperties: X, extend: I, fireEvent: O, isNumber: y, merge: w, objectEach: f, pick: x } = K;
      return class {
        constructor(s, l, p, n, a) {
          this.isNew = !0, this.isNewLabel = !0, this.axis = s, this.pos = l, this.type = p || "", this.parameters = a || {}, this.tickmarkOffset = this.parameters.tickmarkOffset, this.options = this.parameters.options, O(this, "init"), p || n || this.addLabel();
        }
        addLabel() {
          let s = this, l = s.axis, p = l.options, n = l.chart, a = l.categories, v = l.logarithmic, N = l.names, B = s.pos, T = x(s.options && s.options.labels, p.labels), o = l.tickPositions, u = B === o[0], c = B === o[o.length - 1], e = (!T.step || T.step === 1) && l.tickInterval === 1, t = o.info, h = s.label, b, r, g, d = this.parameters.category || (a ? x(a[B], N[B], B) : B);
          v && y(d) && (d = q(v.lin2log(d))), l.dateTime && (t ? b = (r = n.time.resolveDTLFormat(p.dateTimeLabelFormats[!p.grid && t.higherRanks[B] || t.unitName])).main : y(d) && (b = l.dateTime.getXDateFormat(d, p.dateTimeLabelFormats || {}))), s.isFirst = u, s.isLast = c;
          let M = { axis: l, chart: n, dateTimeLabelFormat: b, isFirst: u, isLast: c, pos: B, tick: s, tickPositionInfo: t, value: d };
          O(this, "labelFormat", M);
          let H = (W) => T.formatter ? T.formatter.call(W, W) : T.format ? (W.text = l.defaultLabelFormatter.call(W), U.format(T.format, W, n)) : l.defaultLabelFormatter.call(W), A = H.call(M, M), D = r && r.list;
          D ? s.shortenLabel = function() {
            for (g = 0; g < D.length; g++) if (I(M, { dateTimeLabelFormat: D[g] }), h.attr({ text: H.call(M, M) }), h.getBBox().width < l.getSlotWidth(s) - 2 * (T.padding || 0)) return;
            h.attr({ text: "" });
          } : s.shortenLabel = void 0, e && l._addedPlotLB && s.moveLabel(A, T), tt(h) || s.movedLabel ? h && h.textStr !== A && !e && (!h.textWidth || T.style.width || h.styles.width || h.css({ width: null }), h.attr({ text: A }), h.textPxLength = h.getBBox().width) : (s.label = h = s.createLabel(A, T), s.rotation = 0);
        }
        createLabel(s, l, p) {
          let n = this.axis, a = n.chart, v = tt(s) && l.enabled ? a.renderer.text(s, p == null ? void 0 : p.x, p == null ? void 0 : p.y, l.useHTML).add(n.labelGroup) : void 0;
          return v && (a.styledMode || v.css(w(l.style)), v.textPxLength = v.getBBox().width), v;
        }
        destroy() {
          X(this, this.axis);
        }
        getPosition(s, l, p, n) {
          let a = this.axis, v = a.chart, N = n && v.oldChartHeight || v.chartHeight, B = { x: s ? q(a.translate(l + p, void 0, void 0, n) + a.transB) : a.left + a.offset + (a.opposite ? (n && v.oldChartWidth || v.chartWidth) - a.right - a.left : 0), y: s ? N - a.bottom + a.offset - (a.opposite ? a.height : 0) : q(N - a.translate(l + p, void 0, void 0, n) - a.transB) };
          return B.y = J(B.y, -1e9, 1e9), O(this, "afterGetPosition", { pos: B }), B;
        }
        getLabelPosition(s, l, p, n, a, v, N, B) {
          let T, o, u = this.axis, c = u.transA, e = u.isLinked && u.linkedParent ? u.linkedParent.reversed : u.reversed, t = u.staggerLines, h = u.tickRotCorr || { x: 0, y: 0 }, b = n || u.reserveSpaceDefault ? 0 : -u.labelOffset * (u.labelAlign === "center" ? 0.5 : 1), r = a.distance, g = {};
          return T = u.side === 0 ? p.rotation ? -r : -p.getBBox().height : u.side === 2 ? h.y + r : Math.cos(p.rotation * Z) * (h.y - p.getBBox(!1, 0).height / 2), tt(a.y) && (T = u.side === 0 && u.horiz ? a.y + T : a.y), s = s + x(a.x, [0, 1, 0, -1][u.side] * r) + b + h.x - (v && n ? v * c * (e ? -1 : 1) : 0), l = l + T - (v && !n ? v * c * (e ? 1 : -1) : 0), t && (o = N / (B || 1) % t, u.opposite && (o = t - o - 1), l += o * (u.labelOffset / t)), g.x = s, g.y = Math.round(l), O(this, "afterGetLabelPosition", { pos: g, tickmarkOffset: v, index: N }), g;
        }
        getLabelSize() {
          return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
        }
        getMarkPath(s, l, p, n, a = !1, v) {
          return v.crispLine([["M", s, l], ["L", s + (a ? 0 : -p), l + (a ? p : 0)]], n);
        }
        handleOverflow(s) {
          let l = this.axis, p = l.options.labels, n = s.x, a = l.chart.chartWidth, v = l.chart.spacing, N = x(l.labelLeft, Math.min(l.pos, v[3])), B = x(l.labelRight, Math.max(l.isRadial ? 0 : l.pos + l.len, a - v[1])), T = this.label, o = this.rotation, u = { left: 0, center: 0.5, right: 1 }[l.labelAlign || T.attr("align")], c = T.getBBox().width, e = l.getSlotWidth(this), t = {}, h = e, b = 1, r, g, d;
          o || p.overflow !== "justify" ? o < 0 && n - u * c < N ? d = Math.round(n / Math.cos(o * Z) - N) : o > 0 && n + u * c > B && (d = Math.round((a - n) / Math.cos(o * Z))) : (r = n - u * c, g = n + (1 - u) * c, r < N ? h = s.x + h * (1 - u) - N : g > B && (h = B - s.x + h * u, b = -1), (h = Math.min(e, h)) < e && l.labelAlign === "center" && (s.x += b * (e - h - u * (e - Math.min(c, h)))), (c > h || l.autoRotation && (T.styles || {}).width) && (d = h)), d && (this.shortenLabel ? this.shortenLabel() : (t.width = Math.floor(d) + "px", (p.style || {}).textOverflow || (t.textOverflow = "ellipsis"), T.css(t)));
        }
        moveLabel(s, l) {
          let p = this, n = p.label, a = p.axis, v = !1, N;
          n && n.textStr === s ? (p.movedLabel = n, v = !0, delete p.label) : f(a.ticks, function(B) {
            v || B.isNew || B === p || !B.label || B.label.textStr !== s || (p.movedLabel = B.label, v = !0, B.labelPos = p.movedLabel.xy, delete B.label);
          }), !v && (p.labelPos || n) && (N = p.labelPos || n.xy, p.movedLabel = p.createLabel(s, l, N), p.movedLabel && p.movedLabel.attr({ opacity: 0 }));
        }
        render(s, l, p) {
          let n = this.axis, a = n.horiz, v = this.pos, N = x(this.tickmarkOffset, n.tickmarkOffset), B = this.getPosition(a, v, N, l), T = B.x, o = B.y, u = n.pos, c = u + n.len, e = a ? T : o;
          !n.chart.polar && this.isNew && (q(e) < u || e > c) && (p = 0);
          let t = x(p, this.label && this.label.newOpacity, 1);
          p = x(p, 1), this.isActive = !0, this.renderGridLine(l, p), this.renderMark(B, p), this.renderLabel(B, l, t, s), this.isNew = !1, O(this, "afterRender");
        }
        renderGridLine(s, l) {
          let p = this.axis, n = p.options, a = {}, v = this.pos, N = this.type, B = x(this.tickmarkOffset, p.tickmarkOffset), T = p.chart.renderer, o = this.gridLine, u, c = n.gridLineWidth, e = n.gridLineColor, t = n.gridLineDashStyle;
          this.type === "minor" && (c = n.minorGridLineWidth, e = n.minorGridLineColor, t = n.minorGridLineDashStyle), o || (p.chart.styledMode || (a.stroke = e, a["stroke-width"] = c || 0, a.dashstyle = t), N || (a.zIndex = 1), s && (l = 0), this.gridLine = o = T.path().attr(a).addClass("highcharts-" + (N ? N + "-" : "") + "grid-line").add(p.gridGroup)), o && (u = p.getPlotLinePath({ value: v + B, lineWidth: o.strokeWidth(), force: "pass", old: s, acrossPanes: !1 })) && o[s || this.isNew ? "attr" : "animate"]({ d: u, opacity: l });
        }
        renderMark(s, l) {
          let p = this.axis, n = p.options, a = p.chart.renderer, v = this.type, N = p.tickSize(v ? v + "Tick" : "tick"), B = s.x, T = s.y, o = x(n[v !== "minor" ? "tickWidth" : "minorTickWidth"], !v && p.isXAxis ? 1 : 0), u = n[v !== "minor" ? "tickColor" : "minorTickColor"], c = this.mark, e = !c;
          N && (p.opposite && (N[0] = -N[0]), c || (this.mark = c = a.path().addClass("highcharts-" + (v ? v + "-" : "") + "tick").add(p.axisGroup), p.chart.styledMode || c.attr({ stroke: u, "stroke-width": o })), c[e ? "attr" : "animate"]({ d: this.getMarkPath(B, T, N[0], c.strokeWidth(), p.horiz, a), opacity: l }));
        }
        renderLabel(s, l, p, n) {
          let a = this.axis, v = a.horiz, N = a.options, B = this.label, T = N.labels, o = T.step, u = x(this.tickmarkOffset, a.tickmarkOffset), c = s.x, e = s.y, t = !0;
          B && y(c) && (B.xy = s = this.getLabelPosition(c, e, B, v, T, u, n, o), (!this.isFirst || this.isLast || N.showFirstLabel) && (!this.isLast || this.isFirst || N.showLastLabel) ? !v || T.step || T.rotation || l || p === 0 || this.handleOverflow(s) : t = !1, o && n % o && (t = !1), t && y(s.y) ? (s.opacity = p, B[this.isNewLabel ? "attr" : "animate"](s).show(!0), this.isNewLabel = !1) : (B.hide(), this.isNewLabel = !0));
        }
        replaceMovedLabel() {
          let s = this.label, l = this.axis;
          s && !this.isNew && (s.animate({ opacity: 0 }, void 0, s.destroy), delete this.label), l.isDirty = !0, this.label = this.movedLabel, delete this.movedLabel;
        }
      };
    }), ot(i, "Core/Axis/Axis.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Axis/AxisDefaults.js"], i["Core/Color/Color.js"], i["Core/Defaults.js"], i["Core/Foundation.js"], i["Core/Globals.js"], i["Core/Axis/Tick.js"], i["Core/Utilities.js"]], function(U, _, K, Z, J, q, tt, X) {
      let { animObject: I } = U, { xAxis: O, yAxis: y } = _, { defaultOptions: w } = Z, { registerEventOptions: f } = J, { deg2rad: x } = q, { arrayMax: s, arrayMin: l, clamp: p, correctFloat: n, defined: a, destroyObjectProperties: v, erase: N, error: B, extend: T, fireEvent: o, getClosestDistance: u, insertItem: c, isArray: e, isNumber: t, isString: h, merge: b, normalizeTickInterval: r, objectEach: g, pick: d, relativeLength: M, removeEvent: H, splat: A, syncTimeout: D } = X, W = (it, C) => r(C, void 0, void 0, d(it.options.allowDecimals, C < 0.5 || it.tickAmount !== void 0), !!it.tickAmount);
      T(w, { xAxis: O, yAxis: b(O, y) });
      class G {
        constructor(C, k, L) {
          this.init(C, k, L);
        }
        init(C, k, L = this.coll) {
          var z, $, et, rt;
          let F = L === "xAxis", m = this.isZAxis || (C.inverted ? !F : F);
          this.chart = C, this.horiz = m, this.isXAxis = F, this.coll = L, o(this, "init", { userOptions: k }), this.opposite = d(k.opposite, this.opposite), this.side = d(k.side, this.side, m ? this.opposite ? 0 : 2 : this.opposite ? 1 : 3), this.setOptions(k);
          let E = this.options, P = E.labels;
          (z = this.type) != null || (this.type = E.type || "linear"), (et = this.uniqueNames) != null || (this.uniqueNames = ($ = E.uniqueNames) != null ? $ : !0), o(this, "afterSetType"), this.userOptions = k, this.minPixelPadding = 0, this.reversed = d(E.reversed, this.reversed), this.visible = E.visible, this.zoomEnabled = E.zoomEnabled, this.hasNames = this.type === "category" || E.categories === !0, this.categories = e(E.categories) && E.categories || (this.hasNames ? [] : void 0), this.names || (this.names = [], this.names.keys = {}), this.plotLinesAndBandsGroups = {}, this.positiveValuesOnly = !!this.logarithmic, this.isLinked = a(E.linkedTo), this.ticks = {}, this.labelEdge = [], this.minorTicks = {}, this.plotLinesAndBands = [], this.alternateBands = {}, (rt = this.len) != null || (this.len = 0), this.minRange = this.userMinRange = E.minRange || E.maxZoom, this.range = E.range, this.offset = E.offset || 0, this.max = void 0, this.min = void 0;
          let R = d(E.crosshair, A(C.options.tooltip.crosshairs)[F ? 0 : 1]);
          this.crosshair = R === !0 ? {} : R, C.axes.indexOf(this) === -1 && (F ? C.axes.splice(C.xAxis.length, 0, this) : C.axes.push(this), c(this, C[this.coll])), C.orderItems(this.coll), this.series = this.series || [], C.inverted && !this.isZAxis && F && !a(this.reversed) && (this.reversed = !0), this.labelRotation = t(P.rotation) ? P.rotation : void 0, f(this, E), o(this, "afterInit");
        }
        setOptions(C) {
          let k = this.horiz ? { labels: { autoRotation: [-45], padding: 4 }, margin: 15 } : { labels: { padding: 1 }, title: { rotation: 90 * this.side } };
          this.options = b(k, w[this.coll], C), o(this, "afterSetOptions", { userOptions: C });
        }
        defaultLabelFormatter() {
          let C = this.axis, { numberFormatter: k } = this.chart, L = t(this.value) ? this.value : NaN, F = C.chart.time, m = C.categories, E = this.dateTimeLabelFormat, P = w.lang, R = P.numericSymbols, z = P.numericSymbolMagnitude || 1e3, $ = C.logarithmic ? Math.abs(L) : C.tickInterval, et = R && R.length, rt, nt;
          if (m) nt = `${this.value}`;
          else if (E) nt = F.dateFormat(E, L);
          else if (et && R && $ >= 1e3) for (; et-- && nt === void 0; ) $ >= (rt = Math.pow(z, et + 1)) && 10 * L % rt == 0 && R[et] !== null && L !== 0 && (nt = k(L / rt, -1) + R[et]);
          return nt === void 0 && (nt = Math.abs(L) >= 1e4 ? k(L, -1) : k(L, -1, void 0, "")), nt;
        }
        getSeriesExtremes() {
          let C, k = this;
          o(this, "getSeriesExtremes", null, function() {
            k.hasVisibleSeries = !1, k.dataMin = k.dataMax = k.threshold = void 0, k.softThreshold = !k.isXAxis, k.series.forEach((L) => {
              if (L.reserveSpace()) {
                let F = L.options, m, E = F.threshold, P, R;
                if (k.hasVisibleSeries = !0, k.positiveValuesOnly && 0 >= (E || 0) && (E = void 0), k.isXAxis) (m = L.xData) && m.length && (m = k.logarithmic ? m.filter((z) => z > 0) : m, P = (C = L.getXExtremes(m)).min, R = C.max, t(P) || P instanceof Date || (m = m.filter(t), P = (C = L.getXExtremes(m)).min, R = C.max), m.length && (k.dataMin = Math.min(d(k.dataMin, P), P), k.dataMax = Math.max(d(k.dataMax, R), R)));
                else {
                  let z = L.applyExtremes();
                  t(z.dataMin) && (P = z.dataMin, k.dataMin = Math.min(d(k.dataMin, P), P)), t(z.dataMax) && (R = z.dataMax, k.dataMax = Math.max(d(k.dataMax, R), R)), a(E) && (k.threshold = E), (!F.softThreshold || k.positiveValuesOnly) && (k.softThreshold = !1);
                }
              }
            });
          }), o(this, "afterGetSeriesExtremes");
        }
        translate(C, k, L, F, m, E) {
          var ct;
          let P = this.linkedParent || this, R = F && P.old ? P.old.min : P.min;
          if (!t(R)) return NaN;
          let z = P.minPixelPadding, $ = (P.isOrdinal || ((ct = P.brokenAxis) == null ? void 0 : ct.hasBreaks) || P.logarithmic && m) && P.lin2val, et = 1, rt = 0, nt = F && P.old ? P.old.transA : P.transA, dt = 0;
          return nt || (nt = P.transA), L && (et *= -1, rt = P.len), P.reversed && (et *= -1, rt -= et * (P.sector || P.len)), k ? (dt = (C = C * et + rt - z) / nt + R, $ && (dt = P.lin2val(dt))) : ($ && (C = P.val2lin(C)), dt = et * (C - R) * nt + rt + et * z + (t(E) ? nt * E : 0), P.isRadial || (dt = n(dt))), dt;
        }
        toPixels(C, k) {
          return this.translate(C, !1, !this.horiz, void 0, !0) + (k ? 0 : this.pos);
        }
        toValue(C, k) {
          return this.translate(C - (k ? 0 : this.pos), !0, !this.horiz, void 0, !0);
        }
        getPlotLinePath(C) {
          let k = this, L = k.chart, F = k.left, m = k.top, E = C.old, P = C.value, R = C.lineWidth, z = E && L.oldChartHeight || L.chartHeight, $ = E && L.oldChartWidth || L.chartWidth, et = k.transB, rt = C.translatedValue, nt = C.force, dt, ct, V, Y, Q;
          function st(ht, lt, ut) {
            return nt !== "pass" && (ht < lt || ht > ut) && (nt ? ht = p(ht, lt, ut) : Q = !0), ht;
          }
          let at = { value: P, lineWidth: R, old: E, force: nt, acrossPanes: C.acrossPanes, translatedValue: rt };
          return o(this, "getPlotLinePath", at, function(ht) {
            dt = V = (rt = p(rt = d(rt, k.translate(P, void 0, void 0, E)), -1e9, 1e9)) + et, ct = Y = z - rt - et, t(rt) ? k.horiz ? (ct = m, Y = z - k.bottom + (k.options.isInternal ? 0 : L.scrollablePixelsY || 0), dt = V = st(dt, F, F + k.width)) : (dt = F, V = $ - k.right + (L.scrollablePixelsX || 0), ct = Y = st(ct, m, m + k.height)) : (Q = !0, nt = !1), ht.path = Q && !nt ? void 0 : L.renderer.crispLine([["M", dt, ct], ["L", V, Y]], R || 1);
          }), at.path;
        }
        getLinearTickPositions(C, k, L) {
          let F, m, E, P = n(Math.floor(k / C) * C), R = n(Math.ceil(L / C) * C), z = [];
          if (n(P + C) === P && (E = 20), this.single) return [k];
          for (F = P; F <= R && (z.push(F), (F = n(F + C, E)) !== m); ) m = F;
          return z;
        }
        getMinorTickInterval() {
          let { minorTicks: C, minorTickInterval: k } = this.options;
          return C === !0 ? d(k, "auto") : C !== !1 ? k : void 0;
        }
        getMinorTickPositions() {
          let C = this.options, k = this.tickPositions, L = this.minorTickInterval, F = this.pointRangePadding || 0, m = (this.min || 0) - F, E = (this.max || 0) + F, P = E - m, R = [], z;
          if (P && P / L < this.len / 3) {
            let $ = this.logarithmic;
            if ($) this.paddedTicks.forEach(function(et, rt, nt) {
              rt && R.push.apply(R, $.getLogTickPositions(L, nt[rt - 1], nt[rt], !0));
            });
            else if (this.dateTime && this.getMinorTickInterval() === "auto") R = R.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(L), m, E, C.startOfWeek));
            else for (z = m + (k[0] - m) % L; z <= E && z !== R[0]; z += L) R.push(z);
          }
          return R.length !== 0 && this.trimTicks(R), R;
        }
        adjustForMinRange() {
          let C = this.options, k = this.logarithmic, { max: L, min: F, minRange: m } = this, E, P, R, z;
          this.isXAxis && m === void 0 && !k && (m = a(C.min) || a(C.max) || a(C.floor) || a(C.ceiling) ? null : Math.min(5 * (u(this.series.map(($) => {
            var et;
            return ($.xIncrement ? (et = $.xData) == null ? void 0 : et.slice(0, 2) : $.xData) || [];
          })) || 0), this.dataMax - this.dataMin)), t(L) && t(F) && t(m) && L - F < m && (P = this.dataMax - this.dataMin >= m, E = (m - L + F) / 2, R = [F - E, d(C.min, F - E)], P && (R[2] = k ? k.log2lin(this.dataMin) : this.dataMin), z = [(F = s(R)) + m, d(C.max, F + m)], P && (z[2] = k ? k.log2lin(this.dataMax) : this.dataMax), (L = l(z)) - F < m && (R[0] = L - m, R[1] = d(C.min, L - m), F = s(R))), this.minRange = m, this.min = F, this.max = L;
        }
        getClosest() {
          let C, k;
          if (this.categories) k = 1;
          else {
            let L = [];
            this.series.forEach(function(F) {
              var E;
              let m = F.closestPointRange;
              ((E = F.xData) == null ? void 0 : E.length) === 1 ? L.push(F.xData[0]) : !F.noSharedTooltip && a(m) && F.reserveSpace() && (k = a(k) ? Math.min(k, m) : m);
            }), L.length && (L.sort((F, m) => F - m), C = u([L]));
          }
          return C && k ? Math.min(C, k) : C || k;
        }
        nameToX(C) {
          let k = e(this.options.categories), L = k ? this.categories : this.names, F = C.options.x, m;
          return C.series.requireSorting = !1, a(F) || (F = this.uniqueNames && L ? k ? L.indexOf(C.name) : d(L.keys[C.name], -1) : C.series.autoIncrement()), F === -1 ? !k && L && (m = L.length) : m = F, m !== void 0 ? (this.names[m] = C.name, this.names.keys[C.name] = m) : C.x && (m = C.x), m;
        }
        updateNames() {
          let C = this, k = this.names;
          k.length > 0 && (Object.keys(k.keys).forEach(function(L) {
            delete k.keys[L];
          }), k.length = 0, this.minRange = this.userMinRange, (this.series || []).forEach((L) => {
            L.xIncrement = null, (!L.points || L.isDirtyData) && (C.max = Math.max(C.max, L.xData.length - 1), L.processData(), L.generatePoints()), L.data.forEach(function(F, m) {
              let E;
              F != null && F.options && F.name !== void 0 && (E = C.nameToX(F)) !== void 0 && E !== F.x && (F.x = E, L.xData[m] = E);
            });
          }));
        }
        setAxisTranslation() {
          let C = this, k = C.max - C.min, L = C.linkedParent, F = !!C.categories, m = C.isXAxis, E = C.axisPointRange || 0, P, R = 0, z = 0, $, et = C.transA;
          (m || F || E) && (P = C.getClosest(), L ? (R = L.minPointOffset, z = L.pointRangePadding) : C.series.forEach(function(rt) {
            let nt = F ? 1 : m ? d(rt.options.pointRange, P, 0) : C.axisPointRange || 0, dt = rt.options.pointPlacement;
            if (E = Math.max(E, nt), !C.single || F) {
              let ct = rt.is("xrange") ? !m : m;
              R = Math.max(R, ct && h(dt) ? 0 : nt / 2), z = Math.max(z, ct && dt === "on" ? 0 : nt);
            }
          }), $ = C.ordinal && C.ordinal.slope && P ? C.ordinal.slope / P : 1, C.minPointOffset = R *= $, C.pointRangePadding = z *= $, C.pointRange = Math.min(E, C.single && F ? 1 : k), m && P && (C.closestPointRange = P)), C.translationSlope = C.transA = et = C.staticScale || C.len / (k + z || 1), C.transB = C.horiz ? C.left : C.bottom, C.minPixelPadding = et * R, o(this, "afterSetAxisTranslation");
        }
        minFromRange() {
          let { max: C, min: k } = this;
          return t(C) && t(k) && C - k || void 0;
        }
        setTickInterval(C) {
          var xt, bt, Ct, vt;
          let { categories: k, chart: L, dataMax: F, dataMin: m, dateTime: E, isXAxis: P, logarithmic: R, options: z, softThreshold: $ } = this, et = t(this.threshold) ? this.threshold : void 0, rt = this.minRange || 0, { ceiling: nt, floor: dt, linkedTo: ct, softMax: V, softMin: Y } = z, Q = t(ct) && ((xt = L[this.coll]) == null ? void 0 : xt[ct]), st = z.tickPixelInterval, at = z.maxPadding, ht = z.minPadding, lt = 0, ut, pt = t(z.tickInterval) && z.tickInterval >= 0 ? z.tickInterval : void 0, ft, gt, mt, yt;
          if (E || k || Q || this.getTickAmount(), mt = d(this.userMin, z.min), yt = d(this.userMax, z.max), Q ? (this.linkedParent = Q, ut = Q.getExtremes(), this.min = d(ut.min, ut.dataMin), this.max = d(ut.max, ut.dataMax), this.type !== Q.type && B(11, !0, L)) : ($ && a(et) && t(F) && t(m) && (m >= et ? (ft = et, ht = 0) : F <= et && (gt = et, at = 0)), this.min = d(mt, ft, m), this.max = d(yt, gt, F)), t(this.max) && t(this.min) && (R && (this.positiveValuesOnly && !C && 0 >= Math.min(this.min, d(m, this.min)) && B(10, !0, L), this.min = n(R.log2lin(this.min), 16), this.max = n(R.log2lin(this.max), 16)), this.range && t(m) && (this.userMin = this.min = mt = Math.max(m, this.minFromRange() || 0), this.userMax = yt = this.max, this.range = void 0)), o(this, "foundExtremes"), this.adjustForMinRange(), t(this.min) && t(this.max)) {
            if (!t(this.userMin) && t(Y) && Y < this.min && (this.min = mt = Y), !t(this.userMax) && t(V) && V > this.max && (this.max = yt = V), k || this.axisPointRange || (bt = this.stacking) != null && bt.usePercentage || Q || !(lt = this.max - this.min) || (!a(mt) && ht && (this.min -= lt * ht), a(yt) || !at || (this.max += lt * at)), !t(this.userMin) && t(dt) && (this.min = Math.max(this.min, dt)), !t(this.userMax) && t(nt) && (this.max = Math.min(this.max, nt)), $ && t(m) && t(F)) {
              let kt = et || 0;
              !a(mt) && this.min < kt && m >= kt ? this.min = z.minRange ? Math.min(kt, this.max - rt) : kt : !a(yt) && this.max > kt && F <= kt && (this.max = z.minRange ? Math.max(kt, this.min + rt) : kt);
            }
            !L.polar && this.min > this.max && (a(z.min) ? this.max = this.min : a(z.max) && (this.min = this.max)), lt = this.max - this.min;
          }
          if (this.min !== this.max && t(this.min) && t(this.max) ? Q && !pt && st === Q.options.tickPixelInterval ? this.tickInterval = pt = Q.tickInterval : this.tickInterval = d(pt, this.tickAmount ? lt / Math.max(this.tickAmount - 1, 1) : void 0, k ? 1 : lt * st / Math.max(this.len, st)) : this.tickInterval = 1, P && !C) {
            let kt = this.min !== ((Ct = this.old) == null ? void 0 : Ct.min) || this.max !== ((vt = this.old) == null ? void 0 : vt.max);
            this.series.forEach(function(Tt) {
              var St;
              Tt.forceCrop = (St = Tt.forceCropping) == null ? void 0 : St.call(Tt), Tt.processData(kt);
            }), o(this, "postProcessData", { hasExtremesChanged: kt });
          }
          this.setAxisTranslation(), o(this, "initialAxisTranslation"), this.pointRange && !pt && (this.tickInterval = Math.max(this.pointRange, this.tickInterval));
          let wt = d(z.minTickInterval, E && !this.series.some((kt) => kt.noSharedTooltip) ? this.closestPointRange : 0);
          !pt && this.tickInterval < wt && (this.tickInterval = wt), E || R || pt || (this.tickInterval = W(this, this.tickInterval)), this.tickAmount || (this.tickInterval = this.unsquish()), this.setTickPositions();
        }
        setTickPositions() {
          var $, et;
          let C = this.options, k = C.tickPositions, L = C.tickPositioner, F = this.getMinorTickInterval(), m = !this.isPanning, E = m && C.startOnTick, P = m && C.endOnTick, R = [], z;
          if (this.tickmarkOffset = this.categories && C.tickmarkPlacement === "between" && this.tickInterval === 1 ? 0.5 : 0, this.single = this.min === this.max && a(this.min) && !this.tickAmount && (this.min % 1 == 0 || C.allowDecimals !== !1), k) R = k.slice();
          else if (t(this.min) && t(this.max)) {
            if (!(($ = this.ordinal) != null && $.positions) && (this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200)) R = [this.min, this.max], B(19, !1, this.chart);
            else if (this.dateTime) R = this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval, C.units), this.min, this.max, C.startOfWeek, (et = this.ordinal) == null ? void 0 : et.positions, this.closestPointRange, !0);
            else if (this.logarithmic) R = this.logarithmic.getLogTickPositions(this.tickInterval, this.min, this.max);
            else {
              let rt = this.tickInterval, nt = rt;
              for (; nt <= 2 * rt && (R = this.getLinearTickPositions(this.tickInterval, this.min, this.max), this.tickAmount && R.length > this.tickAmount); ) this.tickInterval = W(this, nt *= 1.1);
            }
            R.length > this.len && (R = [R[0], R[R.length - 1]])[0] === R[1] && (R.length = 1), L && (this.tickPositions = R, (z = L.apply(this, [this.min, this.max])) && (R = z));
          }
          this.tickPositions = R, this.minorTickInterval = F === "auto" && this.tickInterval ? this.tickInterval / C.minorTicksPerMajor : F, this.paddedTicks = R.slice(0), this.trimTicks(R, E, P), !this.isLinked && t(this.min) && t(this.max) && (this.single && R.length < 2 && !this.categories && !this.series.some((rt) => rt.is("heatmap") && rt.options.pointPlacement === "between") && (this.min -= 0.5, this.max += 0.5), k || z || this.adjustTickAmount()), o(this, "afterSetTickPositions");
        }
        trimTicks(C, k, L) {
          let F = C[0], m = C[C.length - 1], E = !this.isOrdinal && this.minPointOffset || 0;
          if (o(this, "trimTicks"), !this.isLinked) {
            if (k && F !== -1 / 0) this.min = F;
            else for (; this.min - E > C[0]; ) C.shift();
            if (L) this.max = m;
            else for (; this.max + E < C[C.length - 1]; ) C.pop();
            C.length === 0 && a(F) && !this.options.tickPositions && C.push((m + F) / 2);
          }
        }
        alignToOthers() {
          let C, k = this, L = k.chart, F = [this], m = k.options, E = L.options.chart, P = this.coll === "yAxis" && E.alignThresholds, R = [];
          if (k.thresholdAlignment = void 0, (E.alignTicks !== !1 && m.alignTicks || P) && m.startOnTick !== !1 && m.endOnTick !== !1 && !k.logarithmic) {
            let z = (et) => {
              let { horiz: rt, options: nt } = et;
              return [rt ? nt.left : nt.top, nt.width, nt.height, nt.pane].join(",");
            }, $ = z(this);
            L[this.coll].forEach(function(et) {
              let { series: rt } = et;
              rt.length && rt.some((nt) => nt.visible) && et !== k && z(et) === $ && (C = !0, F.push(et));
            });
          }
          if (C && P) {
            F.forEach(($) => {
              let et = $.getThresholdAlignment(k);
              t(et) && R.push(et);
            });
            let z = R.length > 1 ? R.reduce(($, et) => $ += et, 0) / R.length : void 0;
            F.forEach(($) => {
              $.thresholdAlignment = z;
            });
          }
          return C;
        }
        getThresholdAlignment(C) {
          if ((!t(this.dataMin) || this !== C && this.series.some((k) => k.isDirty || k.isDirtyData)) && this.getSeriesExtremes(), t(this.threshold)) {
            let k = p((this.threshold - (this.dataMin || 0)) / ((this.dataMax || 0) - (this.dataMin || 0)), 0, 1);
            return this.options.reversed && (k = 1 - k), k;
          }
        }
        getTickAmount() {
          let C = this.options, k = C.tickPixelInterval, L = C.tickAmount;
          a(C.tickInterval) || L || !(this.len < k) || this.isRadial || this.logarithmic || !C.startOnTick || !C.endOnTick || (L = 2), !L && this.alignToOthers() && (L = Math.ceil(this.len / k) + 1), L < 4 && (this.finalTickAmt = L, L = 5), this.tickAmount = L;
        }
        adjustTickAmount() {
          let C = this, { finalTickAmt: k, max: L, min: F, options: m, tickPositions: E, tickAmount: P, thresholdAlignment: R } = C, z = E == null ? void 0 : E.length, $ = d(C.threshold, C.softThreshold ? 0 : null), et, rt, nt = C.tickInterval, dt, ct = () => E.push(n(E[E.length - 1] + nt)), V = () => E.unshift(n(E[0] - nt));
          if (t(R) && (dt = R < 0.5 ? Math.ceil(R * (P - 1)) : Math.floor(R * (P - 1)), m.reversed && (dt = P - 1 - dt)), C.hasData() && t(F) && t(L)) {
            let Y = () => {
              C.transA *= (z - 1) / (P - 1), C.min = m.startOnTick ? E[0] : Math.min(F, E[0]), C.max = m.endOnTick ? E[E.length - 1] : Math.max(L, E[E.length - 1]);
            };
            if (t(dt) && t(C.threshold)) {
              for (; E[dt] !== $ || E.length !== P || E[0] > F || E[E.length - 1] < L; ) {
                for (E.length = 0, E.push(C.threshold); E.length < P; ) E[dt] === void 0 || E[dt] > C.threshold ? V() : ct();
                if (nt > 8 * C.tickInterval) break;
                nt *= 2;
              }
              Y();
            } else if (z < P) {
              for (; E.length < P; ) E.length % 2 || F === $ ? ct() : V();
              Y();
            }
            if (a(k)) {
              for (rt = et = E.length; rt--; ) (k === 3 && rt % 2 == 1 || k <= 2 && rt > 0 && rt < et - 1) && E.splice(rt, 1);
              C.finalTickAmt = void 0;
            }
          }
        }
        setScale() {
          var E, P;
          let { coll: C, stacking: k } = this, L = !1, F = !1;
          this.series.forEach((R) => {
            L = L || R.isDirtyData || R.isDirty, F = F || R.xAxis && R.xAxis.isDirty || !1;
          }), this.setAxisSize();
          let m = this.len !== (this.old && this.old.len);
          m || L || F || this.isLinked || this.forceRedraw || this.userMin !== (this.old && this.old.userMin) || this.userMax !== (this.old && this.old.userMax) || this.alignToOthers() ? (k && C === "yAxis" && k.buildStacks(), this.forceRedraw = !1, this.userMinRange || (this.minRange = void 0), this.getSeriesExtremes(), this.setTickInterval(), k && C === "xAxis" && k.buildStacks(), this.isDirty || (this.isDirty = m || this.min !== ((E = this.old) == null ? void 0 : E.min) || this.max !== ((P = this.old) == null ? void 0 : P.max))) : k && k.cleanStacks(), L && delete this.allExtremes, o(this, "afterSetScale");
        }
        setExtremes(C, k, L = !0, F, m) {
          this.series.forEach((E) => {
            delete E.kdTree;
          }), o(this, "setExtremes", m = T(m, { min: C, max: k }), (E) => {
            this.userMin = E.min, this.userMax = E.max, this.eventArgs = E, L && this.chart.redraw(F);
          });
        }
        setAxisSize() {
          let C = this.chart, k = this.options, L = k.offsets || [0, 0, 0, 0], F = this.horiz, m = this.width = Math.round(M(d(k.width, C.plotWidth - L[3] + L[1]), C.plotWidth)), E = this.height = Math.round(M(d(k.height, C.plotHeight - L[0] + L[2]), C.plotHeight)), P = this.top = Math.round(M(d(k.top, C.plotTop + L[0]), C.plotHeight, C.plotTop)), R = this.left = Math.round(M(d(k.left, C.plotLeft + L[3]), C.plotWidth, C.plotLeft));
          this.bottom = C.chartHeight - E - P, this.right = C.chartWidth - m - R, this.len = Math.max(F ? m : E, 0), this.pos = F ? R : P;
        }
        getExtremes() {
          let C = this.logarithmic;
          return { min: C ? n(C.lin2log(this.min)) : this.min, max: C ? n(C.lin2log(this.max)) : this.max, dataMin: this.dataMin, dataMax: this.dataMax, userMin: this.userMin, userMax: this.userMax };
        }
        getThreshold(C) {
          let k = this.logarithmic, L = k ? k.lin2log(this.min) : this.min, F = k ? k.lin2log(this.max) : this.max;
          return C === null || C === -1 / 0 ? C = L : C === 1 / 0 ? C = F : L > C ? C = L : F < C && (C = F), this.translate(C, 0, 1, 0, 1);
        }
        autoLabelAlign(C) {
          let k = (d(C, 0) - 90 * this.side + 720) % 360, L = { align: "center" };
          return o(this, "autoLabelAlign", L, function(F) {
            k > 15 && k < 165 ? F.align = "right" : k > 195 && k < 345 && (F.align = "left");
          }), L.align;
        }
        tickSize(C) {
          let k = this.options, L = d(k[C === "tick" ? "tickWidth" : "minorTickWidth"], C === "tick" && this.isXAxis && !this.categories ? 1 : 0), F = k[C === "tick" ? "tickLength" : "minorTickLength"], m;
          L && F && (k[C + "Position"] === "inside" && (F = -F), m = [F, L]);
          let E = { tickSize: m };
          return o(this, "afterTickSize", E), E.tickSize;
        }
        labelMetrics() {
          let C = this.chart.renderer, k = this.ticks, L = k[Object.keys(k)[0]] || {};
          return this.chart.renderer.fontMetrics(L.label || L.movedLabel || C.box);
        }
        unsquish() {
          let C = this.options.labels, k = C.padding || 0, L = this.horiz, F = this.tickInterval, m = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / F), E = C.rotation, P = n(0.8 * this.labelMetrics().h), R = Math.max(this.max - this.min, 0), z = function(dt) {
            let ct = (dt + 2 * k) / (m || 1);
            return (ct = ct > 1 ? Math.ceil(ct) : 1) * F > R && dt !== 1 / 0 && m !== 1 / 0 && R && (ct = Math.ceil(R / F)), n(ct * F);
          }, $ = F, et, rt = Number.MAX_VALUE, nt;
          if (L) {
            if (!C.staggerLines && (t(E) ? nt = [E] : m < C.autoRotationLimit && (nt = C.autoRotation)), nt) {
              let dt, ct;
              for (let V of nt) (V === E || V && V >= -90 && V <= 90) && (ct = (dt = z(Math.abs(P / Math.sin(x * V)))) + Math.abs(V / 360)) < rt && (rt = ct, et = V, $ = dt);
            }
          } else $ = z(0.75 * P);
          return this.autoRotation = nt, this.labelRotation = d(et, t(E) ? E : 0), C.step ? F : $;
        }
        getSlotWidth(C) {
          let k = this.chart, L = this.horiz, F = this.options.labels, m = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1), E = k.margin[3];
          if (C && t(C.slotWidth)) return C.slotWidth;
          if (L && F.step < 2) return F.rotation ? 0 : (this.staggerLines || 1) * this.len / m;
          if (!L) {
            let P = F.style.width;
            if (P !== void 0) return parseInt(String(P), 10);
            if (E) return E - k.spacing[3];
          }
          return 0.33 * k.chartWidth;
        }
        renderUnsquish() {
          let C = this.chart, k = C.renderer, L = this.tickPositions, F = this.ticks, m = this.options.labels, E = m.style, P = this.horiz, R = this.getSlotWidth(), z = Math.max(1, Math.round(R - (P ? 2 * (m.padding || 0) : m.distance || 0))), $ = {}, et = this.labelMetrics(), rt = E.textOverflow, nt, dt, ct = 0, V, Y;
          if (h(m.rotation) || ($.rotation = m.rotation || 0), L.forEach(function(Q) {
            let st = F[Q];
            st.movedLabel && st.replaceMovedLabel(), st && st.label && st.label.textPxLength > ct && (ct = st.label.textPxLength);
          }), this.maxLabelLength = ct, this.autoRotation) ct > z && ct > et.h ? $.rotation = this.labelRotation : this.labelRotation = 0;
          else if (R && (nt = z, !rt)) for (dt = "clip", Y = L.length; !P && Y--; ) (V = F[L[Y]].label) && (V.styles.textOverflow === "ellipsis" ? V.css({ textOverflow: "clip" }) : V.textPxLength > R && V.css({ width: R + "px" }), V.getBBox().height > this.len / L.length - (et.h - et.f) && (V.specificTextOverflow = "ellipsis"));
          $.rotation && (nt = ct > 0.5 * C.chartHeight ? 0.33 * C.chartHeight : ct, rt || (dt = "ellipsis")), this.labelAlign = m.align || this.autoLabelAlign(this.labelRotation), this.labelAlign && ($.align = this.labelAlign), L.forEach(function(Q) {
            let st = F[Q], at = st && st.label, ht = E.width, lt = {};
            at && (at.attr($), st.shortenLabel ? st.shortenLabel() : nt && !ht && E.whiteSpace !== "nowrap" && (nt < at.textPxLength || at.element.tagName === "SPAN") ? (lt.width = nt + "px", rt || (lt.textOverflow = at.specificTextOverflow || dt), at.css(lt)) : !at.styles.width || lt.width || ht || at.css({ width: null }), delete at.specificTextOverflow, st.rotation = $.rotation);
          }, this), this.tickRotCorr = k.rotCorr(et.b, this.labelRotation || 0, this.side !== 0);
        }
        hasData() {
          return this.series.some(function(C) {
            return C.hasData();
          }) || this.options.showEmpty && a(this.min) && a(this.max);
        }
        addTitle(C) {
          let k, L = this.chart.renderer, F = this.horiz, m = this.opposite, E = this.options.title, P = this.chart.styledMode;
          this.axisTitle || ((k = E.textAlign) || (k = (F ? { low: "left", middle: "center", high: "right" } : { low: m ? "right" : "left", middle: "center", high: m ? "left" : "right" })[E.align]), this.axisTitle = L.text(E.text || "", 0, 0, E.useHTML).attr({ zIndex: 7, rotation: E.rotation || 0, align: k }).addClass("highcharts-axis-title"), P || this.axisTitle.css(b(E.style)), this.axisTitle.add(this.axisGroup), this.axisTitle.isNew = !0), P || E.style.width || this.isRadial || this.axisTitle.css({ width: this.len + "px" }), this.axisTitle[C ? "show" : "hide"](C);
        }
        generateTick(C) {
          let k = this.ticks;
          k[C] ? k[C].addLabel() : k[C] = new tt(this, C);
        }
        createGroups() {
          let { axisParent: C, chart: k, coll: L, options: F } = this, m = k.renderer, E = (P, R, z) => m.g(P).attr({ zIndex: z }).addClass(`highcharts-${L.toLowerCase()}${R} ` + (this.isRadial ? `highcharts-radial-axis${R} ` : "") + (F.className || "")).add(C);
          this.axisGroup || (this.gridGroup = E("grid", "-grid", F.gridZIndex), this.axisGroup = E("axis", "", F.zIndex), this.labelGroup = E("axis-labels", "-labels", F.labels.zIndex));
        }
        getOffset() {
          let C = this, { chart: k, horiz: L, options: F, side: m, ticks: E, tickPositions: P, coll: R } = C, z = k.inverted && !C.isZAxis ? [1, 0, 3, 2][m] : m, $ = C.hasData(), et = F.title, rt = F.labels, nt = t(F.crossing), dt = k.axisOffset, ct = k.clipOffset, V = [-1, 1, 1, -1][m], Y, Q = 0, st, at = 0, ht = 0, lt, ut;
          if (C.showAxis = Y = $ || F.showEmpty, C.staggerLines = C.horiz && rt.staggerLines || void 0, C.createGroups(), $ || C.isLinked ? (P.forEach(function(pt) {
            C.generateTick(pt);
          }), C.renderUnsquish(), C.reserveSpaceDefault = m === 0 || m === 2 || { 1: "left", 3: "right" }[m] === C.labelAlign, d(rt.reserveSpace, !nt && null, C.labelAlign === "center" || null, C.reserveSpaceDefault) && P.forEach(function(pt) {
            ht = Math.max(E[pt].getLabelSize(), ht);
          }), C.staggerLines && (ht *= C.staggerLines), C.labelOffset = ht * (C.opposite ? -1 : 1)) : g(E, function(pt, ft) {
            pt.destroy(), delete E[ft];
          }), et != null && et.text && et.enabled !== !1 && (C.addTitle(Y), Y && !nt && et.reserveSpace !== !1 && (C.titleOffset = Q = C.axisTitle.getBBox()[L ? "height" : "width"], at = a(st = et.offset) ? 0 : d(et.margin, L ? 5 : 10))), C.renderLine(), C.offset = V * d(F.offset, dt[m] ? dt[m] + (F.margin || 0) : 0), C.tickRotCorr = C.tickRotCorr || { x: 0, y: 0 }, ut = m === 0 ? -C.labelMetrics().h : m === 2 ? C.tickRotCorr.y : 0, lt = Math.abs(ht) + at, ht && (lt -= ut, lt += V * (L ? d(rt.y, C.tickRotCorr.y + V * rt.distance) : d(rt.x, V * rt.distance))), C.axisTitleMargin = d(st, lt), C.getMaxLabelDimensions && (C.maxLabelDimensions = C.getMaxLabelDimensions(E, P)), R !== "colorAxis" && ct) {
            let pt = this.tickSize("tick");
            dt[m] = Math.max(dt[m], (C.axisTitleMargin || 0) + Q + V * C.offset, lt, P && P.length && pt ? pt[0] + V * C.offset : 0);
            let ft = !C.axisLine || F.offset ? 0 : C.axisLine.strokeWidth() / 2;
            ct[z] = Math.max(ct[z], ft);
          }
          o(this, "afterGetOffset");
        }
        getLinePath(C) {
          let k = this.chart, L = this.opposite, F = this.offset, m = this.horiz, E = this.left + (L ? this.width : 0) + F, P = k.chartHeight - this.bottom - (L ? this.height : 0) + F;
          return L && (C *= -1), k.renderer.crispLine([["M", m ? this.left : E, m ? P : this.top], ["L", m ? k.chartWidth - this.right : E, m ? P : k.chartHeight - this.bottom]], C);
        }
        renderLine() {
          this.axisLine || (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.chart.styledMode || this.axisLine.attr({ stroke: this.options.lineColor, "stroke-width": this.options.lineWidth, zIndex: 7 }));
        }
        getTitlePosition(C) {
          let k = this.horiz, L = this.left, F = this.top, m = this.len, E = this.options.title, P = k ? L : F, R = this.opposite, z = this.offset, $ = E.x, et = E.y, rt = this.chart.renderer.fontMetrics(C), nt = C ? Math.max(C.getBBox(!1, 0).height - rt.h - 1, 0) : 0, dt = { low: P + (k ? 0 : m), middle: P + m / 2, high: P + (k ? m : 0) }[E.align], ct = (k ? F + this.height : L) + (k ? 1 : -1) * (R ? -1 : 1) * (this.axisTitleMargin || 0) + [-nt, nt, rt.f, -nt][this.side], V = { x: k ? dt + $ : ct + (R ? this.width : 0) + z + $, y: k ? ct + et - (R ? this.height : 0) + z : dt + et };
          return o(this, "afterGetTitlePosition", { titlePosition: V }), V;
        }
        renderMinorTick(C, k) {
          let L = this.minorTicks;
          L[C] || (L[C] = new tt(this, C, "minor")), k && L[C].isNew && L[C].render(null, !0), L[C].render(null, !1, 1);
        }
        renderTick(C, k, L) {
          let F = this.isLinked, m = this.ticks;
          (!F || C >= this.min && C <= this.max || this.grid && this.grid.isColumn) && (m[C] || (m[C] = new tt(this, C)), L && m[C].isNew && m[C].render(k, !0, -1), m[C].render(k));
        }
        render() {
          let C, k, L = this, F = L.chart, m = L.logarithmic, E = F.renderer, P = L.options, R = L.isLinked, z = L.tickPositions, $ = L.axisTitle, et = L.ticks, rt = L.minorTicks, nt = L.alternateBands, dt = P.stackLabels, ct = P.alternateGridColor, V = P.crossing, Y = L.tickmarkOffset, Q = L.axisLine, st = L.showAxis, at = I(E.globalAnimation);
          if (L.labelEdge.length = 0, L.overlap = !1, [et, rt, nt].forEach(function(ht) {
            g(ht, function(lt) {
              lt.isActive = !1;
            });
          }), t(V)) {
            let ht = this.isXAxis ? F.yAxis[0] : F.xAxis[0], lt = [1, -1, -1, 1][this.side];
            if (ht) {
              let ut = ht.toPixels(V, !0);
              L.horiz && (ut = ht.len - ut), L.offset = lt * ut;
            }
          }
          if (L.hasData() || R) {
            let ht = L.chart.hasRendered && L.old && t(L.old.min);
            L.minorTickInterval && !L.categories && L.getMinorTickPositions().forEach(function(lt) {
              L.renderMinorTick(lt, ht);
            }), z.length && (z.forEach(function(lt, ut) {
              L.renderTick(lt, ut, ht);
            }), Y && (L.min === 0 || L.single) && (et[-1] || (et[-1] = new tt(L, -1, null, !0)), et[-1].render(-1))), ct && z.forEach(function(lt, ut) {
              k = z[ut + 1] !== void 0 ? z[ut + 1] + Y : L.max - Y, ut % 2 == 0 && lt < L.max && k <= L.max + (F.polar ? -Y : Y) && (nt[lt] || (nt[lt] = new q.PlotLineOrBand(L, {})), C = lt + Y, nt[lt].options = { from: m ? m.lin2log(C) : C, to: m ? m.lin2log(k) : k, color: ct, className: "highcharts-alternate-grid" }, nt[lt].render(), nt[lt].isActive = !0);
            }), L._addedPlotLB || (L._addedPlotLB = !0, (P.plotLines || []).concat(P.plotBands || []).forEach(function(lt) {
              L.addPlotBandOrLine(lt);
            }));
          }
          [et, rt, nt].forEach(function(ht) {
            let lt = [], ut = at.duration;
            g(ht, function(pt, ft) {
              pt.isActive || (pt.render(ft, !1, 0), pt.isActive = !1, lt.push(ft));
            }), D(function() {
              let pt = lt.length;
              for (; pt--; ) ht[lt[pt]] && !ht[lt[pt]].isActive && (ht[lt[pt]].destroy(), delete ht[lt[pt]]);
            }, ht !== nt && F.hasRendered && ut ? ut : 0);
          }), Q && (Q[Q.isPlaced ? "animate" : "attr"]({ d: this.getLinePath(Q.strokeWidth()) }), Q.isPlaced = !0, Q[st ? "show" : "hide"](st)), $ && st && ($[$.isNew ? "attr" : "animate"](L.getTitlePosition($)), $.isNew = !1), dt && dt.enabled && L.stacking && L.stacking.renderStackTotals(), L.old = { len: L.len, max: L.max, min: L.min, transA: L.transA, userMax: L.userMax, userMin: L.userMin }, L.isDirty = !1, o(this, "afterRender");
        }
        redraw() {
          this.visible && (this.render(), this.plotLinesAndBands.forEach(function(C) {
            C.render();
          })), this.series.forEach(function(C) {
            C.isDirty = !0;
          });
        }
        getKeepProps() {
          return this.keepProps || G.keepProps;
        }
        destroy(C) {
          let k = this, L = k.plotLinesAndBands, F = this.eventOptions;
          if (o(this, "destroy", { keepEvents: C }), C || H(k), [k.ticks, k.minorTicks, k.alternateBands].forEach(function(m) {
            v(m);
          }), L) {
            let m = L.length;
            for (; m--; ) L[m].destroy();
          }
          for (let m in ["axisLine", "axisTitle", "axisGroup", "gridGroup", "labelGroup", "cross", "scrollbar"].forEach(function(E) {
            k[E] && (k[E] = k[E].destroy());
          }), k.plotLinesAndBandsGroups) k.plotLinesAndBandsGroups[m] = k.plotLinesAndBandsGroups[m].destroy();
          g(k, function(m, E) {
            k.getKeepProps().indexOf(E) === -1 && delete k[E];
          }), this.eventOptions = F;
        }
        drawCrosshair(C, k) {
          let L = this.crosshair, F = d(L && L.snap, !0), m = this.chart, E, P, R, z = this.cross, $;
          if (o(this, "drawCrosshair", { e: C, point: k }), C || (C = this.cross && this.cross.e), L && (a(k) || !F) !== !1) {
            if (F ? a(k) && (P = d(this.coll !== "colorAxis" ? k.crosshairPos : null, this.isXAxis ? k.plotX : this.len - k.plotY)) : P = C && (this.horiz ? C.chartX - this.pos : this.len - C.chartY + this.pos), a(P) && ($ = { value: k && (this.isXAxis ? k.x : d(k.stackY, k.y)), translatedValue: P }, m.polar && T($, { isCrosshair: !0, chartX: C && C.chartX, chartY: C && C.chartY, point: k }), E = this.getPlotLinePath($) || null), !a(E)) {
              this.hideCrosshair();
              return;
            }
            R = this.categories && !this.isRadial, z || (this.cross = z = m.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (R ? "category " : "thin ") + (L.className || "")).attr({ zIndex: d(L.zIndex, 2) }).add(), !m.styledMode && (z.attr({ stroke: L.color || (R ? K.parse("#ccd3ff").setOpacity(0.25).get() : "#cccccc"), "stroke-width": d(L.width, 1) }).css({ "pointer-events": "none" }), L.dashStyle && z.attr({ dashstyle: L.dashStyle }))), z.show().attr({ d: E }), R && !L.width && z.attr({ "stroke-width": this.transA }), this.cross.e = C;
          } else this.hideCrosshair();
          o(this, "afterDrawCrosshair", { e: C, point: k });
        }
        hideCrosshair() {
          this.cross && this.cross.hide(), o(this, "afterHideCrosshair");
        }
        update(C, k) {
          let L = this.chart;
          C = b(this.userOptions, C), this.destroy(!0), this.init(L, C), L.isDirtyBox = !0, d(k, !0) && L.redraw();
        }
        remove(C) {
          let k = this.chart, L = this.coll, F = this.series, m = F.length;
          for (; m--; ) F[m] && F[m].remove(!1);
          N(k.axes, this), N(k[L] || [], this), k.orderItems(L), this.destroy(), k.isDirtyBox = !0, d(C, !0) && k.redraw();
        }
        setTitle(C, k) {
          this.update({ title: C }, k);
        }
        setCategories(C, k) {
          this.update({ categories: C }, k);
        }
      }
      return G.keepProps = ["coll", "extKey", "hcEvents", "len", "names", "series", "userMax", "userMin"], G;
    }), ot(i, "Core/Axis/DateTimeAxis.js", [i["Core/Utilities.js"]], function(U) {
      var _;
      let { addEvent: K, getMagnitude: Z, normalizeTickInterval: J, timeUnits: q } = U;
      return function(tt) {
        function X() {
          return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
        }
        function I() {
          if (this.type !== "datetime") {
            this.dateTime = void 0;
            return;
          }
          this.dateTime || (this.dateTime = new O(this));
        }
        tt.compose = function(y) {
          return y.keepProps.includes("dateTime") || (y.keepProps.push("dateTime"), y.prototype.getTimeTicks = X, K(y, "afterSetType", I)), y;
        };
        class O {
          constructor(w) {
            this.axis = w;
          }
          normalizeTimeTickInterval(w, f) {
            let x = f || [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2]], ["week", [1, 2]], ["month", [1, 2, 3, 4, 6]], ["year", null]], s = x[x.length - 1], l = q[s[0]], p = s[1], n;
            for (n = 0; n < x.length && (l = q[(s = x[n])[0]], p = s[1], !x[n + 1] || !(w <= (l * p[p.length - 1] + q[x[n + 1][0]]) / 2)); n++) ;
            l === q.year && w < 5 * l && (p = [1, 2, 5]);
            let a = J(w / l, p, s[0] === "year" ? Math.max(Z(w / l), 1) : 1);
            return { unitRange: l, count: a, unitName: s[0] };
          }
          getXDateFormat(w, f) {
            let { axis: x } = this, s = x.chart.time;
            return x.closestPointRange ? s.getDateFormat(x.closestPointRange, w, x.options.startOfWeek, f) || s.resolveDTLFormat(f.year).main : s.resolveDTLFormat(f.day).main;
          }
        }
        tt.Additions = O;
      }(_ || (_ = {})), _;
    }), ot(i, "Core/Axis/LogarithmicAxis.js", [i["Core/Utilities.js"]], function(U) {
      var _;
      let { addEvent: K, normalizeTickInterval: Z, pick: J } = U;
      return function(q) {
        function tt() {
          var O;
          this.type !== "logarithmic" ? this.logarithmic = void 0 : (O = this.logarithmic) != null || (this.logarithmic = new I(this));
        }
        function X() {
          let O = this.logarithmic;
          O && (this.lin2val = function(y) {
            return O.lin2log(y);
          }, this.val2lin = function(y) {
            return O.log2lin(y);
          });
        }
        q.compose = function(O) {
          return O.keepProps.includes("logarithmic") || (O.keepProps.push("logarithmic"), K(O, "afterSetType", tt), K(O, "afterInit", X)), O;
        };
        class I {
          constructor(y) {
            this.axis = y;
          }
          getLogTickPositions(y, w, f, x) {
            let s = this.axis, l = s.len, p = s.options, n = [];
            if (x || (this.minorAutoInterval = void 0), y >= 0.5) y = Math.round(y), n = s.getLinearTickPositions(y, w, f);
            else if (y >= 0.08) {
              let a, v, N, B, T, o, u, c = Math.floor(w);
              for (a = y > 0.3 ? [1, 2, 4] : y > 0.15 ? [1, 2, 4, 6, 8] : [1, 2, 3, 4, 5, 6, 7, 8, 9], v = c; v < f + 1 && !u; v++) for (N = 0, B = a.length; N < B && !u; N++) (T = this.log2lin(this.lin2log(v) * a[N])) > w && (!x || o <= f) && o !== void 0 && n.push(o), o > f && (u = !0), o = T;
            } else {
              let a = this.lin2log(w), v = this.lin2log(f), N = x ? s.getMinorTickInterval() : p.tickInterval, B = p.tickPixelInterval / (x ? 5 : 1), T = x ? l / s.tickPositions.length : l;
              y = Z(y = J(N === "auto" ? null : N, this.minorAutoInterval, (v - a) * B / (T || 1))), n = s.getLinearTickPositions(y, a, v).map(this.log2lin), x || (this.minorAutoInterval = y / 5);
            }
            return x || (s.tickInterval = y), n;
          }
          lin2log(y) {
            return Math.pow(10, y);
          }
          log2lin(y) {
            return Math.log(y) / Math.LN10;
          }
        }
        q.Additions = I;
      }(_ || (_ = {})), _;
    }), ot(i, "Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js", [i["Core/Utilities.js"]], function(U) {
      var _;
      let { erase: K, extend: Z, isNumber: J } = U;
      return function(q) {
        let tt;
        function X(s) {
          return this.addPlotBandOrLine(s, "plotBands");
        }
        function I(s, l) {
          let p = this.userOptions, n = new tt(this, s);
          if (this.visible && (n = n.render()), n) {
            if (this._addedPlotLB || (this._addedPlotLB = !0, (p.plotLines || []).concat(p.plotBands || []).forEach((a) => {
              this.addPlotBandOrLine(a);
            })), l) {
              let a = p[l] || [];
              a.push(s), p[l] = a;
            }
            this.plotLinesAndBands.push(n);
          }
          return n;
        }
        function O(s) {
          return this.addPlotBandOrLine(s, "plotLines");
        }
        function y(s, l, p) {
          p = p || this.options;
          let n = this.getPlotLinePath({ value: l, force: !0, acrossPanes: p.acrossPanes }), a = [], v = this.horiz, N = !J(this.min) || !J(this.max) || s < this.min && l < this.min || s > this.max && l > this.max, B = this.getPlotLinePath({ value: s, force: !0, acrossPanes: p.acrossPanes }), T, o = 1, u;
          if (B && n) for (N && (u = B.toString() === n.toString(), o = 0), T = 0; T < B.length; T += 2) {
            let c = B[T], e = B[T + 1], t = n[T], h = n[T + 1];
            (c[0] === "M" || c[0] === "L") && (e[0] === "M" || e[0] === "L") && (t[0] === "M" || t[0] === "L") && (h[0] === "M" || h[0] === "L") && (v && t[1] === c[1] ? (t[1] += o, h[1] += o) : v || t[2] !== c[2] || (t[2] += o, h[2] += o), a.push(["M", c[1], c[2]], ["L", e[1], e[2]], ["L", h[1], h[2]], ["L", t[1], t[2]], ["Z"])), a.isFlat = u;
          }
          return a;
        }
        function w(s) {
          this.removePlotBandOrLine(s);
        }
        function f(s) {
          let l = this.plotLinesAndBands, p = this.options, n = this.userOptions;
          if (l) {
            let a = l.length;
            for (; a--; ) l[a].id === s && l[a].destroy();
            [p.plotLines || [], n.plotLines || [], p.plotBands || [], n.plotBands || []].forEach(function(v) {
              for (a = v.length; a--; ) (v[a] || {}).id === s && K(v, v[a]);
            });
          }
        }
        function x(s) {
          this.removePlotBandOrLine(s);
        }
        q.compose = function(s, l) {
          let p = l.prototype;
          return p.addPlotBand || (tt = s, Z(p, { addPlotBand: X, addPlotLine: O, addPlotBandOrLine: I, getPlotBandPath: y, removePlotBand: w, removePlotLine: x, removePlotBandOrLine: f })), l;
        };
      }(_ || (_ = {})), _;
    }), ot(i, "Core/Axis/PlotLineOrBand/PlotLineOrBand.js", [i["Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js"], i["Core/Utilities.js"]], function(U, _) {
      let { addEvent: K, arrayMax: Z, arrayMin: J, defined: q, destroyObjectProperties: tt, erase: X, fireEvent: I, merge: O, objectEach: y, pick: w } = _;
      class f {
        static compose(s, l) {
          return K(s, "afterInit", function() {
            this.labelCollectors.push(() => {
              var n;
              let p = [];
              for (let a of this.axes) for (let { label: v, options: N } of a.plotLinesAndBands) v && !((n = N == null ? void 0 : N.label) != null && n.allowOverlap) && p.push(v);
              return p;
            });
          }), U.compose(f, l);
        }
        constructor(s, l) {
          this.axis = s, this.options = l, this.id = l.id;
        }
        render() {
          var W, G, it;
          I(this, "render");
          let { axis: s, options: l } = this, { horiz: p, logarithmic: n } = s, { color: a, events: v, zIndex: N = 0 } = l, B = {}, T = s.chart.renderer, o = l.to, u = l.from, c = l.value, e = l.borderWidth, t = l.label, { label: h, svgElem: b } = this, r = [], g, d = q(u) && q(o), M = q(c), H = !b, A = { class: "highcharts-plot-" + (d ? "band " : "line ") + (l.className || "") }, D = d ? "bands" : "lines";
          if (!s.chart.styledMode && (M ? (A.stroke = a || "#999999", A["stroke-width"] = w(l.width, 1), l.dashStyle && (A.dashstyle = l.dashStyle)) : d && (A.fill = a || "#e6e9ff", e && (A.stroke = l.borderColor, A["stroke-width"] = e))), B.zIndex = N, D += "-" + N, (g = s.plotLinesAndBandsGroups[D]) || (s.plotLinesAndBandsGroups[D] = g = T.g("plot-" + D).attr(B).add()), b || (this.svgElem = b = T.path().attr(A).add(g)), q(c)) r = s.getPlotLinePath({ value: (W = n == null ? void 0 : n.log2lin(c)) != null ? W : c, lineWidth: b.strokeWidth(), acrossPanes: l.acrossPanes });
          else {
            if (!(q(u) && q(o))) return;
            r = s.getPlotBandPath((G = n == null ? void 0 : n.log2lin(u)) != null ? G : u, (it = n == null ? void 0 : n.log2lin(o)) != null ? it : o, l);
          }
          return !this.eventsAdded && v && (y(v, (C, k) => {
            b == null || b.on(k, (L) => {
              v[k].apply(this, [L]);
            });
          }), this.eventsAdded = !0), (H || !b.d) && (r != null && r.length) ? b.attr({ d: r }) : b && (r ? (b.show(), b.animate({ d: r })) : b.d && (b.hide(), h && (this.label = h = h.destroy()))), t && (q(t.text) || q(t.formatter)) && (r != null && r.length) && s.width > 0 && s.height > 0 && !r.isFlat ? (t = O({ align: p && d ? "center" : void 0, x: p ? !d && 4 : 10, verticalAlign: !p && d ? "middle" : void 0, y: p ? d ? 16 : 10 : d ? 6 : -4, rotation: p && !d ? 90 : 0, ...d ? { inside: !0 } : {} }, t), this.renderLabel(t, r, d, N)) : h && h.hide(), this;
        }
        renderLabel(s, l, p, n) {
          var t;
          let a = this.axis, v = a.chart.renderer, N = s.inside, B = this.label;
          B || (this.label = B = v.text(this.getLabelText(s), 0, 0, s.useHTML).attr({ align: s.textAlign || s.align, rotation: s.rotation, class: "highcharts-plot-" + (p ? "band" : "line") + "-label " + (s.className || ""), zIndex: n }), a.chart.styledMode || B.css(O({ fontSize: "0.8em", textOverflow: p && !N ? "" : "ellipsis" }, s.style)), B.add());
          let T = l.xBounds || [l[0][1], l[1][1], p ? l[2][1] : l[0][1]], o = l.yBounds || [l[0][2], l[1][2], p ? l[2][2] : l[0][2]], u = J(T), c = J(o), e = Z(T) - u;
          B.align(s, !1, { x: u, y: c, width: e, height: Z(o) - c }), (!B.alignValue || B.alignValue === "left" || q(N)) && B.css({ width: (((t = s.style) == null ? void 0 : t.width) || (p && N ? e : B.rotation === 90 ? a.height - (B.alignAttr.y - a.top) : (s.clip ? a.width : a.chart.chartWidth) - (B.alignAttr.x - a.left))) + "px" }), B.show(!0);
        }
        getLabelText(s) {
          return q(s.formatter) ? s.formatter.call(this) : s.text;
        }
        destroy() {
          X(this.axis.plotLinesAndBands, this), delete this.axis, tt(this);
        }
      }
      return f;
    }), ot(i, "Core/Tooltip.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Templating.js"], i["Core/Globals.js"], i["Core/Renderer/RendererUtilities.js"], i["Core/Renderer/RendererRegistry.js"], i["Core/Utilities.js"]], function(U, _, K, Z, J, q) {
      var tt;
      let { animObject: X } = U, { format: I } = _, { composed: O, doc: y, isSafari: w } = K, { distribute: f } = Z, { addEvent: x, clamp: s, css: l, discardElement: p, extend: n, fireEvent: a, isArray: v, isNumber: N, isString: B, merge: T, pick: o, pushUnique: u, splat: c, syncTimeout: e } = q;
      class t {
        constructor(b, r, g) {
          this.allowShared = !0, this.crosshairs = [], this.distance = 0, this.isHidden = !0, this.isSticky = !1, this.options = {}, this.outside = !1, this.chart = b, this.init(b, r), this.pointer = g;
        }
        bodyFormatter(b) {
          return b.map(function(r) {
            let g = r.series.tooltipOptions;
            return (g[(r.point.formatPrefix || "point") + "Formatter"] || r.point.tooltipFormatter).call(r.point, g[(r.point.formatPrefix || "point") + "Format"] || "");
          });
        }
        cleanSplit(b) {
          this.chart.series.forEach(function(r) {
            let g = r && r.tt;
            g && (!g.isActive || b ? r.tt = g.destroy() : g.isActive = !1);
          });
        }
        defaultFormatter(b) {
          let r, g = this.points || c(this);
          return (r = (r = [b.tooltipFooterHeaderFormatter(g[0])]).concat(b.bodyFormatter(g))).push(b.tooltipFooterHeaderFormatter(g[0], !0)), r;
        }
        destroy() {
          this.label && (this.label = this.label.destroy()), this.split && (this.cleanSplit(!0), this.tt && (this.tt = this.tt.destroy())), this.renderer && (this.renderer = this.renderer.destroy(), p(this.container)), q.clearTimeout(this.hideTimer);
        }
        getAnchor(b, r) {
          let g, { chart: d, pointer: M } = this, H = d.inverted, A = d.plotTop, D = d.plotLeft;
          if ((b = c(b))[0].series && b[0].series.yAxis && !b[0].series.yAxis.options.reversedStacks && (b = b.slice().reverse()), this.followPointer && r) r.chartX === void 0 && (r = M.normalize(r)), g = [r.chartX - D, r.chartY - A];
          else if (b[0].tooltipPos) g = b[0].tooltipPos;
          else {
            let W = 0, G = 0;
            b.forEach(function(it) {
              let C = it.pos(!0);
              C && (W += C[0], G += C[1]);
            }), W /= b.length, G /= b.length, this.shared && b.length > 1 && r && (H ? W = r.chartX : G = r.chartY), g = [W - D, G - A];
          }
          return g.map(Math.round);
        }
        getClassName(b, r, g) {
          let d = this.options, M = b.series, H = M.options;
          return [d.className, "highcharts-label", g && "highcharts-tooltip-header", r ? "highcharts-tooltip-box" : "highcharts-tooltip", !g && "highcharts-color-" + o(b.colorIndex, M.colorIndex), H && H.className].filter(B).join(" ");
        }
        getLabel({ anchorX: b, anchorY: r } = { anchorX: 0, anchorY: 0 }) {
          let g = this, d = this.chart.styledMode, M = this.options, H = this.split && this.allowShared, A = this.container, D = this.chart.renderer;
          if (this.label) {
            let W = !this.label.hasClass("highcharts-label");
            (!H && W || H && !W) && this.destroy();
          }
          if (!this.label) {
            if (this.outside) {
              let W = this.chart.options.chart.style, G = J.getRendererType();
              this.container = A = K.doc.createElement("div"), A.className = "highcharts-tooltip-container", l(A, { position: "absolute", top: "1px", pointerEvents: "none", zIndex: Math.max(this.options.style.zIndex || 0, (W && W.zIndex || 0) + 3) }), this.renderer = D = new G(A, 0, 0, W, void 0, void 0, D.styledMode);
            }
            if (H ? this.label = D.g("tooltip") : (this.label = D.label("", b, r, M.shape, void 0, void 0, M.useHTML, void 0, "tooltip").attr({ padding: M.padding, r: M.borderRadius }), d || this.label.attr({ fill: M.backgroundColor, "stroke-width": M.borderWidth || 0 }).css(M.style).css({ pointerEvents: M.style.pointerEvents || (this.shouldStickOnContact() ? "auto" : "none") })), g.outside) {
              let W = this.label;
              [W.xSetter, W.ySetter].forEach((G, it) => {
                W[it ? "ySetter" : "xSetter"] = (C) => {
                  G.call(W, g.distance), W[it ? "y" : "x"] = C, A && (A.style[it ? "top" : "left"] = `${C}px`);
                };
              });
            }
            this.label.attr({ zIndex: 8 }).shadow(M.shadow).add();
          }
          return A && !A.parentElement && K.doc.body.appendChild(A), this.label;
        }
        getPlayingField() {
          let { body: b, documentElement: r } = y, { chart: g, distance: d, outside: M } = this;
          return { width: M ? Math.max(b.scrollWidth, r.scrollWidth, b.offsetWidth, r.offsetWidth, r.clientWidth) - 2 * d : g.chartWidth, height: M ? Math.max(b.scrollHeight, r.scrollHeight, b.offsetHeight, r.offsetHeight, r.clientHeight) : g.chartHeight };
        }
        getPosition(b, r, g) {
          var at, ht;
          let { distance: d, chart: M, outside: H, pointer: A } = this, { inverted: D, plotLeft: W, plotTop: G, polar: it } = M, { plotX: C = 0, plotY: k = 0 } = g, L = {}, F = D && g.h || 0, { height: m, width: E } = this.getPlayingField(), P = A.getChartPosition(), R = (lt) => lt * P.scaleX, z = (lt) => lt * P.scaleY, $ = (lt) => {
            let ut = lt === "x";
            return [lt, ut ? E : m, ut ? b : r].concat(H ? [ut ? R(b) : z(r), ut ? P.left - d + R(C + W) : P.top - d + z(k + G), 0, ut ? E : m] : [ut ? b : r, ut ? C + W : k + G, ut ? W : G, ut ? W + M.plotWidth : G + M.plotHeight]);
          }, et = $("y"), rt = $("x"), nt, dt = !!g.negative;
          !it && ((ht = (at = M.hoverSeries) == null ? void 0 : at.yAxis) != null && ht.reversed) && (dt = !dt);
          let ct = !this.followPointer && o(g.ttBelow, !it && !D === dt), V = function(lt, ut, pt, ft, gt, mt, yt) {
            let wt = H ? lt === "y" ? z(d) : R(d) : d, xt = (pt - ft) / 2, bt = ft < gt - d, Ct = gt + d + ft < ut, vt = gt - wt - pt + xt, kt = gt + wt - xt;
            if (ct && Ct) L[lt] = kt;
            else if (!ct && bt) L[lt] = vt;
            else if (bt) L[lt] = Math.min(yt - ft, vt - F < 0 ? vt : vt - F);
            else {
              if (!Ct) return !1;
              L[lt] = Math.max(mt, kt + F + pt > ut ? kt : kt + F);
            }
          }, Y = function(lt, ut, pt, ft, gt) {
            if (gt < d || gt > ut - d) return !1;
            gt < pt / 2 ? L[lt] = 1 : gt > ut - ft / 2 ? L[lt] = ut - ft - 2 : L[lt] = gt - pt / 2;
          }, Q = function(lt) {
            [et, rt] = [rt, et], nt = lt;
          }, st = () => {
            V.apply(0, et) !== !1 ? Y.apply(0, rt) !== !1 || nt || (Q(!0), st()) : nt ? L.x = L.y = 0 : (Q(!0), st());
          };
          return (D && !it || this.len > 1) && Q(), st(), L;
        }
        hide(b) {
          let r = this;
          q.clearTimeout(this.hideTimer), b = o(b, this.options.hideDelay), this.isHidden || (this.hideTimer = e(function() {
            let g = r.getLabel();
            r.getLabel().animate({ opacity: 0 }, { duration: b && 150, complete: () => {
              g.hide(), r.container && r.container.remove();
            } }), r.isHidden = !0;
          }, b));
        }
        init(b, r) {
          this.chart = b, this.options = r, this.crosshairs = [], this.isHidden = !0, this.split = r.split && !b.inverted && !b.polar, this.shared = r.shared || this.split, this.outside = o(r.outside, !!(b.scrollablePixelsX || b.scrollablePixelsY));
        }
        shouldStickOnContact(b) {
          return !!(!this.followPointer && this.options.stickOnContact && (!b || this.pointer.inClass(b.target, "highcharts-tooltip")));
        }
        move(b, r, g, d) {
          let M = this, H = X(!M.isHidden && M.options.animation), A = M.followPointer || (M.len || 0) > 1, D = { x: b, y: r };
          A || (D.anchorX = g, D.anchorY = d), H.step = () => M.drawTracker(), M.getLabel().animate(D, H);
        }
        refresh(b, r) {
          let { chart: g, options: d, pointer: M, shared: H } = this, A = c(b), D = A[0], W = [], G = d.format, it = d.formatter || this.defaultFormatter, C = g.styledMode, k = {}, L = this.allowShared;
          if (!d.enabled || !D.series) return;
          q.clearTimeout(this.hideTimer), this.allowShared = !(!v(b) && b.series && b.series.noSharedTooltip), L = L && !this.allowShared, this.followPointer = !this.split && D.series.tooltipOptions.followPointer;
          let F = this.getAnchor(b, r), m = F[0], E = F[1];
          H && this.allowShared ? (M.applyInactiveState(A), A.forEach(function(z) {
            z.setState("hover"), W.push(z.getLabelConfig());
          }), (k = D.getLabelConfig()).points = W) : k = D.getLabelConfig(), this.len = W.length;
          let P = B(G) ? I(G, k, g) : it.call(k, this), R = D.series;
          if (this.distance = o(R.tooltipOptions.distance, 16), P === !1) this.hide();
          else {
            if (this.split && this.allowShared) this.renderSplit(P, A);
            else {
              let z = m, $ = E;
              if (r && M.isDirectTouch && (z = r.chartX - g.plotLeft, $ = r.chartY - g.plotTop), g.polar || R.options.clip === !1 || A.some((et) => M.isDirectTouch || et.series.shouldShowTooltip(z, $))) {
                let et = this.getLabel(L && this.tt || {});
                (!d.style.width || C) && et.css({ width: (this.outside ? this.getPlayingField() : g.spacingBox).width + "px" }), et.attr({ class: this.getClassName(D), text: P && P.join ? P.join("") : P }), this.outside && et.attr({ x: s(et.x || 0, 0, this.getPlayingField().width - (et.width || 0)) }), C || et.attr({ stroke: d.borderColor || D.color || R.color || "#666666" }), this.updatePosition({ plotX: m, plotY: E, negative: D.negative, ttBelow: D.ttBelow, h: F[2] || 0 });
              } else {
                this.hide();
                return;
              }
            }
            this.isHidden && this.label && this.label.attr({ opacity: 1 }).show(), this.isHidden = !1;
          }
          a(this, "refresh");
        }
        renderSplit(b, r) {
          var ut;
          let g = this, { chart: d, chart: { chartWidth: M, chartHeight: H, plotHeight: A, plotLeft: D, plotTop: W, scrollablePixelsY: G = 0, scrollablePixelsX: it, styledMode: C }, distance: k, options: L, options: { positioner: F }, pointer: m } = g, { scrollLeft: E = 0, scrollTop: P = 0 } = ((ut = d.scrollablePlotArea) == null ? void 0 : ut.scrollingContainer) || {}, R = g.outside && typeof it != "number" ? y.documentElement.getBoundingClientRect() : { left: E, right: E + M }, z = g.getLabel(), $ = this.renderer || d.renderer, et = !!(d.xAxis[0] && d.xAxis[0].opposite), { left: rt, top: nt } = m.getChartPosition(), dt = W + P, ct = 0, V = A - G;
          function Y(pt, ft, gt, mt, yt = !0) {
            let wt, xt;
            return gt ? (wt = et ? 0 : V, xt = s(pt - mt / 2, R.left, R.right - mt - (g.outside ? rt : 0))) : (wt = ft - dt, xt = s(xt = yt ? pt - mt - k : pt + k, yt ? xt : R.left, R.right)), { x: xt, y: wt };
          }
          B(b) && (b = [!1, b]);
          let Q = b.slice(0, r.length + 1).reduce(function(pt, ft, gt) {
            if (ft !== !1 && ft !== "") {
              let mt = r[gt - 1] || { isHeader: !0, plotX: r[0].plotX, plotY: A, series: {} }, yt = mt.isHeader, wt = yt ? g : mt.series, xt = wt.tt = function(Tt, St, Et) {
                var Ut;
                let Pt = Tt, { isHeader: Yt, series: Qt } = St;
                if (!Pt) {
                  let Gt = { padding: L.padding, r: L.borderRadius };
                  C || (Gt.fill = L.backgroundColor, Gt["stroke-width"] = (Ut = L.borderWidth) != null ? Ut : 1), Pt = $.label("", 0, 0, L[Yt ? "headerShape" : "shape"], void 0, void 0, L.useHTML).addClass(g.getClassName(St, !0, Yt)).attr(Gt).add(z);
                }
                return Pt.isActive = !0, Pt.attr({ text: Et }), C || Pt.css(L.style).attr({ stroke: L.borderColor || St.color || Qt.color || "#333333" }), Pt;
              }(wt.tt, mt, ft.toString()), bt = xt.getBBox(), Ct = bt.width + xt.strokeWidth();
              yt && (ct = bt.height, V += ct, et && (dt -= ct));
              let { anchorX: vt, anchorY: kt } = function(Tt) {
                let St, Et, { isHeader: Pt, plotX: Yt = 0, plotY: Qt = 0, series: Ut } = Tt;
                if (Pt) St = Math.max(D + Yt, D), Et = W + A / 2;
                else {
                  let { xAxis: Gt, yAxis: Nt } = Ut;
                  St = Gt.pos + s(Yt, -k, Gt.len + k), Ut.shouldShowTooltip(0, Nt.pos - W + Qt, { ignoreX: !0 }) && (Et = Nt.pos + Qt);
                }
                return { anchorX: St = s(St, R.left - k, R.right + k), anchorY: Et };
              }(mt);
              if (typeof kt == "number") {
                let Tt = bt.height + 1, St = F ? F.call(g, Ct, Tt, mt) : Y(vt, kt, yt, Ct);
                pt.push({ align: F ? 0 : void 0, anchorX: vt, anchorY: kt, boxWidth: Ct, point: mt, rank: o(St.rank, yt ? 1 : 0), size: Tt, target: St.y, tt: xt, x: St.x });
              } else xt.isActive = !1;
            }
            return pt;
          }, []);
          !F && Q.some((pt) => {
            let { outside: ft } = g, gt = (ft ? rt : 0) + pt.anchorX;
            return gt < R.left && gt + pt.boxWidth < R.right || gt < rt - R.left + pt.boxWidth && R.right - gt > gt;
          }) && (Q = Q.map((pt) => {
            let { x: ft, y: gt } = Y(pt.anchorX, pt.anchorY, pt.point.isHeader, pt.boxWidth, !1);
            return n(pt, { target: gt, x: ft });
          })), g.cleanSplit(), f(Q, V);
          let st = { left: rt, right: rt };
          Q.forEach(function(pt) {
            let { x: ft, boxWidth: gt, isHeader: mt } = pt;
            !mt && (g.outside && rt + ft < st.left && (st.left = rt + ft), !mt && g.outside && st.left + gt > st.right && (st.right = rt + ft));
          }), Q.forEach(function(pt) {
            let { x: ft, anchorX: gt, anchorY: mt, pos: yt, point: { isHeader: wt } } = pt, xt = { visibility: yt === void 0 ? "hidden" : "inherit", x: ft, y: (yt || 0) + dt, anchorX: gt, anchorY: mt };
            if (g.outside && ft < gt) {
              let bt = rt - st.left;
              bt > 0 && (wt || (xt.x = ft + bt, xt.anchorX = gt + bt), wt && (xt.x = (st.right - st.left) / 2, xt.anchorX = gt + bt));
            }
            pt.tt.attr(xt);
          });
          let { container: at, outside: ht, renderer: lt } = g;
          if (ht && at && lt) {
            let { width: pt, height: ft, x: gt, y: mt } = z.getBBox();
            lt.setSize(pt + gt, ft + mt, !1), at.style.left = st.left + "px", at.style.top = nt + "px";
          }
          w && z.attr({ opacity: z.opacity === 1 ? 0.999 : 1 });
        }
        drawTracker() {
          if (!this.shouldStickOnContact()) {
            this.tracker && (this.tracker = this.tracker.destroy());
            return;
          }
          let b = this.chart, r = this.label, g = this.shared ? b.hoverPoints : b.hoverPoint;
          if (!r || !g) return;
          let d = { x: 0, y: 0, width: 0, height: 0 }, M = this.getAnchor(g), H = r.getBBox();
          M[0] += b.plotLeft - (r.translateX || 0), M[1] += b.plotTop - (r.translateY || 0), d.x = Math.min(0, M[0]), d.y = Math.min(0, M[1]), d.width = M[0] < 0 ? Math.max(Math.abs(M[0]), H.width - M[0]) : Math.max(Math.abs(M[0]), H.width), d.height = M[1] < 0 ? Math.max(Math.abs(M[1]), H.height - Math.abs(M[1])) : Math.max(Math.abs(M[1]), H.height), this.tracker ? this.tracker.attr(d) : (this.tracker = r.renderer.rect(d).addClass("highcharts-tracker").add(r), b.styledMode || this.tracker.attr({ fill: "rgba(0,0,0,0)" }));
        }
        styledModeFormat(b) {
          return b.replace('style="font-size: 0.8em"', 'class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g, 'class="highcharts-color-{$1.colorIndex} {series.options.className} {point.options.className}"');
        }
        tooltipFooterHeaderFormatter(b, r) {
          let g = b.series, d = g.tooltipOptions, M = g.xAxis, H = M && M.dateTime, A = { isFooter: r, labelConfig: b }, D = d.xDateFormat, W = d[r ? "footerFormat" : "headerFormat"];
          return a(this, "headerFormatter", A, function(G) {
            H && !D && N(b.key) && (D = H.getXDateFormat(b.key, d.dateTimeLabelFormats)), H && D && (b.point && b.point.tooltipDateKeys || ["key"]).forEach(function(it) {
              W = W.replace("{point." + it + "}", "{point." + it + ":" + D + "}");
            }), g.chart.styledMode && (W = this.styledModeFormat(W)), G.text = I(W, { point: b, series: g }, this.chart);
          }), A.text;
        }
        update(b) {
          this.destroy(), this.init(this.chart, T(!0, this.options, b));
        }
        updatePosition(b) {
          let { chart: r, container: g, distance: d, options: M, pointer: H, renderer: A } = this, { height: D = 0, width: W = 0 } = this.getLabel(), { left: G, top: it, scaleX: C, scaleY: k } = H.getChartPosition(), L = (M.positioner || this.getPosition).call(this, W, D, b), F = (b.plotX || 0) + r.plotLeft, m = (b.plotY || 0) + r.plotTop, E;
          A && g && (M.positioner && (L.x += G - d, L.y += it - d), E = (M.borderWidth || 0) + 2 * d + 2, A.setSize(W + E, D + E, !1), (C !== 1 || k !== 1) && (l(g, { transform: `scale(${C}, ${k})` }), F *= C, m *= k), F += G - L.x, m += it - L.y), this.move(Math.round(L.x), Math.round(L.y || 0), F, m);
        }
      }
      return (tt = t || (t = {})).compose = function(h) {
        u(O, "Core.Tooltip") && x(h, "afterInit", function() {
          let b = this.chart;
          b.options.tooltip && (b.tooltip = new tt(b, b.options.tooltip, this));
        });
      }, t;
    }), ot(i, "Core/Series/Point.js", [i["Core/Renderer/HTML/AST.js"], i["Core/Animation/AnimationUtilities.js"], i["Core/Defaults.js"], i["Core/Templating.js"], i["Core/Utilities.js"]], function(U, _, K, Z, J) {
      let { animObject: q } = _, { defaultOptions: tt } = K, { format: X } = Z, { addEvent: I, crisp: O, erase: y, extend: w, fireEvent: f, getNestedProperty: x, isArray: s, isFunction: l, isNumber: p, isObject: n, merge: a, pick: v, syncTimeout: N, removeEvent: B, uniqueKey: T } = J;
      class o {
        animateBeforeDestroy() {
          let c = this, e = { x: c.startXPos, opacity: 0 }, t = c.getGraphicalProps();
          t.singular.forEach(function(h) {
            c[h] = c[h].animate(h === "dataLabel" ? { x: c[h].startXPos, y: c[h].startYPos, opacity: 0 } : e);
          }), t.plural.forEach(function(h) {
            c[h].forEach(function(b) {
              b.element && b.animate(w({ x: c.startXPos }, b.startYPos ? { x: b.startXPos, y: b.startYPos } : {}));
            });
          });
        }
        applyOptions(c, e) {
          let t = this.series, h = t.options.pointValKey || t.pointValKey;
          return w(this, c = o.prototype.optionsToObject.call(this, c)), this.options = this.options ? w(this.options, c) : c, c.group && delete this.group, c.dataLabels && delete this.dataLabels, h && (this.y = o.prototype.getNestedProperty.call(this, h)), this.selected && (this.state = "select"), "name" in this && e === void 0 && t.xAxis && t.xAxis.hasNames && (this.x = t.xAxis.nameToX(this)), this.x === void 0 && t ? this.x = e != null ? e : t.autoIncrement() : p(c.x) && t.options.relativeXValue && (this.x = t.autoIncrement(c.x)), this.isNull = this.isValid && !this.isValid(), this.formatPrefix = this.isNull ? "null" : "point", this;
        }
        destroy() {
          if (!this.destroyed) {
            let c = this, e = c.series, t = e.chart, h = e.options.dataSorting, b = t.hoverPoints, r = q(c.series.chart.renderer.globalAnimation), g = () => {
              for (let d in (c.graphic || c.graphics || c.dataLabel || c.dataLabels) && (B(c), c.destroyElements()), c) delete c[d];
            };
            c.legendItem && t.legend.destroyItem(c), b && (c.setState(), y(b, c), b.length || (t.hoverPoints = null)), c === t.hoverPoint && c.onMouseOut(), h && h.enabled ? (this.animateBeforeDestroy(), N(g, r.duration)) : g(), t.pointCount--;
          }
          this.destroyed = !0;
        }
        destroyElements(c) {
          let e = this, t = e.getGraphicalProps(c);
          t.singular.forEach(function(h) {
            e[h] = e[h].destroy();
          }), t.plural.forEach(function(h) {
            e[h].forEach(function(b) {
              b && b.element && b.destroy();
            }), delete e[h];
          });
        }
        firePointEvent(c, e, t) {
          let h = this, b = this.series.options;
          h.manageEvent(c), c === "click" && b.allowPointSelect && (t = function(r) {
            !h.destroyed && h.select && h.select(null, r.ctrlKey || r.metaKey || r.shiftKey);
          }), f(h, c, e, t);
        }
        getClassName() {
          return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + (this.colorIndex !== void 0 ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone && this.zone.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
        }
        getGraphicalProps(c) {
          let e, t, h = this, b = [], r = { singular: [], plural: [] };
          for ((c = c || { graphic: 1, dataLabel: 1 }).graphic && b.push("graphic", "connector"), c.dataLabel && b.push("dataLabel", "dataLabelPath", "dataLabelUpper"), t = b.length; t--; ) h[e = b[t]] && r.singular.push(e);
          return ["graphic", "dataLabel"].forEach(function(g) {
            let d = g + "s";
            c[g] && h[d] && r.plural.push(d);
          }), r;
        }
        getLabelConfig() {
          return { x: this.category, y: this.y, color: this.color, colorIndex: this.colorIndex, key: this.name || this.category, series: this.series, point: this, percentage: this.percentage, total: this.total || this.stackTotal };
        }
        getNestedProperty(c) {
          return c ? c.indexOf("custom.") === 0 ? x(c, this.options) : this[c] : void 0;
        }
        getZone() {
          let c = this.series, e = c.zones, t = c.zoneAxis || "y", h, b = 0;
          for (h = e[0]; this[t] >= h.value; ) h = e[++b];
          return this.nonZonedColor || (this.nonZonedColor = this.color), h && h.color && !this.options.color ? this.color = h.color : this.color = this.nonZonedColor, h;
        }
        hasNewShapeType() {
          return (this.graphic && (this.graphic.symbolName || this.graphic.element.nodeName)) !== this.shapeType;
        }
        constructor(c, e, t) {
          var h;
          this.formatPrefix = "point", this.visible = !0, this.series = c, this.applyOptions(e, t), (h = this.id) != null || (this.id = T()), this.resolveColor(), c.chart.pointCount++, f(this, "afterInit");
        }
        isValid() {
          return (p(this.x) || this.x instanceof Date) && p(this.y);
        }
        optionsToObject(c) {
          let e = this.series, t = e.options.keys, h = t || e.pointArrayMap || ["y"], b = h.length, r = {}, g, d = 0, M = 0;
          if (p(c) || c === null) r[h[0]] = c;
          else if (s(c)) for (!t && c.length > b && ((g = typeof c[0]) == "string" ? r.name = c[0] : g === "number" && (r.x = c[0]), d++); M < b; ) t && c[d] === void 0 || (h[M].indexOf(".") > 0 ? o.prototype.setNestedProperty(r, c[d], h[M]) : r[h[M]] = c[d]), d++, M++;
          else typeof c == "object" && (r = c, c.dataLabels && (e.hasDataLabels = () => !0), c.marker && (e._hasPointMarkers = !0));
          return r;
        }
        pos(c, e = this.plotY) {
          if (!this.destroyed) {
            let { plotX: t, series: h } = this, { chart: b, xAxis: r, yAxis: g } = h, d = 0, M = 0;
            if (p(t) && p(e)) return c && (d = r ? r.pos : b.plotLeft, M = g ? g.pos : b.plotTop), b.inverted && r && g ? [g.len - e + M, r.len - t + d] : [t + d, e + M];
          }
        }
        resolveColor() {
          let c = this.series, e = c.chart.options.chart, t = c.chart.styledMode, h, b, r = e.colorCount, g;
          delete this.nonZonedColor, c.options.colorByPoint ? (t || (h = (b = c.options.colors || c.chart.options.colors)[c.colorCounter], r = b.length), g = c.colorCounter, c.colorCounter++, c.colorCounter === r && (c.colorCounter = 0)) : (t || (h = c.color), g = c.colorIndex), this.colorIndex = v(this.options.colorIndex, g), this.color = v(this.options.color, h);
        }
        setNestedProperty(c, e, t) {
          return t.split(".").reduce(function(h, b, r, g) {
            let d = g.length - 1 === r;
            return h[b] = d ? e : n(h[b], !0) ? h[b] : {}, h[b];
          }, c), c;
        }
        shouldDraw() {
          return !this.isNull;
        }
        tooltipFormatter(c) {
          let e = this.series, t = e.tooltipOptions, h = v(t.valueDecimals, ""), b = t.valuePrefix || "", r = t.valueSuffix || "";
          return e.chart.styledMode && (c = e.chart.tooltip.styledModeFormat(c)), (e.pointArrayMap || ["y"]).forEach(function(g) {
            g = "{point." + g, (b || r) && (c = c.replace(RegExp(g + "}", "g"), b + g + "}" + r)), c = c.replace(RegExp(g + "}", "g"), g + ":,." + h + "f}");
          }), X(c, { point: this, series: this.series }, e.chart);
        }
        update(c, e, t, h) {
          let b, r = this, g = r.series, d = r.graphic, M = g.chart, H = g.options;
          function A() {
            r.applyOptions(c);
            let D = d && r.hasMockGraphic, W = r.y === null ? !D : D;
            d && W && (r.graphic = d.destroy(), delete r.hasMockGraphic), n(c, !0) && (d && d.element && c && c.marker && c.marker.symbol !== void 0 && (r.graphic = d.destroy()), c != null && c.dataLabels && r.dataLabel && (r.dataLabel = r.dataLabel.destroy())), b = r.index, g.updateParallelArrays(r, b), H.data[b] = n(H.data[b], !0) || n(c, !0) ? r.options : v(c, H.data[b]), g.isDirty = g.isDirtyData = !0, !g.fixedBox && g.hasCartesianSeries && (M.isDirtyBox = !0), H.legendType === "point" && (M.isDirtyLegend = !0), e && M.redraw(t);
          }
          e = v(e, !0), h === !1 ? A() : r.firePointEvent("update", { options: c }, A);
        }
        remove(c, e) {
          this.series.removePoint(this.series.data.indexOf(this), c, e);
        }
        select(c, e) {
          let t = this, h = t.series, b = h.chart;
          c = v(c, !t.selected), this.selectedStaging = c, t.firePointEvent(c ? "select" : "unselect", { accumulate: e }, function() {
            t.selected = t.options.selected = c, h.options.data[h.data.indexOf(t)] = t.options, t.setState(c && "select"), e || b.getSelectedPoints().forEach(function(r) {
              let g = r.series;
              r.selected && r !== t && (r.selected = r.options.selected = !1, g.options.data[g.data.indexOf(r)] = r.options, r.setState(b.hoverPoints && g.options.inactiveOtherPoints ? "inactive" : ""), r.firePointEvent("unselect"));
            });
          }), delete this.selectedStaging;
        }
        onMouseOver(c) {
          let { inverted: e, pointer: t } = this.series.chart;
          t && (c = c ? t.normalize(c) : t.getChartCoordinatesFromPoint(this, e), t.runPointActions(c, this));
        }
        onMouseOut() {
          let c = this.series.chart;
          this.firePointEvent("mouseOut"), this.series.options.inactiveOtherPoints || (c.hoverPoints || []).forEach(function(e) {
            e.setState();
          }), c.hoverPoints = c.hoverPoint = null;
        }
        manageEvent(c) {
          var h, b, r, g, d, M;
          let e = a(this.series.options.point, this.options), t = (h = e.events) == null ? void 0 : h[c];
          l(t) && (!((b = this.hcEvents) != null && b[c]) || ((g = (r = this.hcEvents) == null ? void 0 : r[c]) == null ? void 0 : g.map((H) => H.fn).indexOf(t)) === -1) ? ((d = this.importedUserEvent) == null || d.call(this), this.importedUserEvent = I(this, c, t)) : this.importedUserEvent && !t && ((M = this.hcEvents) != null && M[c]) && (B(this, c), delete this.hcEvents[c], Object.keys(this.hcEvents) || delete this.importedUserEvent);
        }
        setState(c, e) {
          var P;
          let t = this.series, h = this.state, b = t.options.states[c || "normal"] || {}, r = tt.plotOptions[t.type].marker && t.options.marker, g = r && r.enabled === !1, d = r && r.states && r.states[c || "normal"] || {}, M = d.enabled === !1, H = this.marker || {}, A = t.chart, D = r && t.markerAttribs, W = t.halo, G, it, C, k = t.stateMarkerGraphic, L;
          if ((c = c || "") === this.state && !e || this.selected && c !== "select" || b.enabled === !1 || c && (M || g && d.enabled === !1) || c && H.states && H.states[c] && H.states[c].enabled === !1) return;
          if (this.state = c, D && (G = t.markerAttribs(this, c)), this.graphic && !this.hasMockGraphic) {
            if (h && this.graphic.removeClass("highcharts-point-" + h), c && this.graphic.addClass("highcharts-point-" + c), !A.styledMode) {
              it = t.pointAttribs(this, c), C = v(A.options.chart.animation, b.animation);
              let R = it.opacity;
              t.options.inactiveOtherPoints && p(R) && (this.dataLabels || []).forEach(function(z) {
                z && !z.hasClass("highcharts-data-label-hidden") && (z.animate({ opacity: R }, C), z.connector && z.connector.animate({ opacity: R }, C));
              }), this.graphic.animate(it, C);
            }
            G && this.graphic.animate(G, v(A.options.chart.animation, d.animation, r.animation)), k && k.hide();
          } else c && d && (L = H.symbol || t.symbol, k && k.currentSymbol !== L && (k = k.destroy()), G && (k ? k[e ? "animate" : "attr"]({ x: G.x, y: G.y }) : L && (t.stateMarkerGraphic = k = A.renderer.symbol(L, G.x, G.y, G.width, G.height).add(t.markerGroup), k.currentSymbol = L)), !A.styledMode && k && this.state !== "inactive" && k.attr(t.pointAttribs(this, c))), k && (k[c && this.isInside ? "show" : "hide"](), k.element.point = this, k.addClass(this.getClassName(), !0));
          let F = b.halo, m = this.graphic || k, E = m && m.visibility || "inherit";
          F && F.size && m && E !== "hidden" && !this.isCluster ? (W || (t.halo = W = A.renderer.path().add(m.parentGroup)), W.show()[e ? "animate" : "attr"]({ d: this.haloPath(F.size) }), W.attr({ class: "highcharts-halo highcharts-color-" + v(this.colorIndex, t.colorIndex) + (this.className ? " " + this.className : ""), visibility: E, zIndex: -1 }), W.point = this, A.styledMode || W.attr(w({ fill: this.color || t.color, "fill-opacity": F.opacity }, U.filterUserAttributes(F.attributes || {})))) : (P = W == null ? void 0 : W.point) != null && P.haloPath && !W.point.destroyed && W.animate({ d: W.point.haloPath(0) }, null, W.hide), f(this, "afterSetState", { state: c });
        }
        haloPath(c) {
          let e = this.pos();
          return e ? this.series.chart.renderer.symbols.circle(O(e[0], 1) - c, e[1] - c, 2 * c, 2 * c) : [];
        }
      }
      return o;
    }), ot(i, "Core/Pointer.js", [i["Core/Color/Color.js"], i["Core/Globals.js"], i["Core/Utilities.js"]], function(U, _, K) {
      var Z;
      let { parse: J } = U, { charts: q, composed: tt, isTouchDevice: X } = _, { addEvent: I, attr: O, css: y, extend: w, find: f, fireEvent: x, isNumber: s, isObject: l, objectEach: p, offset: n, pick: a, pushUnique: v, splat: N } = K;
      class B {
        applyInactiveState(o) {
          let u = [], c;
          (o || []).forEach(function(e) {
            c = e.series, u.push(c), c.linkedParent && u.push(c.linkedParent), c.linkedSeries && (u = u.concat(c.linkedSeries)), c.navigatorSeries && u.push(c.navigatorSeries);
          }), this.chart.series.forEach(function(e) {
            u.indexOf(e) === -1 ? e.setState("inactive", !0) : e.options.inactiveOtherPoints && e.setAllPointsToState("inactive");
          });
        }
        destroy() {
          let o = this;
          this.eventsToUnbind.forEach((u) => u()), this.eventsToUnbind = [], !_.chartCount && (B.unbindDocumentMouseUp && B.unbindDocumentMouseUp.forEach((u) => u()), B.unbindDocumentTouchEnd && (B.unbindDocumentTouchEnd = B.unbindDocumentTouchEnd())), clearInterval(o.tooltipTimeout), p(o, function(u, c) {
            o[c] = void 0;
          });
        }
        getSelectionMarkerAttrs(o, u) {
          let c = { args: { chartX: o, chartY: u }, attrs: {}, shapeType: "rect" };
          return x(this, "getSelectionMarkerAttrs", c, (e) => {
            let t, { chart: h, zoomHor: b, zoomVert: r } = this, { mouseDownX: g = 0, mouseDownY: d = 0 } = h, M = e.attrs;
            M.x = h.plotLeft, M.y = h.plotTop, M.width = b ? 1 : h.plotWidth, M.height = r ? 1 : h.plotHeight, b && (t = o - g, M.width = Math.max(1, Math.abs(t)), M.x = (t > 0 ? 0 : t) + g), r && (t = u - d, M.height = Math.max(1, Math.abs(t)), M.y = (t > 0 ? 0 : t) + d);
          }), c;
        }
        drag(o) {
          let { chart: u } = this, { mouseDownX: c = 0, mouseDownY: e = 0 } = u, { panning: t, panKey: h, selectionMarkerFill: b } = u.options.chart, r = u.plotLeft, g = u.plotTop, d = u.plotWidth, M = u.plotHeight, H = l(t) ? t.enabled : t, A = h && o[`${h}Key`], D = o.chartX, W = o.chartY, G, it = this.selectionMarker;
          if ((!it || !it.touch) && (D < r ? D = r : D > r + d && (D = r + d), W < g ? W = g : W > g + M && (W = g + M), this.hasDragged = Math.sqrt(Math.pow(c - D, 2) + Math.pow(e - W, 2)), this.hasDragged > 10)) {
            G = u.isInsidePlot(c - r, e - g, { visiblePlotOnly: !0 });
            let { shapeType: C, attrs: k } = this.getSelectionMarkerAttrs(D, W);
            (u.hasCartesianSeries || u.mapView) && this.hasZoom && G && !A && !it && (this.selectionMarker = it = u.renderer[C](), it.attr({ class: "highcharts-selection-marker", zIndex: 7 }).add(), u.styledMode || it.attr({ fill: b || J("#334eff").setOpacity(0.25).get() })), it && it.attr(k), G && !it && H && u.pan(o, t);
          }
        }
        dragStart(o) {
          let u = this.chart;
          u.mouseIsDown = o.type, u.cancelClick = !1, u.mouseDownX = o.chartX, u.mouseDownY = o.chartY;
        }
        getSelectionBox(o) {
          let u = { args: { marker: o }, result: o.getBBox() };
          return x(this, "getSelectionBox", u), u.result;
        }
        drop(o) {
          let u, { chart: c, selectionMarker: e } = this;
          for (let t of c.axes) t.isPanning && (t.isPanning = !1, (t.options.startOnTick || t.options.endOnTick || t.series.some((h) => h.boosted)) && (t.forceRedraw = !0, t.setExtremes(t.userMin, t.userMax, !1), u = !0));
          if (u && c.redraw(), e && o) {
            if (this.hasDragged) {
              let t = this.getSelectionBox(e);
              c.transform({ axes: c.axes.filter((h) => h.zoomEnabled && (h.coll === "xAxis" && this.zoomX || h.coll === "yAxis" && this.zoomY)), selection: { originalEvent: o, xAxis: [], yAxis: [], ...t }, from: t });
            }
            s(c.index) && (this.selectionMarker = e.destroy());
          }
          c && s(c.index) && (y(c.container, { cursor: c._cursor }), c.cancelClick = this.hasDragged > 10, c.mouseIsDown = !1, this.hasDragged = 0, this.pinchDown = []);
        }
        findNearestKDPoint(o, u, c) {
          let e;
          return o.forEach(function(t) {
            let h = !(t.noSharedTooltip && u) && 0 > t.options.findNearestPointBy.indexOf("y"), b = t.searchPoint(c, h);
            l(b, !0) && b.series && (!l(e, !0) || function(r, g) {
              var A, D;
              let d = r.distX - g.distX, M = r.dist - g.dist, H = ((A = g.series.group) == null ? void 0 : A.zIndex) - ((D = r.series.group) == null ? void 0 : D.zIndex);
              return d !== 0 && u ? d : M !== 0 ? M : H !== 0 ? H : r.series.index > g.series.index ? -1 : 1;
            }(e, b) > 0) && (e = b);
          }), e;
        }
        getChartCoordinatesFromPoint(o, u) {
          var h, b;
          let { xAxis: c, yAxis: e } = o.series, t = o.shapeArgs;
          if (c && e) {
            let r = (b = (h = o.clientX) != null ? h : o.plotX) != null ? b : 0, g = o.plotY || 0;
            return o.isNode && t && s(t.x) && s(t.y) && (r = t.x, g = t.y), u ? { chartX: e.len + e.pos - g, chartY: c.len + c.pos - r } : { chartX: r + c.pos, chartY: g + e.pos };
          }
          if (t && t.x && t.y) return { chartX: t.x, chartY: t.y };
        }
        getChartPosition() {
          if (this.chartPosition) return this.chartPosition;
          let { container: o } = this.chart, u = n(o);
          this.chartPosition = { left: u.left, top: u.top, scaleX: 1, scaleY: 1 };
          let { offsetHeight: c, offsetWidth: e } = o;
          return e > 2 && c > 2 && (this.chartPosition.scaleX = u.width / e, this.chartPosition.scaleY = u.height / c), this.chartPosition;
        }
        getCoordinates(o) {
          let u = { xAxis: [], yAxis: [] };
          for (let c of this.chart.axes) u[c.isXAxis ? "xAxis" : "yAxis"].push({ axis: c, value: c.toValue(o[c.horiz ? "chartX" : "chartY"]) });
          return u;
        }
        getHoverData(o, u, c, e, t, h) {
          let b = [], r = function(A) {
            return A.visible && !(!t && A.directTouch) && a(A.options.enableMouseTracking, !0);
          }, g = u, d, M = { chartX: h ? h.chartX : void 0, chartY: h ? h.chartY : void 0, shared: t };
          x(this, "beforeGetHoverData", M), d = g && !g.stickyTracking ? [g] : c.filter((A) => A.stickyTracking && (M.filter || r)(A));
          let H = e && o || !h ? o : this.findNearestKDPoint(d, t, h);
          return g = H && H.series, H && (t && !g.noSharedTooltip ? (d = c.filter(function(A) {
            return M.filter ? M.filter(A) : r(A) && !A.noSharedTooltip;
          })).forEach(function(A) {
            let D = f(A.points, function(W) {
              return W.x === H.x && !W.isNull;
            });
            l(D) && (A.boosted && A.boost && (D = A.boost.getPoint(D)), b.push(D));
          }) : b.push(H)), x(this, "afterGetHoverData", M = { hoverPoint: H }), { hoverPoint: M.hoverPoint, hoverSeries: g, hoverPoints: b };
        }
        getPointFromEvent(o) {
          let u = o.target, c;
          for (; u && !c; ) c = u.point, u = u.parentNode;
          return c;
        }
        onTrackerMouseOut(o) {
          let u = this.chart, c = o.relatedTarget, e = u.hoverSeries;
          this.isDirectTouch = !1, !e || !c || e.stickyTracking || this.inClass(c, "highcharts-tooltip") || this.inClass(c, "highcharts-series-" + e.index) && this.inClass(c, "highcharts-tracker") || e.onMouseOut();
        }
        inClass(o, u) {
          let c = o, e;
          for (; c; ) {
            if (e = O(c, "class")) {
              if (e.indexOf(u) !== -1) return !0;
              if (e.indexOf("highcharts-container") !== -1) return !1;
            }
            c = c.parentElement;
          }
        }
        constructor(o, u) {
          var c;
          this.hasDragged = 0, this.pointerCaptureEventsToUnbind = [], this.eventsToUnbind = [], this.options = u, this.chart = o, this.runChartClick = !!((c = u.chart.events) != null && c.click), this.pinchDown = [], this.setDOMEvents(), x(this, "afterInit");
        }
        normalize(o, u) {
          let c = o.touches, e = c ? c.length ? c.item(0) : a(c.changedTouches, o.changedTouches)[0] : o;
          u || (u = this.getChartPosition());
          let t = e.pageX - u.left, h = e.pageY - u.top;
          return w(o, { chartX: Math.round(t /= u.scaleX), chartY: Math.round(h /= u.scaleY) });
        }
        onContainerClick(o) {
          let u = this.chart, c = u.hoverPoint, e = this.normalize(o), t = u.plotLeft, h = u.plotTop;
          !u.cancelClick && (c && this.inClass(e.target, "highcharts-tracker") ? (x(c.series, "click", w(e, { point: c })), u.hoverPoint && c.firePointEvent("click", e)) : (w(e, this.getCoordinates(e)), u.isInsidePlot(e.chartX - t, e.chartY - h, { visiblePlotOnly: !0 }) && x(u, "click", e)));
        }
        onContainerMouseDown(o) {
          var c;
          let u = (1 & (o.buttons || o.button)) == 1;
          o = this.normalize(o), _.isFirefox && o.button !== 0 && this.onContainerMouseMove(o), (o.button === void 0 || u) && (this.zoomOption(o), u && ((c = o.preventDefault) == null || c.call(o)), this.dragStart(o));
        }
        onContainerMouseLeave(o) {
          let { pointer: u } = q[a(B.hoverChartIndex, -1)] || {};
          o = this.normalize(o), this.onContainerMouseMove(o), u && !this.inClass(o.relatedTarget, "highcharts-tooltip") && (u.reset(), u.chartPosition = void 0);
        }
        onContainerMouseEnter() {
          delete this.chartPosition;
        }
        onContainerMouseMove(o) {
          let u = this.chart, c = u.tooltip, e = this.normalize(o);
          this.setHoverChartIndex(o), (u.mouseIsDown === "mousedown" || this.touchSelect(e)) && this.drag(e), !u.openMenu && (this.inClass(e.target, "highcharts-tracker") || u.isInsidePlot(e.chartX - u.plotLeft, e.chartY - u.plotTop, { visiblePlotOnly: !0 })) && !(c && c.shouldStickOnContact(e)) && (this.inClass(e.target, "highcharts-no-tooltip") ? this.reset(!1, 0) : this.runPointActions(e));
        }
        onDocumentTouchEnd(o) {
          this.onDocumentMouseUp(o);
        }
        onContainerTouchMove(o) {
          this.touchSelect(o) ? this.onContainerMouseMove(o) : this.touch(o);
        }
        onContainerTouchStart(o) {
          this.touchSelect(o) ? this.onContainerMouseDown(o) : (this.zoomOption(o), this.touch(o, !0));
        }
        onDocumentMouseMove(o) {
          let u = this.chart, c = u.tooltip, e = this.chartPosition, t = this.normalize(o, e);
          !e || u.isInsidePlot(t.chartX - u.plotLeft, t.chartY - u.plotTop, { visiblePlotOnly: !0 }) || c && c.shouldStickOnContact(t) || t.target !== u.container.ownerDocument && this.inClass(t.target, "highcharts-tracker") || this.reset();
        }
        onDocumentMouseUp(o) {
          var u, c;
          (c = (u = q[a(B.hoverChartIndex, -1)]) == null ? void 0 : u.pointer) == null || c.drop(o);
        }
        pinch(o) {
          let u = this, { chart: c, hasZoom: e, lastTouches: t } = u, h = [].map.call(o.touches || [], (M) => u.normalize(M)), b = h.length, r = b === 1 && (u.inClass(o.target, "highcharts-tracker") && c.runTrackerClick || u.runChartClick), g = c.tooltip, d = b === 1 && a(g == null ? void 0 : g.options.followTouchMove, !0);
          b > 1 ? u.initiated = !0 : d && (u.initiated = !1), e && u.initiated && !r && o.cancelable !== !1 && o.preventDefault(), o.type === "touchstart" ? (u.pinchDown = h, u.res = !0, c.mouseDownX = o.chartX) : d ? this.runPointActions(u.normalize(o)) : t && (x(c, "touchpan", { originalEvent: o, touches: h }, () => {
            let M = (H) => {
              let A = H[0], D = H[1] || A;
              return { x: A.chartX, y: A.chartY, width: D.chartX - A.chartX, height: D.chartY - A.chartY };
            };
            c.transform({ axes: c.axes.filter((H) => H.zoomEnabled && (this.zoomHor && H.horiz || this.zoomVert && !H.horiz)), to: M(h), from: M(t), trigger: o.type });
          }), u.res && (u.res = !1, this.reset(!1, 0))), u.lastTouches = h;
        }
        reset(o, u) {
          let c = this.chart, e = c.hoverSeries, t = c.hoverPoint, h = c.hoverPoints, b = c.tooltip, r = b && b.shared ? h : t;
          o && r && N(r).forEach(function(g) {
            g.series.isCartesian && g.plotX === void 0 && (o = !1);
          }), o ? b && r && N(r).length && (b.refresh(r), b.shared && h ? h.forEach(function(g) {
            g.setState(g.state, !0), g.series.isCartesian && (g.series.xAxis.crosshair && g.series.xAxis.drawCrosshair(null, g), g.series.yAxis.crosshair && g.series.yAxis.drawCrosshair(null, g));
          }) : t && (t.setState(t.state, !0), c.axes.forEach(function(g) {
            g.crosshair && t.series[g.coll] === g && g.drawCrosshair(null, t);
          }))) : (t && t.onMouseOut(), h && h.forEach(function(g) {
            g.setState();
          }), e && e.onMouseOut(), b && b.hide(u), this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove()), c.axes.forEach(function(g) {
            g.hideCrosshair();
          }), c.hoverPoints = c.hoverPoint = void 0);
        }
        runPointActions(o, u, c) {
          let e = this.chart, t = e.series, h = e.tooltip && e.tooltip.options.enabled ? e.tooltip : void 0, b = !!h && h.shared, r = u || e.hoverPoint, g = r && r.series || e.hoverSeries, d = (!o || o.type !== "touchmove") && (!!u || g && g.directTouch && this.isDirectTouch), M = this.getHoverData(r, g, t, d, b, o);
          r = M.hoverPoint, g = M.hoverSeries;
          let H = M.hoverPoints, A = g && g.tooltipOptions.followPointer && !g.tooltipOptions.split, D = b && g && !g.noSharedTooltip;
          if (r && (c || r !== e.hoverPoint || h && h.isHidden)) {
            if ((e.hoverPoints || []).forEach(function(W) {
              H.indexOf(W) === -1 && W.setState();
            }), e.hoverSeries !== g && g.onMouseOver(), this.applyInactiveState(H), (H || []).forEach(function(W) {
              W.setState("hover");
            }), e.hoverPoint && e.hoverPoint.firePointEvent("mouseOut"), !r.series) return;
            e.hoverPoints = H, e.hoverPoint = r, r.firePointEvent("mouseOver", void 0, () => {
              h && r && h.refresh(D ? H : r, o);
            });
          } else if (A && h && !h.isHidden) {
            let W = h.getAnchor([{}], o);
            e.isInsidePlot(W[0], W[1], { visiblePlotOnly: !0 }) && h.updatePosition({ plotX: W[0], plotY: W[1] });
          }
          this.unDocMouseMove || (this.unDocMouseMove = I(e.container.ownerDocument, "mousemove", (W) => {
            var G, it, C;
            return (C = (it = q[(G = B.hoverChartIndex) != null ? G : -1]) == null ? void 0 : it.pointer) == null ? void 0 : C.onDocumentMouseMove(W);
          }), this.eventsToUnbind.push(this.unDocMouseMove)), e.axes.forEach(function(W) {
            let G, it = a((W.crosshair || {}).snap, !0);
            !it || (G = e.hoverPoint) && G.series[W.coll] === W || (G = f(H, (C) => C.series && C.series[W.coll] === W)), G || !it ? W.drawCrosshair(o, G) : W.hideCrosshair();
          });
        }
        setDOMEvents() {
          let o = this.chart.container, u = o.ownerDocument;
          o.onmousedown = this.onContainerMouseDown.bind(this), o.onmousemove = this.onContainerMouseMove.bind(this), o.onclick = this.onContainerClick.bind(this), this.eventsToUnbind.push(I(o, "mouseenter", this.onContainerMouseEnter.bind(this)), I(o, "mouseleave", this.onContainerMouseLeave.bind(this))), B.unbindDocumentMouseUp || (B.unbindDocumentMouseUp = []), B.unbindDocumentMouseUp.push(I(u, "mouseup", this.onDocumentMouseUp.bind(this)));
          let c = this.chart.renderTo.parentElement;
          for (; c && c.tagName !== "BODY"; ) this.eventsToUnbind.push(I(c, "scroll", () => {
            delete this.chartPosition;
          })), c = c.parentElement;
          this.eventsToUnbind.push(I(o, "touchstart", this.onContainerTouchStart.bind(this), { passive: !1 }), I(o, "touchmove", this.onContainerTouchMove.bind(this), { passive: !1 })), B.unbindDocumentTouchEnd || (B.unbindDocumentTouchEnd = I(u, "touchend", this.onDocumentTouchEnd.bind(this), { passive: !1 })), this.setPointerCapture(), I(this.chart, "redraw", this.setPointerCapture.bind(this));
        }
        setPointerCapture() {
          var t, h;
          if (!X) return;
          let o = this.pointerCaptureEventsToUnbind, u = this.chart, c = u.container, e = a((t = u.options.tooltip) == null ? void 0 : t.followTouchMove, !0) && u.series.some((b) => b.options.findNearestPointBy.indexOf("y") > -1);
          !this.hasPointerCapture && e ? (o.push(I(c, "pointerdown", (b) => {
            var r, g;
            (r = b.target) != null && r.hasPointerCapture(b.pointerId) && ((g = b.target) == null || g.releasePointerCapture(b.pointerId));
          }), I(c, "pointermove", (b) => {
            var r, g;
            (g = (r = u.pointer) == null ? void 0 : r.getPointFromEvent(b)) == null || g.onMouseOver(b);
          })), u.styledMode || y(c, { "touch-action": "none" }), c.className += " highcharts-no-touch-action", this.hasPointerCapture = !0) : this.hasPointerCapture && !e && (o.forEach((b) => b()), o.length = 0, u.styledMode || y(c, { "touch-action": a((h = u.options.chart.style) == null ? void 0 : h["touch-action"], "manipulation") }), c.className = c.className.replace(" highcharts-no-touch-action", ""), this.hasPointerCapture = !1);
        }
        setHoverChartIndex(o) {
          var e;
          let u = this.chart, c = _.charts[a(B.hoverChartIndex, -1)];
          if (c && c !== u) {
            let t = { relatedTarget: u.container };
            o && !(o != null && o.relatedTarget) && (o = { ...t, ...o }), (e = c.pointer) == null || e.onContainerMouseLeave(o || t);
          }
          c && c.mouseIsDown || (B.hoverChartIndex = u.index);
        }
        touch(o, u) {
          let c, { chart: e, pinchDown: t = [] } = this;
          this.setHoverChartIndex(), (o = this.normalize(o)).touches.length === 1 ? e.isInsidePlot(o.chartX - e.plotLeft, o.chartY - e.plotTop, { visiblePlotOnly: !0 }) && !e.openMenu ? (u && this.runPointActions(o), o.type === "touchmove" && (c = !!t[0] && Math.pow(t[0].chartX - o.chartX, 2) + Math.pow(t[0].chartY - o.chartY, 2) >= 16), a(c, !0) && this.pinch(o)) : u && this.reset() : o.touches.length === 2 && this.pinch(o);
        }
        touchSelect(o) {
          return !!(this.chart.zooming.singleTouch && o.touches && o.touches.length === 1);
        }
        zoomOption(o) {
          let u = this.chart, c = u.inverted, e = u.zooming.type || "", t, h;
          /touch/.test(o.type) && (e = a(u.zooming.pinchType, e)), this.zoomX = t = /x/.test(e), this.zoomY = h = /y/.test(e), this.zoomHor = t && !c || h && c, this.zoomVert = h && !c || t && c, this.hasZoom = t || h;
        }
      }
      return (Z = B || (B = {})).compose = function(T) {
        v(tt, "Core.Pointer") && I(T, "beforeRender", function() {
          this.pointer = new Z(this, this.options);
        });
      }, B;
    }), ot(i, "Core/Legend/LegendSymbol.js", [i["Core/Utilities.js"]], function(U) {
      var _;
      let { extend: K, merge: Z, pick: J } = U;
      return function(q) {
        function tt(X, I, O) {
          var c, e;
          let y = this.legendItem = this.legendItem || {}, { chart: w, options: f } = this, { baseline: x = 0, symbolWidth: s, symbolHeight: l } = X, p = this.symbol || "circle", n = l / 2, a = w.renderer, v = y.group, N = x - Math.round((((c = X.fontMetrics) == null ? void 0 : c.b) || l) * (O ? 0.4 : 0.3)), B = {}, T, o = f.marker, u = 0;
          if (w.styledMode || (B["stroke-width"] = Math.min(f.lineWidth || 0, 24), f.dashStyle ? B.dashstyle = f.dashStyle : f.linecap === "square" || (B["stroke-linecap"] = "round")), y.line = a.path().addClass("highcharts-graph").attr(B).add(v), O && (y.area = a.path().addClass("highcharts-area").add(v)), B["stroke-linecap"] && (u = Math.min(y.line.strokeWidth(), s) / 2), s) {
            let t = [["M", u, N], ["L", s - u, N]];
            y.line.attr({ d: t }), (e = y.area) == null || e.attr({ d: [...t, ["L", s - u, x], ["L", u, x]] });
          }
          if (o && o.enabled !== !1 && s) {
            let t = Math.min(J(o.radius, n), n);
            p.indexOf("url") === 0 && (o = Z(o, { width: l, height: l }), t = 0), y.symbol = T = a.symbol(p, s / 2 - t, N - t, 2 * t, 2 * t, K({ context: "legend" }, o)).addClass("highcharts-point").add(v), T.isMarker = !0;
          }
        }
        q.areaMarker = function(X, I) {
          tt.call(this, X, I, !0);
        }, q.lineMarker = tt, q.rectangle = function(X, I) {
          let O = I.legendItem || {}, y = X.options, w = X.symbolHeight, f = y.squareSymbol, x = f ? w : X.symbolWidth;
          O.symbol = this.chart.renderer.rect(f ? (X.symbolWidth - w) / 2 : 0, X.baseline - w + 1, x, w, J(X.options.symbolRadius, w / 2)).addClass("highcharts-point").attr({ zIndex: 3 }).add(O.group);
        };
      }(_ || (_ = {})), _;
    }), ot(i, "Core/Series/SeriesDefaults.js", [], function() {
      return { lineWidth: 2, allowPointSelect: !1, crisp: !0, showCheckbox: !1, animation: { duration: 1e3 }, enableMouseTracking: !0, events: {}, marker: { enabledThreshold: 2, lineColor: "#ffffff", lineWidth: 0, radius: 4, states: { normal: { animation: !0 }, hover: { animation: { duration: 150 }, enabled: !0, radiusPlus: 2, lineWidthPlus: 1 }, select: { fillColor: "#cccccc", lineColor: "#000000", lineWidth: 2 } } }, point: { events: {} }, dataLabels: { animation: {}, align: "center", borderWidth: 0, defer: !0, formatter: function() {
        let { numberFormatter: U } = this.series.chart;
        return typeof this.y != "number" ? "" : U(this.y, -1);
      }, padding: 5, style: { fontSize: "0.7em", fontWeight: "bold", color: "contrast", textOutline: "1px contrast" }, verticalAlign: "bottom", x: 0, y: 0 }, cropThreshold: 300, opacity: 1, pointRange: 0, softThreshold: !0, states: { normal: { animation: !0 }, hover: { animation: { duration: 150 }, lineWidthPlus: 1, marker: {}, halo: { size: 10, opacity: 0.25 } }, select: { animation: { duration: 0 } }, inactive: { animation: { duration: 150 }, opacity: 0.2 } }, stickyTracking: !0, turboThreshold: 1e3, findNearestPointBy: "x" };
    }), ot(i, "Core/Series/SeriesRegistry.js", [i["Core/Globals.js"], i["Core/Defaults.js"], i["Core/Series/Point.js"], i["Core/Utilities.js"]], function(U, _, K, Z) {
      var J;
      let { defaultOptions: q } = _, { extend: tt, extendClass: X, merge: I } = Z;
      return function(O) {
        function y(w, f) {
          let x = q.plotOptions || {}, s = f.defaultOptions, l = f.prototype;
          return l.type = w, l.pointClass || (l.pointClass = K), !O.seriesTypes[w] && (s && (x[w] = s), O.seriesTypes[w] = f, !0);
        }
        O.seriesTypes = U.seriesTypes, O.registerSeriesType = y, O.seriesType = function(w, f, x, s, l) {
          let p = q.plotOptions || {};
          if (f = f || "", p[w] = I(p[f], x), delete O.seriesTypes[w], y(w, X(O.seriesTypes[f] || function() {
          }, s)), O.seriesTypes[w].prototype.type = w, l) {
            class n extends K {
            }
            tt(n.prototype, l), O.seriesTypes[w].prototype.pointClass = n;
          }
          return O.seriesTypes[w];
        };
      }(J || (J = {})), J;
    }), ot(i, "Core/Series/Series.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Defaults.js"], i["Core/Foundation.js"], i["Core/Globals.js"], i["Core/Legend/LegendSymbol.js"], i["Core/Series/Point.js"], i["Core/Series/SeriesDefaults.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Renderer/SVG/SVGElement.js"], i["Core/Utilities.js"]], function(U, _, K, Z, J, q, tt, X, I, O) {
      let { animObject: y, setAnimation: w } = U, { defaultOptions: f } = _, { registerEventOptions: x } = K, { svg: s, win: l } = Z, { seriesTypes: p } = X, { arrayMax: n, arrayMin: a, clamp: v, correctFloat: N, crisp: B, defined: T, destroyObjectProperties: o, diffObjects: u, erase: c, error: e, extend: t, find: h, fireEvent: b, getClosestDistance: r, getNestedProperty: g, insertItem: d, isArray: M, isNumber: H, isString: A, merge: D, objectEach: W, pick: G, removeEvent: it, splat: C, syncTimeout: k } = O;
      class L {
        constructor() {
          this.zoneAxis = "y";
        }
        init(m, E) {
          let P;
          b(this, "init", { options: E });
          let R = this, z = m.series;
          this.eventsToUnbind = [], R.chart = m, R.options = R.setOptions(E);
          let $ = R.options, et = $.visible !== !1;
          R.linkedSeries = [], R.bindAxes(), t(R, { name: $.name, state: "", visible: et, selected: $.selected === !0 }), x(this, $);
          let rt = $.events;
          (rt && rt.click || $.point && $.point.events && $.point.events.click || $.allowPointSelect) && (m.runTrackerClick = !0), R.getColor(), R.getSymbol(), R.parallelArrays.forEach(function(nt) {
            R[nt + "Data"] || (R[nt + "Data"] = []);
          }), R.isCartesian && (m.hasCartesianSeries = !0), z.length && (P = z[z.length - 1]), R._i = G(P && P._i, -1) + 1, R.opacity = R.options.opacity, m.orderItems("series", d(this, z)), $.dataSorting && $.dataSorting.enabled ? R.setDataSortingOptions() : R.points || R.data || R.setData($.data, !1), b(this, "afterInit");
        }
        is(m) {
          return p[m] && this instanceof p[m];
        }
        bindAxes() {
          let m, E = this, P = E.options, R = E.chart;
          b(this, "bindAxes", null, function() {
            (E.axisTypes || []).forEach(function(z) {
              (R[z] || []).forEach(function($) {
                m = $.options, (G(P[z], 0) === $.index || P[z] !== void 0 && P[z] === m.id) && (d(E, $.series), E[z] = $, $.isDirty = !0);
              }), E[z] || E.optionalAxis === z || e(18, !0, R);
            });
          }), b(this, "afterBindAxes");
        }
        updateParallelArrays(m, E, P) {
          let R = m.series, z = H(E) ? function($) {
            let et = $ === "y" && R.toYData ? R.toYData(m) : m[$];
            R[$ + "Data"][E] = et;
          } : function($) {
            Array.prototype[E].apply(R[$ + "Data"], P);
          };
          R.parallelArrays.forEach(z);
        }
        hasData() {
          return this.visible && this.dataMax !== void 0 && this.dataMin !== void 0 || this.visible && this.yData && this.yData.length > 0;
        }
        hasMarkerChanged(m, E) {
          let P = m.marker, R = E.marker || {};
          return P && (R.enabled && !P.enabled || R.symbol !== P.symbol || R.height !== P.height || R.width !== P.width);
        }
        autoIncrement(m) {
          let E = this.options, P = E.pointIntervalUnit, R = E.relativeXValue, z = this.chart.time, $ = this.xIncrement, et, rt;
          return $ = G($, E.pointStart, 0), this.pointInterval = rt = G(this.pointInterval, E.pointInterval, 1), R && H(m) && (rt *= m), P && (et = new z.Date($), P === "day" ? z.set("Date", et, z.get("Date", et) + rt) : P === "month" ? z.set("Month", et, z.get("Month", et) + rt) : P === "year" && z.set("FullYear", et, z.get("FullYear", et) + rt), rt = et.getTime() - $), R && H(m) ? $ + rt : (this.xIncrement = $ + rt, $);
        }
        setDataSortingOptions() {
          let m = this.options;
          t(this, { requireSorting: !1, sorted: !1, enabledDataSorting: !0, allowDG: !1 }), T(m.pointRange) || (m.pointRange = 1);
        }
        setOptions(m) {
          var at, ht;
          let E, P = this.chart, R = P.options.plotOptions, z = P.userOptions || {}, $ = D(m), et = P.styledMode, rt = { plotOptions: R, userOptions: $ };
          b(this, "setOptions", rt);
          let nt = rt.plotOptions[this.type], dt = z.plotOptions || {}, ct = dt.series || {}, V = f.plotOptions[this.type] || {}, Y = dt[this.type] || {};
          this.userOptions = rt.userOptions;
          let Q = D(nt, R.series, Y, $);
          this.tooltipOptions = D(f.tooltip, (at = f.plotOptions.series) == null ? void 0 : at.tooltip, V == null ? void 0 : V.tooltip, P.userOptions.tooltip, (ht = dt.series) == null ? void 0 : ht.tooltip, Y.tooltip, $.tooltip), this.stickyTracking = G($.stickyTracking, Y.stickyTracking, ct.stickyTracking, !!this.tooltipOptions.shared && !this.noSharedTooltip || Q.stickyTracking), nt.marker === null && delete Q.marker, this.zoneAxis = Q.zoneAxis || "y";
          let st = this.zones = (Q.zones || []).map((lt) => ({ ...lt }));
          return (Q.negativeColor || Q.negativeFillColor) && !Q.zones && (E = { value: Q[this.zoneAxis + "Threshold"] || Q.threshold || 0, className: "highcharts-negative" }, et || (E.color = Q.negativeColor, E.fillColor = Q.negativeFillColor), st.push(E)), st.length && T(st[st.length - 1].value) && st.push(et ? {} : { color: this.color, fillColor: this.fillColor }), b(this, "afterSetOptions", { options: Q }), Q;
        }
        getName() {
          return G(this.options.name, "Series " + (this.index + 1));
        }
        getCyclic(m, E, P) {
          let R, z, $ = this.chart, et = `${m}Index`, rt = `${m}Counter`, nt = (P == null ? void 0 : P.length) || $.options.chart.colorCount;
          !E && (T(z = G(m === "color" ? this.options.colorIndex : void 0, this[et])) ? R = z : ($.series.length || ($[rt] = 0), R = $[rt] % nt, $[rt] += 1), P && (E = P[R])), R !== void 0 && (this[et] = R), this[m] = E;
        }
        getColor() {
          this.chart.styledMode ? this.getCyclic("color") : this.options.colorByPoint ? this.color = "#cccccc" : this.getCyclic("color", this.options.color || f.plotOptions[this.type].color, this.chart.options.colors);
        }
        getPointsCollection() {
          return (this.hasGroupedData ? this.points : this.data) || [];
        }
        getSymbol() {
          let m = this.options.marker;
          this.getCyclic("symbol", m.symbol, this.chart.options.symbols);
        }
        findPointIndex(m, E) {
          let P, R, z, $ = m.id, et = m.x, rt = this.points, nt = this.options.dataSorting;
          if ($) {
            let dt = this.chart.get($);
            dt instanceof q && (P = dt);
          } else if (this.linkedParent || this.enabledDataSorting || this.options.relativeXValue) {
            let dt = (ct) => !ct.touched && ct.index === m.index;
            if (nt && nt.matchByName ? dt = (ct) => !ct.touched && ct.name === m.name : this.options.relativeXValue && (dt = (ct) => !ct.touched && ct.options.x === m.x), !(P = h(rt, dt))) return;
          }
          return P && (z = P && P.index) !== void 0 && (R = !0), z === void 0 && H(et) && (z = this.xData.indexOf(et, E)), z !== -1 && z !== void 0 && this.cropped && (z = z >= this.cropStart ? z - this.cropStart : z), !R && H(z) && rt[z] && rt[z].touched && (z = void 0), z;
        }
        updateData(m, E) {
          let P = this.options, R = P.dataSorting, z = this.points, $ = [], et = this.requireSorting, rt = m.length === z.length, nt, dt, ct, V, Y = !0;
          if (this.xIncrement = null, m.forEach(function(Q, st) {
            let at, ht = T(Q) && this.pointClass.prototype.optionsToObject.call({ series: this }, Q) || {}, lt = ht.x;
            ht.id || H(lt) ? ((at = this.findPointIndex(ht, V)) === -1 || at === void 0 ? $.push(Q) : z[at] && Q !== P.data[at] ? (z[at].update(Q, !1, null, !1), z[at].touched = !0, et && (V = at + 1)) : z[at] && (z[at].touched = !0), (!rt || st !== at || R && R.enabled || this.hasDerivedData) && (nt = !0)) : $.push(Q);
          }, this), nt) for (dt = z.length; dt--; ) (ct = z[dt]) && !ct.touched && ct.remove && ct.remove(!1, E);
          else !rt || R && R.enabled ? Y = !1 : (m.forEach(function(Q, st) {
            Q === z[st].y || z[st].destroyed || z[st].update(Q, !1, null, !1);
          }), $.length = 0);
          return z.forEach(function(Q) {
            Q && (Q.touched = !1);
          }), !!Y && ($.forEach(function(Q) {
            this.addPoint(Q, !1, null, null, !1);
          }, this), this.xIncrement === null && this.xData && this.xData.length && (this.xIncrement = n(this.xData), this.autoIncrement()), !0);
        }
        setData(m, E = !0, P, R) {
          var wt;
          let z = this, $ = z.points, et = $ && $.length || 0, rt = z.options, nt = z.chart, dt = rt.dataSorting, ct = z.xAxis, V = rt.turboThreshold, Y = this.xData, Q = this.yData, st = z.pointArrayMap, at = st && st.length, ht = rt.keys, lt, ut, pt, ft = 0, gt = 1, mt;
          nt.options.chart.allowMutatingData || (rt.data && delete z.options.data, z.userOptions.data && delete z.userOptions.data, mt = D(!0, m));
          let yt = (m = mt || m || []).length;
          if (dt && dt.enabled && (m = this.sortData(m)), nt.options.chart.allowMutatingData && R !== !1 && yt && et && !z.cropped && !z.hasGroupedData && z.visible && !z.boosted && (pt = this.updateData(m, P)), !pt) {
            z.xIncrement = null, z.colorCounter = 0, this.parallelArrays.forEach(function(bt) {
              z[bt + "Data"].length = 0;
            });
            let xt = V && yt > V;
            if (xt) {
              let bt = z.getFirstValidPoint(m), Ct = z.getFirstValidPoint(m, yt - 1, -1), vt = (kt) => !!(M(kt) && (ht || H(kt[0])));
              if (H(bt) && H(Ct)) for (lt = 0; lt < yt; lt++) Y[lt] = this.autoIncrement(), Q[lt] = m[lt];
              else if (vt(bt) && vt(Ct))
                if (at)
                  if (bt.length === at) for (lt = 0; lt < yt; lt++) Y[lt] = this.autoIncrement(), Q[lt] = m[lt];
                  else for (lt = 0; lt < yt; lt++) ut = m[lt], Y[lt] = ut[0], Q[lt] = ut.slice(1, at + 1);
                else if (ht && (ft = ht.indexOf("x"), gt = ht.indexOf("y"), ft = ft >= 0 ? ft : 0, gt = gt >= 0 ? gt : 1), bt.length === 1 && (gt = 0), ft === gt) for (lt = 0; lt < yt; lt++) Y[lt] = this.autoIncrement(), Q[lt] = m[lt][gt];
                else for (lt = 0; lt < yt; lt++) ut = m[lt], Y[lt] = ut[ft], Q[lt] = ut[gt];
              else xt = !1;
            }
            if (!xt) for (lt = 0; lt < yt; lt++) ut = { series: z }, z.pointClass.prototype.applyOptions.apply(ut, [m[lt]]), z.updateParallelArrays(ut, lt);
            for (Q && A(Q[0]) && e(14, !0, nt), z.data = [], z.options.data = z.userOptions.data = m, lt = et; lt--; ) (wt = $[lt]) == null || wt.destroy();
            ct && (ct.minRange = ct.userMinRange), z.isDirty = nt.isDirtyBox = !0, z.isDirtyData = !!$, P = !1;
          }
          rt.legendType === "point" && (this.processData(), this.generatePoints()), E && nt.redraw(P);
        }
        sortData(m) {
          let E = this, P = E.options.dataSorting.sortKey || "y", R = function(z, $) {
            return T($) && z.pointClass.prototype.optionsToObject.call({ series: z }, $) || {};
          };
          return m.forEach(function(z, $) {
            m[$] = R(E, z), m[$].index = $;
          }, this), m.concat().sort((z, $) => {
            let et = g(P, z), rt = g(P, $);
            return rt < et ? -1 : rt > et ? 1 : 0;
          }).forEach(function(z, $) {
            z.x = $;
          }, this), E.linkedSeries && E.linkedSeries.forEach(function(z) {
            let $ = z.options, et = $.data;
            $.dataSorting && $.dataSorting.enabled || !et || (et.forEach(function(rt, nt) {
              et[nt] = R(z, rt), m[nt] && (et[nt].x = m[nt].x, et[nt].index = nt);
            }), z.setData(et, !1));
          }), m;
        }
        getProcessedData(m) {
          let E = this, P = E.xAxis, R = E.options.cropThreshold, z = P == null ? void 0 : P.logarithmic, $ = E.isCartesian, et, rt, nt = 0, dt, ct, V, Y = E.xData, Q = E.yData, st = !1, at = Y.length;
          P && (ct = (dt = P.getExtremes()).min, V = dt.max, st = !!(P.categories && !P.names.length)), $ && E.sorted && !m && (!R || at > R || E.forceCrop) && (Y[at - 1] < ct || Y[0] > V ? (Y = [], Q = []) : E.yData && (Y[0] < ct || Y[at - 1] > V) && (Y = (et = this.cropData(E.xData, E.yData, ct, V)).xData, Q = et.yData, nt = et.start, rt = !0));
          let ht = r([z ? Y.map(z.log2lin) : Y], () => E.requireSorting && !st && e(15, !1, E.chart));
          return { xData: Y, yData: Q, cropped: rt, cropStart: nt, closestPointRange: ht };
        }
        processData(m) {
          let E = this.xAxis;
          if (this.isCartesian && !this.isDirty && !E.isDirty && !this.yAxis.isDirty && !m) return !1;
          let P = this.getProcessedData();
          this.cropped = P.cropped, this.cropStart = P.cropStart, this.processedXData = P.xData, this.processedYData = P.yData, this.closestPointRange = this.basePointRange = P.closestPointRange, b(this, "afterProcessData");
        }
        cropData(m, E, P, R) {
          let z = m.length, $, et, rt = 0, nt = z;
          for ($ = 0; $ < z; $++) if (m[$] >= P) {
            rt = Math.max(0, $ - 1);
            break;
          }
          for (et = $; et < z; et++) if (m[et] > R) {
            nt = et + 1;
            break;
          }
          return { xData: m.slice(rt, nt), yData: E.slice(rt, nt), start: rt, end: nt };
        }
        generatePoints() {
          let m = this.options, E = this.processedData || m.data, P = this.processedXData, R = this.processedYData, z = this.pointClass, $ = P.length, et = this.cropStart || 0, rt = this.hasGroupedData, nt = m.keys, dt = [], ct = m.dataGrouping && m.dataGrouping.groupAll ? et : 0, V, Y, Q, st, at = this.data;
          if (!at && !rt) {
            let ht = [];
            ht.length = E.length, at = this.data = ht;
          }
          for (nt && rt && (this.options.keys = !1), st = 0; st < $; st++) Y = et + st, rt ? ((Q = new z(this, [P[st]].concat(C(R[st])))).dataGroup = this.groupMap[ct + st], Q.dataGroup.options && (Q.options = Q.dataGroup.options, t(Q, Q.dataGroup.options), delete Q.dataLabels)) : (Q = at[Y]) || E[Y] === void 0 || (at[Y] = Q = new z(this, E[Y], P[st])), Q && (Q.index = rt ? ct + st : Y, dt[st] = Q);
          if (this.options.keys = nt, at && ($ !== (V = at.length) || rt)) for (st = 0; st < V; st++) st !== et || rt || (st += $), at[st] && (at[st].destroyElements(), at[st].plotX = void 0);
          this.data = at, this.points = dt, b(this, "afterGeneratePoints");
        }
        getXExtremes(m) {
          return { min: a(m), max: n(m) };
        }
        getExtremes(m, E) {
          let P = this.xAxis, R = this.yAxis, z = [], $ = this.requireSorting && !this.is("column") ? 1 : 0, et = !!R && R.positiveValuesOnly, rt = E || this.getExtremesFromAll || this.options.getExtremesFromAll, { processedXData: nt, processedYData: dt } = this, ct, V, Y, Q, st, at, ht, lt = 0, ut = 0, pt = 0;
          if (this.cropped && rt) {
            let yt = this.getProcessedData(!0);
            nt = yt.xData, dt = yt.yData;
          }
          let ft = (m = m || this.stackedYData || dt || []).length, gt = nt || this.xData;
          for (P && (lt = (ct = P.getExtremes()).min, ut = ct.max), at = 0; at < ft; at++) if (Q = gt[at], V = (H(st = m[at]) || M(st)) && ((H(st) ? st > 0 : st.length) || !et), Y = E || this.getExtremesFromAll || this.options.getExtremesFromAll || this.cropped || !P || (gt[at + $] || Q) >= lt && (gt[at - $] || Q) <= ut, V && Y)
            if (ht = st.length) for (; ht--; ) H(st[ht]) && (z[pt++] = st[ht]);
            else z[pt++] = st;
          let mt = { activeYData: z, dataMin: a(z), dataMax: n(z) };
          return b(this, "afterGetExtremes", { dataExtremes: mt }), mt;
        }
        applyExtremes() {
          let m = this.getExtremes();
          return this.dataMin = m.dataMin, this.dataMax = m.dataMax, m;
        }
        getFirstValidPoint(m, E = 0, P = 1) {
          let R = m.length, z = E;
          for (; z >= 0 && z < R; ) {
            if (T(m[z])) return m[z];
            z += P;
          }
        }
        translate() {
          var ut;
          this.processedXData || this.processData(), this.generatePoints();
          let m = this.options, E = m.stacking, P = this.xAxis, R = P.categories, z = this.enabledDataSorting, $ = this.yAxis, et = this.points, rt = et.length, nt = this.pointPlacementToXValue(), dt = !!nt, ct = m.threshold, V = m.startFromThreshold ? ct : 0, Y, Q, st, at, ht = Number.MAX_VALUE;
          function lt(pt) {
            return v(pt, -1e9, 1e9);
          }
          for (Y = 0; Y < rt; Y++) {
            let pt, ft = et[Y], gt = ft.x, mt, yt, wt = ft.y, xt = ft.low, bt = E && ((ut = $.stacking) == null ? void 0 : ut.stacks[(this.negStacks && wt < (V ? 0 : ct) ? "-" : "") + this.stackKey]);
            Q = P.translate(gt, !1, !1, !1, !0, nt), ft.plotX = H(Q) ? N(lt(Q)) : void 0, E && this.visible && bt && bt[gt] && (at = this.getStackIndicator(at, gt, this.index), !ft.isNull && at.key && (yt = (mt = bt[gt]).points[at.key]), mt && M(yt) && (xt = yt[0], wt = yt[1], xt === V && at.key === bt[gt].base && (xt = G(H(ct) ? ct : $.min)), $.positiveValuesOnly && T(xt) && xt <= 0 && (xt = void 0), ft.total = ft.stackTotal = G(mt.total), ft.percentage = T(ft.y) && mt.total ? ft.y / mt.total * 100 : void 0, ft.stackY = wt, this.irregularWidths || mt.setOffset(this.pointXOffset || 0, this.barW || 0, void 0, void 0, void 0, this.xAxis))), ft.yBottom = T(xt) ? lt($.translate(xt, !1, !0, !1, !0)) : void 0, this.dataModify && (wt = this.dataModify.modifyValue(wt, Y)), H(wt) && ft.plotX !== void 0 && (pt = H(pt = $.translate(wt, !1, !0, !1, !0)) ? lt(pt) : void 0), ft.plotY = pt, ft.isInside = this.isPointInside(ft), ft.clientX = dt ? N(P.translate(gt, !1, !1, !1, !0, nt)) : Q, ft.negative = (ft.y || 0) < (ct || 0), ft.category = G(R && R[ft.x], ft.x), ft.isNull || ft.visible === !1 || (st !== void 0 && (ht = Math.min(ht, Math.abs(Q - st))), st = Q), ft.zone = this.zones.length ? ft.getZone() : void 0, !ft.graphic && this.group && z && (ft.isNew = !0);
          }
          this.closestPointRangePx = ht, b(this, "afterTranslate");
        }
        getValidPoints(m, E, P) {
          let R = this.chart;
          return (m || this.points || []).filter(function(z) {
            let { plotX: $, plotY: et } = z;
            return !!((P || !z.isNull && H(et)) && (!E || R.isInsidePlot($, et, { inverted: R.inverted }))) && z.visible !== !1;
          });
        }
        getClipBox() {
          let { chart: m, xAxis: E, yAxis: P } = this, { x: R, y: z, width: $, height: et } = D(m.clipBox);
          return E && E.len !== m.plotSizeX && ($ = E.len), P && P.len !== m.plotSizeY && (et = P.len), m.inverted && !this.invertible && ([$, et] = [et, $]), { x: R, y: z, width: $, height: et };
        }
        getSharedClipKey() {
          return this.sharedClipKey = (this.options.xAxis || 0) + "," + (this.options.yAxis || 0), this.sharedClipKey;
        }
        setClip() {
          let { chart: m, group: E, markerGroup: P } = this, R = m.sharedClips, z = m.renderer, $ = this.getClipBox(), et = this.getSharedClipKey(), rt = R[et];
          rt ? rt.animate($) : R[et] = rt = z.clipRect($), E && E.clip(this.options.clip === !1 ? void 0 : rt), P && P.clip();
        }
        animate(m) {
          let { chart: E, group: P, markerGroup: R } = this, z = E.inverted, $ = y(this.options.animation), et = [this.getSharedClipKey(), $.duration, $.easing, $.defer].join(","), rt = E.sharedClips[et], nt = E.sharedClips[et + "m"];
          if (m && P) {
            let dt = this.getClipBox();
            if (rt) rt.attr("height", dt.height);
            else {
              dt.width = 0, z && (dt.x = E.plotHeight), rt = E.renderer.clipRect(dt), E.sharedClips[et] = rt;
              let ct = { x: -99, y: -99, width: z ? E.plotWidth + 199 : 99, height: z ? 99 : E.plotHeight + 199 };
              nt = E.renderer.clipRect(ct), E.sharedClips[et + "m"] = nt;
            }
            P.clip(rt), R == null || R.clip(nt);
          } else if (rt && !rt.hasClass("highcharts-animating")) {
            let dt = this.getClipBox(), ct = $.step;
            (R != null && R.element.childNodes.length || E.series.length > 1) && ($.step = function(V, Y) {
              ct && ct.apply(Y, arguments), Y.prop === "width" && (nt != null && nt.element) && nt.attr(z ? "height" : "width", V + 99);
            }), rt.addClass("highcharts-animating").animate(dt, $);
          }
        }
        afterAnimate() {
          this.setClip(), W(this.chart.sharedClips, (m, E, P) => {
            m && !this.chart.container.querySelector(`[clip-path="url(#${m.id})"]`) && (m.destroy(), delete P[E]);
          }), this.finishedAnimating = !0, b(this, "afterAnimate");
        }
        drawPoints(m = this.points) {
          let E, P, R, z, $, et, rt, nt = this.chart, dt = nt.styledMode, { colorAxis: ct, options: V } = this, Y = V.marker, Q = this[this.specialGroup || "markerGroup"], st = this.xAxis, at = G(Y.enabled, !st || !!st.isRadial || null, this.closestPointRangePx >= Y.enabledThreshold * Y.radius);
          if (Y.enabled !== !1 || this._hasPointMarkers) for (E = 0; E < m.length; E++) if (z = (R = (P = m[E]).graphic) ? "animate" : "attr", $ = P.marker || {}, et = !!P.marker, (at && $.enabled === void 0 || $.enabled) && !P.isNull && P.visible !== !1) {
            let ht = G($.symbol, this.symbol, "rect");
            rt = this.markerAttribs(P, P.selected && "select"), this.enabledDataSorting && (P.startXPos = st.reversed ? -(rt.width || 0) : st.width);
            let lt = P.isInside !== !1;
            if (!R && lt && ((rt.width || 0) > 0 || P.hasImage) && (P.graphic = R = nt.renderer.symbol(ht, rt.x, rt.y, rt.width, rt.height, et ? $ : Y).add(Q), this.enabledDataSorting && nt.hasRendered && (R.attr({ x: P.startXPos }), z = "animate")), R && z === "animate" && R[lt ? "show" : "hide"](lt).animate(rt), R) {
              let ut = this.pointAttribs(P, dt || !P.selected ? void 0 : "select");
              dt ? ct && R.css({ fill: ut.fill }) : R[z](ut);
            }
            R && R.addClass(P.getClassName(), !0);
          } else R && (P.graphic = R.destroy());
        }
        markerAttribs(m, E) {
          let P = this.options, R = P.marker, z = m.marker || {}, $ = z.symbol || R.symbol, et = {}, rt, nt, dt = G(z.radius, R && R.radius);
          E && (rt = R.states[E], dt = G((nt = z.states && z.states[E]) && nt.radius, rt && rt.radius, dt && dt + (rt && rt.radiusPlus || 0))), m.hasImage = $ && $.indexOf("url") === 0, m.hasImage && (dt = 0);
          let ct = m.pos();
          return H(dt) && ct && (P.crisp && (ct[0] = B(ct[0], m.hasImage ? 0 : $ === "rect" ? (R == null ? void 0 : R.lineWidth) || 0 : 1)), et.x = ct[0] - dt, et.y = ct[1] - dt), dt && (et.width = et.height = 2 * dt), et;
        }
        pointAttribs(m, E) {
          let P = this.options.marker, R = m && m.options, z = R && R.marker || {}, $ = R && R.color, et = m && m.color, rt = m && m.zone && m.zone.color, nt, dt, ct = this.color, V, Y, Q = G(z.lineWidth, P.lineWidth), st = 1;
          return ct = $ || rt || et || ct, V = z.fillColor || P.fillColor || ct, Y = z.lineColor || P.lineColor || ct, E = E || "normal", nt = P.states[E] || {}, Q = G((dt = z.states && z.states[E] || {}).lineWidth, nt.lineWidth, Q + G(dt.lineWidthPlus, nt.lineWidthPlus, 0)), V = dt.fillColor || nt.fillColor || V, { stroke: Y = dt.lineColor || nt.lineColor || Y, "stroke-width": Q, fill: V, opacity: st = G(dt.opacity, nt.opacity, st) };
        }
        destroy(m) {
          let E, P, R, z = this, $ = z.chart, et = /AppleWebKit\/533/.test(l.navigator.userAgent), rt = z.data || [];
          for (b(z, "destroy", { keepEventsForUpdate: m }), this.removeEvents(m), (z.axisTypes || []).forEach(function(nt) {
            (R = z[nt]) && R.series && (c(R.series, z), R.isDirty = R.forceRedraw = !0);
          }), z.legendItem && z.chart.legend.destroyItem(z), E = rt.length; E--; ) (P = rt[E]) && P.destroy && P.destroy();
          for (let nt of z.zones) o(nt, void 0, !0);
          O.clearTimeout(z.animationTimeout), W(z, function(nt, dt) {
            nt instanceof I && !nt.survive && nt[et && dt === "group" ? "hide" : "destroy"]();
          }), $.hoverSeries === z && ($.hoverSeries = void 0), c($.series, z), $.orderItems("series"), W(z, function(nt, dt) {
            m && dt === "hcEvents" || delete z[dt];
          });
        }
        applyZones() {
          let { area: m, chart: E, graph: P, zones: R, points: z, xAxis: $, yAxis: et, zoneAxis: rt } = this, { inverted: nt, renderer: dt } = E, ct = this[`${rt}Axis`], { isXAxis: V, len: Y = 0 } = ct || {}, Q = ((P == null ? void 0 : P.strokeWidth()) || 0) / 2 + 1, st = (at, ht = 0, lt = 0) => {
            nt && (lt = Y - lt);
            let { translated: ut = 0, lineClip: pt } = at, ft = lt - ut;
            pt == null || pt.push(["L", ht, Math.abs(ft) < Q ? lt - Q * (ft <= 0 ? -1 : 1) : ut]);
          };
          if (R.length && (P || m) && ct && H(ct.min)) {
            let at = ct.getExtremes().max, ht = (pt) => {
              pt.forEach((ft, gt) => {
                (ft[0] === "M" || ft[0] === "L") && (pt[gt] = [ft[0], V ? Y - ft[1] : ft[1], V ? ft[2] : Y - ft[2]]);
              });
            };
            if (R.forEach((pt) => {
              pt.lineClip = [], pt.translated = v(ct.toPixels(G(pt.value, at), !0) || 0, 0, Y);
            }), P && !this.showLine && P.hide(), m && m.hide(), rt === "y" && z.length < $.len) for (let pt of z) {
              let { plotX: ft, plotY: gt, zone: mt } = pt, yt = mt && R[R.indexOf(mt) - 1];
              mt && st(mt, ft, gt), yt && st(yt, ft, gt);
            }
            let lt = [], ut = ct.toPixels(ct.getExtremes().min, !0);
            R.forEach((pt) => {
              var Tt, St;
              let ft = pt.lineClip || [], gt = Math.round(pt.translated || 0);
              $.reversed && ft.reverse();
              let { clip: mt, simpleClip: yt } = pt, wt = 0, xt = 0, bt = $.len, Ct = et.len;
              V ? (wt = gt, bt = ut) : (xt = gt, Ct = ut);
              let vt = [["M", wt, xt], ["L", bt, xt], ["L", bt, Ct], ["L", wt, Ct], ["Z"]], kt = [vt[0], ...ft, vt[1], vt[2], ...lt, vt[3], vt[4]];
              lt = ft.reverse(), ut = gt, nt && (ht(kt), m && ht(vt)), mt ? (mt.animate({ d: kt }), yt == null || yt.animate({ d: vt })) : (mt = pt.clip = dt.path(kt), m && (yt = pt.simpleClip = dt.path(vt))), P && ((Tt = pt.graph) == null || Tt.clip(mt)), m && ((St = pt.area) == null || St.clip(yt));
            });
          } else this.visible && (P && P.show(), m && m.show());
        }
        plotGroup(m, E, P, R, z) {
          let $ = this[m], et = !$, rt = { visibility: P, zIndex: R || 0.1 };
          return T(this.opacity) && !this.chart.styledMode && this.state !== "inactive" && (rt.opacity = this.opacity), $ || (this[m] = $ = this.chart.renderer.g().add(z)), $.addClass("highcharts-" + E + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (T(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + ($.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0), $.attr(rt)[et ? "attr" : "animate"](this.getPlotBox(E)), $;
        }
        getPlotBox(m) {
          let E = this.xAxis, P = this.yAxis, R = this.chart, z = R.inverted && !R.polar && E && this.invertible && m === "series";
          return R.inverted && (E = P, P = this.xAxis), { translateX: E ? E.left : R.plotLeft, translateY: P ? P.top : R.plotTop, rotation: z ? 90 : 0, rotationOriginX: z ? (E.len - P.len) / 2 : 0, rotationOriginY: z ? (E.len + P.len) / 2 : 0, scaleX: z ? -1 : 1, scaleY: 1 };
        }
        removeEvents(m) {
          let { eventsToUnbind: E } = this;
          m || it(this), E.length && (E.forEach((P) => {
            P();
          }), E.length = 0);
        }
        render() {
          var dt, ct, V, Y, Q;
          let m = this, { chart: E, options: P, hasRendered: R } = m, z = y(P.animation), $ = m.visible ? "inherit" : "hidden", et = P.zIndex, rt = E.seriesGroup, nt = m.finishedAnimating ? 0 : z.duration;
          b(this, "render"), m.plotGroup("group", "series", $, et, rt), m.markerGroup = m.plotGroup("markerGroup", "markers", $, et, rt), P.clip !== !1 && m.setClip(), nt && ((dt = m.animate) == null || dt.call(m, !0)), m.drawGraph && (m.drawGraph(), m.applyZones()), m.visible && m.drawPoints(), (ct = m.drawDataLabels) == null || ct.call(m), (V = m.redrawPoints) == null || V.call(m), P.enableMouseTracking && ((Y = m.drawTracker) == null || Y.call(m)), nt && ((Q = m.animate) == null || Q.call(m)), R || (nt && z.defer && (nt += z.defer), m.animationTimeout = k(() => {
            m.afterAnimate();
          }, nt || 0)), m.isDirty = !1, m.hasRendered = !0, b(m, "afterRender");
        }
        redraw() {
          let m = this.isDirty || this.isDirtyData;
          this.translate(), this.render(), m && delete this.kdTree;
        }
        reserveSpace() {
          return this.visible || !this.chart.options.chart.ignoreHiddenSeries;
        }
        searchPoint(m, E) {
          let { xAxis: P, yAxis: R } = this, z = this.chart.inverted;
          return this.searchKDTree({ clientX: z ? P.len - m.chartY + P.pos : m.chartX - P.pos, plotY: z ? R.len - m.chartX + R.pos : m.chartY - R.pos }, E, m);
        }
        buildKDTree(m) {
          this.buildingKdTree = !0;
          let E = this, P = E.options.findNearestPointBy.indexOf("y") > -1 ? 2 : 1;
          delete E.kdTree, k(function() {
            E.kdTree = function R(z, $, et) {
              let rt, nt, dt = z == null ? void 0 : z.length;
              if (dt) return rt = E.kdAxisArray[$ % et], z.sort((ct, V) => (ct[rt] || 0) - (V[rt] || 0)), { point: z[nt = Math.floor(dt / 2)], left: R(z.slice(0, nt), $ + 1, et), right: R(z.slice(nt + 1), $ + 1, et) };
            }(E.getValidPoints(void 0, !E.directTouch), P, P), E.buildingKdTree = !1;
          }, E.options.kdNow || (m == null ? void 0 : m.type) === "touchstart" ? 0 : 1);
        }
        searchKDTree(m, E, P) {
          let R = this, [z, $] = this.kdAxisArray, et = E ? "distX" : "dist", rt = (R.options.findNearestPointBy || "").indexOf("y") > -1 ? 2 : 1, nt = !!R.isBubble;
          if (this.kdTree || this.buildingKdTree || this.buildKDTree(P), this.kdTree) return function dt(ct, V, Y, Q) {
            var mt;
            let st = V.point, at = R.kdAxisArray[Y % Q], ht, lt, ut = st;
            (function(yt, wt) {
              var Et;
              let xt = yt[z], bt = wt[z], Ct = T(xt) && T(bt) ? xt - bt : null, vt = yt[$], kt = wt[$], Tt = T(vt) && T(kt) ? vt - kt : 0, St = nt && ((Et = wt.marker) == null ? void 0 : Et.radius) || 0;
              wt.dist = Math.sqrt((Ct && Ct * Ct || 0) + Tt * Tt) - St, wt.distX = T(Ct) ? Math.abs(Ct) - St : Number.MAX_VALUE;
            })(ct, st);
            let pt = (ct[at] || 0) - (st[at] || 0) + (nt && ((mt = st.marker) == null ? void 0 : mt.radius) || 0), ft = pt < 0 ? "left" : "right", gt = pt < 0 ? "right" : "left";
            return V[ft] && (ut = (ht = dt(ct, V[ft], Y + 1, Q))[et] < ut[et] ? ht : st), V[gt] && Math.sqrt(pt * pt) < ut[et] && (ut = (lt = dt(ct, V[gt], Y + 1, Q))[et] < ut[et] ? lt : ut), ut;
          }(m, this.kdTree, rt, rt);
        }
        pointPlacementToXValue() {
          let { options: m, xAxis: E } = this, P = m.pointPlacement;
          return P === "between" && (P = E.reversed ? -0.5 : 0.5), H(P) ? P * (m.pointRange || E.pointRange) : 0;
        }
        isPointInside(m) {
          let { chart: E, xAxis: P, yAxis: R } = this, { plotX: z = -1, plotY: $ = -1 } = m;
          return $ >= 0 && $ <= (R ? R.len : E.plotHeight) && z >= 0 && z <= (P ? P.len : E.plotWidth);
        }
        drawTracker() {
          var V;
          let m = this, E = m.options, P = E.trackByArea, R = [].concat((P ? m.areaPath : m.graphPath) || []), z = m.chart, $ = z.pointer, et = z.renderer, rt = ((V = z.options.tooltip) == null ? void 0 : V.snap) || 0, nt = () => {
            E.enableMouseTracking && z.hoverSeries !== m && m.onMouseOver();
          }, dt = "rgba(192,192,192," + (s ? 1e-4 : 2e-3) + ")", ct = m.tracker;
          ct ? ct.attr({ d: R }) : m.graph && (m.tracker = ct = et.path(R).attr({ visibility: m.visible ? "inherit" : "hidden", zIndex: 2 }).addClass(P ? "highcharts-tracker-area" : "highcharts-tracker-line").add(m.group), z.styledMode || ct.attr({ "stroke-linecap": "round", "stroke-linejoin": "round", stroke: dt, fill: P ? dt : "none", "stroke-width": m.graph.strokeWidth() + (P ? 0 : 2 * rt) }), [m.tracker, m.markerGroup, m.dataLabelsGroup].forEach((Y) => {
            Y && (Y.addClass("highcharts-tracker").on("mouseover", nt).on("mouseout", (Q) => {
              $ == null || $.onTrackerMouseOut(Q);
            }), E.cursor && !z.styledMode && Y.css({ cursor: E.cursor }), Y.on("touchstart", nt));
          })), b(this, "afterDrawTracker");
        }
        addPoint(m, E, P, R, z) {
          let $, et, rt = this.options, nt = this.data, dt = this.chart, ct = this.xAxis, V = ct && ct.hasNames && ct.names, Y = rt.data, Q = this.xData;
          E = G(E, !0);
          let st = { series: this };
          this.pointClass.prototype.applyOptions.apply(st, [m]);
          let at = st.x;
          if (et = Q.length, this.requireSorting && at < Q[et - 1]) for ($ = !0; et && Q[et - 1] > at; ) et--;
          this.updateParallelArrays(st, "splice", [et, 0, 0]), this.updateParallelArrays(st, et), V && st.name && (V[at] = st.name), Y.splice(et, 0, m), ($ || this.processedData) && (this.data.splice(et, 0, null), this.processData()), rt.legendType === "point" && this.generatePoints(), P && (nt[0] && nt[0].remove ? nt[0].remove(!1) : (nt.shift(), this.updateParallelArrays(st, "shift"), Y.shift())), z !== !1 && b(this, "addPoint", { point: st }), this.isDirty = !0, this.isDirtyData = !0, E && dt.redraw(R);
        }
        removePoint(m, E, P) {
          let R = this, z = R.data, $ = z[m], et = R.points, rt = R.chart, nt = function() {
            et && et.length === z.length && et.splice(m, 1), z.splice(m, 1), R.options.data.splice(m, 1), R.updateParallelArrays($ || { series: R }, "splice", [m, 1]), $ && $.destroy(), R.isDirty = !0, R.isDirtyData = !0, E && rt.redraw();
          };
          w(P, rt), E = G(E, !0), $ ? $.firePointEvent("remove", null, nt) : nt();
        }
        remove(m, E, P, R) {
          let z = this, $ = z.chart;
          function et() {
            z.destroy(R), $.isDirtyLegend = $.isDirtyBox = !0, $.linkSeries(R), G(m, !0) && $.redraw(E);
          }
          P !== !1 ? b(z, "remove", null, et) : et();
        }
        update(m, E) {
          var ht, lt, ut, pt, ft;
          b(this, "update", { options: m = u(m, this.userOptions) });
          let P = this, R = P.chart, z = P.userOptions, $ = P.initialType || P.type, et = R.options.plotOptions, rt = p[$].prototype, nt = P.finishedAnimating && { animation: !1 }, dt = {}, ct, V, Y = ["colorIndex", "eventOptions", "navigatorSeries", "symbolIndex", "baseSeries"], Q = m.type || z.type || R.options.chart.type, st = !(this.hasDerivedData || Q && Q !== this.type || m.pointStart !== void 0 || m.pointInterval !== void 0 || m.relativeXValue !== void 0 || m.joinBy || m.mapData || ["dataGrouping", "pointStart", "pointInterval", "pointIntervalUnit", "keys"].some((gt) => P.hasOptionChanged(gt)));
          Q = Q || $, st && (Y.push("data", "isDirtyData", "isDirtyCanvas", "points", "processedData", "processedXData", "processedYData", "xIncrement", "cropped", "_hasPointMarkers", "hasDataLabels", "nodes", "layout", "level", "mapMap", "mapData", "minY", "maxY", "minX", "maxX", "transformGroups"), m.visible !== !1 && Y.push("area", "graph"), P.parallelArrays.forEach(function(gt) {
            Y.push(gt + "Data");
          }), m.data && (m.dataSorting && t(P.options.dataSorting, m.dataSorting), this.setData(m.data, !1))), m = D(z, { index: z.index === void 0 ? P.index : z.index, pointStart: (pt = (lt = (ht = et == null ? void 0 : et.series) == null ? void 0 : ht.pointStart) != null ? lt : z.pointStart) != null ? pt : (ut = P.xData) == null ? void 0 : ut[0] }, !st && { data: P.options.data }, m, nt), st && m.data && (m.data = P.options.data), (Y = ["group", "markerGroup", "dataLabelsGroup", "transformGroup"].concat(Y)).forEach(function(gt) {
            Y[gt] = P[gt], delete P[gt];
          });
          let at = !1;
          if (p[Q]) {
            if (at = Q !== P.type, P.remove(!1, !1, !1, !0), at)
              if (R.propFromSeries(), Object.setPrototypeOf) Object.setPrototypeOf(P, p[Q].prototype);
              else {
                let gt = Object.hasOwnProperty.call(P, "hcEvents") && P.hcEvents;
                for (V in rt) P[V] = void 0;
                t(P, p[Q].prototype), gt ? P.hcEvents = gt : delete P.hcEvents;
              }
          } else e(17, !0, R, { missingModuleFor: Q });
          if (Y.forEach(function(gt) {
            P[gt] = Y[gt];
          }), P.init(R, m), st && this.points) for (let gt of ((ct = P.options).visible === !1 ? (dt.graphic = 1, dt.dataLabel = 1) : (this.hasMarkerChanged(ct, z) && (dt.graphic = 1), (ft = P.hasDataLabels) != null && ft.call(P) || (dt.dataLabel = 1)), this.points)) gt && gt.series && (gt.resolveColor(), Object.keys(dt).length && gt.destroyElements(dt), ct.showInLegend === !1 && gt.legendItem && R.legend.destroyItem(gt));
          P.initialType = $, R.linkSeries(), R.setSortedData(), at && P.linkedSeries.length && (P.isDirtyData = !0), b(this, "afterUpdate"), G(E, !0) && R.redraw(!!st && void 0);
        }
        setName(m) {
          this.name = this.options.name = this.userOptions.name = m, this.chart.isDirtyLegend = !0;
        }
        hasOptionChanged(m) {
          var et, rt;
          let E = this.chart, P = this.options[m], R = E.options.plotOptions, z = this.userOptions[m], $ = G((et = R == null ? void 0 : R[this.type]) == null ? void 0 : et[m], (rt = R == null ? void 0 : R.series) == null ? void 0 : rt[m]);
          return z && !T($) ? P !== z : P !== G($, P);
        }
        onMouseOver() {
          let m = this.chart, E = m.hoverSeries, P = m.pointer;
          P == null || P.setHoverChartIndex(), E && E !== this && E.onMouseOut(), this.options.events.mouseOver && b(this, "mouseOver"), this.setState("hover"), m.hoverSeries = this;
        }
        onMouseOut() {
          let m = this.options, E = this.chart, P = E.tooltip, R = E.hoverPoint;
          E.hoverSeries = null, R && R.onMouseOut(), this && m.events.mouseOut && b(this, "mouseOut"), P && !this.stickyTracking && (!P.shared || this.noSharedTooltip) && P.hide(), E.series.forEach(function(z) {
            z.setState("", !0);
          });
        }
        setState(m, E) {
          let P = this, R = P.options, z = P.graph, $ = R.inactiveOtherPoints, et = R.states, rt = G(et[m || "normal"] && et[m || "normal"].animation, P.chart.options.chart.animation), nt = R.lineWidth, dt = R.opacity;
          if (m = m || "", P.state !== m && ([P.group, P.markerGroup, P.dataLabelsGroup].forEach(function(ct) {
            ct && (P.state && ct.removeClass("highcharts-series-" + P.state), m && ct.addClass("highcharts-series-" + m));
          }), P.state = m, !P.chart.styledMode)) {
            if (et[m] && et[m].enabled === !1) return;
            if (m && (nt = et[m].lineWidth || nt + (et[m].lineWidthPlus || 0), dt = G(et[m].opacity, dt)), z && !z.dashstyle && H(nt)) for (let ct of [z, ...this.zones.map((V) => V.graph)]) ct == null || ct.animate({ "stroke-width": nt }, rt);
            $ || [P.group, P.markerGroup, P.dataLabelsGroup, P.labelBySeries].forEach(function(ct) {
              ct && ct.animate({ opacity: dt }, rt);
            });
          }
          E && $ && P.points && P.setAllPointsToState(m || void 0);
        }
        setAllPointsToState(m) {
          this.points.forEach(function(E) {
            E.setState && E.setState(m);
          });
        }
        setVisible(m, E) {
          var rt;
          let P = this, R = P.chart, z = R.options.chart.ignoreHiddenSeries, $ = P.visible;
          P.visible = m = P.options.visible = P.userOptions.visible = m === void 0 ? !$ : m;
          let et = m ? "show" : "hide";
          ["group", "dataLabelsGroup", "markerGroup", "tracker", "tt"].forEach((nt) => {
            var dt;
            (dt = P[nt]) == null || dt[et]();
          }), (R.hoverSeries === P || ((rt = R.hoverPoint) == null ? void 0 : rt.series) === P) && P.onMouseOut(), P.legendItem && R.legend.colorizeItem(P, m), P.isDirty = !0, P.options.stacking && R.series.forEach((nt) => {
            nt.options.stacking && nt.visible && (nt.isDirty = !0);
          }), P.linkedSeries.forEach((nt) => {
            nt.setVisible(m, !1);
          }), z && (R.isDirtyBox = !0), b(P, et), E !== !1 && R.redraw();
        }
        show() {
          this.setVisible(!0);
        }
        hide() {
          this.setVisible(!1);
        }
        select(m) {
          this.selected = m = this.options.selected = m === void 0 ? !this.selected : m, this.checkbox && (this.checkbox.checked = m), b(this, m ? "select" : "unselect");
        }
        shouldShowTooltip(m, E, P = {}) {
          return P.series = this, P.visiblePlotOnly = !0, this.chart.isInsidePlot(m, E, P);
        }
        drawLegendSymbol(m, E) {
          var P;
          (P = J[this.options.legendSymbol || "rectangle"]) == null || P.call(this, m, E);
        }
      }
      return L.defaultOptions = tt, L.types = X.seriesTypes, L.registerType = X.registerSeriesType, t(L.prototype, { axisTypes: ["xAxis", "yAxis"], coll: "series", colorCounter: 0, directTouch: !1, invertible: !0, isCartesian: !0, kdAxisArray: ["clientX", "plotY"], parallelArrays: ["x", "y"], pointClass: q, requireSorting: !0, sorted: !0 }), X.series = L, L;
    }), ot(i, "Core/Legend/Legend.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Foundation.js"], i["Core/Globals.js"], i["Core/Series/Series.js"], i["Core/Series/Point.js"], i["Core/Renderer/RendererUtilities.js"], i["Core/Templating.js"], i["Core/Utilities.js"]], function(U, _, K, Z, J, q, tt, X) {
      var I;
      let { animObject: O, setAnimation: y } = U, { registerEventOptions: w } = _, { composed: f, marginNames: x } = K, { distribute: s } = q, { format: l } = tt, { addEvent: p, createElement: n, css: a, defined: v, discardElement: N, find: B, fireEvent: T, isNumber: o, merge: u, pick: c, pushUnique: e, relativeLength: t, stableSort: h, syncTimeout: b } = X;
      class r {
        constructor(d, M) {
          this.allItems = [], this.initialItemY = 0, this.itemHeight = 0, this.itemMarginBottom = 0, this.itemMarginTop = 0, this.itemX = 0, this.itemY = 0, this.lastItemY = 0, this.lastLineHeight = 0, this.legendHeight = 0, this.legendWidth = 0, this.maxItemWidth = 0, this.maxLegendWidth = 0, this.offsetWidth = 0, this.padding = 0, this.pages = [], this.symbolHeight = 0, this.symbolWidth = 0, this.titleHeight = 0, this.totalItemWidth = 0, this.widthOption = 0, this.chart = d, this.setOptions(M), M.enabled && (this.render(), w(this, M), p(this.chart, "endResize", function() {
            this.legend.positionCheckboxes();
          })), p(this.chart, "render", () => {
            this.options.enabled && this.proximate && (this.proximatePositions(), this.positionItems());
          });
        }
        setOptions(d) {
          let M = c(d.padding, 8);
          this.options = d, this.chart.styledMode || (this.itemStyle = d.itemStyle, this.itemHiddenStyle = u(this.itemStyle, d.itemHiddenStyle)), this.itemMarginTop = d.itemMarginTop, this.itemMarginBottom = d.itemMarginBottom, this.padding = M, this.initialItemY = M - 5, this.symbolWidth = c(d.symbolWidth, 16), this.pages = [], this.proximate = d.layout === "proximate" && !this.chart.inverted, this.baseline = void 0;
        }
        update(d, M) {
          let H = this.chart;
          this.setOptions(u(!0, this.options, d)), "events" in this.options && w(this, this.options), this.destroy(), H.isDirtyLegend = H.isDirtyBox = !0, c(M, !0) && H.redraw(), T(this, "afterUpdate", { redraw: M });
        }
        colorizeItem(d, M) {
          let { area: H, group: A, label: D, line: W, symbol: G } = d.legendItem || {};
          if (A == null || A[M ? "removeClass" : "addClass"]("highcharts-legend-item-hidden"), !this.chart.styledMode) {
            let { itemHiddenStyle: it = {} } = this, C = it.color, { fillColor: k, fillOpacity: L, lineColor: F, marker: m } = d.options, E = (P) => (!M && (P.fill && (P.fill = C), P.stroke && (P.stroke = C)), P);
            D == null || D.css(u(M ? this.itemStyle : it)), W == null || W.attr(E({ stroke: F || d.color })), G && G.attr(E(m && G.isMarker ? d.pointAttribs() : { fill: d.color })), H == null || H.attr(E({ fill: k || d.color, "fill-opacity": k ? 1 : L != null ? L : 0.75 }));
          }
          T(this, "afterColorizeItem", { item: d, visible: M });
        }
        positionItems() {
          this.allItems.forEach(this.positionItem, this), this.chart.isResizing || this.positionCheckboxes();
        }
        positionItem(d) {
          let { group: M, x: H = 0, y: A = 0 } = d.legendItem || {}, D = this.options, W = D.symbolPadding, G = !D.rtl, it = d.checkbox;
          if (M && M.element) {
            let C = { translateX: G ? H : this.legendWidth - H - 2 * W - 4, translateY: A };
            M[v(M.translateY) ? "animate" : "attr"](C, void 0, () => {
              T(this, "afterPositionItem", { item: d });
            });
          }
          it && (it.x = H, it.y = A);
        }
        destroyItem(d) {
          let M = d.checkbox, H = d.legendItem || {};
          for (let A of ["group", "label", "line", "symbol"]) H[A] && (H[A] = H[A].destroy());
          M && N(M), d.legendItem = void 0;
        }
        destroy() {
          for (let d of this.getAllItems()) this.destroyItem(d);
          for (let d of ["clipRect", "up", "down", "pager", "nav", "box", "title", "group"]) this[d] && (this[d] = this[d].destroy());
          this.display = null;
        }
        positionCheckboxes() {
          let d, M = this.group && this.group.alignAttr, H = this.clipHeight || this.legendHeight, A = this.titleHeight;
          M && (d = M.translateY, this.allItems.forEach(function(D) {
            let W, G = D.checkbox;
            G && (W = d + A + G.y + (this.scrollOffset || 0) + 3, a(G, { left: M.translateX + D.checkboxOffset + G.x - 20 + "px", top: W + "px", display: this.proximate || W > d - 6 && W < d + H - 6 ? "" : "none" }));
          }, this));
        }
        renderTitle() {
          let d = this.options, M = this.padding, H = d.title, A, D = 0;
          H.text && (this.title || (this.title = this.chart.renderer.label(H.text, M - 3, M - 4, void 0, void 0, void 0, d.useHTML, void 0, "legend-title").attr({ zIndex: 1 }), this.chart.styledMode || this.title.css(H.style), this.title.add(this.group)), H.width || this.title.css({ width: this.maxLegendWidth + "px" }), D = (A = this.title.getBBox()).height, this.offsetWidth = A.width, this.contentGroup.attr({ translateY: D })), this.titleHeight = D;
        }
        setText(d) {
          let M = this.options;
          d.legendItem.label.attr({ text: M.labelFormat ? l(M.labelFormat, d, this.chart) : M.labelFormatter.call(d) });
        }
        renderItem(d) {
          let M = d.legendItem = d.legendItem || {}, H = this.chart, A = H.renderer, D = this.options, W = D.layout === "horizontal", G = this.symbolWidth, it = D.symbolPadding || 0, C = this.itemStyle, k = this.itemHiddenStyle, L = W ? c(D.itemDistance, 20) : 0, F = !D.rtl, m = !d.series, E = !m && d.series.drawLegendSymbol ? d.series : d, P = E.options, R = !!this.createCheckboxForItem && P && P.showCheckbox, z = D.useHTML, $ = d.options.className, et = M.label, rt = G + it + L + (R ? 20 : 0);
          !et && (M.group = A.g("legend-item").addClass("highcharts-" + E.type + "-series highcharts-color-" + d.colorIndex + ($ ? " " + $ : "") + (m ? " highcharts-series-" + d.index : "")).attr({ zIndex: 1 }).add(this.scrollGroup), M.label = et = A.text("", F ? G + it : -it, this.baseline || 0, z), H.styledMode || et.css(u(d.visible ? C : k)), et.attr({ align: F ? "left" : "right", zIndex: 2 }).add(M.group), !this.baseline && (this.fontMetrics = A.fontMetrics(et), this.baseline = this.fontMetrics.f + 3 + this.itemMarginTop, et.attr("y", this.baseline), this.symbolHeight = c(D.symbolHeight, this.fontMetrics.f), D.squareSymbol && (this.symbolWidth = c(D.symbolWidth, Math.max(this.symbolHeight, 16)), rt = this.symbolWidth + it + L + (R ? 20 : 0), F && et.attr("x", this.symbolWidth + it))), E.drawLegendSymbol(this, d), this.setItemEvents && this.setItemEvents(d, et, z)), R && !d.checkbox && this.createCheckboxForItem && this.createCheckboxForItem(d), this.colorizeItem(d, d.visible), (H.styledMode || !C.width) && et.css({ width: (D.itemWidth || this.widthOption || H.spacingBox.width) - rt + "px" }), this.setText(d);
          let nt = et.getBBox(), dt = this.fontMetrics && this.fontMetrics.h || 0;
          d.itemWidth = d.checkboxOffset = D.itemWidth || M.labelWidth || nt.width + rt, this.maxItemWidth = Math.max(this.maxItemWidth, d.itemWidth), this.totalItemWidth += d.itemWidth, this.itemHeight = d.itemHeight = Math.round(M.labelHeight || (nt.height > 1.5 * dt ? nt.height : dt));
        }
        layoutItem(d) {
          let M = this.options, H = this.padding, A = M.layout === "horizontal", D = d.itemHeight, W = this.itemMarginBottom, G = this.itemMarginTop, it = A ? c(M.itemDistance, 20) : 0, C = this.maxLegendWidth, k = M.alignColumns && this.totalItemWidth > C ? this.maxItemWidth : d.itemWidth, L = d.legendItem || {};
          A && this.itemX - H + k > C && (this.itemX = H, this.lastLineHeight && (this.itemY += G + this.lastLineHeight + W), this.lastLineHeight = 0), this.lastItemY = G + this.itemY + W, this.lastLineHeight = Math.max(D, this.lastLineHeight), L.x = this.itemX, L.y = this.itemY, A ? this.itemX += k : (this.itemY += G + D + W, this.lastLineHeight = D), this.offsetWidth = this.widthOption || Math.max((A ? this.itemX - H - (d.checkbox ? 0 : it) : k) + H, this.offsetWidth);
        }
        getAllItems() {
          let d = [];
          return this.chart.series.forEach(function(M) {
            let H = M && M.options;
            M && c(H.showInLegend, !v(H.linkedTo) && void 0, !0) && (d = d.concat((M.legendItem || {}).labels || (H.legendType === "point" ? M.data : M)));
          }), T(this, "afterGetAllItems", { allItems: d }), d;
        }
        getAlignment() {
          let d = this.options;
          return this.proximate ? d.align.charAt(0) + "tv" : d.floating ? "" : d.align.charAt(0) + d.verticalAlign.charAt(0) + d.layout.charAt(0);
        }
        adjustMargins(d, M) {
          let H = this.chart, A = this.options, D = this.getAlignment();
          D && [/(lth|ct|rth)/, /(rtv|rm|rbv)/, /(rbh|cb|lbh)/, /(lbv|lm|ltv)/].forEach(function(W, G) {
            W.test(D) && !v(d[G]) && (H[x[G]] = Math.max(H[x[G]], H.legend[(G + 1) % 2 ? "legendHeight" : "legendWidth"] + [1, -1, -1, 1][G] * A[G % 2 ? "x" : "y"] + c(A.margin, 12) + M[G] + (H.titleOffset[G] || 0)));
          });
        }
        proximatePositions() {
          let d, M = this.chart, H = [], A = this.options.align === "left";
          for (let D of (this.allItems.forEach(function(W) {
            let G, it, C = A, k, L;
            W.yAxis && (W.xAxis.options.reversed && (C = !C), W.points && (G = B(C ? W.points : W.points.slice(0).reverse(), function(F) {
              return o(F.plotY);
            })), it = this.itemMarginTop + W.legendItem.label.getBBox().height + this.itemMarginBottom, L = W.yAxis.top - M.plotTop, k = W.visible ? (G ? G.plotY : W.yAxis.height) + (L - 0.3 * it) : L + W.yAxis.height, H.push({ target: k, size: it, item: W }));
          }, this), s(H, M.plotHeight))) d = D.item.legendItem || {}, o(D.pos) && (d.y = M.plotTop - M.spacing[0] + D.pos);
        }
        render() {
          let d = this.chart, M = d.renderer, H = this.options, A = this.padding, D = this.getAllItems(), W, G, it, C = this.group, k, L = this.box;
          this.itemX = A, this.itemY = this.initialItemY, this.offsetWidth = 0, this.lastItemY = 0, this.widthOption = t(H.width, d.spacingBox.width - A), k = d.spacingBox.width - 2 * A - H.x, ["rm", "lm"].indexOf(this.getAlignment().substring(0, 2)) > -1 && (k /= 2), this.maxLegendWidth = this.widthOption || k, C || (this.group = C = M.g("legend").addClass(H.className || "").attr({ zIndex: 7 }).add(), this.contentGroup = M.g().attr({ zIndex: 1 }).add(C), this.scrollGroup = M.g().add(this.contentGroup)), this.renderTitle(), h(D, (F, m) => (F.options && F.options.legendIndex || 0) - (m.options && m.options.legendIndex || 0)), H.reversed && D.reverse(), this.allItems = D, this.display = W = !!D.length, this.lastLineHeight = 0, this.maxItemWidth = 0, this.totalItemWidth = 0, this.itemHeight = 0, D.forEach(this.renderItem, this), D.forEach(this.layoutItem, this), G = (this.widthOption || this.offsetWidth) + A, it = this.lastItemY + this.lastLineHeight + this.titleHeight, it = this.handleOverflow(it) + A, L || (this.box = L = M.rect().addClass("highcharts-legend-box").attr({ r: H.borderRadius }).add(C)), d.styledMode || L.attr({ stroke: H.borderColor, "stroke-width": H.borderWidth || 0, fill: H.backgroundColor || "none" }).shadow(H.shadow), G > 0 && it > 0 && L[L.placed ? "animate" : "attr"](L.crisp.call({}, { x: 0, y: 0, width: G, height: it }, L.strokeWidth())), C[W ? "show" : "hide"](), d.styledMode && C.getStyle("display") === "none" && (G = it = 0), this.legendWidth = G, this.legendHeight = it, W && this.align(), this.proximate || this.positionItems(), T(this, "afterRender");
        }
        align(d = this.chart.spacingBox) {
          let M = this.chart, H = this.options, A = d.y;
          /(lth|ct|rth)/.test(this.getAlignment()) && M.titleOffset[0] > 0 ? A += M.titleOffset[0] : /(lbh|cb|rbh)/.test(this.getAlignment()) && M.titleOffset[2] > 0 && (A -= M.titleOffset[2]), A !== d.y && (d = u(d, { y: A })), M.hasRendered || (this.group.placed = !1), this.group.align(u(H, { width: this.legendWidth, height: this.legendHeight, verticalAlign: this.proximate ? "top" : H.verticalAlign }), !0, d);
        }
        handleOverflow(d) {
          let M = this, H = this.chart, A = H.renderer, D = this.options, W = D.y, G = D.verticalAlign === "top", it = this.padding, C = D.maxHeight, k = D.navigation, L = c(k.animation, !0), F = k.arrowSize || 12, m = this.pages, E = this.allItems, P = function(ct) {
            typeof ct == "number" ? dt.attr({ height: ct }) : dt && (M.clipRect = dt.destroy(), M.contentGroup.clip()), M.contentGroup.div && (M.contentGroup.div.style.clip = ct ? "rect(" + it + "px,9999px," + (it + ct) + "px,0)" : "auto");
          }, R = function(ct) {
            return M[ct] = A.circle(0, 0, 1.3 * F).translate(F / 2, F / 2).add(nt), H.styledMode || M[ct].attr("fill", "rgba(0,0,0,0.0001)"), M[ct];
          }, z, $, et, rt = H.spacingBox.height + (G ? -W : W) - it, nt = this.nav, dt = this.clipRect;
          return D.layout !== "horizontal" || D.verticalAlign === "middle" || D.floating || (rt /= 2), C && (rt = Math.min(rt, C)), m.length = 0, d && rt > 0 && d > rt && k.enabled !== !1 ? (this.clipHeight = z = Math.max(rt - 20 - this.titleHeight - it, 0), this.currentPage = c(this.currentPage, 1), this.fullHeight = d, E.forEach((ct, V) => {
            let Y = (et = ct.legendItem || {}).y || 0, Q = Math.round(et.label.getBBox().height), st = m.length;
            (!st || Y - m[st - 1] > z && ($ || Y) !== m[st - 1]) && (m.push($ || Y), st++), et.pageIx = st - 1, $ && ((E[V - 1].legendItem || {}).pageIx = st - 1), V === E.length - 1 && Y + Q - m[st - 1] > z && Y > m[st - 1] && (m.push(Y), et.pageIx = st), Y !== $ && ($ = Y);
          }), dt || (dt = M.clipRect = A.clipRect(0, it - 2, 9999, 0), M.contentGroup.clip(dt)), P(z), nt || (this.nav = nt = A.g().attr({ zIndex: 1 }).add(this.group), this.up = A.symbol("triangle", 0, 0, F, F).add(nt), R("upTracker").on("click", function() {
            M.scroll(-1, L);
          }), this.pager = A.text("", 15, 10).addClass("highcharts-legend-navigation"), !H.styledMode && k.style && this.pager.css(k.style), this.pager.add(nt), this.down = A.symbol("triangle-down", 0, 0, F, F).add(nt), R("downTracker").on("click", function() {
            M.scroll(1, L);
          })), M.scroll(0), d = rt) : nt && (P(), this.nav = nt.destroy(), this.scrollGroup.attr({ translateY: 1 }), this.clipHeight = 0), d;
        }
        scroll(d, M) {
          let H = this.chart, A = this.pages, D = A.length, W = this.clipHeight, G = this.options.navigation, it = this.pager, C = this.padding, k = this.currentPage + d;
          k > D && (k = D), k > 0 && (M !== void 0 && y(M, H), this.nav.attr({ translateX: C, translateY: W + this.padding + 7 + this.titleHeight, visibility: "inherit" }), [this.up, this.upTracker].forEach(function(L) {
            L.attr({ class: k === 1 ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" });
          }), it.attr({ text: k + "/" + D }), [this.down, this.downTracker].forEach(function(L) {
            L.attr({ x: 18 + this.pager.getBBox().width, class: k === D ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active" });
          }, this), H.styledMode || (this.up.attr({ fill: k === 1 ? G.inactiveColor : G.activeColor }), this.upTracker.css({ cursor: k === 1 ? "default" : "pointer" }), this.down.attr({ fill: k === D ? G.inactiveColor : G.activeColor }), this.downTracker.css({ cursor: k === D ? "default" : "pointer" })), this.scrollOffset = -A[k - 1] + this.initialItemY, this.scrollGroup.animate({ translateY: this.scrollOffset }), this.currentPage = k, this.positionCheckboxes(), b(() => {
            T(this, "afterScroll", { currentPage: k });
          }, O(c(M, H.renderer.globalAnimation, !0)).duration));
        }
        setItemEvents(d, M, H) {
          let A = this, D = d.legendItem || {}, W = A.chart.renderer.boxWrapper, G = d instanceof J, it = d instanceof Z, C = "highcharts-legend-" + (G ? "point" : "series") + "-active", k = A.chart.styledMode, L = H ? [M, D.symbol] : [D.group], F = (m) => {
            A.allItems.forEach((E) => {
              d !== E && [E].concat(E.linkedSeries || []).forEach((P) => {
                P.setState(m, !G);
              });
            });
          };
          for (let m of L) m && m.on("mouseover", function() {
            d.visible && F("inactive"), d.setState("hover"), d.visible && W.addClass(C), k || M.css(A.options.itemHoverStyle);
          }).on("mouseout", function() {
            A.chart.styledMode || M.css(u(d.visible ? A.itemStyle : A.itemHiddenStyle)), F(""), W.removeClass(C), d.setState();
          }).on("click", function(E) {
            let P = function() {
              d.setVisible && d.setVisible(), F(d.visible ? "inactive" : "");
            };
            W.removeClass(C), T(A, "itemClick", { browserEvent: E, legendItem: d }, P), G ? d.firePointEvent("legendItemClick", { browserEvent: E }) : it && T(d, "legendItemClick", { browserEvent: E });
          });
        }
        createCheckboxForItem(d) {
          d.checkbox = n("input", { type: "checkbox", className: "highcharts-legend-checkbox", checked: d.selected, defaultChecked: d.selected }, this.options.itemCheckboxStyle, this.chart.container), p(d.checkbox, "click", function(M) {
            let H = M.target;
            T(d.series || d, "checkboxClick", { checked: H.checked, item: d }, function() {
              d.select();
            });
          });
        }
      }
      return (I = r || (r = {})).compose = function(g) {
        e(f, "Core.Legend") && p(g, "beforeMargins", function() {
          this.legend = new I(this, this.options.legend);
        });
      }, r;
    }), ot(i, "Core/Chart/Chart.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Axis/Axis.js"], i["Core/Defaults.js"], i["Core/Templating.js"], i["Core/Foundation.js"], i["Core/Globals.js"], i["Core/Renderer/RendererRegistry.js"], i["Core/Series/Series.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Renderer/SVG/SVGRenderer.js"], i["Core/Time.js"], i["Core/Utilities.js"], i["Core/Renderer/HTML/AST.js"], i["Core/Axis/Tick.js"]], function(U, _, K, Z, J, q, tt, X, I, O, y, w, f, x) {
      let { animate: s, animObject: l, setAnimation: p } = U, { defaultOptions: n, defaultTime: a } = K, { numberFormat: v } = Z, { registerEventOptions: N } = J, { charts: B, doc: T, marginNames: o, svg: u, win: c } = q, { seriesTypes: e } = I, { addEvent: t, attr: h, createElement: b, css: r, defined: g, diffObjects: d, discardElement: M, erase: H, error: A, extend: D, find: W, fireEvent: G, getStyle: it, isArray: C, isNumber: k, isObject: L, isString: F, merge: m, objectEach: E, pick: P, pInt: R, relativeLength: z, removeEvent: $, splat: et, syncTimeout: rt, uniqueKey: nt } = w;
      class dt {
        static chart(V, Y, Q) {
          return new dt(V, Y, Q);
        }
        constructor(V, Y, Q) {
          this.sharedClips = {};
          let st = [...arguments];
          (F(V) || V.nodeName) && (this.renderTo = st.shift()), this.init(st[0], st[1]);
        }
        setZoomOptions() {
          let V = this.options.chart, Y = V.zooming;
          this.zooming = { ...Y, type: P(V.zoomType, Y.type), key: P(V.zoomKey, Y.key), pinchType: P(V.pinchType, Y.pinchType), singleTouch: P(V.zoomBySingleTouch, Y.singleTouch, !1), resetButton: m(Y.resetButton, V.resetZoomButton) };
        }
        init(V, Y) {
          G(this, "init", { args: arguments }, function() {
            let Q = m(n, V), st = Q.chart;
            this.userOptions = D({}, V), this.margin = [], this.spacing = [], this.labelCollectors = [], this.callback = Y, this.isResizing = 0, this.options = Q, this.axes = [], this.series = [], this.time = V.time && Object.keys(V.time).length ? new y(V.time) : q.time, this.numberFormatter = st.numberFormatter || v, this.styledMode = st.styledMode, this.hasCartesianSeries = st.showAxes, this.index = B.length, B.push(this), q.chartCount++, N(this, st), this.xAxis = [], this.yAxis = [], this.pointCount = this.colorCounter = this.symbolCounter = 0, this.setZoomOptions(), G(this, "afterInit"), this.firstRender();
          });
        }
        initSeries(V) {
          let Y = this.options.chart, Q = V.type || Y.type, st = e[Q];
          st || A(17, !0, this, { missingModuleFor: Q });
          let at = new st();
          return typeof at.init == "function" && at.init(this, V), at;
        }
        setSortedData() {
          this.getSeriesOrderByLinks().forEach(function(V) {
            V.points || V.data || !V.enabledDataSorting || V.setData(V.options.data, !1);
          });
        }
        getSeriesOrderByLinks() {
          return this.series.concat().sort(function(V, Y) {
            return V.linkedSeries.length || Y.linkedSeries.length ? Y.linkedSeries.length - V.linkedSeries.length : 0;
          });
        }
        orderItems(V, Y = 0) {
          let Q = this[V], st = this.options[V] = et(this.options[V]).slice(), at = this.userOptions[V] = this.userOptions[V] ? et(this.userOptions[V]).slice() : [];
          if (this.hasRendered && (st.splice(Y), at.splice(Y)), Q) for (let ht = Y, lt = Q.length; ht < lt; ++ht) {
            let ut = Q[ht];
            ut && (ut.index = ht, ut instanceof X && (ut.name = ut.getName()), ut.options.isInternal || (st[ht] = ut.options, at[ht] = ut.userOptions));
          }
        }
        isInsidePlot(V, Y, Q = {}) {
          var bt;
          let { inverted: st, plotBox: at, plotLeft: ht, plotTop: lt, scrollablePlotBox: ut } = this, { scrollLeft: pt = 0, scrollTop: ft = 0 } = Q.visiblePlotOnly && ((bt = this.scrollablePlotArea) == null ? void 0 : bt.scrollingContainer) || {}, gt = Q.series, mt = Q.visiblePlotOnly && ut || at, yt = Q.inverted ? Y : V, wt = Q.inverted ? V : Y, xt = { x: yt, y: wt, isInsidePlot: !0, options: Q };
          if (!Q.ignoreX) {
            let Ct = gt && (st && !this.polar ? gt.yAxis : gt.xAxis) || { pos: ht, len: 1 / 0 }, vt = Q.paneCoordinates ? Ct.pos + yt : ht + yt;
            vt >= Math.max(pt + ht, Ct.pos) && vt <= Math.min(pt + ht + mt.width, Ct.pos + Ct.len) || (xt.isInsidePlot = !1);
          }
          if (!Q.ignoreY && xt.isInsidePlot) {
            let Ct = !st && Q.axis && !Q.axis.isXAxis && Q.axis || gt && (st ? gt.xAxis : gt.yAxis) || { pos: lt, len: 1 / 0 }, vt = Q.paneCoordinates ? Ct.pos + wt : lt + wt;
            vt >= Math.max(ft + lt, Ct.pos) && vt <= Math.min(ft + lt + mt.height, Ct.pos + Ct.len) || (xt.isInsidePlot = !1);
          }
          return G(this, "afterIsInsidePlot", xt), xt.isInsidePlot;
        }
        redraw(V) {
          G(this, "beforeRedraw");
          let Y = this.hasCartesianSeries ? this.axes : this.colorAxis || [], Q = this.series, st = this.pointer, at = this.legend, ht = this.userOptions.legend, lt = this.renderer, ut = lt.isHidden(), pt = [], ft, gt, mt, yt = this.isDirtyBox, wt = this.isDirtyLegend, xt;
          for (lt.rootFontSize = lt.boxWrapper.getStyle("font-size"), this.setResponsive && this.setResponsive(!1), p(!!this.hasRendered && V, this), ut && this.temporaryDisplay(), this.layOutTitles(!1), mt = Q.length; mt--; ) if (((xt = Q[mt]).options.stacking || xt.options.centerInCategory) && (gt = !0, xt.isDirty)) {
            ft = !0;
            break;
          }
          if (ft) for (mt = Q.length; mt--; ) (xt = Q[mt]).options.stacking && (xt.isDirty = !0);
          Q.forEach(function(bt) {
            bt.isDirty && (bt.options.legendType === "point" ? (typeof bt.updateTotals == "function" && bt.updateTotals(), wt = !0) : ht && (ht.labelFormatter || ht.labelFormat) && (wt = !0)), bt.isDirtyData && G(bt, "updatedData");
          }), wt && at && at.options.enabled && (at.render(), this.isDirtyLegend = !1), gt && this.getStacks(), Y.forEach(function(bt) {
            bt.updateNames(), bt.setScale();
          }), this.getMargins(), Y.forEach(function(bt) {
            bt.isDirty && (yt = !0);
          }), Y.forEach(function(bt) {
            let Ct = bt.min + "," + bt.max;
            bt.extKey !== Ct && (bt.extKey = Ct, pt.push(function() {
              G(bt, "afterSetExtremes", D(bt.eventArgs, bt.getExtremes())), delete bt.eventArgs;
            })), (yt || gt) && bt.redraw();
          }), yt && this.drawChartBox(), G(this, "predraw"), Q.forEach(function(bt) {
            (yt || bt.isDirty) && bt.visible && bt.redraw(), bt.isDirtyData = !1;
          }), st && st.reset(!0), lt.draw(), G(this, "redraw"), G(this, "render"), ut && this.temporaryDisplay(!0), pt.forEach(function(bt) {
            bt.call();
          });
        }
        get(V) {
          let Y = this.series;
          function Q(at) {
            return at.id === V || at.options && at.options.id === V;
          }
          let st = W(this.axes, Q) || W(this.series, Q);
          for (let at = 0; !st && at < Y.length; at++) st = W(Y[at].points || [], Q);
          return st;
        }
        getAxes() {
          let V = this.userOptions;
          for (let Y of (G(this, "getAxes"), ["xAxis", "yAxis"])) for (let Q of V[Y] = et(V[Y] || {})) new _(this, Q, Y);
          G(this, "afterGetAxes");
        }
        getSelectedPoints() {
          return this.series.reduce((V, Y) => (Y.getPointsCollection().forEach((Q) => {
            P(Q.selectedStaging, Q.selected) && V.push(Q);
          }), V), []);
        }
        getSelectedSeries() {
          return this.series.filter(function(V) {
            return V.selected;
          });
        }
        setTitle(V, Y, Q) {
          this.applyDescription("title", V), this.applyDescription("subtitle", Y), this.applyDescription("caption", void 0), this.layOutTitles(Q);
        }
        applyDescription(V, Y) {
          let Q = this, st = this.options[V] = m(this.options[V], Y), at = this[V];
          at && Y && (this[V] = at = at.destroy()), st && !at && ((at = this.renderer.text(st.text, 0, 0, st.useHTML).attr({ align: st.align, class: "highcharts-" + V, zIndex: st.zIndex || 4 }).add()).update = function(ht, lt) {
            Q.applyDescription(V, ht), Q.layOutTitles(lt);
          }, this.styledMode || at.css(D(V === "title" ? { fontSize: this.options.isStock ? "1em" : "1.2em" } : {}, st.style)), this[V] = at);
        }
        layOutTitles(V = !0) {
          let Y = [0, 0, 0], Q = this.renderer, st = this.spacingBox;
          ["title", "subtitle", "caption"].forEach(function(ht) {
            let lt = this[ht], ut = this.options[ht], pt = ut.verticalAlign || "top", ft = ht === "title" ? pt === "top" ? -3 : 0 : pt === "top" ? Y[0] + 2 : 0;
            if (lt) {
              lt.css({ width: (ut.width || st.width + (ut.widthAdjust || 0)) + "px" });
              let gt = Q.fontMetrics(lt).b, mt = Math.round(lt.getBBox(ut.useHTML).height);
              lt.align(D({ y: pt === "bottom" ? gt : ft + gt, height: mt }, ut), !1, "spacingBox"), ut.floating || (pt === "top" ? Y[0] = Math.ceil(Y[0] + mt) : pt === "bottom" && (Y[2] = Math.ceil(Y[2] + mt)));
            }
          }, this), Y[0] && (this.options.title.verticalAlign || "top") === "top" && (Y[0] += this.options.title.margin), Y[2] && this.options.caption.verticalAlign === "bottom" && (Y[2] += this.options.caption.margin);
          let at = !this.titleOffset || this.titleOffset.join(",") !== Y.join(",");
          this.titleOffset = Y, G(this, "afterLayOutTitles"), !this.isDirtyBox && at && (this.isDirtyBox = this.isDirtyLegend = at, this.hasRendered && V && this.isDirtyBox && this.redraw());
        }
        getContainerBox() {
          let V = [].map.call(this.renderTo.children, (Q) => {
            if (Q !== this.container) {
              let st = Q.style.display;
              return Q.style.display = "none", [Q, st];
            }
          }), Y = { width: it(this.renderTo, "width", !0) || 0, height: it(this.renderTo, "height", !0) || 0 };
          return V.filter(Boolean).forEach(([Q, st]) => {
            Q.style.display = st;
          }), Y;
        }
        getChartSize() {
          var ht;
          let V = this.options.chart, Y = V.width, Q = V.height, st = this.getContainerBox(), at = st.height > 1 && !(!((ht = this.renderTo.parentElement) != null && ht.style.height) && this.renderTo.style.height === "100%");
          this.chartWidth = Math.max(0, Y || st.width || 600), this.chartHeight = Math.max(0, z(Q, this.chartWidth) || (at ? st.height : 400)), this.containerBox = st;
        }
        temporaryDisplay(V) {
          let Y = this.renderTo, Q;
          if (V) for (; Y && Y.style; ) Y.hcOrigStyle && (r(Y, Y.hcOrigStyle), delete Y.hcOrigStyle), Y.hcOrigDetached && (T.body.removeChild(Y), Y.hcOrigDetached = !1), Y = Y.parentNode;
          else for (; Y && Y.style && (T.body.contains(Y) || Y.parentNode || (Y.hcOrigDetached = !0, T.body.appendChild(Y)), (it(Y, "display", !1) === "none" || Y.hcOricDetached) && (Y.hcOrigStyle = { display: Y.style.display, height: Y.style.height, overflow: Y.style.overflow }, Q = { display: "block", overflow: "hidden" }, Y !== this.renderTo && (Q.height = 0), r(Y, Q), Y.offsetWidth || Y.style.setProperty("display", "block", "important")), (Y = Y.parentNode) !== T.body); ) ;
        }
        setClassName(V) {
          this.container.className = "highcharts-container " + (V || "");
        }
        getContainer() {
          var mt;
          let V = this.options, Y = V.chart, Q = "data-highcharts-chart", st = nt(), at, ht = this.renderTo;
          ht || (this.renderTo = ht = Y.renderTo), F(ht) && (this.renderTo = ht = T.getElementById(ht)), ht || A(13, !0, this);
          let lt = R(h(ht, Q));
          k(lt) && B[lt] && B[lt].hasRendered && B[lt].destroy(), h(ht, Q, this.index), ht.innerHTML = f.emptyHTML, Y.skipClone || ht.offsetWidth || this.temporaryDisplay(), this.getChartSize();
          let ut = this.chartHeight, pt = this.chartWidth;
          r(ht, { overflow: "hidden" }), this.styledMode || (at = D({ position: "relative", overflow: "hidden", width: pt + "px", height: ut + "px", textAlign: "left", lineHeight: "normal", zIndex: 0, "-webkit-tap-highlight-color": "rgba(0,0,0,0)", userSelect: "none", "touch-action": "manipulation", outline: "none", padding: "0px" }, Y.style || {}));
          let ft = b("div", { id: st }, at, ht);
          this.container = ft, this.getChartSize(), pt === this.chartWidth || (pt = this.chartWidth, this.styledMode || r(ft, { width: P((mt = Y.style) == null ? void 0 : mt.width, pt + "px") })), this.containerBox = this.getContainerBox(), this._cursor = ft.style.cursor;
          let gt = Y.renderer || !u ? tt.getRendererType(Y.renderer) : O;
          if (this.renderer = new gt(ft, pt, ut, void 0, Y.forExport, V.exporting && V.exporting.allowHTML, this.styledMode), p(void 0, this), this.setClassName(Y.className), this.styledMode) for (let yt in V.defs) this.renderer.definition(V.defs[yt]);
          else this.renderer.setStyle(Y.style);
          this.renderer.chartIndex = this.index, G(this, "afterGetContainer");
        }
        getMargins(V) {
          let { spacing: Y, margin: Q, titleOffset: st } = this;
          this.resetMargins(), st[0] && !g(Q[0]) && (this.plotTop = Math.max(this.plotTop, st[0] + Y[0])), st[2] && !g(Q[2]) && (this.marginBottom = Math.max(this.marginBottom, st[2] + Y[2])), this.legend && this.legend.display && this.legend.adjustMargins(Q, Y), G(this, "getMargins"), V || this.getAxisMargins();
        }
        getAxisMargins() {
          let V = this, Y = V.axisOffset = [0, 0, 0, 0], Q = V.colorAxis, st = V.margin, at = function(ht) {
            ht.forEach(function(lt) {
              lt.visible && lt.getOffset();
            });
          };
          V.hasCartesianSeries ? at(V.axes) : Q && Q.length && at(Q), o.forEach(function(ht, lt) {
            g(st[lt]) || (V[ht] += Y[lt]);
          }), V.setChartSize();
        }
        getOptions() {
          return d(this.userOptions, n);
        }
        reflow(V) {
          var at;
          let Y = this, Q = Y.containerBox, st = Y.getContainerBox();
          (at = Y.pointer) == null || delete at.chartPosition, !Y.isPrinting && !Y.isResizing && Q && st.width && ((st.width !== Q.width || st.height !== Q.height) && (w.clearTimeout(Y.reflowTimeout), Y.reflowTimeout = rt(function() {
            Y.container && Y.setSize(void 0, void 0, !1);
          }, V ? 100 : 0)), Y.containerBox = st);
        }
        setReflow() {
          let V = this, Y = (Q) => {
            var st;
            (st = V.options) != null && st.chart.reflow && V.hasLoaded && V.reflow(Q);
          };
          if (typeof ResizeObserver == "function") new ResizeObserver(Y).observe(V.renderTo);
          else {
            let Q = t(c, "resize", Y);
            t(this, "destroy", Q);
          }
        }
        setSize(V, Y, Q) {
          let st = this, at = st.renderer;
          st.isResizing += 1, p(Q, st);
          let ht = at.globalAnimation;
          st.oldChartHeight = st.chartHeight, st.oldChartWidth = st.chartWidth, V !== void 0 && (st.options.chart.width = V), Y !== void 0 && (st.options.chart.height = Y), st.getChartSize();
          let { chartWidth: lt, chartHeight: ut, scrollablePixelsX: pt = 0, scrollablePixelsY: ft = 0 } = st;
          (st.isDirtyBox || lt !== st.oldChartWidth || ut !== st.oldChartHeight) && (st.styledMode || (ht ? s : r)(st.container, { width: `${lt + pt}px`, height: `${ut + ft}px` }, ht), st.setChartSize(!0), at.setSize(lt, ut, ht), st.axes.forEach(function(gt) {
            gt.isDirty = !0, gt.setScale();
          }), st.isDirtyLegend = !0, st.isDirtyBox = !0, st.layOutTitles(), st.getMargins(), st.redraw(ht), st.oldChartHeight = void 0, G(st, "resize"), setTimeout(() => {
            st && G(st, "endResize");
          }, l(ht).duration)), st.isResizing -= 1;
        }
        setChartSize(V) {
          let Y, Q, st, at, { chartHeight: ht, chartWidth: lt, inverted: ut, spacing: pt, renderer: ft } = this, gt = this.clipOffset, mt = Math[ut ? "floor" : "round"];
          this.plotLeft = Y = Math.round(this.plotLeft), this.plotTop = Q = Math.round(this.plotTop), this.plotWidth = st = Math.max(0, Math.round(lt - Y - this.marginRight)), this.plotHeight = at = Math.max(0, Math.round(ht - Q - this.marginBottom)), this.plotSizeX = ut ? at : st, this.plotSizeY = ut ? st : at, this.spacingBox = ft.spacingBox = { x: pt[3], y: pt[0], width: lt - pt[3] - pt[1], height: ht - pt[0] - pt[2] }, this.plotBox = ft.plotBox = { x: Y, y: Q, width: st, height: at }, gt && (this.clipBox = { x: mt(gt[3]), y: mt(gt[0]), width: mt(this.plotSizeX - gt[1] - gt[3]), height: mt(this.plotSizeY - gt[0] - gt[2]) }), V || (this.axes.forEach(function(yt) {
            yt.setAxisSize(), yt.setAxisTranslation();
          }), ft.alignElements()), G(this, "afterSetChartSize", { skipAxes: V });
        }
        resetMargins() {
          G(this, "resetMargins");
          let V = this, Y = V.options.chart, Q = Y.plotBorderWidth || 0, st = Q / 2;
          ["margin", "spacing"].forEach(function(at) {
            let ht = Y[at], lt = L(ht) ? ht : [ht, ht, ht, ht];
            ["Top", "Right", "Bottom", "Left"].forEach(function(ut, pt) {
              V[at][pt] = P(Y[at + ut], lt[pt]);
            });
          }), o.forEach(function(at, ht) {
            V[at] = P(V.margin[ht], V.spacing[ht]);
          }), V.axisOffset = [0, 0, 0, 0], V.clipOffset = [st, st, st, st], V.plotBorderWidth = Q;
        }
        drawChartBox() {
          let V = this.options.chart, Y = this.renderer, Q = this.chartWidth, st = this.chartHeight, at = this.styledMode, ht = this.plotBGImage, lt = V.backgroundColor, ut = V.plotBackgroundColor, pt = V.plotBackgroundImage, ft = this.plotLeft, gt = this.plotTop, mt = this.plotWidth, yt = this.plotHeight, wt = this.plotBox, xt = this.clipRect, bt = this.clipBox, Ct = this.chartBackground, vt = this.plotBackground, kt = this.plotBorder, Tt, St, Et, Pt = "animate";
          Ct || (this.chartBackground = Ct = Y.rect().addClass("highcharts-background").add(), Pt = "attr"), at ? Tt = St = Ct.strokeWidth() : (St = (Tt = V.borderWidth || 0) + (V.shadow ? 8 : 0), Et = { fill: lt || "none" }, (Tt || Ct["stroke-width"]) && (Et.stroke = V.borderColor, Et["stroke-width"] = Tt), Ct.attr(Et).shadow(V.shadow)), Ct[Pt]({ x: St / 2, y: St / 2, width: Q - St - Tt % 2, height: st - St - Tt % 2, r: V.borderRadius }), Pt = "animate", vt || (Pt = "attr", this.plotBackground = vt = Y.rect().addClass("highcharts-plot-background").add()), vt[Pt](wt), !at && (vt.attr({ fill: ut || "none" }).shadow(V.plotShadow), pt && (ht ? (pt !== ht.attr("href") && ht.attr("href", pt), ht.animate(wt)) : this.plotBGImage = Y.image(pt, ft, gt, mt, yt).add())), xt ? xt.animate({ width: bt.width, height: bt.height }) : this.clipRect = Y.clipRect(bt), Pt = "animate", kt || (Pt = "attr", this.plotBorder = kt = Y.rect().addClass("highcharts-plot-border").attr({ zIndex: 1 }).add()), at || kt.attr({ stroke: V.plotBorderColor, "stroke-width": V.plotBorderWidth || 0, fill: "none" }), kt[Pt](kt.crisp({ x: ft, y: gt, width: mt, height: yt }, -kt.strokeWidth())), this.isDirtyBox = !1, G(this, "afterDrawChartBox");
        }
        propFromSeries() {
          let V, Y, Q, st = this, at = st.options.chart, ht = st.options.series;
          ["inverted", "angular", "polar"].forEach(function(lt) {
            for (Y = e[at.type], Q = at[lt] || Y && Y.prototype[lt], V = ht && ht.length; !Q && V--; ) (Y = e[ht[V].type]) && Y.prototype[lt] && (Q = !0);
            st[lt] = Q;
          });
        }
        linkSeries(V) {
          let Y = this, Q = Y.series;
          Q.forEach(function(st) {
            st.linkedSeries.length = 0;
          }), Q.forEach(function(st) {
            let { linkedTo: at } = st.options;
            if (F(at)) {
              let ht;
              (ht = at === ":previous" ? Y.series[st.index - 1] : Y.get(at)) && ht.linkedParent !== st && (ht.linkedSeries.push(st), st.linkedParent = ht, ht.enabledDataSorting && st.setDataSortingOptions(), st.visible = P(st.options.visible, ht.options.visible, st.visible));
            }
          }), G(this, "afterLinkSeries", { isUpdating: V });
        }
        renderSeries() {
          this.series.forEach(function(V) {
            V.translate(), V.render();
          });
        }
        render() {
          var ft;
          let V = this.axes, Y = this.colorAxis, Q = this.renderer, st = this.options.chart.axisLayoutRuns || 2, at = (gt) => {
            gt.forEach((mt) => {
              mt.visible && mt.render();
            });
          }, ht = 0, lt = !0, ut, pt = 0;
          for (let gt of (this.setTitle(), G(this, "beforeMargins"), (ft = this.getStacks) == null || ft.call(this), this.getMargins(!0), this.setChartSize(), V)) {
            let { options: mt } = gt, { labels: yt } = mt;
            if (this.hasCartesianSeries && gt.horiz && gt.visible && yt.enabled && gt.series.length && gt.coll !== "colorAxis" && !this.polar) {
              ht = mt.tickLength, gt.createGroups();
              let wt = new x(gt, 0, "", !0), xt = wt.createLabel("x", yt);
              if (wt.destroy(), xt && P(yt.reserveSpace, !k(mt.crossing)) && (ht = xt.getBBox().height + yt.distance + Math.max(mt.offset || 0, 0)), ht) {
                xt == null || xt.destroy();
                break;
              }
            }
          }
          for (this.plotHeight = Math.max(this.plotHeight - ht, 0); (lt || ut || st > 1) && pt < st; ) {
            let gt = this.plotWidth, mt = this.plotHeight;
            for (let yt of V) pt === 0 ? yt.setScale() : (yt.horiz && lt || !yt.horiz && ut) && yt.setTickInterval(!0);
            pt === 0 ? this.getAxisMargins() : this.getMargins(), lt = gt / this.plotWidth > (pt ? 1 : 1.1), ut = mt / this.plotHeight > (pt ? 1 : 1.05), pt++;
          }
          this.drawChartBox(), this.hasCartesianSeries ? at(V) : Y && Y.length && at(Y), this.seriesGroup || (this.seriesGroup = Q.g("series-group").attr({ zIndex: 3 }).shadow(this.options.chart.seriesGroupShadow).add()), this.renderSeries(), this.addCredits(), this.setResponsive && this.setResponsive(), this.hasRendered = !0;
        }
        addCredits(V) {
          let Y = this, Q = m(!0, this.options.credits, V);
          Q.enabled && !this.credits && (this.credits = this.renderer.text(Q.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function() {
            Q.href && (c.location.href = Q.href);
          }).attr({ align: Q.position.align, zIndex: 8 }), Y.styledMode || this.credits.css(Q.style), this.credits.add().align(Q.position), this.credits.update = function(st) {
            Y.credits = Y.credits.destroy(), Y.addCredits(st);
          });
        }
        destroy() {
          let V, Y = this, Q = Y.axes, st = Y.series, at = Y.container, ht = at && at.parentNode;
          for (G(Y, "destroy"), Y.renderer.forExport ? H(B, Y) : B[Y.index] = void 0, q.chartCount--, Y.renderTo.removeAttribute("data-highcharts-chart"), $(Y), V = Q.length; V--; ) Q[V] = Q[V].destroy();
          for (this.scroller && this.scroller.destroy && this.scroller.destroy(), V = st.length; V--; ) st[V] = st[V].destroy();
          ["title", "subtitle", "chartBackground", "plotBackground", "plotBGImage", "plotBorder", "seriesGroup", "clipRect", "credits", "pointer", "rangeSelector", "legend", "resetZoomButton", "tooltip", "renderer"].forEach(function(lt) {
            let ut = Y[lt];
            ut && ut.destroy && (Y[lt] = ut.destroy());
          }), at && (at.innerHTML = f.emptyHTML, $(at), ht && M(at)), E(Y, function(lt, ut) {
            delete Y[ut];
          });
        }
        firstRender() {
          var st;
          let V = this, Y = V.options;
          V.getContainer(), V.resetMargins(), V.setChartSize(), V.propFromSeries(), V.getAxes();
          let Q = C(Y.series) ? Y.series : [];
          Y.series = [], Q.forEach(function(at) {
            V.initSeries(at);
          }), V.linkSeries(), V.setSortedData(), G(V, "beforeRender"), V.render(), (st = V.pointer) == null || st.getChartPosition(), V.renderer.imgCount || V.hasLoaded || V.onload(), V.temporaryDisplay(!0);
        }
        onload() {
          this.callbacks.concat([this.callback]).forEach(function(V) {
            V && this.index !== void 0 && V.apply(this, [this]);
          }, this), G(this, "load"), G(this, "render"), g(this.index) && this.setReflow(), this.warnIfA11yModuleNotLoaded(), this.hasLoaded = !0;
        }
        warnIfA11yModuleNotLoaded() {
          let { options: V, title: Y } = this;
          !V || this.accessibility || (this.renderer.boxWrapper.attr({ role: "img", "aria-label": (Y && Y.element.textContent || "").replace(/</g, "&lt;") }), V.accessibility && V.accessibility.enabled === !1 || A('Highcharts warning: Consider including the "accessibility.js" module to make your chart more usable for people with disabilities. Set the "accessibility.enabled" option to false to remove this warning. See https://www.highcharts.com/docs/accessibility/accessibility-module.', !1, this));
        }
        addSeries(V, Y, Q) {
          let st, at = this;
          return V && (Y = P(Y, !0), G(at, "addSeries", { options: V }, function() {
            st = at.initSeries(V), at.isDirtyLegend = !0, at.linkSeries(), st.enabledDataSorting && st.setData(V.data, !1), G(at, "afterAddSeries", { series: st }), Y && at.redraw(Q);
          })), st;
        }
        addAxis(V, Y, Q, st) {
          return this.createAxis(Y ? "xAxis" : "yAxis", { axis: V, redraw: Q, animation: st });
        }
        addColorAxis(V, Y, Q) {
          return this.createAxis("colorAxis", { axis: V, redraw: Y, animation: Q });
        }
        createAxis(V, Y) {
          let Q = new _(this, Y.axis, V);
          return P(Y.redraw, !0) && this.redraw(Y.animation), Q;
        }
        showLoading(V) {
          let Y = this, Q = Y.options, st = Q.loading, at = function() {
            ht && r(ht, { left: Y.plotLeft + "px", top: Y.plotTop + "px", width: Y.plotWidth + "px", height: Y.plotHeight + "px" });
          }, ht = Y.loadingDiv, lt = Y.loadingSpan;
          ht || (Y.loadingDiv = ht = b("div", { className: "highcharts-loading highcharts-loading-hidden" }, null, Y.container)), lt || (Y.loadingSpan = lt = b("span", { className: "highcharts-loading-inner" }, null, ht), t(Y, "redraw", at)), ht.className = "highcharts-loading", f.setElementHTML(lt, P(V, Q.lang.loading, "")), Y.styledMode || (r(ht, D(st.style, { zIndex: 10 })), r(lt, st.labelStyle), Y.loadingShown || (r(ht, { opacity: 0, display: "" }), s(ht, { opacity: st.style.opacity || 0.5 }, { duration: st.showDuration || 0 }))), Y.loadingShown = !0, at();
        }
        hideLoading() {
          let V = this.options, Y = this.loadingDiv;
          Y && (Y.className = "highcharts-loading highcharts-loading-hidden", this.styledMode || s(Y, { opacity: 0 }, { duration: V.loading.hideDuration || 100, complete: function() {
            r(Y, { display: "none" });
          } })), this.loadingShown = !1;
        }
        update(V, Y, Q, st) {
          let at, ht, lt, ut = this, pt = { credits: "addCredits", title: "setTitle", subtitle: "setSubtitle", caption: "setCaption" }, ft = V.isResponsiveOptions, gt = [];
          G(ut, "update", { options: V }), ft || ut.setResponsive(!1, !0), V = d(V, ut.options), ut.userOptions = m(ut.userOptions, V);
          let mt = V.chart;
          mt && (m(!0, ut.options.chart, mt), this.setZoomOptions(), "className" in mt && ut.setClassName(mt.className), ("inverted" in mt || "polar" in mt || "type" in mt) && (ut.propFromSeries(), at = !0), "alignTicks" in mt && (at = !0), "events" in mt && N(this, mt), E(mt, function(xt, bt) {
            ut.propsRequireUpdateSeries.indexOf("chart." + bt) !== -1 && (ht = !0), ut.propsRequireDirtyBox.indexOf(bt) !== -1 && (ut.isDirtyBox = !0), ut.propsRequireReflow.indexOf(bt) === -1 || (ut.isDirtyBox = !0, ft || (lt = !0));
          }), !ut.styledMode && mt.style && ut.renderer.setStyle(ut.options.chart.style || {})), !ut.styledMode && V.colors && (this.options.colors = V.colors), V.time && (this.time === a && (this.time = new y(V.time)), m(!0, ut.options.time, V.time)), E(V, function(xt, bt) {
            ut[bt] && typeof ut[bt].update == "function" ? ut[bt].update(xt, !1) : typeof ut[pt[bt]] == "function" ? ut[pt[bt]](xt) : bt !== "colors" && ut.collectionsWithUpdate.indexOf(bt) === -1 && m(!0, ut.options[bt], V[bt]), bt !== "chart" && ut.propsRequireUpdateSeries.indexOf(bt) !== -1 && (ht = !0);
          }), this.collectionsWithUpdate.forEach(function(xt) {
            V[xt] && (et(V[xt]).forEach(function(bt, Ct) {
              let vt, kt = g(bt.id);
              kt && (vt = ut.get(bt.id)), !vt && ut[xt] && (vt = ut[xt][P(bt.index, Ct)]) && (kt && g(vt.options.id) || vt.options.isInternal) && (vt = void 0), vt && vt.coll === xt && (vt.update(bt, !1), Q && (vt.touched = !0)), !vt && Q && ut.collectionsWithInit[xt] && (ut.collectionsWithInit[xt][0].apply(ut, [bt].concat(ut.collectionsWithInit[xt][1] || []).concat([!1])).touched = !0);
            }), Q && ut[xt].forEach(function(bt) {
              bt.touched || bt.options.isInternal ? delete bt.touched : gt.push(bt);
            }));
          }), gt.forEach(function(xt) {
            xt.chart && xt.remove && xt.remove(!1);
          }), at && ut.axes.forEach(function(xt) {
            xt.update({}, !1);
          }), ht && ut.getSeriesOrderByLinks().forEach(function(xt) {
            xt.chart && xt.update({}, !1);
          }, this);
          let yt = mt && mt.width, wt = mt && (F(mt.height) ? z(mt.height, yt || ut.chartWidth) : mt.height);
          lt || k(yt) && yt !== ut.chartWidth || k(wt) && wt !== ut.chartHeight ? ut.setSize(yt, wt, st) : P(Y, !0) && ut.redraw(st), G(ut, "afterUpdate", { options: V, redraw: Y, animation: st });
        }
        setSubtitle(V, Y) {
          this.applyDescription("subtitle", V), this.layOutTitles(Y);
        }
        setCaption(V, Y) {
          this.applyDescription("caption", V), this.layOutTitles(Y);
        }
        showResetZoom() {
          let V = this, Y = n.lang, Q = V.zooming.resetButton, st = Q.theme, at = Q.relativeTo === "chart" || Q.relativeTo === "spacingBox" ? null : "plotBox";
          function ht() {
            V.zoomOut();
          }
          G(this, "beforeShowResetZoom", null, function() {
            V.resetZoomButton = V.renderer.button(Y.resetZoom, null, null, ht, st).attr({ align: Q.position.align, title: Y.resetZoomTitle }).addClass("highcharts-reset-zoom").add().align(Q.position, !1, at);
          }), G(this, "afterShowResetZoom");
        }
        zoomOut() {
          G(this, "selection", { resetSelection: !0 }, () => this.transform({ reset: !0, trigger: "zoom" }));
        }
        pan(V, Y) {
          let Q = this, st = typeof Y == "object" ? Y : { enabled: Y, type: "x" }, at = st.type, ht = at && Q[{ x: "xAxis", xy: "axes", y: "yAxis" }[at]].filter((ut) => ut.options.panningEnabled && !ut.options.isInternal), lt = Q.options.chart;
          lt != null && lt.panning && (lt.panning = st), G(this, "pan", { originalEvent: V }, () => {
            Q.transform({ axes: ht, event: V, to: { x: V.chartX - (Q.mouseDownX || 0), y: V.chartY - (Q.mouseDownY || 0) }, trigger: "pan" }), r(Q.container, { cursor: "move" });
          });
        }
        transform(V) {
          var yt, wt, xt, bt, Ct;
          let { axes: Y = this.axes, event: Q, from: st = {}, reset: at, selection: ht, to: lt = {}, trigger: ut } = V, { inverted: pt } = this, ft = !1, gt, mt;
          for (let vt of ((yt = this.hoverPoints) == null || yt.forEach((kt) => kt.setState()), Y)) {
            let { horiz: kt, len: Tt, minPointOffset: St = 0, options: Et, reversed: Pt } = vt, Yt = kt ? "width" : "height", Qt = kt ? "x" : "y", Ut = P(lt[Yt], vt.len), Gt = P(st[Yt], vt.len), Nt = 10 > Math.abs(Ut) ? 1 : Ut / Gt, Ee = (st[Qt] || 0) + Gt / 2 - vt.pos, Pe = Ee - (((wt = lt[Qt]) != null ? wt : vt.pos) + Ut / 2 - vt.pos) / Nt, ni = Pt && !pt || !Pt && pt ? -1 : 1;
            if (!at && (Ee < 0 || Ee > vt.len)) continue;
            let Dt = vt.toValue(Pe, !0) + (ht || vt.isOrdinal ? 0 : St * ni), It = vt.toValue(Pe + Tt / Nt, !0) - (ht || vt.isOrdinal ? 0 : St * ni || 0), Rt = vt.allExtremes;
            if (Dt > It && ([Dt, It] = [It, Dt]), Nt === 1 && !at && vt.coll === "yAxis" && !Rt) {
              for (let pi of vt.series) {
                let fe = pi.getExtremes(pi.getProcessedData(!0).yData, !0);
                Rt != null || (Rt = { dataMin: Number.MAX_VALUE, dataMax: -Number.MAX_VALUE }), k(fe.dataMin) && k(fe.dataMax) && (Rt.dataMin = Math.min(fe.dataMin, Rt.dataMin), Rt.dataMax = Math.max(fe.dataMax, Rt.dataMax));
              }
              vt.allExtremes = Rt;
            }
            let { dataMin: Le, dataMax: Oe, min: ai, max: li } = D(vt.getExtremes(), Rt || {}), hi = Le != null ? Le : Et.min, ci = Oe != null ? Oe : Et.max, De = It - Dt, di = vt.categories ? 0 : Math.min(De, ci - hi), Ie = hi - di * (g(Et.min) ? 0 : Et.minPadding), je = ci + di * (g(Et.max) ? 0 : Et.maxPadding), ui = vt.allowZoomOutside || Nt === 1 || ut !== "zoom" && Nt > 1, pe = Math.min((xt = Et.min) != null ? xt : Ie, Ie, ui ? ai : Ie), ge = Math.max((bt = Et.max) != null ? bt : je, je, ui ? li : je);
            (!vt.isOrdinal || vt.options.overscroll || Nt !== 1 || at) && (Dt < pe && (Dt = pe, Nt >= 1 && (It = Dt + De)), It > ge && (It = ge, Nt >= 1 && (Dt = It - De)), (at || vt.series.length && (Dt !== ai || It !== li) && Dt >= pe && It <= ge) && (ht ? ht[vt.coll].push({ axis: vt, min: Dt, max: It }) : (vt.isPanning = ut !== "zoom", vt.isPanning && (mt = !0), vt.setExtremes(at ? void 0 : Dt, at ? void 0 : It, !1, !1, { move: Pe, trigger: ut, scale: Nt }), !at && (Dt > pe || It < ge) && ut !== "mousewheel" && (gt = !0)), ft = !0), Q && (this[kt ? "mouseDownX" : "mouseDownY"] = Q[kt ? "chartX" : "chartY"]));
          }
          return ft && (ht ? G(this, "selection", ht, () => {
            delete V.selection, V.trigger = "zoom", this.transform(V);
          }) : (!gt || mt || this.resetZoomButton ? !gt && this.resetZoomButton && (this.resetZoomButton = this.resetZoomButton.destroy()) : this.showResetZoom(), this.redraw(ut === "zoom" && ((Ct = this.options.chart.animation) != null ? Ct : this.pointCount < 100)))), ft;
        }
      }
      return D(dt.prototype, { callbacks: [], collectionsWithInit: { xAxis: [dt.prototype.addAxis, [!0]], yAxis: [dt.prototype.addAxis, [!1]], series: [dt.prototype.addSeries] }, collectionsWithUpdate: ["xAxis", "yAxis", "series"], propsRequireDirtyBox: ["backgroundColor", "borderColor", "borderWidth", "borderRadius", "plotBackgroundColor", "plotBackgroundImage", "plotBorderColor", "plotBorderWidth", "plotShadow", "shadow"], propsRequireReflow: ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "spacing", "spacingTop", "spacingRight", "spacingBottom", "spacingLeft"], propsRequireUpdateSeries: ["chart.inverted", "chart.polar", "chart.ignoreHiddenSeries", "chart.type", "colors", "plotOptions", "time", "tooltip"] }), dt;
    }), ot(i, "Extensions/ScrollablePlotArea.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Globals.js"], i["Core/Renderer/RendererRegistry.js"], i["Core/Utilities.js"]], function(U, _, K, Z) {
      let { stop: J } = U, { composed: q } = _, { addEvent: tt, createElement: X, css: I, defined: O, merge: y, pushUnique: w } = Z;
      function f() {
        let l = this.scrollablePlotArea;
        (this.scrollablePixelsX || this.scrollablePixelsY) && !l && (this.scrollablePlotArea = l = new s(this)), l == null || l.applyFixed();
      }
      function x() {
        this.chart.scrollablePlotArea && (this.chart.scrollablePlotArea.isDirty = !0);
      }
      class s {
        static compose(p, n, a) {
          w(q, this.compose) && (tt(p, "afterInit", x), tt(n, "afterSetChartSize", (v) => this.afterSetSize(v.target, v)), tt(n, "render", f), tt(a, "show", x));
        }
        static afterSetSize(p, n) {
          let a, v, N, { minWidth: B, minHeight: T } = p.options.chart.scrollablePlotArea || {}, { clipBox: o, plotBox: u, inverted: c, renderer: e } = p;
          if (!e.forExport && (B ? (p.scrollablePixelsX = a = Math.max(0, B - p.chartWidth), a && (p.scrollablePlotBox = y(p.plotBox), u.width = p.plotWidth += a, o[c ? "height" : "width"] += a, N = !0)) : T && (p.scrollablePixelsY = v = Math.max(0, T - p.chartHeight), O(v) && (p.scrollablePlotBox = y(p.plotBox), u.height = p.plotHeight += v, o[c ? "width" : "height"] += v, N = !1)), O(N) && !n.skipAxes)) for (let t of p.axes) t.horiz === N && (t.setAxisSize(), t.setAxisTranslation());
        }
        constructor(p) {
          var h, b;
          let n, a = p.options.chart, v = K.getRendererType(), N = a.scrollablePlotArea || {}, B = this.moveFixedElements.bind(this), T = { WebkitOverflowScrolling: "touch", overflowX: "hidden", overflowY: "hidden" };
          p.scrollablePixelsX && (T.overflowX = "auto"), p.scrollablePixelsY && (T.overflowY = "auto"), this.chart = p;
          let o = this.parentDiv = X("div", { className: "highcharts-scrolling-parent" }, { position: "relative" }, p.renderTo), u = this.scrollingContainer = X("div", { className: "highcharts-scrolling" }, T, o), c = this.innerContainer = X("div", { className: "highcharts-inner-container" }, void 0, u), e = this.fixedDiv = X("div", { className: "highcharts-fixed" }, { position: "absolute", overflow: "hidden", pointerEvents: "none", zIndex: (((h = a.style) == null ? void 0 : h.zIndex) || 0) + 2, top: 0 }, void 0, !0), t = this.fixedRenderer = new v(e, p.chartWidth, p.chartHeight, a.style);
          this.mask = t.path().attr({ fill: a.backgroundColor || "#fff", "fill-opacity": (b = N.opacity) != null ? b : 0.85, zIndex: -1 }).addClass("highcharts-scrollable-mask").add(), u.parentNode.insertBefore(e, u), I(p.renderTo, { overflow: "visible" }), tt(p, "afterShowResetZoom", B), tt(p, "afterApplyDrilldown", B), tt(p, "afterLayOutTitles", B), tt(u, "scroll", () => {
            let { pointer: r, hoverPoint: g } = p;
            r && (delete r.chartPosition, g && (n = g), r.runPointActions(void 0, n, !0));
          }), c.appendChild(p.container);
        }
        applyFixed() {
          var k;
          let { chart: p, fixedRenderer: n, isDirty: a, scrollingContainer: v } = this, { axisOffset: N, chartWidth: B, chartHeight: T, container: o, plotHeight: u, plotLeft: c, plotTop: e, plotWidth: t, scrollablePixelsX: h = 0, scrollablePixelsY: b = 0 } = p, { scrollPositionX: r = 0, scrollPositionY: g = 0 } = p.options.chart.scrollablePlotArea || {}, d = B + h, M = T + b;
          n.setSize(B, T), (a == null || a) && (this.isDirty = !1, this.moveFixedElements()), J(p.container), I(o, { width: `${d}px`, height: `${M}px` }), p.renderer.boxWrapper.attr({ width: d, height: M, viewBox: [0, 0, d, M].join(" ") }), (k = p.chartBackground) == null || k.attr({ width: d, height: M }), I(v, { width: `${B}px`, height: `${T}px` }), O(a) || (v.scrollLeft = h * r, v.scrollTop = b * g);
          let H = e - N[0] - 1, A = c - N[3] - 1, D = e + u + N[2] + 1, W = c + t + N[1] + 1, G = c + t - h, it = e + u - b, C = [["M", 0, 0]];
          h ? C = [["M", 0, H], ["L", c - 1, H], ["L", c - 1, D], ["L", 0, D], ["Z"], ["M", G, H], ["L", B, H], ["L", B, D], ["L", G, D], ["Z"]] : b && (C = [["M", A, 0], ["L", A, e - 1], ["L", W, e - 1], ["L", W, 0], ["Z"], ["M", A, it], ["L", A, T], ["L", W, T], ["L", W, it], ["Z"]]), p.redrawTrigger !== "adjustHeight" && this.mask.attr({ d: C });
        }
        moveFixedElements() {
          let p, { container: n, inverted: a, scrollablePixelsX: v, scrollablePixelsY: N } = this.chart, B = this.fixedRenderer, T = s.fixedSelectors;
          for (let o of (v && !a ? p = ".highcharts-yaxis" : v && a || N && !a ? p = ".highcharts-xaxis" : N && a && (p = ".highcharts-yaxis"), p && T.push(`${p}:not(.highcharts-radial-axis)`, `${p}-labels:not(.highcharts-radial-axis-labels)`), T)) [].forEach.call(n.querySelectorAll(o), (u) => {
            (u.namespaceURI === B.SVG_NS ? B.box : B.box.parentNode).appendChild(u), u.style.pointerEvents = "auto";
          });
        }
      }
      return s.fixedSelectors = [".highcharts-breadcrumbs-group", ".highcharts-contextbutton", ".highcharts-caption", ".highcharts-credits", ".highcharts-drillup-button", ".highcharts-legend", ".highcharts-legend-checkbox", ".highcharts-navigator-series", ".highcharts-navigator-xaxis", ".highcharts-navigator-yaxis", ".highcharts-navigator", ".highcharts-range-selector-group", ".highcharts-reset-zoom", ".highcharts-scrollbar", ".highcharts-subtitle", ".highcharts-title"], s;
    }), ot(i, "Core/Axis/Stacking/StackItem.js", [i["Core/Templating.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Utilities.js"]], function(U, _, K) {
      let { format: Z } = U, { series: J } = _, { destroyObjectProperties: q, fireEvent: tt, isNumber: X, pick: I } = K;
      return class {
        constructor(O, y, w, f, x) {
          let s = O.chart.inverted, l = O.reversed;
          this.axis = O;
          let p = this.isNegative = !!w != !!l;
          this.options = y = y || {}, this.x = f, this.total = null, this.cumulative = null, this.points = {}, this.hasValidPoints = !1, this.stack = x, this.leftCliff = 0, this.rightCliff = 0, this.alignOptions = { align: y.align || (s ? p ? "left" : "right" : "center"), verticalAlign: y.verticalAlign || (s ? "middle" : p ? "bottom" : "top"), y: y.y, x: y.x }, this.textAlign = y.textAlign || (s ? p ? "right" : "left" : "center");
        }
        destroy() {
          q(this, this.axis);
        }
        render(O) {
          let y = this.axis.chart, w = this.options, f = w.format, x = f ? Z(f, this, y) : w.formatter.call(this);
          if (this.label) this.label.attr({ text: x, visibility: "hidden" });
          else {
            this.label = y.renderer.label(x, null, void 0, w.shape, void 0, void 0, w.useHTML, !1, "stack-labels");
            let s = { r: w.borderRadius || 0, text: x, padding: I(w.padding, 5), visibility: "hidden" };
            y.styledMode || (s.fill = w.backgroundColor, s.stroke = w.borderColor, s["stroke-width"] = w.borderWidth, this.label.css(w.style || {})), this.label.attr(s), this.label.added || this.label.add(O);
          }
          this.label.labelrank = y.plotSizeY, tt(this, "afterRender");
        }
        setOffset(O, y, w, f, x, s) {
          let { alignOptions: l, axis: p, label: n, options: a, textAlign: v } = this, N = p.chart, B = this.getStackBox({ xOffset: O, width: y, boxBottom: w, boxTop: f, defaultX: x, xAxis: s }), { verticalAlign: T } = l;
          if (n && B) {
            let o = n.getBBox(void 0, 0), u = n.padding, c = I(a.overflow, "justify") === "justify", e;
            l.x = a.x || 0, l.y = a.y || 0;
            let { x: t, y: h } = this.adjustStackPosition({ labelBox: o, verticalAlign: T, textAlign: v });
            B.x -= t, B.y -= h, n.align(l, !1, B), (e = N.isInsidePlot(n.alignAttr.x + l.x + t, n.alignAttr.y + l.y + h)) || (c = !1), c && J.prototype.justifyDataLabel.call(p, n, l, n.alignAttr, o, B), n.attr({ x: n.alignAttr.x, y: n.alignAttr.y, rotation: a.rotation, rotationOriginX: o.width * { left: 0, center: 0.5, right: 1 }[a.textAlign || "center"], rotationOriginY: o.height / 2 }), I(!c && a.crop, !0) && (e = X(n.x) && X(n.y) && N.isInsidePlot(n.x - u + (n.width || 0), n.y) && N.isInsidePlot(n.x + u, n.y)), n[e ? "show" : "hide"]();
          }
          tt(this, "afterSetOffset", { xOffset: O, width: y });
        }
        adjustStackPosition({ labelBox: O, verticalAlign: y, textAlign: w }) {
          let f = { bottom: 0, middle: 1, top: 2, right: 1, center: 0, left: -1 }, x = f[y], s = f[w];
          return { x: O.width / 2 + O.width / 2 * s, y: O.height / 2 * x };
        }
        getStackBox(O) {
          let y = this.axis, w = y.chart, { boxTop: f, defaultX: x, xOffset: s, width: l, boxBottom: p } = O, n = y.stacking.usePercentage ? 100 : I(f, this.total, 0), a = y.toPixels(n), v = O.xAxis || w.xAxis[0], N = I(x, v.translate(this.x)) + s, B = Math.abs(a - y.toPixels(p || X(y.min) && y.logarithmic && y.logarithmic.lin2log(y.min) || 0)), T = w.inverted, o = this.isNegative;
          return T ? { x: (o ? a : a - B) - w.plotLeft, y: v.height - N - l + v.top - w.plotTop, width: B, height: l } : { x: N + v.transB - w.plotLeft, y: (o ? a - B : a) - w.plotTop, width: l, height: B };
        }
      };
    }), ot(i, "Core/Axis/Stacking/StackingAxis.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Axis/Axis.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Axis/Stacking/StackItem.js"], i["Core/Utilities.js"]], function(U, _, K, Z, J) {
      var q;
      let { getDeferredAnimation: tt } = U, { series: { prototype: X } } = K, { addEvent: I, correctFloat: O, defined: y, destroyObjectProperties: w, fireEvent: f, isArray: x, isNumber: s, objectEach: l, pick: p } = J;
      function n() {
        let e = this.inverted;
        this.axes.forEach((t) => {
          t.stacking && t.stacking.stacks && t.hasVisibleSeries && (t.stacking.oldStacks = t.stacking.stacks);
        }), this.series.forEach((t) => {
          let h = t.xAxis && t.xAxis.options || {};
          t.options.stacking && t.reserveSpace() && (t.stackKey = [t.type, p(t.options.stack, ""), e ? h.top : h.left, e ? h.height : h.width].join(","));
        });
      }
      function a() {
        var t;
        let e = this.stacking;
        if (e) {
          let h = e.stacks;
          l(h, (b, r) => {
            w(b), delete h[r];
          }), (t = e.stackTotalGroup) == null || t.destroy();
        }
      }
      function v() {
        this.stacking || (this.stacking = new c(this));
      }
      function N(e, t, h, b) {
        return !y(e) || e.x !== t || b && e.stackKey !== b ? e = { x: t, index: 0, key: b, stackKey: b } : e.index++, e.key = [h, t, e.index].join(","), e;
      }
      function B() {
        let e, t = this, h = t.yAxis, b = t.stackKey || "", r = h.stacking.stacks, g = t.processedXData, d = t.options.stacking, M = t[d + "Stacker"];
        M && [b, "-" + b].forEach((H) => {
          var it;
          let A = g.length, D, W, G;
          for (; A--; ) D = g[A], e = t.getStackIndicator(e, D, t.index, H), W = (it = r[H]) == null ? void 0 : it[D], (G = W == null ? void 0 : W.points[e.key || ""]) && M.call(t, G, W, A);
        });
      }
      function T(e, t, h) {
        let b = t.total ? 100 / t.total : 0;
        e[0] = O(e[0] * b), e[1] = O(e[1] * b), this.stackedYData[h] = e[1];
      }
      function o(e) {
        (this.is("column") || this.is("columnrange")) && (this.options.centerInCategory && !this.options.stacking && this.chart.series.length > 1 ? X.setStackedPoints.call(this, e, "group") : e.stacking.resetStacks());
      }
      function u(e, t) {
        var nt, dt;
        let h, b, r, g, d, M, H, A, D, W = t || this.options.stacking;
        if (!W || !this.reserveSpace() || ({ group: "xAxis" }[W] || "yAxis") !== e.coll) return;
        let G = this.processedXData, it = this.processedYData, C = [], k = it.length, L = this.options, F = L.threshold || 0, m = L.startFromThreshold ? F : 0, E = L.stack, P = t ? `${this.type},${W}` : this.stackKey || "", R = "-" + P, z = this.negStacks, $ = e.stacking, et = $.stacks, rt = $.oldStacks;
        for ($.stacksTouched += 1, H = 0; H < k; H++) {
          A = G[H], D = it[H], M = (h = this.getStackIndicator(h, A, this.index)).key || "", et[d = (b = z && D < (m ? 0 : F)) ? R : P] || (et[d] = {}), et[d][A] || ((nt = rt[d]) != null && nt[A] ? (et[d][A] = rt[d][A], et[d][A].total = null) : et[d][A] = new Z(e, e.options.stackLabels, !!b, A, E)), r = et[d][A], D !== null ? (r.points[M] = r.points[this.index] = [p(r.cumulative, m)], y(r.cumulative) || (r.base = M), r.touched = $.stacksTouched, h.index > 0 && this.singleStacks === !1 && (r.points[M][0] = r.points[this.index + "," + A + ",0"][0])) : (delete r.points[M], delete r.points[this.index]);
          let ct = r.total || 0;
          W === "percent" ? (g = b ? P : R, ct = z && ((dt = et[g]) != null && dt[A]) ? (g = et[g][A]).total = Math.max(g.total || 0, ct) + Math.abs(D) || 0 : O(ct + (Math.abs(D) || 0))) : W === "group" ? (x(D) && (D = D[0]), D !== null && ct++) : ct = O(ct + (D || 0)), W === "group" ? r.cumulative = (ct || 1) - 1 : r.cumulative = O(p(r.cumulative, m) + (D || 0)), r.total = ct, D !== null && (r.points[M].push(r.cumulative), C[H] = r.cumulative, r.hasValidPoints = !0);
        }
        W === "percent" && ($.usePercentage = !0), W !== "group" && (this.stackedYData = C), $.oldStacks = {};
      }
      class c {
        constructor(t) {
          this.oldStacks = {}, this.stacks = {}, this.stacksTouched = 0, this.axis = t;
        }
        buildStacks() {
          let t, h, b = this.axis, r = b.series, g = b.coll === "xAxis", d = b.options.reversedStacks, M = r.length;
          for (this.resetStacks(), this.usePercentage = !1, h = M; h--; ) t = r[d ? h : M - h - 1], g && t.setGroupedPoints(b), t.setStackedPoints(b);
          if (!g) for (h = 0; h < M; h++) r[h].modifyStacks();
          f(b, "afterBuildStacks");
        }
        cleanStacks() {
          this.oldStacks && (this.stacks = this.oldStacks, l(this.stacks, (t) => {
            l(t, (h) => {
              h.cumulative = h.total;
            });
          }));
        }
        resetStacks() {
          l(this.stacks, (t) => {
            l(t, (h, b) => {
              s(h.touched) && h.touched < this.stacksTouched ? (h.destroy(), delete t[b]) : (h.total = null, h.cumulative = null);
            });
          });
        }
        renderStackTotals() {
          var M;
          let t = this.axis, h = t.chart, b = h.renderer, r = this.stacks, g = tt(h, ((M = t.options.stackLabels) == null ? void 0 : M.animation) || !1), d = this.stackTotalGroup = this.stackTotalGroup || b.g("stack-labels").attr({ zIndex: 6, opacity: 0 }).add();
          d.translate(h.plotLeft, h.plotTop), l(r, (H) => {
            l(H, (A) => {
              A.render(d);
            });
          }), d.animate({ opacity: 1 }, g);
        }
      }
      return (q || (q = {})).compose = function(e, t, h) {
        let b = t.prototype, r = h.prototype;
        b.getStacks || (I(e, "init", v), I(e, "destroy", a), b.getStacks = n, r.getStackIndicator = N, r.modifyStacks = B, r.percentStacker = T, r.setGroupedPoints = o, r.setStackedPoints = u);
      }, q;
    }), ot(i, "Series/Line/LineSeries.js", [i["Core/Series/Series.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Utilities.js"]], function(U, _, K) {
      let { defined: Z, merge: J, isObject: q } = K;
      class tt extends U {
        drawGraph() {
          let I = this.options, O = (this.gappedPath || this.getGraphPath).call(this), y = this.chart.styledMode;
          [this, ...this.zones].forEach((w, f) => {
            let x, s = w.graph, l = s ? "animate" : "attr", p = w.dashStyle || I.dashStyle;
            s ? (s.endX = this.preventGraphAnimation ? null : O.xMap, s.animate({ d: O })) : O.length && (w.graph = s = this.chart.renderer.path(O).addClass("highcharts-graph" + (f ? ` highcharts-zone-graph-${f - 1} ` : " ") + (f && w.className || "")).attr({ zIndex: 1 }).add(this.group)), s && !y && (x = { stroke: !f && I.lineColor || w.color || this.color || "#cccccc", "stroke-width": I.lineWidth || 0, fill: this.fillGraph && this.color || "none" }, p ? x.dashstyle = p : I.linecap !== "square" && (x["stroke-linecap"] = x["stroke-linejoin"] = "round"), s[l](x).shadow(f < 2 && I.shadow && J({ filterUnits: "userSpaceOnUse" }, q(I.shadow) ? I.shadow : {}))), s && (s.startX = O.xMap, s.isArea = O.isArea);
          });
        }
        getGraphPath(I, O, y) {
          let w = this, f = w.options, x = [], s = [], l, p = f.step, n = (I = I || w.points).reversed;
          return n && I.reverse(), (p = { right: 1, center: 2 }[p] || p && 3) && n && (p = 4 - p), (I = this.getValidPoints(I, !1, !(f.connectNulls && !O && !y))).forEach(function(a, v) {
            let N, B = a.plotX, T = a.plotY, o = I[v - 1], u = a.isNull || typeof T != "number";
            (a.leftCliff || o && o.rightCliff) && !y && (l = !0), u && !Z(O) && v > 0 ? l = !f.connectNulls : u && !O ? l = !0 : (v === 0 || l ? N = [["M", a.plotX, a.plotY]] : w.getPointSpline ? N = [w.getPointSpline(I, a, v)] : p ? (N = p === 1 ? [["L", o.plotX, T]] : p === 2 ? [["L", (o.plotX + B) / 2, o.plotY], ["L", (o.plotX + B) / 2, T]] : [["L", B, o.plotY]]).push(["L", B, T]) : N = [["L", B, T]], s.push(a.x), p && (s.push(a.x), p === 2 && s.push(a.x)), x.push.apply(x, N), l = !1);
          }), x.xMap = s, w.graphPath = x, x;
        }
      }
      return tt.defaultOptions = J(U.defaultOptions, { legendSymbol: "lineMarker" }), _.registerSeriesType("line", tt), tt;
    }), ot(i, "Series/Area/AreaSeriesDefaults.js", [], function() {
      return { threshold: 0, legendSymbol: "areaMarker" };
    }), ot(i, "Series/Area/AreaSeries.js", [i["Series/Area/AreaSeriesDefaults.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Utilities.js"]], function(U, _, K) {
      let { seriesTypes: { line: Z } } = _, { extend: J, merge: q, objectEach: tt, pick: X } = K;
      class I extends Z {
        drawGraph() {
          this.areaPath = [], super.drawGraph.apply(this);
          let { areaPath: y, options: w } = this;
          [this, ...this.zones].forEach((f, x) => {
            var a;
            let s = {}, l = f.fillColor || w.fillColor, p = f.area, n = p ? "animate" : "attr";
            p ? (p.endX = this.preventGraphAnimation ? null : y.xMap, p.animate({ d: y })) : (s.zIndex = 0, (p = f.area = this.chart.renderer.path(y).addClass("highcharts-area" + (x ? ` highcharts-zone-area-${x - 1} ` : " ") + (x && f.className || "")).add(this.group)).isArea = !0), this.chart.styledMode || (s.fill = l || f.color || this.color, s["fill-opacity"] = l ? 1 : (a = w.fillOpacity) != null ? a : 0.75, p.css({ pointerEvents: this.stickyTracking ? "none" : "auto" })), p[n](s), p.startX = y.xMap, p.shiftUnit = w.step ? 2 : 1;
          });
        }
        getGraphPath(y) {
          let w, f, x, s = Z.prototype.getGraphPath, l = this.options, p = l.stacking, n = this.yAxis, a = [], v = [], N = this.index, B = n.stacking.stacks[this.stackKey], T = l.threshold, o = Math.round(n.getThreshold(l.threshold)), u = X(l.connectNulls, p === "percent"), c = function(g, d, M) {
            let H = y[g], A = p && B[H.x].points[N], D = H[M + "Null"] || 0, W = H[M + "Cliff"] || 0, G, it, C = !0;
            W || D ? (G = (D ? A[0] : A[1]) + W, it = A[0] + W, C = !!D) : !p && y[d] && y[d].isNull && (G = it = T), G !== void 0 && (v.push({ plotX: w, plotY: G === null ? o : n.getThreshold(G), isNull: C, isCliff: !0 }), a.push({ plotX: w, plotY: it === null ? o : n.getThreshold(it), doCurve: !1 }));
          };
          y = y || this.points, p && (y = this.getStackPoints(y));
          for (let g = 0, d = y.length; g < d; ++g) p || (y[g].leftCliff = y[g].rightCliff = y[g].leftNull = y[g].rightNull = void 0), f = y[g].isNull, w = X(y[g].rectPlotX, y[g].plotX), x = p ? X(y[g].yBottom, o) : o, f && !u || (u || c(g, g - 1, "left"), f && !p && u || (v.push(y[g]), a.push({ x: g, plotX: w, plotY: x })), u || c(g, g + 1, "right"));
          let e = s.call(this, v, !0, !0);
          a.reversed = !0;
          let t = s.call(this, a, !0, !0), h = t[0];
          h && h[0] === "M" && (t[0] = ["L", h[1], h[2]]);
          let b = e.concat(t);
          b.length && b.push(["Z"]);
          let r = s.call(this, v, !1, u);
          return this.chart.series.length > 1 && p && v.some((g) => g.isCliff) && (b.hasStackedCliffs = r.hasStackedCliffs = !0), b.xMap = e.xMap, this.areaPath = b, r;
        }
        getStackPoints(y) {
          let w = this, f = [], x = [], s = this.xAxis, l = this.yAxis, p = l.stacking.stacks[this.stackKey], n = {}, a = l.series, v = a.length, N = l.options.reversedStacks ? 1 : -1, B = a.indexOf(w);
          if (y = y || this.points, this.options.stacking) {
            for (let o = 0; o < y.length; o++) y[o].leftNull = y[o].rightNull = void 0, n[y[o].x] = y[o];
            tt(p, function(o, u) {
              o.total !== null && x.push(u);
            }), x.sort(function(o, u) {
              return o - u;
            });
            let T = a.map((o) => o.visible);
            x.forEach(function(o, u) {
              let c = 0, e, t;
              if (n[o] && !n[o].isNull) f.push(n[o]), [-1, 1].forEach(function(h) {
                let b = h === 1 ? "rightNull" : "leftNull", r = p[x[u + h]], g = 0;
                if (r) {
                  let d = B;
                  for (; d >= 0 && d < v; ) {
                    let M = a[d].index;
                    !(e = r.points[M]) && (M === w.index ? n[o][b] = !0 : T[d] && (t = p[o].points[M]) && (g -= t[1] - t[0])), d += N;
                  }
                }
                n[o][h === 1 ? "rightCliff" : "leftCliff"] = g;
              });
              else {
                let h = B;
                for (; h >= 0 && h < v; ) {
                  let b = a[h].index;
                  if (e = p[o].points[b]) {
                    c = e[1];
                    break;
                  }
                  h += N;
                }
                c = X(c, 0), c = l.translate(c, 0, 1, 0, 1), f.push({ isNull: !0, plotX: s.translate(o, 0, 0, 0, 1), x: o, plotY: c, yBottom: c });
              }
            });
          }
          return f;
        }
      }
      return I.defaultOptions = q(Z.defaultOptions, U), J(I.prototype, { singleStacks: !1 }), _.registerSeriesType("area", I), I;
    }), ot(i, "Series/Spline/SplineSeries.js", [i["Core/Series/SeriesRegistry.js"], i["Core/Utilities.js"]], function(U, _) {
      let { line: K } = U.seriesTypes, { merge: Z, pick: J } = _;
      class q extends K {
        getPointSpline(X, I, O) {
          let y, w, f, x, s = I.plotX || 0, l = I.plotY || 0, p = X[O - 1], n = X[O + 1];
          function a(N) {
            return N && !N.isNull && N.doCurve !== !1 && !I.isCliff;
          }
          if (a(p) && a(n)) {
            let N = p.plotX || 0, B = p.plotY || 0, T = n.plotX || 0, o = n.plotY || 0, u = 0;
            y = (1.5 * s + N) / 2.5, w = (1.5 * l + B) / 2.5, f = (1.5 * s + T) / 2.5, x = (1.5 * l + o) / 2.5, f !== y && (u = (x - w) * (f - s) / (f - y) + l - x), w += u, x += u, w > B && w > l ? (w = Math.max(B, l), x = 2 * l - w) : w < B && w < l && (w = Math.min(B, l), x = 2 * l - w), x > o && x > l ? (x = Math.max(o, l), w = 2 * l - x) : x < o && x < l && (x = Math.min(o, l), w = 2 * l - x), I.rightContX = f, I.rightContY = x, I.controlPoints = { low: [y, w], high: [f, x] };
          }
          let v = ["C", J(p.rightContX, p.plotX, 0), J(p.rightContY, p.plotY, 0), J(y, s, 0), J(w, l, 0), s, l];
          return p.rightContX = p.rightContY = void 0, v;
        }
      }
      return q.defaultOptions = Z(K.defaultOptions), U.registerSeriesType("spline", q), q;
    }), ot(i, "Series/AreaSpline/AreaSplineSeries.js", [i["Series/Spline/SplineSeries.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Utilities.js"]], function(U, _, K) {
      let { area: Z, area: { prototype: J } } = _.seriesTypes, { extend: q, merge: tt } = K;
      class X extends U {
      }
      return X.defaultOptions = tt(U.defaultOptions, Z.defaultOptions), q(X.prototype, { getGraphPath: J.getGraphPath, getStackPoints: J.getStackPoints, drawGraph: J.drawGraph }), _.registerSeriesType("areaspline", X), X;
    }), ot(i, "Series/Column/ColumnSeriesDefaults.js", [], function() {
      return { borderRadius: 3, centerInCategory: !1, groupPadding: 0.2, marker: null, pointPadding: 0.1, minPointLength: 0, cropThreshold: 50, pointRange: null, states: { hover: { halo: !1, brightness: 0.1 }, select: { color: "#cccccc", borderColor: "#000000" } }, dataLabels: { align: void 0, verticalAlign: void 0, y: void 0 }, startFromThreshold: !0, stickyTracking: !1, tooltip: { distance: 6 }, threshold: 0, borderColor: "#ffffff" };
    }), ot(i, "Series/Column/ColumnSeries.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Color/Color.js"], i["Series/Column/ColumnSeriesDefaults.js"], i["Core/Globals.js"], i["Core/Series/Series.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Utilities.js"]], function(U, _, K, Z, J, q, tt) {
      let { animObject: X } = U, { parse: I } = _, { noop: O } = Z, { clamp: y, crisp: w, defined: f, extend: x, fireEvent: s, isArray: l, isNumber: p, merge: n, pick: a, objectEach: v } = tt;
      class N extends J {
        animate(T) {
          let o, u, c = this, e = this.yAxis, t = e.pos, h = e.reversed, b = c.options, { clipOffset: r, inverted: g } = this.chart, d = {}, M = g ? "translateX" : "translateY";
          T && r ? (d.scaleY = 1e-3, u = y(e.toPixels(b.threshold), t, t + e.len), g ? (u += h ? -Math.floor(r[0]) : Math.ceil(r[2]), d.translateX = u - e.len) : (u += h ? Math.ceil(r[0]) : -Math.floor(r[2]), d.translateY = u), c.clipBox && c.setClip(), c.group.attr(d)) : (o = Number(c.group.attr(M)), c.group.animate({ scaleY: 1 }, x(X(c.options.animation), { step: function(H, A) {
            c.group && (d[M] = o + A.pos * (t - o), c.group.attr(d));
          } })));
        }
        init(T, o) {
          super.init.apply(this, arguments);
          let u = this;
          (T = u.chart).hasRendered && T.series.forEach(function(c) {
            c.type === u.type && (c.isDirty = !0);
          });
        }
        getColumnMetrics() {
          var D, W;
          let T = this, o = T.options, u = T.xAxis, c = T.yAxis, e = u.options.reversedStacks, t = u.reversed && !e || !u.reversed && e, h = {}, b, r = 0;
          o.grouping === !1 ? r = 1 : T.chart.series.forEach(function(G) {
            let it, C = G.yAxis, k = G.options;
            G.type === T.type && G.reserveSpace() && c.len === C.len && c.pos === C.pos && (k.stacking && k.stacking !== "group" ? (h[b = G.stackKey] === void 0 && (h[b] = r++), it = h[b]) : k.grouping !== !1 && (it = r++), G.columnIndex = it);
          });
          let g = Math.min(Math.abs(u.transA) * (!((D = u.brokenAxis) != null && D.hasBreaks) && ((W = u.ordinal) == null ? void 0 : W.slope) || o.pointRange || u.closestPointRange || u.tickInterval || 1), u.len), d = g * o.groupPadding, M = (g - 2 * d) / (r || 1), H = Math.min(o.maxPointWidth || u.len, a(o.pointWidth, M * (1 - 2 * o.pointPadding))), A = (T.columnIndex || 0) + (t ? 1 : 0);
          return T.columnMetrics = { width: H, offset: (M - H) / 2 + (d + A * M - g / 2) * (t ? -1 : 1), paddedWidth: M, columnCount: r }, T.columnMetrics;
        }
        crispCol(T, o, u, c) {
          let e = this.borderWidth, t = this.chart.inverted;
          return c = w(o + c, e, t) - (o = w(o, e, t)), this.options.crisp && (u = w(T + u, e) - (T = w(T, e))), { x: T, y: o, width: u, height: c };
        }
        adjustForMissingColumns(T, o, u, c) {
          var e;
          if (!u.isNull && c.columnCount > 1) {
            let t = this.xAxis.series.filter((g) => g.visible).map((g) => g.index), h = 0, b = 0;
            v((e = this.xAxis.stacking) == null ? void 0 : e.stacks, (g) => {
              if (typeof u.x == "number") {
                let d = g[u.x.toString()];
                if (d && l(d.points[this.index])) {
                  let M = Object.keys(d.points).filter((H) => !H.match(",") && d.points[H] && d.points[H].length > 1).map(parseFloat).filter((H) => t.indexOf(H) !== -1).sort((H, A) => A - H);
                  h = M.indexOf(this.index), b = M.length;
                }
              }
            }), h = this.xAxis.reversed ? b - 1 - h : h;
            let r = (b - 1) * c.paddedWidth + o;
            T = (u.plotX || 0) + r / 2 - o - h * c.paddedWidth;
          }
          return T;
        }
        translate() {
          let T = this, o = T.chart, u = T.options, c = T.dense = T.closestPointRange * T.xAxis.transA < 2, e = T.borderWidth = a(u.borderWidth, c ? 0 : 1), t = T.xAxis, h = T.yAxis, b = u.threshold, r = a(u.minPointLength, 5), g = T.getColumnMetrics(), d = g.width, M = T.pointXOffset = g.offset, H = T.dataMin, A = T.dataMax, D = T.translatedThreshold = h.getThreshold(b), W = T.barW = Math.max(d, 1 + 2 * e);
          u.pointPadding && (W = Math.ceil(W)), J.prototype.translate.apply(T), T.points.forEach(function(G) {
            let it = a(G.yBottom, D), C = 999 + Math.abs(it), k = G.plotX || 0, L = y(G.plotY, -C, h.len + C), F, m = Math.min(L, it), E = Math.max(L, it) - m, P = d, R = k + M, z = W;
            r && Math.abs(E) < r && (E = r, F = !h.reversed && !G.negative || h.reversed && G.negative, p(b) && p(A) && G.y === b && A <= b && (h.min || 0) < b && (H !== A || (h.max || 0) <= b) && (F = !F, G.negative = !G.negative), m = Math.abs(m - D) > r ? it - r : D - (F ? r : 0)), f(G.options.pointWidth) && (R -= Math.round(((P = z = Math.ceil(G.options.pointWidth)) - d) / 2)), u.centerInCategory && !u.stacking && (R = T.adjustForMissingColumns(R, P, G, g)), G.barX = R, G.pointWidth = P, G.tooltipPos = o.inverted ? [y(h.len + h.pos - o.plotLeft - L, h.pos - o.plotLeft, h.len + h.pos - o.plotLeft), t.len + t.pos - o.plotTop - R - z / 2, E] : [t.left - o.plotLeft + R + z / 2, y(L + h.pos - o.plotTop, h.pos - o.plotTop, h.len + h.pos - o.plotTop), E], G.shapeType = T.pointClass.prototype.shapeType || "roundedRect", G.shapeArgs = T.crispCol(R, G.isNull ? D : m, z, G.isNull ? 0 : E);
          }), s(this, "afterColumnTranslate");
        }
        drawGraph() {
          this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
        }
        pointAttribs(T, o) {
          let u = this.options, c = this.pointAttrToOptions || {}, e = c.stroke || "borderColor", t = c["stroke-width"] || "borderWidth", h, b, r, g = T && T.color || this.color, d = T && T[e] || u[e] || g, M = T && T.options.dashStyle || u.dashStyle, H = T && T[t] || u[t] || this[t] || 0, A = a(T && T.opacity, u.opacity, 1);
          T && this.zones.length && (b = T.getZone(), g = T.options.color || b && (b.color || T.nonZonedColor) || this.color, b && (d = b.borderColor || d, M = b.dashStyle || M, H = b.borderWidth || H)), o && T && (r = (h = n(u.states[o], T.options.states && T.options.states[o] || {})).brightness, g = h.color || r !== void 0 && I(g).brighten(h.brightness).get() || g, d = h[e] || d, H = h[t] || H, M = h.dashStyle || M, A = a(h.opacity, A));
          let D = { fill: g, stroke: d, "stroke-width": H, opacity: A };
          return M && (D.dashstyle = M), D;
        }
        drawPoints(T = this.points) {
          let o, u = this, c = this.chart, e = u.options, t = c.renderer, h = e.animationLimit || 250;
          T.forEach(function(b) {
            let r = b.plotY, g = b.graphic, d = !!g, M = g && c.pointCount < h ? "animate" : "attr";
            p(r) && b.y !== null ? (o = b.shapeArgs, g && b.hasNewShapeType() && (g = g.destroy()), u.enabledDataSorting && (b.startXPos = u.xAxis.reversed ? -(o && o.width || 0) : u.xAxis.width), !g && (b.graphic = g = t[b.shapeType](o).add(b.group || u.group), g && u.enabledDataSorting && c.hasRendered && c.pointCount < h && (g.attr({ x: b.startXPos }), d = !0, M = "animate")), g && d && g[M](n(o)), c.styledMode || g[M](u.pointAttribs(b, b.selected && "select")).shadow(b.allowShadow !== !1 && e.shadow), g && (g.addClass(b.getClassName(), !0), g.attr({ visibility: b.visible ? "inherit" : "hidden" }))) : g && (b.graphic = g.destroy());
          });
        }
        drawTracker(T = this.points) {
          let o, u = this, c = u.chart, e = c.pointer, t = function(h) {
            let b = e == null ? void 0 : e.getPointFromEvent(h);
            e && b && u.options.enableMouseTracking && (e.isDirectTouch = !0, b.onMouseOver(h));
          };
          T.forEach(function(h) {
            o = l(h.dataLabels) ? h.dataLabels : h.dataLabel ? [h.dataLabel] : [], h.graphic && (h.graphic.element.point = h), o.forEach(function(b) {
              (b.div || b.element).point = h;
            });
          }), u._hasTracking || (u.trackerGroups.forEach(function(h) {
            u[h] && (u[h].addClass("highcharts-tracker").on("mouseover", t).on("mouseout", function(b) {
              e == null || e.onTrackerMouseOut(b);
            }).on("touchstart", t), !c.styledMode && u.options.cursor && u[h].css({ cursor: u.options.cursor }));
          }), u._hasTracking = !0), s(this, "afterDrawTracker");
        }
        remove() {
          let T = this, o = T.chart;
          o.hasRendered && o.series.forEach(function(u) {
            u.type === T.type && (u.isDirty = !0);
          }), J.prototype.remove.apply(T, arguments);
        }
      }
      return N.defaultOptions = n(J.defaultOptions, K), x(N.prototype, { directTouch: !0, getSymbol: O, negStacks: !0, trackerGroups: ["group", "dataLabelsGroup"] }), q.registerSeriesType("column", N), N;
    }), ot(i, "Core/Series/DataLabel.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Templating.js"], i["Core/Utilities.js"]], function(U, _, K) {
      var Z;
      let { getDeferredAnimation: J } = U, { format: q } = _, { defined: tt, extend: X, fireEvent: I, isArray: O, isString: y, merge: w, objectEach: f, pick: x, pInt: s, splat: l } = K;
      return function(p) {
        function n() {
          return u(this).some((e) => e == null ? void 0 : e.enabled);
        }
        function a(e, t, h, b, r) {
          var L;
          let { chart: g, enabledDataSorting: d } = this, M = this.isCartesian && g.inverted, H = e.plotX, A = e.plotY, D = h.rotation || 0, W = tt(H) && tt(A) && g.isInsidePlot(H, Math.round(A), { inverted: M, paneCoordinates: !0, series: this }), G = D === 0 && x(h.overflow, d ? "none" : "justify") === "justify", it = this.visible && e.visible !== !1 && tt(H) && (e.series.forceDL || d && !G || W || x(h.inside, !!this.options.stacking) && b && g.isInsidePlot(H, M ? b.x + 1 : b.y + b.height - 1, { inverted: M, paneCoordinates: !0, series: this })), C = e.pos();
          if (it && C) {
            var k;
            let F = t.getBBox(), m = t.getBBox(void 0, 0), E = { right: 1, center: 0.5 }[h.align || 0] || 0, P = { bottom: 1, middle: 0.5 }[h.verticalAlign || 0] || 0;
            if (b = X({ x: C[0], y: Math.round(C[1]), width: 0, height: 0 }, b || {}), h.alignTo === "plotEdges" && this.isCartesian && (b[M ? "x" : "y"] = 0, b[M ? "width" : "height"] = ((L = this.yAxis) == null ? void 0 : L.len) || 0), X(h, { width: F.width, height: F.height }), k = b, d && this.xAxis && !G && this.setDataLabelStartPos(e, t, r, W, k), t.align(w(h, { width: m.width, height: m.height }), !1, b, !1), t.alignAttr.x += E * (m.width - F.width), t.alignAttr.y += P * (m.height - F.height), t[t.placed ? "animate" : "attr"]({ x: t.alignAttr.x + (F.width - m.width) / 2, y: t.alignAttr.y + (F.height - m.height) / 2, rotationOriginX: (t.width || 0) / 2, rotationOriginY: (t.height || 0) / 2 }), G && b.height >= 0) this.justifyDataLabel(t, h, t.alignAttr, F, b, r);
            else if (x(h.crop, !0)) {
              let { x: R, y: z } = t.alignAttr;
              it = g.isInsidePlot(R, z, { paneCoordinates: !0, series: this }) && g.isInsidePlot(R + F.width - 1, z + F.height - 1, { paneCoordinates: !0, series: this });
            }
            h.shape && !D && t[r ? "attr" : "animate"]({ anchorX: C[0], anchorY: C[1] });
          }
          r && d && (t.placed = !1), it || d && !G ? (t.show(), t.placed = !0) : (t.hide(), t.placed = !1);
        }
        function v() {
          return this.plotGroup("dataLabelsGroup", "data-labels", this.hasRendered ? "inherit" : "hidden", this.options.dataLabels.zIndex || 6);
        }
        function N(e) {
          let t = this.hasRendered || 0, h = this.initDataLabelsGroup().attr({ opacity: +t });
          return !t && h && (this.visible && h.show(), this.options.animation ? h.animate({ opacity: 1 }, e) : h.attr({ opacity: 1 })), h;
        }
        function B(e) {
          var it;
          let t;
          e = e || this.points;
          let h = this, b = h.chart, r = h.options, g = b.renderer, { backgroundColor: d, plotBackgroundColor: M } = b.options.chart, H = g.getContrast(y(M) && M || y(d) && d || "#000000"), A = u(h), { animation: D, defer: W } = A[0], G = W ? J(b, D, h) : { defer: 0, duration: 0 };
          I(this, "drawDataLabels"), (it = h.hasDataLabels) != null && it.call(h) && (t = this.initDataLabels(G), e.forEach((C) => {
            var F, m;
            let k = C.dataLabels || [];
            l(o(A, C.dlOptions || ((F = C.options) == null ? void 0 : F.dataLabels))).forEach((E, P) => {
              let R = E.enabled && (C.visible || C.dataLabelOnHidden) && (!C.isNull || C.dataLabelOnNull) && function(ht, lt) {
                let ut = lt.filter;
                if (ut) {
                  let pt = ut.operator, ft = ht[ut.property], gt = ut.value;
                  return pt === ">" && ft > gt || pt === "<" && ft < gt || pt === ">=" && ft >= gt || pt === "<=" && ft <= gt || pt === "==" && ft == gt || pt === "===" && ft === gt || pt === "!=" && ft != gt || pt === "!==" && ft !== gt;
                }
                return !0;
              }(C, E), { backgroundColor: z, borderColor: $, distance: et, style: rt = {} } = E, nt, dt, ct, V, Y = {}, Q = k[P], st = !Q, at;
              R && (dt = x(E[C.formatPrefix + "Format"], E.format), nt = C.getLabelConfig(), ct = tt(dt) ? q(dt, nt, b) : (E[C.formatPrefix + "Formatter"] || E.formatter).call(nt, E), V = E.rotation, !b.styledMode && (rt.color = x(E.color, rt.color, y(h.color) ? h.color : void 0, "#000000"), rt.color === "contrast" ? (z !== "none" && (at = z), C.contrastColor = g.getContrast(at !== "auto" && at || C.color || h.color), rt.color = at || !tt(et) && E.inside || 0 > s(et || 0) || r.stacking ? C.contrastColor : H) : delete C.contrastColor, r.cursor && (rt.cursor = r.cursor)), Y = { r: E.borderRadius || 0, rotation: V, padding: E.padding, zIndex: 1 }, b.styledMode || (Y.fill = z === "auto" ? C.color : z, Y.stroke = $ === "auto" ? C.color : $, Y["stroke-width"] = E.borderWidth), f(Y, (ht, lt) => {
                ht === void 0 && delete Y[lt];
              })), !Q || R && tt(ct) && !!Q.div == !!E.useHTML && (Q.rotation && E.rotation || Q.rotation === E.rotation) || (Q = void 0, st = !0), R && tt(ct) && (Q ? Y.text = ct : (Q = g.label(ct, 0, 0, E.shape, void 0, void 0, E.useHTML, void 0, "data-label")).addClass(" highcharts-data-label-color-" + C.colorIndex + " " + (E.className || "") + (E.useHTML ? " highcharts-tracker" : "")), Q && (Q.options = E, Q.attr(Y), b.styledMode ? rt.width && Q.css({ width: rt.width, textOverflow: rt.textOverflow }) : Q.css(rt).shadow(E.shadow), I(Q, "beforeAddingDataLabel", { labelOptions: E, point: C }), Q.added || Q.add(t), h.alignDataLabel(C, Q, E, void 0, st), Q.isActive = !0, k[P] && k[P] !== Q && k[P].destroy(), k[P] = Q));
            });
            let L = k.length;
            for (; L--; ) k[L] && k[L].isActive ? k[L].isActive = !1 : ((m = k[L]) == null || m.destroy(), k.splice(L, 1));
            C.dataLabel = k[0], C.dataLabels = k;
          })), I(this, "afterDrawDataLabels");
        }
        function T(e, t, h, b, r, g) {
          let d = this.chart, M = t.align, H = t.verticalAlign, A = e.box ? 0 : e.padding || 0, D = d.inverted ? this.yAxis : this.xAxis, W = D ? D.left - d.plotLeft : 0, G = d.inverted ? this.xAxis : this.yAxis, it = G ? G.top - d.plotTop : 0, { x: C = 0, y: k = 0 } = t, L, F;
          return (L = (h.x || 0) + A + W) < 0 && (M === "right" && C >= 0 ? (t.align = "left", t.inside = !0) : C -= L, F = !0), (L = (h.x || 0) + b.width - A + W) > d.plotWidth && (M === "left" && C <= 0 ? (t.align = "right", t.inside = !0) : C += d.plotWidth - L, F = !0), (L = h.y + A + it) < 0 && (H === "bottom" && k >= 0 ? (t.verticalAlign = "top", t.inside = !0) : k -= L, F = !0), (L = (h.y || 0) + b.height - A + it) > d.plotHeight && (H === "top" && k <= 0 ? (t.verticalAlign = "bottom", t.inside = !0) : k += d.plotHeight - L, F = !0), F && (t.x = C, t.y = k, e.placed = !g, e.align(t, void 0, r)), F;
        }
        function o(e, t) {
          let h = [], b;
          if (O(e) && !O(t)) h = e.map(function(r) {
            return w(r, t);
          });
          else if (O(t) && !O(e)) h = t.map(function(r) {
            return w(e, r);
          });
          else if (O(e) || O(t)) {
            if (O(e) && O(t)) for (b = Math.max(e.length, t.length); b--; ) h[b] = w(e[b], t[b]);
          } else h = w(e, t);
          return h;
        }
        function u(e) {
          var h, b;
          let t = e.chart.options.plotOptions;
          return l(o(o((h = t == null ? void 0 : t.series) == null ? void 0 : h.dataLabels, (b = t == null ? void 0 : t[e.type]) == null ? void 0 : b.dataLabels), e.options.dataLabels));
        }
        function c(e, t, h, b, r) {
          let g = this.chart, d = g.inverted, M = this.xAxis, H = M.reversed, A = ((d ? t.height : t.width) || 0) / 2, D = e.pointWidth, W = D ? D / 2 : 0;
          t.startXPos = d ? r.x : H ? -A - W : M.width - A + W, t.startYPos = d ? H ? this.yAxis.height - A + W : -A - W : r.y, b ? t.visibility === "hidden" && (t.show(), t.attr({ opacity: 0 }).animate({ opacity: 1 })) : t.attr({ opacity: 1 }).animate({ opacity: 0 }, void 0, t.hide), g.hasRendered && (h && t.attr({ x: t.startXPos, y: t.startYPos }), t.placed = !0);
        }
        p.compose = function(e) {
          let t = e.prototype;
          t.initDataLabels || (t.initDataLabels = N, t.initDataLabelsGroup = v, t.alignDataLabel = a, t.drawDataLabels = B, t.justifyDataLabel = T, t.setDataLabelStartPos = c, t.hasDataLabels = n);
        };
      }(Z || (Z = {})), Z;
    }), ot(i, "Series/Column/ColumnDataLabel.js", [i["Core/Series/DataLabel.js"], i["Core/Globals.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Utilities.js"]], function(U, _, K, Z) {
      var J;
      let { composed: q } = _, { series: tt } = K, { merge: X, pick: I, pushUnique: O } = Z;
      return function(y) {
        function w(f, x, s, l, p) {
          let n = this.chart.inverted, a = f.series, v = (a.xAxis ? a.xAxis.len : this.chart.plotSizeX) || 0, N = (a.yAxis ? a.yAxis.len : this.chart.plotSizeY) || 0, B = f.dlBox || f.shapeArgs, T = I(f.below, f.plotY > I(this.translatedThreshold, N)), o = I(s.inside, !!this.options.stacking);
          if (B) {
            if (l = X(B), !(s.overflow === "allow" && s.crop === !1)) {
              l.y < 0 && (l.height += l.y, l.y = 0);
              let u = l.y + l.height - N;
              u > 0 && u < l.height - 1 && (l.height -= u);
            }
            n && (l = { x: N - l.y - l.height, y: v - l.x - l.width, width: l.height, height: l.width }), o || (n ? (l.x += T ? 0 : l.width, l.width = 0) : (l.y += T ? l.height : 0, l.height = 0));
          }
          s.align = I(s.align, !n || o ? "center" : T ? "right" : "left"), s.verticalAlign = I(s.verticalAlign, n || o ? "middle" : T ? "top" : "bottom"), tt.prototype.alignDataLabel.call(this, f, x, s, l, p), s.inside && f.contrastColor && x.css({ color: f.contrastColor });
        }
        y.compose = function(f) {
          U.compose(tt), O(q, "ColumnDataLabel") && (f.prototype.alignDataLabel = w);
        };
      }(J || (J = {})), J;
    }), ot(i, "Series/Bar/BarSeries.js", [i["Series/Column/ColumnSeries.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Utilities.js"]], function(U, _, K) {
      let { extend: Z, merge: J } = K;
      class q extends U {
      }
      return q.defaultOptions = J(U.defaultOptions, {}), Z(q.prototype, { inverted: !0 }), _.registerSeriesType("bar", q), q;
    }), ot(i, "Series/Scatter/ScatterSeriesDefaults.js", [], function() {
      return { lineWidth: 0, findNearestPointBy: "xy", jitter: { x: 0, y: 0 }, marker: { enabled: !0 }, tooltip: { headerFormat: '<span style="color:{point.color}">●</span> <span style="font-size: 0.8em"> {series.name}</span><br/>', pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>" } };
    }), ot(i, "Series/Scatter/ScatterSeries.js", [i["Series/Scatter/ScatterSeriesDefaults.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Utilities.js"]], function(U, _, K) {
      let { column: Z, line: J } = _.seriesTypes, { addEvent: q, extend: tt, merge: X } = K;
      class I extends J {
        applyJitter() {
          let y = this, w = this.options.jitter, f = this.points.length;
          w && this.points.forEach(function(x, s) {
            ["x", "y"].forEach(function(l, p) {
              if (w[l] && !x.isNull) {
                let n = `plot${l.toUpperCase()}`, a = y[`${l}Axis`], v = w[l] * a.transA;
                if (a && !a.logarithmic) {
                  let N = Math.max(0, (x[n] || 0) - v), B = Math.min(a.len, (x[n] || 0) + v);
                  x[n] = N + (B - N) * function(T) {
                    let o = 1e4 * Math.sin(T);
                    return o - Math.floor(o);
                  }(s + p * f), l === "x" && (x.clientX = x.plotX);
                }
              }
            });
          });
        }
        drawGraph() {
          this.options.lineWidth ? super.drawGraph() : this.graph && (this.graph = this.graph.destroy());
        }
      }
      return I.defaultOptions = X(J.defaultOptions, U), tt(I.prototype, { drawTracker: Z.prototype.drawTracker, sorted: !1, requireSorting: !1, noSharedTooltip: !0, trackerGroups: ["group", "markerGroup", "dataLabelsGroup"] }), q(I, "afterTranslate", function() {
        this.applyJitter();
      }), _.registerSeriesType("scatter", I), I;
    }), ot(i, "Series/CenteredUtilities.js", [i["Core/Globals.js"], i["Core/Series/Series.js"], i["Core/Utilities.js"]], function(U, _, K) {
      var Z, J;
      let { deg2rad: q } = U, { fireEvent: tt, isNumber: X, pick: I, relativeLength: O } = K;
      return (J = Z || (Z = {})).getCenter = function() {
        let y = this.options, w = this.chart, f = 2 * (y.slicedOffset || 0), x = w.plotWidth - 2 * f, s = w.plotHeight - 2 * f, l = y.center, p = Math.min(x, s), n = y.thickness, a, v = y.size, N = y.innerSize || 0, B, T;
        typeof v == "string" && (v = parseFloat(v)), typeof N == "string" && (N = parseFloat(N));
        let o = [I(l[0], "50%"), I(l[1], "50%"), I(v && v < 0 ? void 0 : y.size, "100%"), I(N && N < 0 ? void 0 : y.innerSize || 0, "0%")];
        for (!w.angular || this instanceof _ || (o[3] = 0), B = 0; B < 4; ++B) T = o[B], a = B < 2 || B === 2 && /%$/.test(T), o[B] = O(T, [x, s, p, o[2]][B]) + (a ? f : 0);
        return o[3] > o[2] && (o[3] = o[2]), X(n) && 2 * n < o[2] && n > 0 && (o[3] = o[2] - 2 * n), tt(this, "afterGetCenter", { positions: o }), o;
      }, J.getStartAndEndRadians = function(y, w) {
        let f = X(y) ? y : 0, x = X(w) && w > f && w - f < 360 ? w : f + 360;
        return { start: q * (f + -90), end: q * (x + -90) };
      }, Z;
    }), ot(i, "Series/Pie/PiePoint.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Series/Point.js"], i["Core/Utilities.js"]], function(U, _, K) {
      let { setAnimation: Z } = U, { addEvent: J, defined: q, extend: tt, isNumber: X, pick: I, relativeLength: O } = K;
      class y extends _ {
        getConnectorPath(f) {
          let x = f.dataLabelPosition, s = f.options || {}, l = s.connectorShape, p = this.connectorShapes[l] || l;
          return x && p.call(this, { ...x.computed, alignment: x.alignment }, x.connectorPosition, s) || [];
        }
        getTranslate() {
          return this.sliced && this.slicedTranslation || { translateX: 0, translateY: 0 };
        }
        haloPath(f) {
          let x = this.shapeArgs;
          return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(x.x, x.y, x.r + f, x.r + f, { innerR: x.r - 1, start: x.start, end: x.end, borderRadius: x.borderRadius });
        }
        constructor(f, x, s) {
          var p;
          super(f, x, s), this.half = 0, (p = this.name) != null || (this.name = "Slice");
          let l = (n) => {
            this.slice(n.type === "select");
          };
          J(this, "select", l), J(this, "unselect", l);
        }
        isValid() {
          return X(this.y) && this.y >= 0;
        }
        setVisible(f, x = !0) {
          f !== this.visible && this.update({ visible: f != null ? f : !this.visible }, x, void 0, !1);
        }
        slice(f, x, s) {
          let l = this.series;
          Z(s, l.chart), x = I(x, !0), this.sliced = this.options.sliced = f = q(f) ? f : !this.sliced, l.options.data[l.data.indexOf(this)] = this.options, this.graphic && this.graphic.animate(this.getTranslate());
        }
      }
      return tt(y.prototype, { connectorShapes: { fixedOffset: function(w, f, x) {
        let s = f.breakAt, l = f.touchingSliceAt, p = x.softConnector ? ["C", w.x + (w.alignment === "left" ? -5 : 5), w.y, 2 * s.x - l.x, 2 * s.y - l.y, s.x, s.y] : ["L", s.x, s.y];
        return [["M", w.x, w.y], p, ["L", l.x, l.y]];
      }, straight: function(w, f) {
        let x = f.touchingSliceAt;
        return [["M", w.x, w.y], ["L", x.x, x.y]];
      }, crookedLine: function(w, f, x) {
        let { breakAt: s, touchingSliceAt: l } = f, { series: p } = this, [n, a, v] = p.center, N = v / 2, { plotLeft: B, plotWidth: T } = p.chart, o = w.alignment === "left", { x: u, y: c } = w, e = s.x;
        if (x.crookDistance) {
          let h = O(x.crookDistance, 1);
          e = o ? n + N + (T + B - n - N) * (1 - h) : B + (n - N) * h;
        } else e = n + (a - c) * Math.tan((this.angle || 0) - Math.PI / 2);
        let t = [["M", u, c]];
        return (o ? e <= u && e >= s.x : e >= u && e <= s.x) && t.push(["L", e, c]), t.push(["L", s.x, s.y], ["L", l.x, l.y]), t;
      } } }), y;
    }), ot(i, "Series/Pie/PieSeriesDefaults.js", [], function() {
      return { borderRadius: 3, center: [null, null], clip: !1, colorByPoint: !0, dataLabels: { connectorPadding: 5, connectorShape: "crookedLine", crookDistance: void 0, distance: 30, enabled: !0, formatter: function() {
        return this.point.isNull ? void 0 : this.point.name;
      }, softConnector: !0, x: 0 }, fillColor: void 0, ignoreHiddenPoint: !0, inactiveOtherPoints: !0, legendType: "point", marker: null, size: null, showInLegend: !1, slicedOffset: 10, stickyTracking: !1, tooltip: { followPointer: !0 }, borderColor: "#ffffff", borderWidth: 1, lineWidth: void 0, states: { hover: { brightness: 0.1 } } };
    }), ot(i, "Series/Pie/PieSeries.js", [i["Series/CenteredUtilities.js"], i["Series/Column/ColumnSeries.js"], i["Core/Globals.js"], i["Series/Pie/PiePoint.js"], i["Series/Pie/PieSeriesDefaults.js"], i["Core/Series/Series.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Renderer/SVG/Symbols.js"], i["Core/Utilities.js"]], function(U, _, K, Z, J, q, tt, X, I) {
      let { getStartAndEndRadians: O } = U, { noop: y } = K, { clamp: w, extend: f, fireEvent: x, merge: s, pick: l } = I;
      class p extends q {
        animate(a) {
          let v = this, N = v.points, B = v.startAngleRad;
          a || N.forEach(function(T) {
            let o = T.graphic, u = T.shapeArgs;
            o && u && (o.attr({ r: l(T.startR, v.center && v.center[3] / 2), start: B, end: B }), o.animate({ r: u.r, start: u.start, end: u.end }, v.options.animation));
          });
        }
        drawEmpty() {
          let a, v, N = this.startAngleRad, B = this.endAngleRad, T = this.options;
          this.total === 0 && this.center ? (a = this.center[0], v = this.center[1], this.graph || (this.graph = this.chart.renderer.arc(a, v, this.center[1] / 2, 0, N, B).addClass("highcharts-empty-series").add(this.group)), this.graph.attr({ d: X.arc(a, v, this.center[2] / 2, 0, { start: N, end: B, innerR: this.center[3] / 2 }) }), this.chart.styledMode || this.graph.attr({ "stroke-width": T.borderWidth, fill: T.fillColor || "none", stroke: T.color || "#cccccc" })) : this.graph && (this.graph = this.graph.destroy());
        }
        drawPoints() {
          let a = this.chart.renderer;
          this.points.forEach(function(v) {
            v.graphic && v.hasNewShapeType() && (v.graphic = v.graphic.destroy()), v.graphic || (v.graphic = a[v.shapeType](v.shapeArgs).add(v.series.group), v.delayedRendering = !0);
          });
        }
        generatePoints() {
          super.generatePoints(), this.updateTotals();
        }
        getX(a, v, N, B) {
          let T = this.center, o = this.radii ? this.radii[N.index] || 0 : T[2] / 2, u = B.dataLabelPosition, c = (u == null ? void 0 : u.distance) || 0, e = Math.asin(w((a - T[1]) / (o + c), -1, 1));
          return T[0] + Math.cos(e) * (o + c) * (v ? -1 : 1) + (c > 0 ? (v ? -1 : 1) * (B.padding || 0) : 0);
        }
        hasData() {
          return !!this.processedXData.length;
        }
        redrawPoints() {
          let a, v, N, B, T = this, o = T.chart;
          this.drawEmpty(), T.group && !o.styledMode && T.group.shadow(T.options.shadow), T.points.forEach(function(u) {
            let c = {};
            v = u.graphic, !u.isNull && v ? (B = u.shapeArgs, a = u.getTranslate(), o.styledMode || (N = T.pointAttribs(u, u.selected && "select")), u.delayedRendering ? (v.setRadialReference(T.center).attr(B).attr(a), o.styledMode || v.attr(N).attr({ "stroke-linejoin": "round" }), u.delayedRendering = !1) : (v.setRadialReference(T.center), o.styledMode || s(!0, c, N), s(!0, c, B, a), v.animate(c)), v.attr({ visibility: u.visible ? "inherit" : "hidden" }), v.addClass(u.getClassName(), !0)) : v && (u.graphic = v.destroy());
          });
        }
        sortByAngle(a, v) {
          a.sort(function(N, B) {
            return N.angle !== void 0 && (B.angle - N.angle) * v;
          });
        }
        translate(a) {
          x(this, "translate"), this.generatePoints();
          let v = this.options, N = v.slicedOffset, B = O(v.startAngle, v.endAngle), T = this.startAngleRad = B.start, o = (this.endAngleRad = B.end) - T, u = this.points, c = v.ignoreHiddenPoint, e = u.length, t, h, b, r, g, d, M, H = 0;
          for (a || (this.center = a = this.getCenter()), d = 0; d < e; d++) {
            M = u[d], t = T + H * o, M.isValid() && (!c || M.visible) && (H += M.percentage / 100), h = T + H * o;
            let A = { x: a[0], y: a[1], r: a[2] / 2, innerR: a[3] / 2, start: Math.round(1e3 * t) / 1e3, end: Math.round(1e3 * h) / 1e3 };
            M.shapeType = "arc", M.shapeArgs = A, (b = (h + t) / 2) > 1.5 * Math.PI ? b -= 2 * Math.PI : b < -Math.PI / 2 && (b += 2 * Math.PI), M.slicedTranslation = { translateX: Math.round(Math.cos(b) * N), translateY: Math.round(Math.sin(b) * N) }, r = Math.cos(b) * a[2] / 2, g = Math.sin(b) * a[2] / 2, M.tooltipPos = [a[0] + 0.7 * r, a[1] + 0.7 * g], M.half = b < -Math.PI / 2 || b > Math.PI / 2 ? 1 : 0, M.angle = b;
          }
          x(this, "afterTranslate");
        }
        updateTotals() {
          let a = this.points, v = a.length, N = this.options.ignoreHiddenPoint, B, T, o = 0;
          for (B = 0; B < v; B++) (T = a[B]).isValid() && (!N || T.visible) && (o += T.y);
          for (B = 0, this.total = o; B < v; B++) (T = a[B]).percentage = o > 0 && (T.visible || !N) ? T.y / o * 100 : 0, T.total = o;
        }
      }
      return p.defaultOptions = s(q.defaultOptions, J), f(p.prototype, { axisTypes: [], directTouch: !0, drawGraph: void 0, drawTracker: _.prototype.drawTracker, getCenter: U.getCenter, getSymbol: y, invertible: !1, isCartesian: !1, noSharedTooltip: !0, pointAttribs: _.prototype.pointAttribs, pointClass: Z, requireSorting: !1, searchPoint: y, trackerGroups: ["group", "dataLabelsGroup"] }), tt.registerSeriesType("pie", p), p;
    }), ot(i, "Series/Pie/PieDataLabel.js", [i["Core/Series/DataLabel.js"], i["Core/Globals.js"], i["Core/Renderer/RendererUtilities.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Utilities.js"]], function(U, _, K, Z, J) {
      var q;
      let { composed: tt, noop: X } = _, { distribute: I } = K, { series: O } = Z, { arrayMax: y, clamp: w, defined: f, pick: x, pushUnique: s, relativeLength: l } = J;
      return function(p) {
        let n = { radialDistributionY: function(T, o) {
          var u;
          return (((u = o.dataLabelPosition) == null ? void 0 : u.top) || 0) + T.distributeBox.pos;
        }, radialDistributionX: function(T, o, u, c, e) {
          let t = e.dataLabelPosition;
          return T.getX(u < ((t == null ? void 0 : t.top) || 0) + 2 || u > ((t == null ? void 0 : t.bottom) || 0) - 2 ? c : u, o.half, o, e);
        }, justify: function(T, o, u, c) {
          var e;
          return c[0] + (T.half ? -1 : 1) * (u + (((e = o.dataLabelPosition) == null ? void 0 : e.distance) || 0));
        }, alignToPlotEdges: function(T, o, u, c) {
          let e = T.getBBox().width;
          return o ? e + c : u - e - c;
        }, alignToConnectors: function(T, o, u, c) {
          let e = 0, t;
          return T.forEach(function(h) {
            (t = h.dataLabel.getBBox().width) > e && (e = t);
          }), o ? e + c : u - e - c;
        } };
        function a(T, o) {
          let { center: u, options: c } = this, e = u[2] / 2, t = T.angle || 0, h = Math.cos(t), b = Math.sin(t), r = u[0] + h * e, g = u[1] + b * e, d = Math.min((c.slicedOffset || 0) + (c.borderWidth || 0), o / 5);
          return { natural: { x: r + h * o, y: g + b * o }, computed: {}, alignment: o < 0 ? "center" : T.half ? "right" : "left", connectorPosition: { breakAt: { x: r + h * d, y: g + b * d }, touchingSliceAt: { x: r, y: g } }, distance: o };
        }
        function v() {
          var it;
          let T = this, o = T.points, u = T.chart, c = u.plotWidth, e = u.plotHeight, t = u.plotLeft, h = Math.round(u.chartWidth / 3), b = T.center, r = b[2] / 2, g = b[1], d = [[], []], M = [0, 0, 0, 0], H = T.dataLabelPositioners, A, D, W, G = 0;
          T.visible && ((it = T.hasDataLabels) != null && it.call(T)) && (o.forEach((C) => {
            (C.dataLabels || []).forEach((k) => {
              k.shortened && (k.attr({ width: "auto" }).css({ width: "auto", textOverflow: "clip" }), k.shortened = !1);
            });
          }), O.prototype.drawDataLabels.apply(T), o.forEach((C) => {
            (C.dataLabels || []).forEach((k, L) => {
              var P;
              let F = b[2] / 2, m = k.options, E = l((m == null ? void 0 : m.distance) || 0, F);
              L === 0 && d[C.half].push(C), !f((P = m == null ? void 0 : m.style) == null ? void 0 : P.width) && k.getBBox().width > h && (k.css({ width: Math.round(0.7 * h) + "px" }), k.shortened = !0), k.dataLabelPosition = this.getDataLabelPosition(C, E), G = Math.max(G, E);
            });
          }), d.forEach((C, k) => {
            let L = C.length, F = [], m, E, P = 0, R;
            L && (T.sortByAngle(C, k - 0.5), G > 0 && (m = Math.max(0, g - r - G), E = Math.min(g + r + G, u.plotHeight), C.forEach((z) => {
              (z.dataLabels || []).forEach(($) => {
                var rt;
                let et = $.dataLabelPosition;
                et && et.distance > 0 && (et.top = Math.max(0, g - r - et.distance), et.bottom = Math.min(g + r + et.distance, u.plotHeight), P = $.getBBox().height || 21, $.lineHeight = u.renderer.fontMetrics($.text || $).h + 2 * $.padding, z.distributeBox = { target: (((rt = $.dataLabelPosition) == null ? void 0 : rt.natural.y) || 0) - et.top + $.lineHeight / 2, size: P, rank: z.y }, F.push(z.distributeBox));
              });
            }), I(F, R = E + P - m, R / 5)), C.forEach((z) => {
              (z.dataLabels || []).forEach(($) => {
                let et = $.options || {}, rt = z.distributeBox, nt = $.dataLabelPosition, dt = (nt == null ? void 0 : nt.natural.y) || 0, ct = et.connectorPadding || 0, V = $.lineHeight || 21, Y = (V - $.getBBox().height) / 2, Q = 0, st = dt, at = "inherit";
                if (nt) {
                  if (F && f(rt) && nt.distance > 0 && (rt.pos === void 0 ? at = "hidden" : (W = rt.size, st = H.radialDistributionY(z, $))), et.justify) Q = H.justify(z, $, r, b);
                  else switch (et.alignTo) {
                    case "connectors":
                      Q = H.alignToConnectors(C, k, c, t);
                      break;
                    case "plotEdges":
                      Q = H.alignToPlotEdges($, k, c, t);
                      break;
                    default:
                      Q = H.radialDistributionX(T, z, st - Y, dt, $);
                  }
                  if (nt.attribs = { visibility: at, align: nt.alignment }, nt.posAttribs = { x: Q + (et.x || 0) + ({ left: ct, right: -ct }[nt.alignment] || 0), y: st + (et.y || 0) - V / 2 }, nt.computed.x = Q, nt.computed.y = st - Y, x(et.crop, !0)) {
                    let ht;
                    Q - (D = $.getBBox().width) < ct && k === 1 ? (ht = Math.round(D - Q + ct), M[3] = Math.max(ht, M[3])) : Q + D > c - ct && k === 0 && (ht = Math.round(Q + D - c + ct), M[1] = Math.max(ht, M[1])), st - W / 2 < 0 ? M[0] = Math.max(Math.round(-st + W / 2), M[0]) : st + W / 2 > e && (M[2] = Math.max(Math.round(st + W / 2 - e), M[2])), nt.sideOverflow = ht;
                  }
                }
              });
            }));
          }), (y(M) === 0 || this.verifyDataLabelOverflow(M)) && (this.placeDataLabels(), this.points.forEach((C) => {
            (C.dataLabels || []).forEach((k) => {
              var E;
              let { connectorColor: L, connectorWidth: F = 1 } = k.options || {}, m = k.dataLabelPosition;
              if (F) {
                let P;
                A = k.connector, m && m.distance > 0 ? (P = !A, A || (k.connector = A = u.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + C.colorIndex + (C.className ? " " + C.className : "")).add(T.dataLabelsGroup)), u.styledMode || A.attr({ "stroke-width": F, stroke: L || C.color || "#666666" }), A[P ? "attr" : "animate"]({ d: C.getConnectorPath(k) }), A.attr({ visibility: (E = m.attribs) == null ? void 0 : E.visibility })) : A && (k.connector = A.destroy());
              }
            });
          })));
        }
        function N() {
          this.points.forEach((T) => {
            (T.dataLabels || []).forEach((o) => {
              var c;
              let u = o.dataLabelPosition;
              u ? (u.sideOverflow && (o.css({ width: Math.max(o.getBBox().width - u.sideOverflow, 0) + "px", textOverflow: (((c = o.options) == null ? void 0 : c.style) || {}).textOverflow || "ellipsis" }), o.shortened = !0), o.attr(u.attribs), o[o.moved ? "animate" : "attr"](u.posAttribs), o.moved = !0) : o && o.attr({ y: -9999 });
            }), delete T.distributeBox;
          }, this);
        }
        function B(T) {
          let o = this.center, u = this.options, c = u.center, e = u.minSize || 80, t = e, h = u.size !== null;
          return !h && (c[0] !== null ? t = Math.max(o[2] - Math.max(T[1], T[3]), e) : (t = Math.max(o[2] - T[1] - T[3], e), o[0] += (T[3] - T[1]) / 2), c[1] !== null ? t = w(t, e, o[2] - Math.max(T[0], T[2])) : (t = w(t, e, o[2] - T[0] - T[2]), o[1] += (T[0] - T[2]) / 2), t < o[2] ? (o[2] = t, o[3] = Math.min(u.thickness ? Math.max(0, t - 2 * u.thickness) : Math.max(0, l(u.innerSize || 0, t)), t), this.translate(o), this.drawDataLabels && this.drawDataLabels()) : h = !0), h;
        }
        p.compose = function(T) {
          if (U.compose(O), s(tt, "PieDataLabel")) {
            let o = T.prototype;
            o.dataLabelPositioners = n, o.alignDataLabel = X, o.drawDataLabels = v, o.getDataLabelPosition = a, o.placeDataLabels = N, o.verifyDataLabelOverflow = B;
          }
        };
      }(q || (q = {})), q;
    }), ot(i, "Core/Geometry/GeometryUtilities.js", [], function() {
      var U, _;
      return (_ = U || (U = {})).getCenterOfPoints = function(K) {
        let Z = K.reduce((J, q) => (J.x += q.x, J.y += q.y, J), { x: 0, y: 0 });
        return { x: Z.x / K.length, y: Z.y / K.length };
      }, _.getDistanceBetweenPoints = function(K, Z) {
        return Math.sqrt(Math.pow(Z.x - K.x, 2) + Math.pow(Z.y - K.y, 2));
      }, _.getAngleBetweenPoints = function(K, Z) {
        return Math.atan2(Z.x - K.x, Z.y - K.y);
      }, _.pointInPolygon = function({ x: K, y: Z }, J) {
        let q = J.length, tt, X, I = !1;
        for (tt = 0, X = q - 1; tt < q; X = tt++) {
          let [O, y] = J[tt], [w, f] = J[X];
          y > Z != f > Z && K < (w - O) * (Z - y) / (f - y) + O && (I = !I);
        }
        return I;
      }, U;
    }), ot(i, "Extensions/OverlappingDataLabels.js", [i["Core/Geometry/GeometryUtilities.js"], i["Core/Utilities.js"]], function(U, _) {
      let { pointInPolygon: K } = U, { addEvent: Z, fireEvent: J, objectEach: q, pick: tt } = _;
      function X(y) {
        let w = y.length, f = (N, B) => !(B.x >= N.x + N.width || B.x + B.width <= N.x || B.y >= N.y + N.height || B.y + B.height <= N.y), x = (N, B) => {
          for (let T of N) if (K({ x: T[0], y: T[1] }, B)) return !0;
          return !1;
        }, s, l, p, n, a, v = !1;
        for (let N = 0; N < w; N++) (s = y[N]) && (s.oldOpacity = s.opacity, s.newOpacity = 1, s.absoluteBox = function(B) {
          var T, o;
          if (B && (!B.alignAttr || B.placed)) {
            let u = B.box ? 0 : B.padding || 0, c = B.alignAttr || { x: B.attr("x"), y: B.attr("y") }, e = B.getBBox();
            return B.width = e.width, B.height = e.height, { x: c.x + (((T = B.parentGroup) == null ? void 0 : T.translateX) || 0) + u, y: c.y + (((o = B.parentGroup) == null ? void 0 : o.translateY) || 0) + u, width: (B.width || 0) - 2 * u, height: (B.height || 0) - 2 * u, polygon: e == null ? void 0 : e.polygon };
          }
        }(s));
        y.sort((N, B) => (B.labelrank || 0) - (N.labelrank || 0));
        for (let N = 0; N < w; ++N) {
          n = (l = y[N]) && l.absoluteBox;
          let B = n == null ? void 0 : n.polygon;
          for (let T = N + 1; T < w; ++T) {
            a = (p = y[T]) && p.absoluteBox;
            let o = !1;
            if (n && a && l !== p && l.newOpacity !== 0 && p.newOpacity !== 0 && l.visibility !== "hidden" && p.visibility !== "hidden") {
              let u = a.polygon;
              if (B && u && B !== u ? x(B, u) && (o = !0) : f(n, a) && (o = !0), o) {
                let c = l.labelrank < p.labelrank ? l : p, e = c.text;
                c.newOpacity = 0, e != null && e.element.querySelector("textPath") && e.hide();
              }
            }
          }
        }
        for (let N of y) I(N, this) && (v = !0);
        v && J(this, "afterHideAllOverlappingLabels");
      }
      function I(y, w) {
        let f, x, s = !1;
        return y && (x = y.newOpacity, y.oldOpacity !== x && (y.hasClass("highcharts-data-label") ? (y[x ? "removeClass" : "addClass"]("highcharts-data-label-hidden"), f = function() {
          w.styledMode || y.css({ pointerEvents: x ? "auto" : "none" });
        }, s = !0, y[y.isOld ? "animate" : "attr"]({ opacity: x }, void 0, f), J(w, "afterHideOverlappingLabel")) : y.attr({ opacity: x })), y.isOld = !0), s;
      }
      function O() {
        var f;
        let y = this, w = [];
        for (let x of y.labelCollectors || []) w = w.concat(x());
        for (let x of y.yAxis || []) x.stacking && x.options.stackLabels && !x.options.stackLabels.allowOverlap && q(x.stacking.stacks, (s) => {
          q(s, (l) => {
            l.label && w.push(l.label);
          });
        });
        for (let x of y.series || []) if (x.visible && ((f = x.hasDataLabels) != null && f.call(x))) {
          let s = (l) => {
            for (let p of l) p.visible && (p.dataLabels || []).forEach((n) => {
              var v, N;
              let a = n.options || {};
              n.labelrank = tt(a.labelrank, p.labelrank, (v = p.shapeArgs) == null ? void 0 : v.height), ((N = a.allowOverlap) != null ? N : Number(a.distance) > 0) ? (n.oldOpacity = n.opacity, n.newOpacity = 1, I(n, y)) : w.push(n);
            });
          };
          s(x.nodes || []), s(x.points);
        }
        this.hideOverlappingLabels(w);
      }
      return { compose: function(y) {
        let w = y.prototype;
        w.hideOverlappingLabels || (w.hideOverlappingLabels = X, Z(y, "render", O));
      } };
    }), ot(i, "Extensions/BorderRadius.js", [i["Core/Defaults.js"], i["Core/Globals.js"], i["Core/Utilities.js"]], function(U, _, K) {
      let { defaultOptions: Z } = U, { noop: J } = _, { addEvent: q, extend: tt, isObject: X, merge: I, relativeLength: O } = K, y = { radius: 0, scope: "stack", where: void 0 }, w = J, f = J;
      function x(a, v, N, B, T = {}) {
        let o = w(a, v, N, B, T), { innerR: u = 0, r: c = N, start: e = 0, end: t = 0 } = T;
        if (T.open || !T.borderRadius) return o;
        let h = t - e, b = Math.sin(h / 2), r = Math.max(Math.min(O(T.borderRadius || 0, c - u), (c - u) / 2, c * b / (1 + b)), 0), g = Math.min(r, h / Math.PI * 2 * u), d = o.length - 1;
        for (; d--; ) (function(M, H, A) {
          let D, W, G, it = M[H], C = M[H + 1];
          if (C[0] === "Z" && (C = M[0]), (it[0] === "M" || it[0] === "L") && C[0] === "A" ? (D = it, W = C, G = !0) : it[0] === "A" && (C[0] === "M" || C[0] === "L") && (D = C, W = it), D && W && W.params) {
            let k = W[1], L = W[5], F = W.params, { start: m, end: E, cx: P, cy: R } = F, z = L ? k - A : k + A, $ = z ? Math.asin(A / z) : 0, et = L ? $ : -$, rt = Math.cos($) * z;
            G ? (F.start = m + et, D[1] = P + rt * Math.cos(m), D[2] = R + rt * Math.sin(m), M.splice(H + 1, 0, ["A", A, A, 0, 0, 1, P + k * Math.cos(F.start), R + k * Math.sin(F.start)])) : (F.end = E - et, W[6] = P + k * Math.cos(F.end), W[7] = R + k * Math.sin(F.end), M.splice(H + 1, 0, ["A", A, A, 0, 0, 1, P + rt * Math.cos(E), R + rt * Math.sin(E)])), W[4] = Math.abs(F.end - F.start) < Math.PI ? 0 : 1;
          }
        })(o, d, d > 1 ? g : r);
        return o;
      }
      function s() {
        var a, v;
        if (this.options.borderRadius && !(this.chart.is3d && this.chart.is3d())) {
          let { options: N, yAxis: B } = this, T = N.stacking === "percent", o = (v = (a = Z.plotOptions) == null ? void 0 : a[this.type]) == null ? void 0 : v.borderRadius, u = l(N.borderRadius, X(o) ? o : {}), c = B.options.reversed;
          for (let e of this.points) {
            let { shapeArgs: t } = e;
            if (e.shapeType === "roundedRect" && t) {
              let { width: h = 0, height: b = 0, y: r = 0 } = t, g = r, d = b;
              if (u.scope === "stack" && e.stackTotal) {
                let D = B.translate(T ? 100 : e.stackTotal, !1, !0, !1, !0), W = B.translate(N.threshold || 0, !1, !0, !1, !0), G = this.crispCol(0, Math.min(D, W), 0, Math.abs(D - W));
                g = G.y, d = G.height;
              }
              let M = (e.negative ? -1 : 1) * (c ? -1 : 1) == -1, H = u.where;
              !H && this.is("waterfall") && Math.abs((e.yBottom || 0) - (this.translatedThreshold || 0)) > this.borderWidth && (H = "all"), H || (H = "end");
              let A = Math.min(O(u.radius, h), h / 2, H === "all" ? b / 2 : 1 / 0) || 0;
              H === "end" && (M && (g -= A), d += A), tt(t, { brBoxHeight: d, brBoxY: g, r: A });
            }
          }
        }
      }
      function l(a, v) {
        return X(a) || (a = { radius: a || 0 }), I(y, v, a);
      }
      function p() {
        let a = l(this.options.borderRadius);
        for (let v of this.points) {
          let N = v.shapeArgs;
          N && (N.borderRadius = O(a.radius, (N.r || 0) - (N.innerR || 0)));
        }
      }
      function n(a, v, N, B, T = {}) {
        let o = f(a, v, N, B, T), { r: u = 0, brBoxHeight: c = B, brBoxY: e = v } = T, t = v - e, h = e + c - (v + B), b = t - u > -0.1 ? 0 : u, r = h - u > -0.1 ? 0 : u, g = Math.max(b && t, 0), d = Math.max(r && h, 0), M = [a + b, v], H = [a + N - b, v], A = [a + N, v + b], D = [a + N, v + B - r], W = [a + N - r, v + B], G = [a + r, v + B], it = [a, v + B - r], C = [a, v + b], k = (L, F) => Math.sqrt(Math.pow(L, 2) - Math.pow(F, 2));
        if (g) {
          let L = k(b, b - g);
          M[0] -= L, H[0] += L, A[1] = C[1] = v + b - g;
        }
        if (B < b - g) {
          let L = k(b, b - g - B);
          A[0] = D[0] = a + N - b + L, W[0] = Math.min(A[0], W[0]), G[0] = Math.max(D[0], G[0]), it[0] = C[0] = a + b - L, A[1] = C[1] = v + B;
        }
        if (d) {
          let L = k(r, r - d);
          W[0] += L, G[0] -= L, D[1] = it[1] = v + B - r + d;
        }
        if (B < r - d) {
          let L = k(r, r - d - B);
          A[0] = D[0] = a + N - r + L, H[0] = Math.min(A[0], H[0]), M[0] = Math.max(D[0], M[0]), it[0] = C[0] = a + r - L, D[1] = it[1] = v;
        }
        return o.length = 0, o.push(["M", ...M], ["L", ...H], ["A", b, b, 0, 0, 1, ...A], ["L", ...D], ["A", r, r, 0, 0, 1, ...W], ["L", ...G], ["A", r, r, 0, 0, 1, ...it], ["L", ...C], ["A", b, b, 0, 0, 1, ...M], ["Z"]), o;
      }
      return { compose: function(a, v, N) {
        let B = a.types.pie;
        if (!v.symbolCustomAttribs.includes("borderRadius")) {
          let T = N.prototype.symbols;
          q(a, "afterColumnTranslate", s, { order: 9 }), q(B, "afterTranslate", p), v.symbolCustomAttribs.push("borderRadius", "brBoxHeight", "brBoxY"), w = T.arc, f = T.roundedRect, T.arc = x, T.roundedRect = n;
        }
      }, optionsToObject: l };
    }), ot(i, "Core/Responsive.js", [i["Core/Utilities.js"]], function(U) {
      var _;
      let { diffObjects: K, extend: Z, find: J, merge: q, pick: tt, uniqueKey: X } = U;
      return function(I) {
        function O(w, f) {
          let x = w.condition;
          (x.callback || function() {
            return this.chartWidth <= tt(x.maxWidth, Number.MAX_VALUE) && this.chartHeight <= tt(x.maxHeight, Number.MAX_VALUE) && this.chartWidth >= tt(x.minWidth, 0) && this.chartHeight >= tt(x.minHeight, 0);
          }).call(this) && f.push(w._id);
        }
        function y(w, f) {
          let x = this.options.responsive, s = this.currentResponsive, l = [], p;
          !f && x && x.rules && x.rules.forEach((v) => {
            v._id === void 0 && (v._id = X()), this.matchResponsiveRule(v, l);
          }, this);
          let n = q(...l.map((v) => J((x || {}).rules || [], (N) => N._id === v)).map((v) => v && v.chartOptions));
          n.isResponsiveOptions = !0, l = l.toString() || void 0;
          let a = s && s.ruleIds;
          l === a || (s && (this.currentResponsive = void 0, this.updatingResponsive = !0, this.update(s.undoOptions, w, !0), this.updatingResponsive = !1), l ? ((p = K(n, this.options, !0, this.collectionsWithUpdate)).isResponsiveOptions = !0, this.currentResponsive = { ruleIds: l, mergedOptions: n, undoOptions: p }, this.updatingResponsive || this.update(n, w, !0)) : this.currentResponsive = void 0);
        }
        I.compose = function(w) {
          let f = w.prototype;
          return f.matchResponsiveRule || Z(f, { matchResponsiveRule: O, setResponsive: y }), w;
        };
      }(_ || (_ = {})), _;
    }), ot(i, "masters/highcharts.src.js", [i["Core/Globals.js"], i["Core/Utilities.js"], i["Core/Defaults.js"], i["Core/Animation/Fx.js"], i["Core/Animation/AnimationUtilities.js"], i["Core/Renderer/HTML/AST.js"], i["Core/Templating.js"], i["Core/Renderer/RendererRegistry.js"], i["Core/Renderer/RendererUtilities.js"], i["Core/Renderer/SVG/SVGElement.js"], i["Core/Renderer/SVG/SVGRenderer.js"], i["Core/Renderer/HTML/HTMLElement.js"], i["Core/Axis/Axis.js"], i["Core/Axis/DateTimeAxis.js"], i["Core/Axis/LogarithmicAxis.js"], i["Core/Axis/PlotLineOrBand/PlotLineOrBand.js"], i["Core/Axis/Tick.js"], i["Core/Tooltip.js"], i["Core/Series/Point.js"], i["Core/Pointer.js"], i["Core/Legend/Legend.js"], i["Core/Legend/LegendSymbol.js"], i["Core/Chart/Chart.js"], i["Extensions/ScrollablePlotArea.js"], i["Core/Axis/Stacking/StackingAxis.js"], i["Core/Axis/Stacking/StackItem.js"], i["Core/Series/Series.js"], i["Core/Series/SeriesRegistry.js"], i["Series/Column/ColumnDataLabel.js"], i["Series/Pie/PieDataLabel.js"], i["Core/Series/DataLabel.js"], i["Extensions/OverlappingDataLabels.js"], i["Extensions/BorderRadius.js"], i["Core/Responsive.js"], i["Core/Color/Color.js"], i["Core/Time.js"]], function(U, _, K, Z, J, q, tt, X, I, O, y, w, f, x, s, l, p, n, a, v, N, B, T, o, u, c, e, t, h, b, r, g, d, M, H, A) {
      return U.AST = q, U.Axis = f, U.Chart = T, U.Color = H, U.DataLabel = r, U.Fx = Z, U.HTMLElement = w, U.Legend = N, U.LegendSymbol = B, U.OverlappingDataLabels = U.OverlappingDataLabels || g, U.PlotLineOrBand = l, U.Point = a, U.Pointer = v, U.RendererRegistry = X, U.Series = e, U.SeriesRegistry = t, U.StackItem = c, U.SVGElement = O, U.SVGRenderer = y, U.Templating = tt, U.Tick = p, U.Time = A, U.Tooltip = n, U.animate = J.animate, U.animObject = J.animObject, U.chart = T.chart, U.color = H.parse, U.dateFormat = tt.dateFormat, U.defaultOptions = K.defaultOptions, U.distribute = I.distribute, U.format = tt.format, U.getDeferredAnimation = J.getDeferredAnimation, U.getOptions = K.getOptions, U.numberFormat = tt.numberFormat, U.seriesType = t.seriesType, U.setAnimation = J.setAnimation, U.setOptions = K.setOptions, U.stop = J.stop, U.time = K.defaultTime, U.timers = Z.timers, d.compose(U.Series, U.SVGElement, U.SVGRenderer), h.compose(U.Series.types.column), r.compose(U.Series), x.compose(U.Axis), w.compose(U.SVGRenderer), N.compose(U.Chart), s.compose(U.Axis), g.compose(U.Chart), b.compose(U.Series.types.pie), l.compose(U.Chart, U.Axis), v.compose(U.Chart), M.compose(U.Chart), o.compose(U.Axis, U.Chart, U.Series), u.compose(U.Axis, U.Chart, U.Series), n.compose(U.Pointer), _.extend(U, _), U;
    }), i["masters/highcharts.src.js"]._modules = i, i["masters/highcharts.src.js"];
  });
})(_i);
var te = _i.exports;
const mi = /* @__PURE__ */ Xi(te), Os = Ye`/**
 * @license Highcharts
 *
 * (c) 2009-2022 Torstein Honsi
 *
 * License: www.highcharts.com/license
 */:root,.highcharts-light{--highcharts-color-0: #2caffe;--highcharts-color-1: #544fc5;--highcharts-color-2: #00e272;--highcharts-color-3: #fe6a35;--highcharts-color-4: #6b8abc;--highcharts-color-5: #d568fb;--highcharts-color-6: #2ee0ca;--highcharts-color-7: #fa4b42;--highcharts-color-8: #feb56a;--highcharts-color-9: #91e8e1;--highcharts-background-color: #ffffff;--highcharts-neutral-color-100: #000000;--highcharts-neutral-color-80: #333333;--highcharts-neutral-color-60: #666666;--highcharts-neutral-color-40: #999999;--highcharts-neutral-color-20: #cccccc;--highcharts-neutral-color-10: #e6e6e6;--highcharts-neutral-color-5: #f2f2f2;--highcharts-neutral-color-3: #f7f7f7;--highcharts-highlight-color-100: #0022ff;--highcharts-highlight-color-80: #334eff;--highcharts-highlight-color-60: #667aff;--highcharts-highlight-color-20: #ccd3ff;--highcharts-highlight-color-10: #e6e9ff;--highcharts-positive-color: #06b535;--highcharts-negative-color: #f21313;--highcharts-annotation-color-0: rgba(130, 170, 255, .4);--highcharts-annotation-color-1: rgba(139, 191, 216, .4);--highcharts-annotation-color-2: rgba(150, 216, 192, .4);--highcharts-annotation-color-3: rgba(156, 229, 161, .4);--highcharts-annotation-color-4: rgba(162, 241, 130, .4);--highcharts-annotation-color-5: rgba(169, 255, 101, .4)}@media (prefers-color-scheme: dark){:root{--highcharts-background-color: rgb(48, 48, 48);--highcharts-neutral-color-100: rgb(255, 255, 255);--highcharts-neutral-color-80: rgb(214, 214, 214);--highcharts-neutral-color-60: rgb(173, 173, 173);--highcharts-neutral-color-40: rgb(133, 133, 133);--highcharts-neutral-color-20: rgb(92, 92, 92);--highcharts-neutral-color-10: rgb(71, 71, 71);--highcharts-neutral-color-5: rgb(61, 61, 61);--highcharts-neutral-color-3: rgb(57, 57, 57);--highcharts-highlight-color-100: rgb(122, 167, 255);--highcharts-highlight-color-80: rgb(108, 144, 214);--highcharts-highlight-color-60: rgb(94, 121, 173);--highcharts-highlight-color-20: rgb(65, 74, 92);--highcharts-highlight-color-10: rgb(58, 63, 71)}}.highcharts-dark{--highcharts-background-color: rgb(48, 48, 48);--highcharts-neutral-color-100: rgb(255, 255, 255);--highcharts-neutral-color-80: rgb(214, 214, 214);--highcharts-neutral-color-60: rgb(173, 173, 173);--highcharts-neutral-color-40: rgb(133, 133, 133);--highcharts-neutral-color-20: rgb(92, 92, 92);--highcharts-neutral-color-10: rgb(71, 71, 71);--highcharts-neutral-color-5: rgb(61, 61, 61);--highcharts-neutral-color-3: rgb(57, 57, 57);--highcharts-highlight-color-100: rgb(122, 167, 255);--highcharts-highlight-color-80: rgb(108, 144, 214);--highcharts-highlight-color-60: rgb(94, 121, 173);--highcharts-highlight-color-20: rgb(65, 74, 92);--highcharts-highlight-color-10: rgb(58, 63, 71)}.highcharts-container{position:relative;overflow:hidden;width:100%;height:100%;text-align:left;line-height:normal;z-index:0;-webkit-tap-highlight-color:rgba(0,0,0,0);font-family:Helvetica,Arial,sans-serif;font-size:1rem;-webkit-user-select:none;user-select:none;touch-action:manipulation;outline:none}.highcharts-no-touch-action{touch-action:none}.highcharts-root{display:block}.highcharts-root text{stroke-width:0}.highcharts-strong{font-weight:700}.highcharts-emphasized{font-style:italic}.highcharts-anchor{cursor:pointer}.highcharts-background{fill:var(--highcharts-background-color)}.highcharts-plot-border,.highcharts-plot-background,.highcharts-label-box{fill:none}.highcharts-label text{fill:var(--highcharts-neutral-color-80);font-size:.8em}.highcharts-button-box{fill:inherit}.highcharts-tracker-line{stroke-linejoin:round;stroke:#c0c0c000;stroke-width:22;fill:none}.highcharts-tracker-area{fill:#c0c0c000;stroke-width:0}.highcharts-title{fill:var(--highcharts-neutral-color-80);font-size:1.2em;font-weight:700}.highcharts-subtitle{fill:var(--highcharts-neutral-color-60);font-size:.8em}.highcharts-axis-line{fill:none;stroke:var(--highcharts-neutral-color-80)}.highcharts-yaxis .highcharts-axis-line{stroke-width:0}.highcharts-axis-title{fill:var(--highcharts-neutral-color-60);font-size:.8em}.highcharts-axis-labels{fill:var(--highcharts-neutral-color-80);cursor:default;font-size:.8em}.highcharts-grid-line{fill:none;stroke:var(--highcharts-neutral-color-10)}.highcharts-xaxis-grid .highcharts-grid-line{stroke-width:0}.highcharts-tick{stroke:var(--highcharts-neutral-color-80)}.highcharts-yaxis .highcharts-tick{stroke-width:0}.highcharts-minor-grid-line{stroke:var(--highcharts-neutral-color-5)}.highcharts-crosshair-thin{stroke-width:1px;stroke:var(--highcharts-neutral-color-20)}.highcharts-crosshair-category{stroke:var(--highcharts-highlight-color-20);stroke-opacity:.25}.highcharts-credits{cursor:pointer;fill:var(--highcharts-neutral-color-40);font-size:.6em;transition:fill .25s,font-size .25s}.highcharts-credits:hover{fill:var(--highcharts-neutral-color-100);font-size:.7em}.highcharts-tooltip{cursor:default;pointer-events:none;white-space:nowrap;transition:stroke .15s}.highcharts-tooltip .highcharts-tracker{fill:none;stroke:none}.highcharts-tooltip text{fill:var(--highcharts-neutral-color-80);font-size:.8em}.highcharts-tooltip .highcharts-header{font-size:.8em}.highcharts-tooltip-box{stroke-width:1px;fill:var(--highcharts-background-color)}.highcharts-tooltip-box{stroke-width:0;fill:var(--highcharts-background-color)}.highcharts-tooltip-box .highcharts-label-box{fill:var(--highcharts-background-color)}div.highcharts-tooltip{filter:none;font-size:.8em}.highcharts-selection-marker{fill:var(--highcharts-highlight-color-80);fill-opacity:.25}.highcharts-graph{fill:none;stroke-width:2px;stroke-linecap:round;stroke-linejoin:round}.highcharts-empty-series{stroke-width:1px;fill:none;stroke:var(--highcharts-neutral-color-20)}.highcharts-state-hover .highcharts-graph{stroke-width:3}.highcharts-point-inactive,.highcharts-series-inactive{opacity:.2;transition:opacity 50ms}.highcharts-state-hover path{transition:stroke-width 50ms}.highcharts-state-normal path{transition:stroke-width .25s}g.highcharts-series,.highcharts-point,.highcharts-markers,.highcharts-data-labels{transition:opacity .25s}.highcharts-legend-series-active g.highcharts-series:not(.highcharts-series-hover),.highcharts-legend-point-active .highcharts-point:not(.highcharts-point-hover,.highcharts-point-select),.highcharts-legend-series-active .highcharts-markers:not(.highcharts-series-hover),.highcharts-legend-series-active .highcharts-data-labels:not(.highcharts-series-hover){opacity:.2}.highcharts-color-0{fill:var(--highcharts-color-0);stroke:var(--highcharts-color-0)}.highcharts-color-1{fill:var(--highcharts-color-1);stroke:var(--highcharts-color-1)}.highcharts-color-2{fill:var(--highcharts-color-2);stroke:var(--highcharts-color-2)}.highcharts-color-3{fill:var(--highcharts-color-3);stroke:var(--highcharts-color-3)}.highcharts-color-4{fill:var(--highcharts-color-4);stroke:var(--highcharts-color-4)}.highcharts-color-5{fill:var(--highcharts-color-5);stroke:var(--highcharts-color-5)}.highcharts-color-6{fill:var(--highcharts-color-6);stroke:var(--highcharts-color-6)}.highcharts-color-7{fill:var(--highcharts-color-7);stroke:var(--highcharts-color-7)}.highcharts-color-8{fill:var(--highcharts-color-8);stroke:var(--highcharts-color-8)}.highcharts-color-9{fill:var(--highcharts-color-9);stroke:var(--highcharts-color-9)}.highcharts-area{fill-opacity:.75;stroke-width:0}.highcharts-markers{stroke-width:1px;stroke:var(--highcharts-background-color)}.highcharts-a11y-markers-hidden .highcharts-point:not(.highcharts-point-hover,.highcharts-a11y-marker-visible),.highcharts-a11y-marker-hidden{opacity:0}.highcharts-point{stroke-width:1px}.highcharts-dense-data .highcharts-point{stroke-width:0}.highcharts-data-label text,text.highcharts-data-label{font-size:.7em;font-weight:700}.highcharts-data-label-box{fill:none;stroke-width:0}.highcharts-data-label text,text.highcharts-data-label{fill:var(--highcharts-neutral-color-80)}.highcharts-data-label-connector{fill:none}.highcharts-data-label-hidden{pointer-events:none}.highcharts-halo{fill-opacity:.25;stroke-width:0}.highcharts-series-label text{fill:inherit;font-weight:700}.highcharts-series:not(.highcharts-pie-series) .highcharts-point-select,.highcharts-markers .highcharts-point-select{fill:var(--highcharts-neutral-color-20);stroke:var(--highcharts-neutral-color-100)}.highcharts-column-series path.highcharts-point,.highcharts-bar-series path.highcharts-point{stroke:var(--highcharts-background-color)}.highcharts-column-series .highcharts-point{transition:fill-opacity .25s}.highcharts-column-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-pie-series .highcharts-point{stroke-linejoin:round;stroke:var(--highcharts-background-color)}.highcharts-pie-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-funnel-series .highcharts-point{stroke-linejoin:round;stroke:var(--highcharts-background-color)}.highcharts-funnel-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-funnel-series .highcharts-point-select{fill:inherit;stroke:inherit}.highcharts-pyramid-series .highcharts-point{stroke-linejoin:round;stroke:var(--highcharts-background-color)}.highcharts-pyramid-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-pyramid-series .highcharts-point-select{fill:inherit;stroke:inherit}.highcharts-solidgauge-series .highcharts-point{stroke-width:0}.highcharts-treemap-series .highcharts-point{stroke-width:1px;stroke:var(--highcharts-neutral-color-10);transition:stroke .25s,fill .25s,fill-opacity .25s}.highcharts-treemap-series .highcharts-point-hover{stroke:var(--highcharts-neutral-color-40);transition:stroke 25ms,fill 25ms,fill-opacity 25ms}.highcharts-treemap-series .highcharts-above-level{display:none}.highcharts-treemap-series .highcharts-internal-node{fill:none}.highcharts-treemap-series .highcharts-internal-node-interactive{fill-opacity:.15;cursor:pointer}.highcharts-treemap-series .highcharts-internal-node-interactive:hover{fill-opacity:.75}.highcharts-vector-series .highcharts-point,.highcharts-windbarb-series .highcharts-point{fill:none;stroke-width:2px}.highcharts-lollipop-stem{stroke:var(--highcharts-neutral-color-100)}.highcharts-focus-border{fill:none;stroke-width:2px}.highcharts-legend-item-hidden .highcharts-focus-border{fill:none!important}.highcharts-legend-box{fill:none;stroke-width:0}.highcharts-legend-item>text{fill:var(--highcharts-neutral-color-80);font-weight:700;font-size:.8em;cursor:pointer;stroke-width:0}.highcharts-legend-item:hover text{fill:var(--highcharts-neutral-color-100)}.highcharts-legend-item-hidden *{fill:var(--highcharts-neutral-color-60)!important;stroke:var(--highcharts-neutral-color-60)!important;transition:fill .25s;text-decoration:line-through}.highcharts-legend-nav-active{fill:var(--highcharts-highlight-color-100);cursor:pointer}.highcharts-legend-nav-inactive{fill:var(--highcharts-neutral-color-20)}circle.highcharts-legend-nav-active,circle.highcharts-legend-nav-inactive{fill:#c0c0c000}.highcharts-legend-title-box{fill:none;stroke-width:0}.highcharts-bubble-legend-symbol{stroke-width:2;fill-opacity:.5}.highcharts-bubble-legend-connectors{stroke-width:1}.highcharts-bubble-legend-labels{fill:var(--highcharts-neutral-color-80);font-size:.7em}.highcharts-loading{position:absolute;background-color:var(--highcharts-background-color);opacity:.5;text-align:center;z-index:10;transition:opacity .25s}.highcharts-loading-hidden{height:0!important;opacity:0;overflow:hidden;transition:opacity .25s,height .25s step-end}.highcharts-loading-inner{font-weight:700;position:relative;top:45%}.highcharts-plot-band,.highcharts-pane{fill:var(--highcharts-neutral-color-100);fill-opacity:.05}.highcharts-plot-line{fill:none;stroke:var(--highcharts-neutral-color-40);stroke-width:1px}.highcharts-plot-line-label{font-size:.8em}.highcharts-boxplot-box{fill:var(--highcharts-background-color)}.highcharts-boxplot-median{stroke-width:2px}.highcharts-bubble-series .highcharts-point{fill-opacity:.5}.highcharts-errorbar-series .highcharts-point{stroke:var(--highcharts-neutral-color-100)}.highcharts-gauge-series .highcharts-data-label-box{stroke:var(--highcharts-neutral-color-20);stroke-width:1px}.highcharts-gauge-series .highcharts-dial{fill:var(--highcharts-neutral-color-100);stroke-width:0}.highcharts-polygon-series .highcharts-graph{fill:inherit;stroke-width:0}.highcharts-waterfall-series .highcharts-graph{stroke:var(--highcharts-neutral-color-80);stroke-dasharray:1,3}.highcharts-sankey-series .highcharts-point{stroke-width:0}.highcharts-sankey-series .highcharts-link{transition:fill .25s,fill-opacity .25s;fill-opacity:.5}.highcharts-sankey-series .highcharts-point-hover.highcharts-link{transition:fill 50ms,fill-opacity 50ms;fill-opacity:1}.highcharts-venn-series .highcharts-point{fill-opacity:.75;stroke:var(--highcharts-neutral-color-20);transition:stroke .25s,fill-opacity .25s}.highcharts-venn-series .highcharts-point-hover{fill-opacity:1;stroke:var(--highcharts-neutral-color-20)}.highcharts-timeline-series .highcharts-graph{stroke:var(--highcharts-neutral-color-20)}.highcharts-navigator-mask-outside{fill-opacity:0}.highcharts-navigator-mask-inside{fill:var(--highcharts-highlight-color-60);fill-opacity:.25;cursor:ew-resize}.highcharts-navigator-outline{stroke:var(--highcharts-neutral-color-40);fill:none}.highcharts-navigator-handle{stroke:var(--highcharts-neutral-color-40);fill:var(--highcharts-neutral-color-5);cursor:ew-resize}.highcharts-navigator-series{fill:var(--highcharts-highlight-color-80);stroke:var(--highcharts-highlight-color-80)}.highcharts-navigator-series .highcharts-graph{stroke-width:1px}.highcharts-navigator-series .highcharts-area{fill-opacity:.05}.highcharts-navigator-xaxis .highcharts-axis-line{stroke-width:0}.highcharts-navigator-xaxis .highcharts-grid-line{stroke-width:1px;stroke:var(--highcharts-neutral-color-10)}.highcharts-navigator-xaxis.highcharts-axis-labels{fill:var(--highcharts-neutral-color-100);font-size:.7em;opacity:.6}.highcharts-navigator-yaxis .highcharts-grid-line{stroke-width:0}.highcharts-scrollbar-thumb{fill:var(--highcharts-neutral-color-20);stroke:var(--highcharts-neutral-color-20);stroke-width:0}.highcharts-scrollbar-button{fill:var(--highcharts-neutral-color-10);stroke:var(--highcharts-neutral-color-20);stroke-width:1px}.highcharts-scrollbar-arrow{fill:var(--highcharts-neutral-color-60)}.highcharts-scrollbar-rifles{stroke:none;stroke-width:1px}.highcharts-scrollbar-track{fill:#fff0;stroke:var(--highcharts-neutral-color-20);stroke-width:1px}.highcharts-button{fill:var(--highcharts-neutral-color-3);stroke:var(--highcharts-neutral-color-20);cursor:default;stroke-width:1px;transition:fill .25s}.highcharts-button text{fill:var(--highcharts-neutral-color-80);font-size:.8em}.highcharts-button-hover{transition:fill 0ms;fill:var(--highcharts-neutral-color-10);stroke:var(--highcharts-neutral-color-20)}.highcharts-button-hover text{fill:var(--highcharts-neutral-color-80)}.highcharts-button-pressed{font-weight:700;fill:var(--highcharts-highlight-color-10);stroke:var(--highcharts-neutral-color-20)}.highcharts-button-pressed text{fill:var(--highcharts-neutral-color-80);font-weight:700}.highcharts-button-disabled text{fill:var(--highcharts-neutral-color-80)}.highcharts-range-selector-buttons .highcharts-button{stroke-width:0}.highcharts-range-label rect{fill:none}.highcharts-range-label text{fill:var(--highcharts-neutral-color-60)}.highcharts-range-input rect{fill:none}.highcharts-range-input text{fill:var(--highcharts-neutral-color-80);font-size:.8em}.highcharts-range-input{stroke-width:1px;stroke:var(--highcharts-neutral-color-20)}input.highcharts-range-selector{position:absolute;border:0;width:1px;height:1px;padding:0;text-align:center;left:-9em}.highcharts-crosshair-label text{fill:var(--highcharts-background-color);font-size:1.7em}.highcharts-crosshair-label .highcharts-label-box{fill:inherit}.highcharts-candlestick-series .highcharts-point{stroke:var(--highcharts-neutral-color-100);stroke-width:1px}.highcharts-candlestick-series .highcharts-point-up{fill:var(--highcharts-background-color)}.highcharts-hollowcandlestick-series .highcharts-point-down{fill:var(--highcharts-negative-color);stroke:var(--highcharts-negative-color)}.highcharts-hollowcandlestick-series .highcharts-point-down-bearish-up{fill:var(--highcharts-positive-color);stroke:var(--highcharts-positive-color)}.highcharts-hollowcandlestick-series .highcharts-point-up{fill:transparent;stroke:var(--highcharts-positive-color)}.highcharts-ohlc-series .highcharts-point-hover{stroke-width:3px}.highcharts-flags-series .highcharts-point .highcharts-label-box{stroke:var(--highcharts-neutral-color-40);fill:var(--highcharts-background-color);transition:fill .25s}.highcharts-flags-series .highcharts-point-hover .highcharts-label-box{stroke:var(--highcharts-neutral-color-100);fill:var(--highcharts-highlight-color-20)}.highcharts-flags-series .highcharts-point text{fill:var(--highcharts-neutral-color-100);font-size:.9em;font-weight:700}.highcharts-map-series .highcharts-point{transition:fill .5s,fill-opacity .5s,stroke-width .25s;stroke:var(--highcharts-neutral-color-20);stroke-width:inherit}.highcharts-map-series .highcharts-point-hover{transition:fill 0ms,fill-opacity 0ms;fill-opacity:.5}.highcharts-mapline-series .highcharts-point{fill:none}.highcharts-heatmap-series .highcharts-point{stroke-width:0}.highcharts-map-navigation{font-size:1.3em;font-weight:700;text-align:center}.highcharts-map-navigation.highcharts-button{fill:var(--highcharts-background-color);stroke:var(--highcharts-neutral-color-10)}.highcharts-map-navigation.highcharts-button:hover{fill:var(--highcharts-neutral-color-10)}.highcharts-map-navigation.highcharts-button .highcharts-button-symbol{stroke-width:2px}.highcharts-mapview-inset-border{stroke:var(--highcharts-neutral-color-20);stroke-width:1px;fill:none}.highcharts-coloraxis{stroke-width:0}.highcharts-coloraxis-marker{fill:var(--highcharts-neutral-color-40)}.highcharts-null-point{fill:var(--highcharts-neutral-color-3)}.highcharts-3d-frame{fill:transparent}.highcharts-contextbutton{fill:var(--highcharts-background-color);stroke:none;stroke-linecap:round}.highcharts-contextbutton:hover{fill:var(--highcharts-neutral-color-10);stroke:var(--highcharts-neutral-color-10)}.highcharts-button-symbol{stroke:var(--highcharts-neutral-color-60);stroke-width:3px}.highcharts-menu{border:none;background:var(--highcharts-background-color);border-radius:3px;padding:.5em;box-shadow:3px 3px 10px #888}.highcharts-menu-item{background:none;border-radius:3px;color:var(--highcharts-neutral-color-80);cursor:pointer;font-size:.8em;list-style-type:none;padding:.5em;transition:background .25s,color .25s}.highcharts-menu-item:hover{background:var(--highcharts-neutral-color-5)}.highcharts-breadcrumbs-button{fill:none;stroke-width:0;cursor:pointer}.highcharts-breadcrumbs-separator{fill:var(--highcharts-neutral-color-60)}.highcharts-drilldown-point{cursor:pointer}.highcharts-drilldown-data-label text,text.highcharts-drilldown-data-label,.highcharts-drilldown-axis-label{cursor:pointer;fill:var(--highcharts-highlight-color-100);font-weight:700;text-decoration:underline}.highcharts-no-data text{font-weight:700;font-size:.8em;fill:var(--highcharts-neutral-color-60)}.highcharts-axis-resizer{cursor:ns-resize;stroke:var(--highcharts-neutral-color-100);stroke-width:2px}.highcharts-bullet-target{stroke-width:0}.highcharts-lineargauge-target,.highcharts-lineargauge-target-line{stroke-width:1px;stroke:var(--highcharts-neutral-color-80)}.highcharts-fibonacci-background-0,.highcharts-pitchfork-inner-background,.highcharts-measure-background{fill:var(--highcharts-annotation-color-0)}.highcharts-fibonacci-background-1{fill:var(--highcharts-annotation-color-1)}.highcharts-fibonacci-background-2{fill:var(--highcharts-annotation-color-2)}.highcharts-fibonacci-background-3,.highcharts-pitchfork-outer-background{fill:var(--highcharts-annotation-color-3)}.highcharts-fibonacci-background-4{fill:var(--highcharts-annotation-color-4)}.highcharts-fibonacci-background-5{fill:var(--highcharts-annotation-color-5)}.highcharts-fibonacci-line{stroke:var(--highcharts-neutral-color-40)}.highcharts-crooked-lines,.highcharts-tunnel-lines,.highcharts-infinity-lines,.highcharts-timecycles-lines,.highcharts-fibonacci-timezones-lines,.highcharts-pitchfork-lines,.highcharts-vertical-line,.highcharts-measure-crosshair-x,.highcharts-measure-crosshair-y{stroke:var(--highcharts-neutral-color-100);stroke-opacity:.75;fill:none}.highcharts-measure-crosshair-x,.highcharts-measure-crosshair-y{stroke-dasharray:1,3}.highcharts-tunnel-background{fill:var(--highcharts-color-0)}.highcharts-annotation-shapes{cursor:move}.highcharts-basic-shape{fill:var(--highcharts-neutral-color-100);stroke:var(--highcharts-neutral-color-100);opacity:.74}.highcharts-annotation-label-box{stroke-width:1px;stroke:var(--highcharts-neutral-color-100);fill:var(--highcharts-neutral-color-100);fill-opacity:.75}.highcharts-annotation-label text{fill:var(--highcharts-neutral-color-10);font-size:.8em}.highcharts-a11y-proxy-element{border-width:0;background-color:transparent;cursor:pointer;outline:none;opacity:.001;z-index:999;overflow:hidden;padding:0;margin:0;display:block;position:absolute}.highcharts-a11y-proxy-group li{list-style:none}.highcharts-visually-hidden{position:absolute;width:1px;height:1px;overflow:hidden;white-space:nowrap;clip:rect(1px,1px,1px,1px);margin-top:-3px;opacity:.01}.highcharts-a11y-invisible{visibility:hidden}.highcharts-a11y-proxy-container,.highcharts-a11y-proxy-container-before,.highcharts-a11y-proxy-container-after{position:absolute;white-space:nowrap}g.highcharts-series,.highcharts-markers,.highcharts-point{outline:none}.highcharts-treegrid-node-collapsed,.highcharts-treegrid-node-expanded{cursor:pointer}.highcharts-point-connecting-path{fill:none}.highcharts-grid-axis .highcharts-tick,.highcharts-grid-axis .highcharts-axis-line{stroke:var(--highcharts-neutral-color-20);stroke-width:1px}`;
var Yi = { exports: {} };
(function(S) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Accessibility module
  *
  * (c) 2010-2024 Highsoft AS
  * Author: Oystein Moseng
  *
  * License: www.highcharts.com/license
  */
  (function(j) {
    S.exports ? (j.default = j, S.exports = j) : j(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(j) {
    var i = j ? j._modules : {};
    function ot(U, _, K, Z) {
      U.hasOwnProperty(_) || (U[_] = Z.apply(null, K), typeof CustomEvent == "function" && j.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: _, module: U[_] } })));
    }
    ot(i, "Accessibility/Utils/HTMLUtilities.js", [i["Core/Globals.js"], i["Core/Utilities.js"]], function(U, _) {
      let { doc: K, win: Z } = U, { css: J } = _, q = Z.EventTarget && new Z.EventTarget() || "none";
      function tt(I) {
        if (typeof Z.MouseEvent == "function") return new Z.MouseEvent(I.type, I);
        if (K.createEvent) {
          let O = K.createEvent("MouseEvent");
          if (O.initMouseEvent) return O.initMouseEvent(I.type, I.bubbles, I.cancelable, I.view || Z, I.detail, I.screenX, I.screenY, I.clientX, I.clientY, I.ctrlKey, I.altKey, I.shiftKey, I.metaKey, I.button, I.relatedTarget), O;
        }
        return X(I.type);
      }
      function X(I, O, y) {
        let w = O || { x: 0, y: 0 };
        if (typeof Z.MouseEvent == "function") return new Z.MouseEvent(I, { bubbles: !0, cancelable: !0, composed: !0, button: 0, buttons: 1, relatedTarget: y || q, view: Z, detail: I === "click" ? 1 : 0, screenX: w.x, screenY: w.y, clientX: w.x, clientY: w.y });
        if (K.createEvent) {
          let f = K.createEvent("MouseEvent");
          if (f.initMouseEvent) return f.initMouseEvent(I, !0, !0, Z, I === "click" ? 1 : 0, w.x, w.y, w.x, w.y, !1, !1, !1, !1, 0, null), f;
        }
        return { type: I };
      }
      return { addClass: function(I, O) {
        I.classList ? I.classList.add(O) : 0 > I.className.indexOf(O) && (I.className += " " + O);
      }, cloneMouseEvent: tt, cloneTouchEvent: function(I) {
        let O = (w) => {
          let f = [];
          for (let x = 0; x < w.length; ++x) {
            let s = w.item(x);
            s && f.push(s);
          }
          return f;
        };
        if (typeof Z.TouchEvent == "function") {
          let w = new Z.TouchEvent(I.type, { touches: O(I.touches), targetTouches: O(I.targetTouches), changedTouches: O(I.changedTouches), ctrlKey: I.ctrlKey, shiftKey: I.shiftKey, altKey: I.altKey, metaKey: I.metaKey, bubbles: I.bubbles, cancelable: I.cancelable, composed: I.composed, detail: I.detail, view: I.view });
          return I.defaultPrevented && w.preventDefault(), w;
        }
        let y = tt(I);
        return y.touches = I.touches, y.changedTouches = I.changedTouches, y.targetTouches = I.targetTouches, y;
      }, escapeStringForHTML: function(I) {
        return I.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/\//g, "&#x2F;");
      }, getElement: function(I) {
        return K.getElementById(I);
      }, getFakeMouseEvent: X, getHeadingTagNameForElement: function(I) {
        let O = (x) => "h" + Math.min(6, parseInt(x.slice(1), 10) + 1), y = (x) => /^H[1-6]$/i.test(x), w = (x) => {
          let s = x;
          for (; s = s.previousSibling; ) {
            let l = s.tagName || "";
            if (y(l)) return l;
          }
          return "";
        }, f = (x) => {
          let s = w(x);
          if (s) return O(s);
          let l = x.parentElement;
          if (!l) return "p";
          let p = l.tagName;
          return y(p) ? O(p) : f(l);
        };
        return f(I);
      }, removeChildNodes: function(I) {
        for (; I.lastChild; ) I.removeChild(I.lastChild);
      }, removeClass: function(I, O) {
        I.classList ? I.classList.remove(O) : I.className = I.className.replace(RegExp(O, "g"), "");
      }, removeElement: function(I) {
        I && I.parentNode && I.parentNode.removeChild(I);
      }, reverseChildNodes: function(I) {
        let O = I.childNodes.length;
        for (; O--; ) I.appendChild(I.childNodes[O]);
      }, simulatedEventTarget: q, stripHTMLTagsFromString: function(I, O = !1) {
        return typeof I == "string" ? O ? I.replace(/<\/?[^>]+(>|$)/g, "") : I.replace(/<\/?(?!\s)[^>]+(>|$)/g, "") : I;
      }, visuallyHideElement: function(I) {
        J(I, { position: "absolute", width: "1px", height: "1px", overflow: "hidden", whiteSpace: "nowrap", clip: "rect(1px, 1px, 1px, 1px)", marginTop: "-3px", "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)", filter: "alpha(opacity=1)", opacity: 0.01 });
      } };
    }), ot(i, "Accessibility/A11yI18n.js", [i["Core/Templating.js"], i["Core/Utilities.js"]], function(U, _) {
      var K;
      let { format: Z } = U, { getNestedProperty: J, pick: q } = _;
      return function(tt) {
        function X(O, y, w) {
          let f = (n, a) => {
            let v = n.slice(a || 0), N = v.indexOf("{"), B = v.indexOf("}");
            if (N > -1 && B > N) return { statement: v.substring(N + 1, B), begin: a + N + 1, end: a + B };
          }, x = [], s, l, p = 0;
          do
            s = f(O, p), (l = O.substring(p, s && s.begin - 1)).length && x.push({ value: l, type: "constant" }), s && x.push({ value: s.statement, type: "statement" }), p = s ? s.end + 1 : p + 1;
          while (s);
          return x.forEach((n) => {
            n.type === "statement" && (n.value = function(a, v) {
              let N, B, T = a.indexOf("#each("), o = a.indexOf("#plural("), u = a.indexOf("["), c = a.indexOf("]");
              if (T > -1) {
                let t = a.slice(T).indexOf(")") + T, h = a.substring(0, T), b = a.substring(t + 1), r = a.substring(T + 6, t).split(","), g = Number(r[1]), d;
                if (B = "", N = J(r[0], v)) {
                  d = (g = isNaN(g) ? N.length : g) < 0 ? N.length + g : Math.min(g, N.length);
                  for (let M = 0; M < d; ++M) B += h + N[M] + b;
                }
                return B.length ? B : "";
              }
              if (o > -1) {
                var e;
                let t = a.slice(o).indexOf(")") + o, h = a.substring(o + 8, t).split(",");
                switch (Number(J(h[0], v))) {
                  case 0:
                    B = q(h[4], h[1]);
                    break;
                  case 1:
                    B = q(h[2], h[1]);
                    break;
                  case 2:
                    B = q(h[3], h[1]);
                    break;
                  default:
                    B = h[1];
                }
                return B ? (e = B).trim && e.trim() || e.replace(/^\s+|\s+$/g, "") : "";
              }
              if (u > -1) {
                let t, h = a.substring(0, u), b = Number(a.substring(u + 1, c));
                return N = J(h, v), !isNaN(b) && N && (b < 0 ? (t = N[N.length + b]) === void 0 && (t = N[0]) : (t = N[b]) === void 0 && (t = N[N.length - 1])), t !== void 0 ? t : "";
              }
              return "{" + a + "}";
            }(n.value, y));
          }), Z(x.reduce((n, a) => n + a.value, ""), y, w);
        }
        function I(O, y) {
          let w = O.split("."), f = this.options.lang, x = 0;
          for (; x < w.length; ++x) f = f && f[w[x]];
          return typeof f == "string" ? X(f, y, this) : "";
        }
        tt.compose = function(O) {
          let y = O.prototype;
          y.langFormat || (y.langFormat = I);
        }, tt.i18nFormat = X;
      }(K || (K = {})), K;
    }), ot(i, "Accessibility/Utils/ChartUtilities.js", [i["Core/Globals.js"], i["Accessibility/Utils/HTMLUtilities.js"], i["Core/Utilities.js"]], function(U, _, K) {
      let { doc: Z } = U, { stripHTMLTagsFromString: J } = _, { defined: q, find: tt, fireEvent: X } = K;
      function I(y) {
        if (y.points && y.points.length) {
          let w = tt(y.points, (f) => !!f.graphic);
          return w && w.graphic && w.graphic.element;
        }
      }
      function O(y) {
        let w = I(y);
        return w && w.parentNode || y.graph && y.graph.element || y.group && y.group.element;
      }
      return { fireEventOnWrappedOrUnwrappedElement: function y(w, f) {
        let x = f.type, s = w.hcEvents;
        Z.createEvent && (w.dispatchEvent || w.fireEvent) ? w.dispatchEvent ? w.dispatchEvent(f) : w.fireEvent(x, f) : s && s[x] ? X(w, x, f) : w.element && y(w.element, f);
      }, getChartTitle: function(y) {
        return J(y.options.title.text || y.langFormat("accessibility.defaultChartTitle", { chart: y }), y.renderer.forExport);
      }, getAxisDescription: function(y) {
        var w, f;
        return y && (((w = y.options.accessibility) == null ? void 0 : w.description) || ((f = y.axisTitle) == null ? void 0 : f.textStr) || y.options.id || y.categories && "categories" || y.dateTime && "Time" || "values");
      }, getAxisRangeDescription: function(y) {
        let w = y.options || {};
        return w.accessibility && w.accessibility.rangeDescription !== void 0 ? w.accessibility.rangeDescription : y.categories ? function(f) {
          let x = f.chart;
          return f.dataMax && f.dataMin ? x.langFormat("accessibility.axis.rangeCategories", { chart: x, axis: f, numCategories: f.dataMax - f.dataMin + 1 }) : "";
        }(y) : y.dateTime && (y.min === 0 || y.dataMin === 0) ? function(f) {
          let x = f.chart, s = {}, l = f.dataMin || f.min || 0, p = f.dataMax || f.max || 0, n = "Seconds";
          s.Seconds = (p - l) / 1e3, s.Minutes = s.Seconds / 60, s.Hours = s.Minutes / 60, s.Days = s.Hours / 24, ["Minutes", "Hours", "Days"].forEach(function(v) {
            s[v] > 2 && (n = v);
          });
          let a = s[n].toFixed(n !== "Seconds" && n !== "Minutes" ? 1 : 0);
          return x.langFormat("accessibility.axis.timeRange" + n, { chart: x, axis: f, range: a.replace(".0", "") });
        }(y) : function(f) {
          let x = f.chart, s = x.options, l = s && s.accessibility && s.accessibility.screenReaderSection.axisRangeDateFormat || "", p = { min: f.dataMin || f.min || 0, max: f.dataMax || f.max || 0 }, n = function(a) {
            return f.dateTime ? x.time.dateFormat(l, p[a]) : p[a].toString();
          };
          return x.langFormat("accessibility.axis.rangeFromTo", { chart: x, axis: f, rangeFrom: n("min"), rangeTo: n("max") });
        }(y);
      }, getPointFromXY: function(y, w, f) {
        let x = y.length, s;
        for (; x--; ) if (s = tt(y[x].points || [], function(l) {
          return l.x === w && l.y === f;
        })) return s;
      }, getSeriesFirstPointElement: I, getSeriesFromName: function(y, w) {
        return w ? (y.series || []).filter(function(f) {
          return f.name === w;
        }) : y.series;
      }, getSeriesA11yElement: O, unhideChartElementFromAT: function y(w, f) {
        f.setAttribute("aria-hidden", !1), f !== w.renderTo && f.parentNode && f.parentNode !== Z.body && (Array.prototype.forEach.call(f.parentNode.childNodes, function(x) {
          x.hasAttribute("aria-hidden") || x.setAttribute("aria-hidden", !0);
        }), y(w, f.parentNode));
      }, hideSeriesFromAT: function(y) {
        let w = O(y);
        w && w.setAttribute("aria-hidden", !0);
      }, scrollAxisToPoint: function(y) {
        let w = y.series.xAxis, f = y.series.yAxis, x = w && w.scrollbar ? w : f, s = x && x.scrollbar;
        if (s && q(s.to) && q(s.from)) {
          let l = s.to - s.from, p = function(n, a) {
            if (!q(n.dataMin) || !q(n.dataMax)) return 0;
            let v = n.toPixels(n.dataMin), N = n.toPixels(n.dataMax), B = n.coll === "xAxis" ? "x" : "y";
            return (n.toPixels(a[B] || 0) - v) / (N - v);
          }(x, y);
          s.updatePosition(p - l / 2, p + l / 2), X(s, "changed", { from: s.from, to: s.to, trigger: "scrollbar", DOMEvent: null });
        }
      } };
    }), ot(i, "Accessibility/Utils/DOMElementProvider.js", [i["Core/Globals.js"], i["Accessibility/Utils/HTMLUtilities.js"]], function(U, _) {
      let { doc: K } = U, { removeElement: Z } = _;
      return class {
        constructor() {
          this.elements = [];
        }
        createElement() {
          let J = K.createElement.apply(K, arguments);
          return this.elements.push(J), J;
        }
        removeElement(J) {
          Z(J), this.elements.splice(this.elements.indexOf(J), 1);
        }
        destroyCreatedElements() {
          this.elements.forEach(function(J) {
            Z(J);
          }), this.elements = [];
        }
      };
    }), ot(i, "Accessibility/Utils/EventProvider.js", [i["Core/Globals.js"], i["Core/Utilities.js"]], function(U, _) {
      let { addEvent: K } = _;
      return class {
        constructor() {
          this.eventRemovers = [];
        }
        addEvent() {
          let Z = K.apply(U, arguments);
          return this.eventRemovers.push({ element: arguments[0], remover: Z }), Z;
        }
        removeEvent(Z) {
          let J = this.eventRemovers.map((q) => q.remover).indexOf(Z);
          this.eventRemovers[J].remover(), this.eventRemovers.splice(J, 1);
        }
        removeAddedEvents() {
          this.eventRemovers.map((Z) => Z.remover).forEach((Z) => Z()), this.eventRemovers = [];
        }
      };
    }), ot(i, "Accessibility/AccessibilityComponent.js", [i["Accessibility/Utils/ChartUtilities.js"], i["Accessibility/Utils/DOMElementProvider.js"], i["Accessibility/Utils/EventProvider.js"], i["Accessibility/Utils/HTMLUtilities.js"]], function(U, _, K, Z) {
      let { fireEventOnWrappedOrUnwrappedElement: J } = U, { getFakeMouseEvent: q } = Z;
      return class {
        destroy() {
        }
        getKeyboardNavigation() {
          return [];
        }
        init() {
        }
        onChartRender() {
        }
        onChartUpdate() {
        }
        initBase(tt, X) {
          this.chart = tt, this.eventProvider = new K(), this.domElementProvider = new _(), this.proxyProvider = X, this.keyCodes = { left: 37, right: 39, up: 38, down: 40, enter: 13, space: 32, esc: 27, tab: 9, pageUp: 33, pageDown: 34, end: 35, home: 36 };
        }
        addEvent(tt, X, I, O) {
          return this.eventProvider.addEvent(tt, X, I, O);
        }
        createElement(tt, X) {
          return this.domElementProvider.createElement(tt, X);
        }
        fakeClickEvent(tt) {
          J(tt, q("click"));
        }
        destroyBase() {
          this.domElementProvider.destroyCreatedElements(), this.eventProvider.removeAddedEvents();
        }
      };
    }), ot(i, "Accessibility/KeyboardNavigationHandler.js", [i["Core/Utilities.js"]], function(U) {
      let { find: _ } = U;
      return class {
        constructor(K, Z) {
          this.chart = K, this.keyCodeMap = Z.keyCodeMap || [], this.validate = Z.validate, this.init = Z.init, this.terminate = Z.terminate, this.response = { success: 1, prev: 2, next: 3, noHandler: 4, fail: 5 };
        }
        run(K) {
          let Z = K.which || K.keyCode, J = this.response.noHandler, q = _(this.keyCodeMap, function(tt) {
            return tt[0].indexOf(Z) > -1;
          });
          return q ? J = q[1].call(this, Z, K) : Z === 9 && (J = this.response[K.shiftKey ? "prev" : "next"]), J;
        }
      };
    }), ot(i, "Accessibility/Components/ContainerComponent.js", [i["Accessibility/AccessibilityComponent.js"], i["Accessibility/KeyboardNavigationHandler.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Core/Globals.js"], i["Accessibility/Utils/HTMLUtilities.js"]], function(U, _, K, Z, J) {
      let { unhideChartElementFromAT: q, getChartTitle: tt } = K, { doc: X } = Z, { stripHTMLTagsFromString: I } = J;
      return class extends U {
        onChartUpdate() {
          this.handleSVGTitleElement(), this.setSVGContainerLabel(), this.setGraphicContainerAttrs(), this.setRenderToAttrs(), this.makeCreditsAccessible();
        }
        handleSVGTitleElement() {
          let O = this.chart, y = "highcharts-title-" + O.index, w = I(O.langFormat("accessibility.svgContainerTitle", { chartTitle: tt(O) }));
          if (w.length) {
            let f = this.svgTitleElement = this.svgTitleElement || X.createElementNS("http://www.w3.org/2000/svg", "title");
            f.textContent = w, f.id = y, O.renderTo.insertBefore(f, O.renderTo.firstChild);
          }
        }
        setSVGContainerLabel() {
          let O = this.chart, y = O.langFormat("accessibility.svgContainerLabel", { chartTitle: tt(O) });
          O.renderer.box && y.length && O.renderer.box.setAttribute("aria-label", y);
        }
        setGraphicContainerAttrs() {
          let O = this.chart, y = O.langFormat("accessibility.graphicContainerLabel", { chartTitle: tt(O) });
          y.length && O.container.setAttribute("aria-label", y);
        }
        setRenderToAttrs() {
          let O = this.chart, y = O.options.accessibility.landmarkVerbosity !== "disabled", w = O.langFormat("accessibility.chartContainerLabel", { title: tt(O), chart: O });
          w && (O.renderTo.setAttribute("role", y ? "region" : "group"), O.renderTo.setAttribute("aria-label", w));
        }
        makeCreditsAccessible() {
          let O = this.chart, y = O.credits;
          y && (y.textStr && y.element.setAttribute("aria-label", O.langFormat("accessibility.credits", { creditsStr: I(y.textStr, O.renderer.forExport) })), q(O, y.element));
        }
        getKeyboardNavigation() {
          let O = this.chart;
          return new _(O, { keyCodeMap: [], validate: function() {
            return !0;
          }, init: function() {
            let y = O.accessibility;
            y && y.keyboardNavigation.tabindexContainer.focus();
          } });
        }
        destroy() {
          this.chart.renderTo.setAttribute("aria-hidden", !0);
        }
      };
    }), ot(i, "Accessibility/FocusBorder.js", [i["Core/Utilities.js"]], function(U) {
      var _;
      let { addEvent: K, pick: Z } = U;
      return function(J) {
        let q = ["x", "y", "transform", "width", "height", "r", "d", "stroke-width"];
        function tt() {
          let y = this.focusElement, w = this.options.accessibility.keyboardNavigation.focusBorder;
          y && (y.removeFocusBorder(), w.enabled && y.addFocusBorder(w.margin, { stroke: w.style.color, strokeWidth: w.style.lineWidth, r: w.style.borderRadius }));
        }
        function X(y, w) {
          let f = this.options.accessibility.keyboardNavigation.focusBorder, x = w || y.element;
          x && x.focus && (x.hcEvents && x.hcEvents.focusin || K(x, "focusin", function() {
          }), x.focus(), f.hideBrowserFocusOutline && (x.style.outline = "none")), this.focusElement && this.focusElement.removeFocusBorder(), this.focusElement = y, this.renderFocusBorder();
        }
        function I(y, w) {
          this.focusBorder && this.removeFocusBorder();
          let f = this.getBBox(), x = Z(y, 3), s = this.parentGroup, l = this.scaleX || s && s.scaleX, p = this.scaleY || s && s.scaleY, n = (l ? !p : p) ? Math.abs(l || p || 1) : (Math.abs(l || 1) + Math.abs(p || 1)) / 2;
          f.x += this.translateX ? this.translateX : 0, f.y += this.translateY ? this.translateY : 0;
          let a = f.x - x, v = f.y - x, N = f.width + 2 * x, B = f.height + 2 * x, T = !!this.text;
          if (this.element.nodeName === "text" || T) {
            let o, u, c = !!this.rotation, e = T ? { x: c ? 1 : 0, y: 0 } : (o = 0, u = 0, this.attr("text-anchor") === "middle" ? o = u = 0.5 : this.rotation ? o = 0.25 : u = 0.75, { x: o, y: u }), t = +this.attr("x"), h = +this.attr("y");
            if (isNaN(t) || (a = t - f.width * e.x - x), isNaN(h) || (v = h - f.height * e.y - x), T && c) {
              let b = N;
              N = B, B = b, isNaN(t) || (a = t - f.height * e.x - x), isNaN(h) || (v = h - f.width * e.y - x);
            }
          }
          this.focusBorder = this.renderer.rect(a, v, N, B, parseInt((w && w.r || 0).toString(), 10) / n).addClass("highcharts-focus-border").attr({ zIndex: 99 }).add(s), this.renderer.styledMode || this.focusBorder.attr({ stroke: w && w.stroke, "stroke-width": (w && w.strokeWidth || 0) / n }), function(o, ...u) {
            o.focusBorderUpdateHooks || (o.focusBorderUpdateHooks = {}, q.forEach((c) => {
              let e = c + "Setter", t = o[e] || o._defaultSetter;
              o.focusBorderUpdateHooks[e] = t, o[e] = function() {
                let h = t.apply(o, arguments);
                return o.addFocusBorder.apply(o, u), h;
              };
            }));
          }(this, y, w), function(o) {
            if (o.focusBorderDestroyHook) return;
            let u = o.destroy;
            o.destroy = function() {
              return o.focusBorder && o.focusBorder.destroy && o.focusBorder.destroy(), u.apply(o, arguments);
            }, o.focusBorderDestroyHook = u;
          }(this);
        }
        function O() {
          var y;
          y = this, y.focusBorderUpdateHooks && (Object.keys(y.focusBorderUpdateHooks).forEach((w) => {
            let f = y.focusBorderUpdateHooks[w];
            f === y._defaultSetter ? delete y[w] : y[w] = f;
          }), delete y.focusBorderUpdateHooks), this.focusBorderDestroyHook && (this.destroy = this.focusBorderDestroyHook, delete this.focusBorderDestroyHook), this.focusBorder && (this.focusBorder.destroy(), delete this.focusBorder);
        }
        J.compose = function(y, w) {
          let f = y.prototype, x = w.prototype;
          f.renderFocusBorder || (f.renderFocusBorder = tt, f.setFocusToElement = X), x.addFocusBorder || (x.addFocusBorder = I, x.removeFocusBorder = O);
        };
      }(_ || (_ = {})), _;
    }), ot(i, "Accessibility/Utils/Announcer.js", [i["Core/Renderer/HTML/AST.js"], i["Accessibility/Utils/DOMElementProvider.js"], i["Core/Globals.js"], i["Accessibility/Utils/HTMLUtilities.js"], i["Core/Utilities.js"]], function(U, _, K, Z, J) {
      let { doc: q } = K, { addClass: tt, visuallyHideElement: X } = Z, { attr: I } = J;
      return class {
        constructor(O, y) {
          this.chart = O, this.domElementProvider = new _(), this.announceRegion = this.addAnnounceRegion(y);
        }
        destroy() {
          this.domElementProvider.destroyCreatedElements();
        }
        announce(O) {
          U.setElementHTML(this.announceRegion, O), this.clearAnnouncementRegionTimer && clearTimeout(this.clearAnnouncementRegionTimer), this.clearAnnouncementRegionTimer = setTimeout(() => {
            this.announceRegion.innerHTML = U.emptyHTML, delete this.clearAnnouncementRegionTimer;
          }, 3e3);
        }
        addAnnounceRegion(O) {
          let y = this.chart.announcerContainer || this.createAnnouncerContainer(), w = this.domElementProvider.createElement("div");
          return I(w, { "aria-hidden": !1, "aria-live": O, "aria-atomic": !0 }), this.chart.styledMode ? tt(w, "highcharts-visually-hidden") : X(w), y.appendChild(w), w;
        }
        createAnnouncerContainer() {
          let O = this.chart, y = q.createElement("div");
          return I(y, { "aria-hidden": !1, class: "highcharts-announcer-container" }), y.style.position = "relative", O.renderTo.insertBefore(y, O.renderTo.firstChild), O.announcerContainer = y, y;
        }
      };
    }), ot(i, "Accessibility/Components/AnnotationsA11y.js", [i["Accessibility/Utils/HTMLUtilities.js"]], function(U) {
      let { escapeStringForHTML: _, stripHTMLTagsFromString: K } = U;
      function Z(X) {
        return (X.annotations || []).reduce((I, O) => (O.options && O.options.visible !== !1 && (I = I.concat(O.labels)), I), []);
      }
      function J(X) {
        return X.options && X.options.accessibility && X.options.accessibility.description || X.graphic && X.graphic.text && X.graphic.text.textStr || "";
      }
      function q(X) {
        let I = X.options && X.options.accessibility && X.options.accessibility.description;
        if (I) return I;
        let O = X.chart, y = J(X), w = X.points, f = (n) => n.graphic && n.graphic.element && n.graphic.element.getAttribute("aria-label") || "", x = w.filter((n) => !!n.graphic).map((n) => {
          let a = n.accessibility && n.accessibility.valueDescription || f(n), v = n && n.series.name || "";
          return (v ? v + ", " : "") + "data point " + a;
        }).filter((n) => !!n), s = x.length, l = s > 1 ? "MultiplePoints" : s ? "SinglePoint" : "NoPoints", p = { annotationText: y, annotation: X, numPoints: s, annotationPoint: x[0], additionalAnnotationPoints: x.slice(1) };
        return O.langFormat("accessibility.screenReaderSection.annotations.description" + l, p);
      }
      function tt(X) {
        return Z(X).map((I) => {
          let O = _(K(q(I), X.renderer.forExport));
          return O ? `<li>${O}</li>` : "";
        });
      }
      return { getAnnotationsInfoHTML: function(X) {
        let I = X.annotations;
        return I && I.length ? `<ul style="list-style-type: none">${tt(X).join(" ")}</ul>` : "";
      }, getAnnotationLabelDescription: q, getAnnotationListItems: tt, getPointAnnotationTexts: function(X) {
        let I = Z(X.series.chart).filter((O) => O.points.indexOf(X) > -1);
        return I.length ? I.map((O) => `${J(O)}`) : [];
      } };
    }), ot(i, "Accessibility/Components/InfoRegionsComponent.js", [i["Accessibility/A11yI18n.js"], i["Accessibility/AccessibilityComponent.js"], i["Accessibility/Utils/Announcer.js"], i["Accessibility/Components/AnnotationsA11y.js"], i["Core/Renderer/HTML/AST.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Core/Templating.js"], i["Core/Globals.js"], i["Accessibility/Utils/HTMLUtilities.js"], i["Core/Utilities.js"]], function(U, _, K, Z, J, q, tt, X, I, O) {
      let { getAnnotationsInfoHTML: y } = Z, { getAxisDescription: w, getAxisRangeDescription: f, getChartTitle: x, unhideChartElementFromAT: s } = q, { format: l } = tt, { doc: p } = X, { addClass: n, getElement: a, getHeadingTagNameForElement: v, stripHTMLTagsFromString: N, visuallyHideElement: B } = I, { attr: T, pick: o, replaceNested: u } = O;
      function c(e) {
        return u(e, [/<([\w\-.:!]+)\b[^<>]*>\s*<\/\1>/g, ""]);
      }
      return class extends _ {
        constructor() {
          super(...arguments), this.screenReaderSections = {};
        }
        init() {
          let e = this.chart, t = this;
          this.initRegionsDefinitions(), this.addEvent(e, "aftergetTableAST", function(h) {
            t.onDataTableCreated(h);
          }), this.addEvent(e, "afterViewData", function(h) {
            h.wasHidden && (t.dataTableDiv = h.element, setTimeout(function() {
              t.focusDataTable();
            }, 300));
          }), this.addEvent(e, "afterHideData", function() {
            t.viewDataTableButton && t.viewDataTableButton.setAttribute("aria-expanded", "false");
          }), e.exporting && this.addEvent(e, "afterPrint", function() {
            t.updateAllScreenReaderSections();
          }), this.announcer = new K(e, "assertive");
        }
        initRegionsDefinitions() {
          let e = this, t = this.chart.options.accessibility;
          this.screenReaderSections = { before: { element: null, buildContent: function(h) {
            let b = t.screenReaderSection.beforeChartFormatter;
            return b ? b(h) : e.defaultBeforeChartFormatter(h);
          }, insertIntoDOM: function(h, b) {
            b.renderTo.insertBefore(h, b.renderTo.firstChild);
          }, afterInserted: function() {
            e.sonifyButtonId !== void 0 && e.initSonifyButton(e.sonifyButtonId), e.dataTableButtonId !== void 0 && e.initDataTableButton(e.dataTableButtonId);
          } }, after: { element: null, buildContent: function(h) {
            let b = t.screenReaderSection.afterChartFormatter;
            return b ? b(h) : e.defaultAfterChartFormatter();
          }, insertIntoDOM: function(h, b) {
            b.renderTo.insertBefore(h, b.container.nextSibling);
          }, afterInserted: function() {
            e.chart.accessibility && t.keyboardNavigation.enabled && e.chart.accessibility.keyboardNavigation.updateExitAnchor();
          } } };
        }
        onChartRender() {
          this.linkedDescriptionElement = this.getLinkedDescriptionElement(), this.setLinkedDescriptionAttrs(), this.updateAllScreenReaderSections();
        }
        updateAllScreenReaderSections() {
          let e = this;
          Object.keys(this.screenReaderSections).forEach(function(t) {
            e.updateScreenReaderSection(t);
          });
        }
        getLinkedDescriptionElement() {
          let e = this.chart.options.accessibility.linkedDescription;
          if (!e) return;
          if (typeof e != "string") return e;
          let t = l(e, this.chart), h = p.querySelectorAll(t);
          if (h.length === 1) return h[0];
        }
        setLinkedDescriptionAttrs() {
          let e = this.linkedDescriptionElement;
          e && (e.setAttribute("aria-hidden", "true"), n(e, "highcharts-linked-description"));
        }
        updateScreenReaderSection(e) {
          let t = this.chart, h = this.screenReaderSections[e], b = h.buildContent(t), r = h.element = h.element || this.createElement("div"), g = r.firstChild || this.createElement("div");
          b ? (this.setScreenReaderSectionAttribs(r, e), J.setElementHTML(g, b), r.appendChild(g), h.insertIntoDOM(r, t), t.styledMode ? n(g, "highcharts-visually-hidden") : B(g), s(t, g), h.afterInserted && h.afterInserted()) : (r.parentNode && r.parentNode.removeChild(r), h.element = null);
        }
        setScreenReaderSectionAttribs(e, t) {
          let h = this.chart, b = h.langFormat("accessibility.screenReaderSection." + t + "RegionLabel", { chart: h, chartTitle: x(h) });
          T(e, { id: `highcharts-screen-reader-region-${t}-${h.index}`, "aria-label": b || void 0 }), e.style.position = "relative", b && e.setAttribute("role", h.options.accessibility.landmarkVerbosity === "all" ? "region" : "group");
        }
        defaultBeforeChartFormatter() {
          let e = this.chart, t = e.options.accessibility.screenReaderSection.beforeChartFormat;
          if (!t) return "";
          let h = this.getAxesDescription(), b = e.sonify && e.options.sonification && e.options.sonification.enabled, r = "highcharts-a11y-sonify-data-btn-" + e.index, g = "hc-linkto-highcharts-data-table-" + e.index, d = y(e), M = e.langFormat("accessibility.screenReaderSection.annotations.heading", { chart: e }), H = { headingTagName: v(e.renderTo), chartTitle: x(e), typeDescription: this.getTypeDescriptionText(), chartSubtitle: this.getSubtitleText(), chartLongdesc: this.getLongdescText(), xAxisDescription: h.xAxis, yAxisDescription: h.yAxis, playAsSoundButton: b ? this.getSonifyButtonText(r) : "", viewTableButton: e.getCSV ? this.getDataTableButtonText(g) : "", annotationsTitle: d ? M : "", annotationsList: d }, A = U.i18nFormat(t, H, e);
          return this.dataTableButtonId = g, this.sonifyButtonId = r, c(A);
        }
        defaultAfterChartFormatter() {
          let e = this.chart, t = e.options.accessibility.screenReaderSection.afterChartFormat;
          if (!t) return "";
          let h = { endOfChartMarker: this.getEndOfChartMarkerText() };
          return c(U.i18nFormat(t, h, e));
        }
        getLinkedDescription() {
          let e = this.linkedDescriptionElement;
          return N(e && e.innerHTML || "", this.chart.renderer.forExport);
        }
        getLongdescText() {
          let e = this.chart.options, t = e.caption, h = t && t.text, b = this.getLinkedDescription();
          return e.accessibility.description || b || h || "";
        }
        getTypeDescriptionText() {
          let e = this.chart;
          return e.types ? e.options.accessibility.typeDescription || function(t, h) {
            let b = h[0], r = t.series && t.series[0] || {}, g = t.mapView && t.mapView.geoMap && t.mapView.geoMap.title, d = { numSeries: t.series.length, numPoints: r.points && r.points.length, chart: t, mapTitle: g };
            return b ? b === "map" || b === "tiledwebmap" ? d.mapTitle ? t.langFormat("accessibility.chartTypes.mapTypeDescription", d) : t.langFormat("accessibility.chartTypes.unknownMap", d) : t.types.length > 1 ? t.langFormat("accessibility.chartTypes.combinationChart", d) : function(M, H, A) {
              let D = H[0], W = M.langFormat("accessibility.seriesTypeDescriptions." + D, A), G = M.series && M.series.length < 2 ? "Single" : "Multiple";
              return (M.langFormat("accessibility.chartTypes." + D + G, A) || M.langFormat("accessibility.chartTypes.default" + G, A)) + (W ? " " + W : "");
            }(t, h, d) : t.langFormat("accessibility.chartTypes.emptyChart", d);
          }(e, e.types) : "";
        }
        getDataTableButtonText(e) {
          let t = this.chart;
          return '<button id="' + e + '">' + t.langFormat("accessibility.table.viewAsDataTableButtonText", { chart: t, chartTitle: x(t) }) + "</button>";
        }
        getSonifyButtonText(e) {
          let t = this.chart;
          return t.options.sonification && t.options.sonification.enabled === !1 ? "" : '<button id="' + e + '">' + t.langFormat("accessibility.sonification.playAsSoundButtonText", { chart: t, chartTitle: x(t) }) + "</button>";
        }
        getSubtitleText() {
          let e = this.chart.options.subtitle;
          return N(e && e.text || "", this.chart.renderer.forExport);
        }
        getEndOfChartMarkerText() {
          let e = a(`highcharts-end-of-chart-marker-${this.chart.index}`);
          if (e) return e.outerHTML;
          let t = this.chart, h = t.langFormat("accessibility.screenReaderSection.endOfChartMarker", { chart: t });
          return '<div id="highcharts-end-of-chart-marker-' + t.index + '">' + h + "</div>";
        }
        onDataTableCreated(e) {
          let t = this.chart;
          if (t.options.accessibility.enabled) {
            this.viewDataTableButton && this.viewDataTableButton.setAttribute("aria-expanded", "true");
            let h = e.tree.attributes || {};
            h.tabindex = -1, h.summary = t.langFormat("accessibility.table.tableSummary", { chart: t }), e.tree.attributes = h;
          }
        }
        focusDataTable() {
          let e = this.dataTableDiv, t = e && e.getElementsByTagName("table")[0];
          t && t.focus && t.focus();
        }
        initSonifyButton(e) {
          let t = this.sonifyButton = a(e), h = this.chart, b = (r) => {
            t && (t.setAttribute("aria-hidden", "true"), t.setAttribute("aria-label", "")), r.preventDefault(), r.stopPropagation();
            let g = h.langFormat("accessibility.sonification.playAsSoundClickAnnouncement", { chart: h });
            this.announcer.announce(g), setTimeout(() => {
              t && (t.removeAttribute("aria-hidden"), t.removeAttribute("aria-label")), h.sonify && h.sonify();
            }, 1e3);
          };
          t && h && (t.setAttribute("tabindex", -1), t.onclick = function(r) {
            (h.options.accessibility && h.options.accessibility.screenReaderSection.onPlayAsSoundClick || b).call(this, r, h);
          });
        }
        initDataTableButton(e) {
          let t = this.viewDataTableButton = a(e), h = this.chart, b = e.replace("hc-linkto-", "");
          t && (T(t, { tabindex: -1, "aria-expanded": !!a(b) }), t.onclick = h.options.accessibility.screenReaderSection.onViewDataTableClick || function() {
            h.viewData();
          });
        }
        getAxesDescription() {
          let e = this.chart, t = function(M, H) {
            let A = e[M];
            return A.length > 1 || A[0] && o(A[0].options.accessibility && A[0].options.accessibility.enabled, H);
          }, h = !!e.types && 0 > e.types.indexOf("map") && 0 > e.types.indexOf("treemap") && 0 > e.types.indexOf("tilemap"), b = !!e.hasCartesianSeries, r = t("xAxis", !e.angular && b && h), g = t("yAxis", b && h), d = {};
          return r && (d.xAxis = this.getAxisDescriptionText("xAxis")), g && (d.yAxis = this.getAxisDescriptionText("yAxis")), d;
        }
        getAxisDescriptionText(e) {
          let t = this.chart, h = t[e];
          return t.langFormat("accessibility.axis." + e + "Description" + (h.length > 1 ? "Plural" : "Singular"), { chart: t, names: h.map(function(b) {
            return w(b);
          }), ranges: h.map(function(b) {
            return f(b);
          }), numAxes: h.length });
        }
        destroy() {
          this.announcer && this.announcer.destroy();
        }
      };
    }), ot(i, "Accessibility/Components/MenuComponent.js", [i["Core/Utilities.js"], i["Accessibility/AccessibilityComponent.js"], i["Accessibility/KeyboardNavigationHandler.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Accessibility/Utils/HTMLUtilities.js"]], function(U, _, K, Z, J) {
      let { attr: q } = U, { getChartTitle: tt, unhideChartElementFromAT: X } = Z, { getFakeMouseEvent: I } = J;
      function O(w) {
        return w.exportSVGElements && w.exportSVGElements[0];
      }
      class y extends _ {
        init() {
          let f = this.chart, x = this;
          this.addEvent(f, "exportMenuShown", function() {
            x.onMenuShown();
          }), this.addEvent(f, "exportMenuHidden", function() {
            x.onMenuHidden();
          }), this.createProxyGroup();
        }
        onMenuHidden() {
          let f = this.chart.exportContextMenu;
          f && f.setAttribute("aria-hidden", "true"), this.setExportButtonExpandedState("false");
        }
        onMenuShown() {
          let f = this.chart, x = f.exportContextMenu;
          x && (this.addAccessibleContextMenuAttribs(), X(f, x)), this.setExportButtonExpandedState("true");
        }
        setExportButtonExpandedState(f) {
          this.exportButtonProxy && this.exportButtonProxy.innerElement.setAttribute("aria-expanded", f);
        }
        onChartRender() {
          let f = this.chart, x = f.focusElement, s = f.accessibility;
          this.proxyProvider.clearGroup("chartMenu"), this.proxyMenuButton(), this.exportButtonProxy && x && x === f.exportingGroup && (x.focusBorder ? f.setFocusToElement(x, this.exportButtonProxy.innerElement) : s && s.keyboardNavigation.tabindexContainer.focus());
        }
        proxyMenuButton() {
          let f = this.chart, x = this.proxyProvider, s = O(f);
          (function(l) {
            let p = l.options.exporting, n = O(l);
            return !!(p && p.enabled !== !1 && p.accessibility && p.accessibility.enabled && n && n.element);
          })(f) && s && (this.exportButtonProxy = x.addProxyElement("chartMenu", { click: s }, "button", { "aria-label": f.langFormat("accessibility.exporting.menuButtonLabel", { chart: f, chartTitle: tt(f) }), "aria-expanded": !1, title: f.options.lang.contextButtonTitle || null }));
        }
        createProxyGroup() {
          this.chart && this.proxyProvider && this.proxyProvider.addGroup("chartMenu");
        }
        addAccessibleContextMenuAttribs() {
          let f = this.chart, x = f.exportDivElements;
          if (x && x.length) {
            x.forEach((l) => {
              l && (l.tagName !== "LI" || l.children && l.children.length ? l.setAttribute("aria-hidden", "true") : l.setAttribute("tabindex", -1));
            });
            let s = x[0] && x[0].parentNode;
            s && q(s, { "aria-hidden": void 0, "aria-label": f.langFormat("accessibility.exporting.chartMenuLabel", { chart: f }), role: "list" });
          }
        }
        getKeyboardNavigation() {
          let f = this.keyCodes, x = this.chart, s = this;
          return new K(x, { keyCodeMap: [[[f.left, f.up], function() {
            return s.onKbdPrevious(this);
          }], [[f.right, f.down], function() {
            return s.onKbdNext(this);
          }], [[f.enter, f.space], function() {
            return s.onKbdClick(this);
          }]], validate: function() {
            return !!x.exporting && x.options.exporting.enabled !== !1 && x.options.exporting.accessibility.enabled !== !1;
          }, init: function() {
            let l = s.exportButtonProxy, p = s.chart.exportingGroup;
            l && p && x.setFocusToElement(p, l.innerElement);
          }, terminate: function() {
            x.hideExportMenu();
          } });
        }
        onKbdPrevious(f) {
          let x = this.chart, s = x.options.accessibility, l = f.response, p = x.highlightedExportItemIx || 0;
          for (; p--; ) if (x.highlightExportItem(p)) return l.success;
          return s.keyboardNavigation.wrapAround ? (x.highlightLastExportItem(), l.success) : l.prev;
        }
        onKbdNext(f) {
          let x = this.chart, s = x.options.accessibility, l = f.response;
          for (let p = (x.highlightedExportItemIx || 0) + 1; p < x.exportDivElements.length; ++p) if (x.highlightExportItem(p)) return l.success;
          return s.keyboardNavigation.wrapAround ? (x.highlightExportItem(0), l.success) : l.next;
        }
        onKbdClick(f) {
          let x = this.chart, s = x.exportDivElements[x.highlightedExportItemIx], l = O(x).element;
          return x.openMenu ? this.fakeClickEvent(s) : (this.fakeClickEvent(l), x.highlightExportItem(0)), f.response.success;
        }
      }
      return function(w) {
        function f() {
          let p = O(this);
          if (p) {
            let n = p.element;
            n.onclick && n.onclick(I("click"));
          }
        }
        function x() {
          let p = this.exportDivElements;
          p && this.exportContextMenu && this.openMenu && (p.forEach((n) => {
            n && n.className === "highcharts-menu-item" && n.onmouseout && n.onmouseout(I("mouseout"));
          }), this.highlightedExportItemIx = 0, this.exportContextMenu.hideMenu(), this.container.focus());
        }
        function s(p) {
          let n = this.exportDivElements && this.exportDivElements[p], a = this.exportDivElements && this.exportDivElements[this.highlightedExportItemIx];
          if (n && n.tagName === "LI" && !(n.children && n.children.length)) {
            let v = !!(this.renderTo.getElementsByTagName("g")[0] || {}).focus;
            return n.focus && v && n.focus(), a && a.onmouseout && a.onmouseout(I("mouseout")), n.onmouseover && n.onmouseover(I("mouseover")), this.highlightedExportItemIx = p, !0;
          }
          return !1;
        }
        function l() {
          if (this.exportDivElements) {
            let p = this.exportDivElements.length;
            for (; p--; ) if (this.highlightExportItem(p)) return !0;
          }
          return !1;
        }
        w.compose = function(p) {
          let n = p.prototype;
          n.hideExportMenu || (n.hideExportMenu = x, n.highlightExportItem = s, n.highlightLastExportItem = l, n.showExportMenu = f);
        };
      }(y || (y = {})), y;
    }), ot(i, "Accessibility/KeyboardNavigation.js", [i["Core/Globals.js"], i["Accessibility/Components/MenuComponent.js"], i["Core/Utilities.js"], i["Accessibility/Utils/EventProvider.js"], i["Accessibility/Utils/HTMLUtilities.js"]], function(U, _, K, Z, J) {
      let { doc: q, win: tt } = U, { addEvent: X, defined: I, fireEvent: O } = K, { getElement: y, simulatedEventTarget: w } = J;
      class f {
        constructor(s, l) {
          this.currentModuleIx = NaN, this.modules = [], this.init(s, l);
        }
        init(s, l) {
          let p = this.eventProvider = new Z();
          this.chart = s, this.components = l, this.modules = [], this.currentModuleIx = 0, this.update(), p.addEvent(this.tabindexContainer, "keydown", (n) => this.onKeydown(n)), p.addEvent(this.tabindexContainer, "focus", (n) => this.onFocus(n)), ["mouseup", "touchend"].forEach((n) => p.addEvent(q, n, (a) => this.onMouseUp(a))), ["mousedown", "touchstart"].forEach((n) => p.addEvent(s.renderTo, n, () => {
            this.isClickingChart = !0;
          }));
        }
        update(s) {
          let l = this.chart.options.accessibility, p = l && l.keyboardNavigation, n = this.components;
          this.updateContainerTabindex(), p && p.enabled && s && s.length ? (this.modules = s.reduce(function(a, v) {
            let N = n[v].getKeyboardNavigation();
            return a.concat(N);
          }, []), this.updateExitAnchor()) : (this.modules = [], this.currentModuleIx = 0, this.removeExitAnchor());
        }
        updateExitAnchor() {
          let s = y(`highcharts-end-of-chart-marker-${this.chart.index}`);
          this.removeExitAnchor(), s ? (this.makeElementAnExitAnchor(s), this.exitAnchor = s) : this.createExitAnchor();
        }
        move(s) {
          let l = this.modules && this.modules[this.currentModuleIx];
          l && l.terminate && l.terminate(s), this.chart.focusElement && this.chart.focusElement.removeFocusBorder(), this.currentModuleIx += s;
          let p = this.modules && this.modules[this.currentModuleIx];
          if (p) {
            if (p.validate && !p.validate()) return this.move(s);
            if (p.init) return p.init(s), !0;
          }
          return this.currentModuleIx = 0, this.exiting = !0, s > 0 ? this.exitAnchor && this.exitAnchor.focus() : this.tabindexContainer.focus(), !1;
        }
        onFocus(s) {
          let l = this.chart, p = s.relatedTarget && l.container.contains(s.relatedTarget), n = l.options.accessibility, a = n && n.keyboardNavigation;
          if (a && a.enabled && !this.exiting && !this.tabbingInBackwards && !this.isClickingChart && !p) {
            let v = this.getFirstValidModuleIx();
            v !== null && (this.currentModuleIx = v, this.modules[v].init(1));
          }
          this.keyboardReset = !1, this.exiting = !1;
        }
        onMouseUp(s) {
          if (delete this.isClickingChart, !this.keyboardReset && s.relatedTarget !== w) {
            let l = this.chart;
            if (!s.target || !l.container.contains(s.target)) {
              let p = this.modules && this.modules[this.currentModuleIx || 0];
              p && p.terminate && p.terminate(), this.currentModuleIx = 0;
            }
            l.focusElement && (l.focusElement.removeFocusBorder(), delete l.focusElement), this.keyboardReset = !0;
          }
        }
        onKeydown(s) {
          let l, p = s || tt.event, n = this.modules && this.modules.length && this.modules[this.currentModuleIx], a = p.target;
          if ((!a || a.nodeName !== "INPUT" || a.classList.contains("highcharts-a11y-proxy-element")) && (this.keyboardReset = !1, this.exiting = !1, n)) {
            let v = n.run(p);
            v === n.response.success ? l = !0 : v === n.response.prev ? l = this.move(-1) : v === n.response.next && (l = this.move(1)), l && (p.preventDefault(), p.stopPropagation());
          }
        }
        updateContainerTabindex() {
          let s, l = this.chart.options.accessibility, p = l && l.keyboardNavigation, n = !(p && p.enabled === !1), a = this.chart, v = a.container;
          a.renderTo.hasAttribute("tabindex") ? (v.removeAttribute("tabindex"), s = a.renderTo) : s = v, this.tabindexContainer = s;
          let N = s.getAttribute("tabindex");
          n && !N ? s.setAttribute("tabindex", "0") : n || a.container.removeAttribute("tabindex");
        }
        createExitAnchor() {
          let s = this.chart, l = this.exitAnchor = q.createElement("div");
          s.renderTo.appendChild(l), this.makeElementAnExitAnchor(l);
        }
        makeElementAnExitAnchor(s) {
          let l = this.tabindexContainer.getAttribute("tabindex") || 0;
          s.setAttribute("class", "highcharts-exit-anchor"), s.setAttribute("tabindex", l), s.setAttribute("aria-hidden", !1), this.addExitAnchorEventsToEl(s);
        }
        removeExitAnchor() {
          if (this.exitAnchor) {
            let s = this.eventProvider.eventRemovers.find((l) => l.element === this.exitAnchor);
            s && I(s.remover) && this.eventProvider.removeEvent(s.remover), this.exitAnchor.parentNode && this.exitAnchor.parentNode.removeChild(this.exitAnchor), delete this.exitAnchor;
          }
        }
        addExitAnchorEventsToEl(s) {
          let l = this.chart, p = this;
          this.eventProvider.addEvent(s, "focus", function(n) {
            let a = n || tt.event, v = !(a.relatedTarget && l.container.contains(a.relatedTarget) || p.exiting);
            if (l.focusElement && delete l.focusElement, v) {
              if (p.tabbingInBackwards = !0, p.tabindexContainer.focus(), delete p.tabbingInBackwards, a.preventDefault(), p.modules && p.modules.length) {
                p.currentModuleIx = p.modules.length - 1;
                let N = p.modules[p.currentModuleIx];
                N && N.validate && !N.validate() ? p.move(-1) : N && N.init(-1);
              }
            } else p.exiting = !1;
          });
        }
        getFirstValidModuleIx() {
          let s = this.modules.length;
          for (let l = 0; l < s; ++l) {
            let p = this.modules[l];
            if (!p.validate || p.validate()) return l;
          }
          return null;
        }
        destroy() {
          this.removeExitAnchor(), this.eventProvider.removeAddedEvents(), this.chart.container.removeAttribute("tabindex");
        }
      }
      return function(x) {
        function s() {
          let p = this;
          O(this, "dismissPopupContent", {}, function() {
            p.tooltip && p.tooltip.hide(0), p.hideExportMenu();
          });
        }
        function l(p) {
          (p.which || p.keyCode) === 27 && U.charts && U.charts.forEach((n) => {
            n && n.dismissPopupContent && n.dismissPopupContent();
          });
        }
        x.compose = function(p) {
          _.compose(p);
          let n = p.prototype;
          return n.dismissPopupContent || (n.dismissPopupContent = s, X(q, "keydown", l)), p;
        };
      }(f || (f = {})), f;
    }), ot(i, "Accessibility/Components/LegendComponent.js", [i["Core/Animation/AnimationUtilities.js"], i["Core/Globals.js"], i["Core/Legend/Legend.js"], i["Core/Utilities.js"], i["Accessibility/AccessibilityComponent.js"], i["Accessibility/KeyboardNavigationHandler.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Accessibility/Utils/HTMLUtilities.js"]], function(U, _, K, Z, J, q, tt, X) {
      let { animObject: I } = U, { doc: O } = _, { addEvent: y, fireEvent: w, isNumber: f, pick: x, syncTimeout: s } = Z, { getChartTitle: l } = tt, { stripHTMLTagsFromString: p, addClass: n, removeClass: a } = X;
      function v(T) {
        let o = T.legend && T.legend.allItems, u = T.options.legend.accessibility || {}, c = T.colorAxis && T.colorAxis.some((e) => !e.dataClasses || !e.dataClasses.length);
        return !!(o && o.length && !c && u.enabled !== !1);
      }
      function N(T, o) {
        let u = o.legendItem || {};
        for (let c of (o.setState(T ? "hover" : "", !0), ["group", "label", "symbol"])) {
          let e = u[c], t = e && e.element || e;
          t && w(t, T ? "mouseover" : "mouseout");
        }
      }
      class B extends J {
        constructor() {
          super(...arguments), this.highlightedLegendItemIx = NaN, this.proxyGroup = null;
        }
        init() {
          let o = this;
          this.recreateProxies(), this.addEvent(K, "afterScroll", function() {
            this.chart === o.chart && (o.proxyProvider.updateGroupProxyElementPositions("legend"), o.updateLegendItemProxyVisibility(), o.highlightedLegendItemIx > -1 && this.chart.highlightLegendItem(o.highlightedLegendItemIx));
          }), this.addEvent(K, "afterPositionItem", function(u) {
            this.chart === o.chart && this.chart.renderer && o.updateProxyPositionForItem(u.item);
          }), this.addEvent(K, "afterRender", function() {
            this.chart === o.chart && this.chart.renderer && o.recreateProxies() && s(() => o.proxyProvider.updateGroupProxyElementPositions("legend"), I(x(this.chart.renderer.globalAnimation, !0)).duration);
          });
        }
        updateLegendItemProxyVisibility() {
          let o, u = this.chart, c = u.legend, e = c.allItems || [], t = c.currentPage || 1, h = c.clipHeight || 0;
          e.forEach((b) => {
            if (b.a11yProxyElement) {
              let r = c.pages && c.pages.length, g = b.a11yProxyElement.element, d = !1;
              if (o = b.legendItem || {}, r) {
                let M = o.pageIx || 0;
                d = (o.y || 0) + (o.label ? Math.round(o.label.getBBox().height) : 0) - c.pages[M] > h || M !== t - 1;
              }
              d ? u.styledMode ? n(g, "highcharts-a11y-invisible") : g.style.visibility = "hidden" : (a(g, "highcharts-a11y-invisible"), g.style.visibility = "");
            }
          });
        }
        onChartRender() {
          v(this.chart) || this.removeProxies();
        }
        highlightAdjacentLegendPage(o) {
          let u = this.chart, c = u.legend, e = (c.currentPage || 1) + o, t = c.pages || [];
          if (e > 0 && e <= t.length) {
            let h = 0;
            for (let b of c.allItems) ((b.legendItem || {}).pageIx || 0) + 1 === e && u.highlightLegendItem(h) && (this.highlightedLegendItemIx = h), ++h;
          }
        }
        updateProxyPositionForItem(o) {
          o.a11yProxyElement && o.a11yProxyElement.refreshPosition();
        }
        recreateProxies() {
          let o = O.activeElement, u = this.proxyGroup, c = o && u && u.contains(o);
          return this.removeProxies(), !!v(this.chart) && (this.addLegendProxyGroup(), this.proxyLegendItems(), this.updateLegendItemProxyVisibility(), this.updateLegendTitle(), c && this.chart.highlightLegendItem(this.highlightedLegendItemIx), !0);
        }
        removeProxies() {
          this.proxyProvider.removeGroup("legend");
        }
        updateLegendTitle() {
          let o = this.chart, u = p((o.legend && o.legend.options.title && o.legend.options.title.text || "").replace(/<br ?\/?>/g, " "), o.renderer.forExport), c = o.langFormat("accessibility.legend.legendLabel" + (u ? "" : "NoTitle"), { chart: o, legendTitle: u, chartTitle: l(o) });
          this.proxyProvider.updateGroupAttrs("legend", { "aria-label": c });
        }
        addLegendProxyGroup() {
          let o = this.chart.options.accessibility.landmarkVerbosity === "all" ? "region" : null;
          this.proxyGroup = this.proxyProvider.addGroup("legend", "ul", { "aria-label": "_placeholder_", role: o });
        }
        proxyLegendItems() {
          let o, u = this;
          ((this.chart.legend || {}).allItems || []).forEach((c) => {
            (o = c.legendItem || {}).label && o.label.element && u.proxyLegendItem(c);
          });
        }
        proxyLegendItem(o) {
          let u = o.legendItem || {};
          if (!u.label || !u.group) return;
          let c = this.chart.langFormat("accessibility.legend.legendItem", { chart: this.chart, itemName: p(o.name, this.chart.renderer.forExport), item: o }), e = { tabindex: -1, "aria-pressed": o.visible, "aria-label": c }, t = u.group.div ? u.label : u.group;
          o.a11yProxyElement = this.proxyProvider.addProxyElement("legend", { click: u.label, visual: t.element }, "button", e);
        }
        getKeyboardNavigation() {
          let o = this.keyCodes, u = this, c = this.chart;
          return new q(c, { keyCodeMap: [[[o.left, o.right, o.up, o.down], function(e) {
            return u.onKbdArrowKey(this, e);
          }], [[o.enter, o.space], function() {
            return u.onKbdClick(this);
          }], [[o.pageDown, o.pageUp], function(e) {
            let t = e === o.pageDown ? 1 : -1;
            return u.highlightAdjacentLegendPage(t), this.response.success;
          }]], validate: function() {
            return u.shouldHaveLegendNavigation();
          }, init: function() {
            c.highlightLegendItem(0), u.highlightedLegendItemIx = 0;
          }, terminate: function() {
            u.highlightedLegendItemIx = -1, c.legend.allItems.forEach((e) => N(!1, e));
          } });
        }
        onKbdArrowKey(o, u) {
          let { keyCodes: { left: c, up: e }, highlightedLegendItemIx: t, chart: h } = this, b = h.legend.allItems.length, r = h.options.accessibility.keyboardNavigation.wrapAround, g = u === c || u === e ? -1 : 1;
          return h.highlightLegendItem(t + g) ? this.highlightedLegendItemIx += g : r && b > 1 && (this.highlightedLegendItemIx = g > 0 ? 0 : b - 1, h.highlightLegendItem(this.highlightedLegendItemIx)), o.response.success;
        }
        onKbdClick(o) {
          let u = this.chart.legend.allItems[this.highlightedLegendItemIx];
          return u && u.a11yProxyElement && u.a11yProxyElement.click(), o.response.success;
        }
        shouldHaveLegendNavigation() {
          if (!v(this.chart)) return !1;
          let o = this.chart, u = (o.options.legend || {}).accessibility || {};
          return !!(o.legend.display && u.keyboardNavigation && u.keyboardNavigation.enabled);
        }
        destroy() {
          this.removeProxies();
        }
      }
      return function(T) {
        function o(c) {
          let e = this.legend.allItems, t = this.accessibility && this.accessibility.components.legend.highlightedLegendItemIx, h = e[c], b = (h == null ? void 0 : h.legendItem) || {};
          if (h) {
            f(t) && e[t] && N(!1, e[t]), function(d, M) {
              let H = (d.allItems[M].legendItem || {}).pageIx, A = d.currentPage;
              H !== void 0 && H + 1 !== A && d.scroll(1 + H - A);
            }(this.legend, c);
            let r = b.label, g = h.a11yProxyElement && h.a11yProxyElement.innerElement;
            return r && r.element && g && this.setFocusToElement(r, g), N(!0, h), !0;
          }
          return !1;
        }
        function u(c) {
          let e = this.chart.options.accessibility, t = c.item;
          e.enabled && t && t.a11yProxyElement && t.a11yProxyElement.innerElement.setAttribute("aria-pressed", c.visible ? "true" : "false");
        }
        T.compose = function(c, e) {
          let t = c.prototype;
          t.highlightLegendItem || (t.highlightLegendItem = o, y(e, "afterColorizeItem", u));
        };
      }(B || (B = {})), B;
    }), ot(i, "Stock/Navigator/ChartNavigatorComposition.js", [i["Core/Globals.js"], i["Core/Utilities.js"]], function(U, _) {
      let K, { isTouchDevice: Z } = U, { addEvent: J, merge: q, pick: tt } = _, X = [];
      function I() {
        this.navigator && this.navigator.setBaseSeries(null, !1);
      }
      function O() {
        var N;
        let l, p, n, a = this.legend, v = this.navigator;
        if (v) {
          l = a && a.options, p = v.xAxis, n = v.yAxis;
          let { scrollbarHeight: B, scrollButtonSize: T } = v;
          this.inverted ? (v.left = v.opposite ? this.chartWidth - B - v.height : this.spacing[3] + B, v.top = this.plotTop + T) : (v.left = tt(p.left, this.plotLeft + T), v.top = v.navigatorOptions.top || this.chartHeight - v.height - B - (((N = this.scrollbar) == null ? void 0 : N.options.margin) || 0) - this.spacing[2] - (this.rangeSelector && this.extraBottomMargin ? this.rangeSelector.getHeight() : 0) - (l && l.verticalAlign === "bottom" && l.layout !== "proximate" && l.enabled && !l.floating ? a.legendHeight + tt(l.margin, 10) : 0) - (this.titleOffset ? this.titleOffset[2] : 0)), p && n && (this.inverted ? p.options.left = n.options.left = v.left : p.options.top = n.options.top = v.top, p.setAxisSize(), n.setAxisSize());
        }
      }
      function y(l) {
        !this.navigator && !this.scroller && (this.options.navigator.enabled || this.options.scrollbar.enabled) && (this.scroller = this.navigator = new K(this), tt(l.redraw, !0) && this.redraw(l.animation));
      }
      function w() {
        let l = this.options;
        (l.navigator.enabled || l.scrollbar.enabled) && (this.scroller = this.navigator = new K(this));
      }
      function f() {
        let l = this.options, p = l.navigator, n = l.rangeSelector;
        if ((p && p.enabled || n && n.enabled) && (!Z && this.zooming.type === "x" || Z && this.zooming.pinchType === "x")) return !1;
      }
      function x(l) {
        let p = l.navigator;
        if (p && l.xAxis[0]) {
          let n = l.xAxis[0].getExtremes();
          p.render(n.min, n.max);
        }
      }
      function s(l) {
        let p = l.options.navigator || {}, n = l.options.scrollbar || {};
        !this.navigator && !this.scroller && (p.enabled || n.enabled) && (q(!0, this.options.navigator, p), q(!0, this.options.scrollbar, n), delete l.options.navigator, delete l.options.scrollbar);
      }
      return { compose: function(l, p) {
        if (_.pushUnique(X, l)) {
          let n = l.prototype;
          K = p, n.callbacks.push(x), J(l, "afterAddSeries", I), J(l, "afterSetChartSize", O), J(l, "afterUpdate", y), J(l, "beforeRender", w), J(l, "beforeShowResetZoom", f), J(l, "update", s);
        }
      } };
    }), ot(i, "Core/Axis/NavigatorAxisComposition.js", [i["Core/Globals.js"], i["Core/Utilities.js"]], function(U, _) {
      let { isTouchDevice: K } = U, { addEvent: Z, correctFloat: J, defined: q, isNumber: tt, pick: X } = _;
      function I() {
        this.navigatorAxis || (this.navigatorAxis = new y(this));
      }
      function O(w) {
        let f, x = this.chart, s = x.options, l = s.navigator, p = this.navigatorAxis, n = x.zooming.pinchType, a = s.rangeSelector, v = x.zooming.type;
        if (this.isXAxis && (l != null && l.enabled || a != null && a.enabled)) {
          if (v === "y" && w.trigger === "zoom") f = !1;
          else if ((w.trigger === "zoom" && v === "xy" || K && n === "xy") && this.options.range) {
            let N = p.previousZoom;
            q(w.min) ? p.previousZoom = [this.min, this.max] : N && (w.min = N[0], w.max = N[1], p.previousZoom = void 0);
          }
        }
        f !== void 0 && w.preventDefault();
      }
      class y {
        static compose(f) {
          f.keepProps.includes("navigatorAxis") || (f.keepProps.push("navigatorAxis"), Z(f, "init", I), Z(f, "setExtremes", O));
        }
        constructor(f) {
          this.axis = f;
        }
        destroy() {
          this.axis = void 0;
        }
        toFixedRange(f, x, s, l) {
          let p = this.axis, n = (p.pointRange || 0) / 2, a = X(s, p.translate(f, !0, !p.horiz)), v = X(l, p.translate(x, !0, !p.horiz));
          return q(s) || (a = J(a + n)), q(l) || (v = J(v - n)), tt(a) && tt(v) || (a = v = void 0), { min: a, max: v };
        }
      }
      return y;
    }), ot(i, "Stock/Navigator/NavigatorDefaults.js", [i["Core/Color/Color.js"], i["Core/Series/SeriesRegistry.js"]], function(U, _) {
      let { parse: K } = U, { seriesTypes: Z } = _;
      return { height: 40, margin: 25, maskInside: !0, handles: { width: 7, borderRadius: 0, height: 15, symbols: ["navigator-handle", "navigator-handle"], enabled: !0, lineWidth: 1, backgroundColor: "#f2f2f2", borderColor: "#999999" }, maskFill: K("#667aff").setOpacity(0.3).get(), outlineColor: "#999999", outlineWidth: 1, series: { type: Z.areaspline === void 0 ? "line" : "areaspline", fillOpacity: 0.05, lineWidth: 1, compare: null, sonification: { enabled: !1 }, dataGrouping: { approximation: "average", enabled: !0, groupPixelWidth: 2, firstAnchor: "firstPoint", anchor: "middle", lastAnchor: "lastPoint", units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2, 3, 4]], ["week", [1, 2, 3]], ["month", [1, 3, 6]], ["year", null]] }, dataLabels: { enabled: !1, zIndex: 2 }, id: "highcharts-navigator-series", className: "highcharts-navigator-series", lineColor: null, marker: { enabled: !1 }, threshold: null }, xAxis: { className: "highcharts-navigator-xaxis", tickLength: 0, lineWidth: 0, gridLineColor: "#e6e6e6", id: "navigator-x-axis", gridLineWidth: 1, tickPixelInterval: 200, labels: { align: "left", style: { color: "#000000", fontSize: "0.7em", opacity: 0.6, textOutline: "2px contrast" }, x: 3, y: -4 }, crosshair: !1 }, yAxis: { className: "highcharts-navigator-yaxis", gridLineWidth: 0, startOnTick: !1, endOnTick: !1, minPadding: 0.1, id: "navigator-y-axis", maxPadding: 0.1, labels: { enabled: !1 }, crosshair: !1, title: { text: null }, tickLength: 0, tickWidth: 0 } };
    }), ot(i, "Stock/Navigator/NavigatorSymbols.js", [i["Core/Renderer/SVG/Symbols.js"], i["Core/Utilities.js"]], function(U, _) {
      let { relativeLength: K } = _;
      return { "navigator-handle": function(Z, J, q, tt, X = {}) {
        let I = X.width ? X.width / 2 : q, O = K(X.borderRadius || 0, Math.min(2 * I, tt));
        return [["M", -1.5, (tt = X.height || tt) / 2 - 3.5], ["L", -1.5, tt / 2 + 4.5], ["M", 0.5, tt / 2 - 3.5], ["L", 0.5, tt / 2 + 4.5], ...U.rect(-I - 1, 0.5, 2 * I + 1, tt, { r: O })];
      } };
    }), ot(i, "Stock/Utilities/StockUtilities.js", [i["Core/Utilities.js"]], function(U) {
      let { defined: _ } = U;
      return { setFixedRange: function(K) {
        let Z = this.xAxis[0];
        _(Z.dataMax) && _(Z.dataMin) && K ? this.fixedRange = Math.min(K, Z.dataMax - Z.dataMin) : this.fixedRange = K;
      } };
    }), ot(i, "Stock/Navigator/NavigatorComposition.js", [i["Core/Defaults.js"], i["Core/Globals.js"], i["Core/Axis/NavigatorAxisComposition.js"], i["Stock/Navigator/NavigatorDefaults.js"], i["Stock/Navigator/NavigatorSymbols.js"], i["Core/Renderer/RendererRegistry.js"], i["Stock/Utilities/StockUtilities.js"], i["Core/Utilities.js"]], function(U, _, K, Z, J, q, tt, X) {
      let { setOptions: I } = U, { composed: O } = _, { getRendererType: y } = q, { setFixedRange: w } = tt, { addEvent: f, extend: x, pushUnique: s } = X;
      function l() {
        this.chart.navigator && !this.options.isInternal && this.chart.navigator.setBaseSeries(null, !1);
      }
      return { compose: function(p, n, a) {
        K.compose(n), s(O, "Navigator") && (p.prototype.setFixedRange = w, x(y().prototype.symbols, J), f(a, "afterUpdate", l), I({ navigator: Z }));
      } };
    }), ot(i, "Core/Axis/ScrollbarAxis.js", [i["Core/Globals.js"], i["Core/Utilities.js"]], function(U, _) {
      var K;
      let { composed: Z } = U, { addEvent: J, defined: q, pick: tt, pushUnique: X } = _;
      return function(I) {
        let O;
        function y(s) {
          let l = tt(s.options && s.options.min, s.min), p = tt(s.options && s.options.max, s.max);
          return { axisMin: l, axisMax: p, scrollMin: q(s.dataMin) ? Math.min(l, s.min, s.dataMin, tt(s.threshold, 1 / 0)) : l, scrollMax: q(s.dataMax) ? Math.max(p, s.max, s.dataMax, tt(s.threshold, -1 / 0)) : p };
        }
        function w() {
          let s = this.scrollbar, l = s && !s.options.opposite, p = this.horiz ? 2 : l ? 3 : 1;
          s && (this.chart.scrollbarsOffsets = [0, 0], this.chart.axisOffset[p] += s.size + (s.options.margin || 0));
        }
        function f() {
          let s = this;
          s.options && s.options.scrollbar && s.options.scrollbar.enabled && (s.options.scrollbar.vertical = !s.horiz, s.options.startOnTick = s.options.endOnTick = !1, s.scrollbar = new O(s.chart.renderer, s.options.scrollbar, s.chart), J(s.scrollbar, "changed", function(l) {
            let p, n, { axisMin: a, axisMax: v, scrollMin: N, scrollMax: B } = y(s), T = B - N;
            if (q(a) && q(v))
              if (s.horiz && !s.reversed || !s.horiz && s.reversed ? (p = N + T * this.to, n = N + T * this.from) : (p = N + T * (1 - this.from), n = N + T * (1 - this.to)), this.shouldUpdateExtremes(l.DOMType)) {
                let o = l.DOMType !== "mousemove" && l.DOMType !== "touchmove" && void 0;
                s.setExtremes(n, p, !0, o, l);
              } else this.setRange(this.from, this.to);
          }));
        }
        function x() {
          let s, l, p, { scrollMin: n, scrollMax: a } = y(this), v = this.scrollbar, N = this.axisTitleMargin + (this.titleOffset || 0), B = this.chart.scrollbarsOffsets, T = this.options.margin || 0;
          if (v && B) {
            if (this.horiz) this.opposite || (B[1] += N), v.position(this.left, this.top + this.height + 2 + B[1] - (this.opposite ? T : 0), this.width, this.height), this.opposite || (B[1] += T), s = 1;
            else {
              let o;
              this.opposite && (B[0] += N), o = v.options.opposite ? this.left + this.width + 2 + B[0] - (this.opposite ? 0 : T) : this.opposite ? 0 : T, v.position(o, this.top, this.width, this.height), this.opposite && (B[0] += T), s = 0;
            }
            if (B[s] += v.size + (v.options.margin || 0), isNaN(n) || isNaN(a) || !q(this.min) || !q(this.max) || this.dataMin === this.dataMax) v.setRange(0, 1);
            else if (this.min === this.max) {
              let o = this.pointRange / (this.dataMax + 1);
              l = o * this.min, p = o * (this.max + 1), v.setRange(l, p);
            } else l = (this.min - n) / (a - n), p = (this.max - n) / (a - n), this.horiz && !this.reversed || !this.horiz && this.reversed ? v.setRange(l, p) : v.setRange(1 - p, 1 - l);
          }
        }
        I.compose = function(s, l) {
          X(Z, "Axis.Scrollbar") && (O = l, J(s, "afterGetOffset", w), J(s, "afterInit", f), J(s, "afterRender", x));
        };
      }(K || (K = {})), K;
    }), ot(i, "Stock/Scrollbar/ScrollbarDefaults.js", [], function() {
      return { height: 10, barBorderRadius: 5, buttonBorderRadius: 0, buttonsEnabled: !1, liveRedraw: void 0, margin: void 0, minWidth: 6, opposite: !0, step: 0.2, zIndex: 3, barBackgroundColor: "#cccccc", barBorderWidth: 0, barBorderColor: "#cccccc", buttonArrowColor: "#333333", buttonBackgroundColor: "#e6e6e6", buttonBorderColor: "#cccccc", buttonBorderWidth: 1, rifleColor: "none", trackBackgroundColor: "rgba(255, 255, 255, 0.001)", trackBorderColor: "#cccccc", trackBorderRadius: 5, trackBorderWidth: 1 };
    }), ot(i, "Stock/Scrollbar/Scrollbar.js", [i["Core/Defaults.js"], i["Core/Globals.js"], i["Core/Axis/ScrollbarAxis.js"], i["Stock/Scrollbar/ScrollbarDefaults.js"], i["Core/Utilities.js"]], function(U, _, K, Z, J) {
      let { defaultOptions: q } = U, { addEvent: tt, correctFloat: X, crisp: I, defined: O, destroyObjectProperties: y, fireEvent: w, merge: f, pick: x, removeEvent: s } = J;
      class l {
        static compose(n) {
          K.compose(n, l);
        }
        static swapXY(n, a) {
          return a && n.forEach((v) => {
            let N, B = v.length;
            for (let T = 0; T < B; T += 2) typeof (N = v[T + 1]) == "number" && (v[T + 1] = v[T + 2], v[T + 2] = N);
          }), n;
        }
        constructor(n, a, v) {
          this._events = [], this.chartX = 0, this.chartY = 0, this.from = 0, this.scrollbarButtons = [], this.scrollbarLeft = 0, this.scrollbarStrokeWidth = 1, this.scrollbarTop = 0, this.size = 0, this.to = 0, this.trackBorderWidth = 1, this.x = 0, this.y = 0, this.init(n, a, v);
        }
        addEvents() {
          let n = this.options.inverted ? [1, 0] : [0, 1], a = this.scrollbarButtons, v = this.scrollbarGroup.element, N = this.track.element, B = this.mouseDownHandler.bind(this), T = this.mouseMoveHandler.bind(this), o = this.mouseUpHandler.bind(this), u = [[a[n[0]].element, "click", this.buttonToMinClick.bind(this)], [a[n[1]].element, "click", this.buttonToMaxClick.bind(this)], [N, "click", this.trackClick.bind(this)], [v, "mousedown", B], [v.ownerDocument, "mousemove", T], [v.ownerDocument, "mouseup", o], [v, "touchstart", B], [v.ownerDocument, "touchmove", T], [v.ownerDocument, "touchend", o]];
          u.forEach(function(c) {
            tt.apply(null, c);
          }), this._events = u;
        }
        buttonToMaxClick(n) {
          let a = (this.to - this.from) * x(this.options.step, 0.2);
          this.updatePosition(this.from + a, this.to + a), w(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: n });
        }
        buttonToMinClick(n) {
          let a = X(this.to - this.from) * x(this.options.step, 0.2);
          this.updatePosition(X(this.from - a), X(this.to - a)), w(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: n });
        }
        cursorToScrollbarPosition(n) {
          let a = this.options, v = a.minWidth > this.calculatedWidth ? a.minWidth : 0;
          return { chartX: (n.chartX - this.x - this.xOffset) / (this.barWidth - v), chartY: (n.chartY - this.y - this.yOffset) / (this.barWidth - v) };
        }
        destroy() {
          let n = this, a = n.chart.scroller;
          n.removeEvents(), ["track", "scrollbarRifles", "scrollbar", "scrollbarGroup", "group"].forEach(function(v) {
            n[v] && n[v].destroy && (n[v] = n[v].destroy());
          }), a && n === a.scrollbar && (a.scrollbar = null, y(a.scrollbarButtons));
        }
        drawScrollbarButton(n) {
          let a = this.renderer, v = this.scrollbarButtons, N = this.options, B = this.size, T = a.g().add(this.group);
          if (v.push(T), N.buttonsEnabled) {
            let o = a.rect().addClass("highcharts-scrollbar-button").add(T);
            this.chart.styledMode || o.attr({ stroke: N.buttonBorderColor, "stroke-width": N.buttonBorderWidth, fill: N.buttonBackgroundColor }), o.attr(o.crisp({ x: -0.5, y: -0.5, width: B, height: B, r: N.buttonBorderRadius }, o.strokeWidth()));
            let u = a.path(l.swapXY([["M", B / 2 + (n ? -1 : 1), B / 2 - 3], ["L", B / 2 + (n ? -1 : 1), B / 2 + 3], ["L", B / 2 + (n ? 2 : -2), B / 2]], N.vertical)).addClass("highcharts-scrollbar-arrow").add(v[n]);
            this.chart.styledMode || u.attr({ fill: N.buttonArrowColor });
          }
        }
        init(n, a, v) {
          this.scrollbarButtons = [], this.renderer = n, this.userOptions = a, this.options = f(Z, q.scrollbar, a), this.options.margin = x(this.options.margin, 10), this.chart = v, this.size = x(this.options.size, this.options.height), a.enabled && (this.render(), this.addEvents());
        }
        mouseDownHandler(n) {
          var N;
          let a = ((N = this.chart.pointer) == null ? void 0 : N.normalize(n)) || n, v = this.cursorToScrollbarPosition(a);
          this.chartX = v.chartX, this.chartY = v.chartY, this.initPositions = [this.from, this.to], this.grabbedCenter = !0;
        }
        mouseMoveHandler(n) {
          var T;
          let a, v = ((T = this.chart.pointer) == null ? void 0 : T.normalize(n)) || n, N = this.options.vertical ? "chartY" : "chartX", B = this.initPositions || [];
          this.grabbedCenter && (!n.touches || n.touches[0][N] !== 0) && (a = this.cursorToScrollbarPosition(v)[N] - this[N], this.hasDragged = !0, this.updatePosition(B[0] + a, B[1] + a), this.hasDragged && w(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: n.type, DOMEvent: n }));
        }
        mouseUpHandler(n) {
          this.hasDragged && w(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMType: n.type, DOMEvent: n }), this.grabbedCenter = this.hasDragged = this.chartX = this.chartY = null;
        }
        position(n, a, v, N) {
          let { buttonsEnabled: B, margin: T = 0, vertical: o } = this.options, u = this.rendered ? "animate" : "attr", c = N, e = 0;
          this.group.show(), this.x = n, this.y = a + this.trackBorderWidth, this.width = v, this.height = N, this.xOffset = c, this.yOffset = e, o ? (this.width = this.yOffset = v = e = this.size, this.xOffset = c = 0, this.yOffset = e = B ? this.size : 0, this.barWidth = N - (B ? 2 * v : 0), this.x = n += T) : (this.height = N = this.size, this.xOffset = c = B ? this.size : 0, this.barWidth = v - (B ? 2 * N : 0), this.y = this.y + T), this.group[u]({ translateX: n, translateY: this.y }), this.track[u]({ width: v, height: N }), this.scrollbarButtons[1][u]({ translateX: o ? 0 : v - c, translateY: o ? N - e : 0 });
        }
        removeEvents() {
          this._events.forEach(function(n) {
            s.apply(null, n);
          }), this._events.length = 0;
        }
        render() {
          let n = this.renderer, a = this.options, v = this.size, N = this.chart.styledMode, B = n.g("scrollbar").attr({ zIndex: a.zIndex }).hide().add();
          this.group = B, this.track = n.rect().addClass("highcharts-scrollbar-track").attr({ r: a.trackBorderRadius || 0, height: v, width: v }).add(B), N || this.track.attr({ fill: a.trackBackgroundColor, stroke: a.trackBorderColor, "stroke-width": a.trackBorderWidth });
          let T = this.trackBorderWidth = this.track.strokeWidth();
          this.track.attr({ x: -I(0, T), y: -I(0, T) }), this.scrollbarGroup = n.g().add(B), this.scrollbar = n.rect().addClass("highcharts-scrollbar-thumb").attr({ height: v - T, width: v - T, r: a.barBorderRadius || 0 }).add(this.scrollbarGroup), this.scrollbarRifles = n.path(l.swapXY([["M", -3, v / 4], ["L", -3, 2 * v / 3], ["M", 0, v / 4], ["L", 0, 2 * v / 3], ["M", 3, v / 4], ["L", 3, 2 * v / 3]], a.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup), N || (this.scrollbar.attr({ fill: a.barBackgroundColor, stroke: a.barBorderColor, "stroke-width": a.barBorderWidth }), this.scrollbarRifles.attr({ stroke: a.rifleColor, "stroke-width": 1 })), this.scrollbarStrokeWidth = this.scrollbar.strokeWidth(), this.scrollbarGroup.translate(-I(0, this.scrollbarStrokeWidth), -I(0, this.scrollbarStrokeWidth)), this.drawScrollbarButton(0), this.drawScrollbarButton(1);
        }
        setRange(n, a) {
          let v, N, B = this.options, T = B.vertical, o = B.minWidth, u = this.barWidth, c = !this.rendered || this.hasDragged || this.chart.navigator && this.chart.navigator.hasDragged ? "attr" : "animate";
          if (!O(u)) return;
          let e = u * Math.min(a, 1);
          v = Math.ceil(u * (n = Math.max(n, 0))), this.calculatedWidth = N = X(e - v), N < o && (v = (u - o + N) * n, N = o);
          let t = Math.floor(v + this.xOffset + this.yOffset), h = N / 2 - 0.5;
          this.from = n, this.to = a, T ? (this.scrollbarGroup[c]({ translateY: t }), this.scrollbar[c]({ height: N }), this.scrollbarRifles[c]({ translateY: h }), this.scrollbarTop = t, this.scrollbarLeft = 0) : (this.scrollbarGroup[c]({ translateX: t }), this.scrollbar[c]({ width: N }), this.scrollbarRifles[c]({ translateX: h }), this.scrollbarLeft = t, this.scrollbarTop = 0), N <= 12 ? this.scrollbarRifles.hide() : this.scrollbarRifles.show(), B.showFull === !1 && (n <= 0 && a >= 1 ? this.group.hide() : this.group.show()), this.rendered = !0;
        }
        shouldUpdateExtremes(n) {
          return x(this.options.liveRedraw, _.svg && !_.isTouchDevice && !this.chart.boosted) || n === "mouseup" || n === "touchend" || !O(n);
        }
        trackClick(n) {
          var T;
          let a = ((T = this.chart.pointer) == null ? void 0 : T.normalize(n)) || n, v = this.to - this.from, N = this.y + this.scrollbarTop, B = this.x + this.scrollbarLeft;
          this.options.vertical && a.chartY > N || !this.options.vertical && a.chartX > B ? this.updatePosition(this.from + v, this.to + v) : this.updatePosition(this.from - v, this.to - v), w(this, "changed", { from: this.from, to: this.to, trigger: "scrollbar", DOMEvent: n });
        }
        update(n) {
          this.destroy(), this.init(this.chart.renderer, f(!0, this.options, n), this.chart);
        }
        updatePosition(n, a) {
          a > 1 && (n = X(1 - X(a - n)), a = 1), n < 0 && (a = X(a - n), n = 0), this.from = n, this.to = a;
        }
      }
      return l.defaultOptions = Z, q.scrollbar = f(!0, l.defaultOptions, q.scrollbar), l;
    }), ot(i, "Stock/Navigator/Navigator.js", [i["Core/Axis/Axis.js"], i["Stock/Navigator/ChartNavigatorComposition.js"], i["Core/Defaults.js"], i["Core/Globals.js"], i["Core/Axis/NavigatorAxisComposition.js"], i["Stock/Navigator/NavigatorComposition.js"], i["Stock/Scrollbar/Scrollbar.js"], i["Core/Renderer/SVG/SVGRenderer.js"], i["Core/Utilities.js"]], function(U, _, K, Z, J, q, tt, X, I) {
      let { defaultOptions: O } = K, { isTouchDevice: y } = Z, { prototype: { symbols: w } } = X, { addEvent: f, clamp: x, correctFloat: s, defined: l, destroyObjectProperties: p, erase: n, extend: a, find: v, fireEvent: N, isArray: B, isNumber: T, merge: o, pick: u, removeEvent: c, splat: e } = I;
      function t(b, ...r) {
        let g = [].filter.call(r, T);
        if (g.length) return Math[b].apply(0, g);
      }
      class h {
        static compose(r, g, d) {
          _.compose(r, h), q.compose(r, g, d);
        }
        constructor(r) {
          this.isDirty = !1, this.scrollbarHeight = 0, this.init(r);
        }
        drawHandle(r, g, d, M) {
          let H = this.navigatorOptions.handles.height;
          this.handles[g][M](d ? { translateX: Math.round(this.left + this.height / 2), translateY: Math.round(this.top + parseInt(r, 10) + 0.5 - H) } : { translateX: Math.round(this.left + parseInt(r, 10)), translateY: Math.round(this.top + this.height / 2 - H / 2 - 1) });
        }
        drawOutline(r, g, d, M) {
          let H = this.navigatorOptions.maskInside, A = this.outline.strokeWidth(), D = A / 2, W = A % 2 / 2, G = this.scrollButtonSize, it = this.size, C = this.top, k = this.height, L = C - D, F = C + k, m = this.left, E, P;
          d ? (E = C + g + W, g = C + r + W, P = [["M", m + k, C - G - W], ["L", m + k, E], ["L", m, E], ["M", m, g], ["L", m + k, g], ["L", m + k, C + it + G]], H && P.push(["M", m + k, E - D], ["L", m + k, g + D])) : (m -= G, r += m + G - W, g += m + G - W, P = [["M", m, L], ["L", r, L], ["L", r, F], ["M", g, F], ["L", g, L], ["L", m + it + 2 * G, L]], H && P.push(["M", r - D, L], ["L", g + D, L])), this.outline[M]({ d: P });
        }
        drawMasks(r, g, d, M) {
          let H, A, D, W, G = this.left, it = this.top, C = this.height;
          d ? (D = [G, G, G], W = [it, it + r, it + g], A = [C, C, C], H = [r, g - r, this.size - g]) : (D = [G, G + r, G + g], W = [it, it, it], A = [r, g - r, this.size - g], H = [C, C, C]), this.shades.forEach((k, L) => {
            k[M]({ x: D[L], y: W[L], width: A[L], height: H[L] });
          });
        }
        renderElements() {
          var G, it;
          let r = this, g = r.navigatorOptions, d = g.maskInside, M = r.chart, H = M.inverted, A = M.renderer, D = { cursor: H ? "ns-resize" : "ew-resize" }, W = (G = r.navigatorGroup) != null ? G : r.navigatorGroup = A.g("navigator").attr({ zIndex: 8, visibility: "hidden" }).add();
          if ([!d, d, !d].forEach((C, k) => {
            var F;
            let L = (F = r.shades[k]) != null ? F : r.shades[k] = A.rect().addClass("highcharts-navigator-mask" + (k === 1 ? "-inside" : "-outside")).add(W);
            M.styledMode || (L.attr({ fill: C ? g.maskFill : "rgba(0,0,0,0)" }), k === 1 && L.css(D));
          }), r.outline || (r.outline = A.path().addClass("highcharts-navigator-outline").add(W)), M.styledMode || r.outline.attr({ "stroke-width": g.outlineWidth, stroke: g.outlineColor }), (it = g.handles) == null ? void 0 : it.enabled) {
            let C = g.handles, { height: k, width: L } = C;
            [0, 1].forEach((F) => {
              var E;
              let m = C.symbols[F];
              if (r.handles[F] && r.handles[F].symbolUrl === m) {
                if (!r.handles[F].isImg && r.handles[F].symbolName !== m) {
                  let P = w[m].call(w, -L / 2 - 1, 0, L, k);
                  r.handles[F].attr({ d: P }), r.handles[F].symbolName = m;
                }
              } else (E = r.handles[F]) == null || E.destroy(), r.handles[F] = A.symbol(m, -L / 2 - 1, 0, L, k, C), r.handles[F].attr({ zIndex: 7 - F }).addClass("highcharts-navigator-handle highcharts-navigator-handle-" + ["left", "right"][F]).add(W), r.addMouseEvents();
              M.inverted && r.handles[F].attr({ rotation: 90, rotationOriginX: Math.floor(-L / 2), rotationOriginY: (k + L) / 2 }), M.styledMode || r.handles[F].attr({ fill: C.backgroundColor, stroke: C.borderColor, "stroke-width": C.lineWidth, width: C.width, height: C.height, x: -L / 2 - 1, y: 0 }).css(D);
            });
          }
        }
        update(r, g = !1) {
          var H, A;
          let d = this.chart, M = d.options.chart.inverted !== ((H = d.scrollbar) == null ? void 0 : H.options.vertical);
          if (o(!0, d.options.navigator, r), this.navigatorOptions = d.options.navigator || {}, this.setOpposite(), l(r.enabled) || M) return this.destroy(), this.navigatorEnabled = r.enabled || this.navigatorEnabled, this.init(d);
          if (this.navigatorEnabled && (this.isDirty = !0, r.adaptToUpdatedData === !1 && this.baseSeries.forEach((D) => {
            c(D, "updatedData", this.updatedDataHandler);
          }, this), r.adaptToUpdatedData && this.baseSeries.forEach((D) => {
            D.eventsToUnbind.push(f(D, "updatedData", this.updatedDataHandler));
          }, this), (r.series || r.baseSeries) && this.setBaseSeries(void 0, !1), r.height || r.xAxis || r.yAxis)) {
            this.height = (A = r.height) != null ? A : this.height;
            let D = this.getXAxisOffsets();
            this.xAxis.update({ ...r.xAxis, offsets: D, [d.inverted ? "width" : "height"]: this.height, [d.inverted ? "height" : "width"]: void 0 }, !1), this.yAxis.update({ ...r.yAxis, [d.inverted ? "width" : "height"]: this.height }, !1);
          }
          g && d.redraw();
        }
        render(r, g, d, M) {
          let H = this.chart, A = this.xAxis, D = A.pointRange || 0, W = A.navigatorAxis.fake ? H.xAxis[0] : A, G = this.navigatorEnabled, it = this.rendered, C = H.inverted, k = H.xAxis[0].minRange, L = H.xAxis[0].options.maxRange, F = this.scrollButtonSize, m, E, P, R = this.scrollbarHeight, z, $;
          if (this.hasDragged && !l(d)) return;
          if (this.isDirty && this.renderElements(), r = s(r - D / 2), g = s(g + D / 2), !T(r) || !T(g)) {
            if (!it) return;
            d = 0, M = u(A.width, W.width);
          }
          this.left = u(A.left, H.plotLeft + F + (C ? H.plotWidth : 0));
          let et = this.size = z = u(A.len, (C ? H.plotHeight : H.plotWidth) - 2 * F);
          m = C ? R : z + 2 * F, d = u(d, A.toPixels(r, !0)), M = u(M, A.toPixels(g, !0)), T(d) && Math.abs(d) !== 1 / 0 || (d = 0, M = m);
          let rt = A.toValue(d, !0), nt = A.toValue(M, !0), dt = Math.abs(s(nt - rt));
          dt < k ? this.grabbedLeft ? d = A.toPixels(nt - k - D, !0) : this.grabbedRight && (M = A.toPixels(rt + k + D, !0)) : l(L) && s(dt - D) > L && (this.grabbedLeft ? d = A.toPixels(nt - L - D, !0) : this.grabbedRight && (M = A.toPixels(rt + L + D, !0))), this.zoomedMax = x(Math.max(d, M), 0, et), this.zoomedMin = x(this.fixedWidth ? this.zoomedMax - this.fixedWidth : Math.min(d, M), 0, et), this.range = this.zoomedMax - this.zoomedMin, et = Math.round(this.zoomedMax);
          let ct = Math.round(this.zoomedMin);
          G && (this.navigatorGroup.attr({ visibility: "inherit" }), $ = it && !this.hasDragged ? "animate" : "attr", this.drawMasks(ct, et, C, $), this.drawOutline(ct, et, C, $), this.navigatorOptions.handles.enabled && (this.drawHandle(ct, 0, C, $), this.drawHandle(et, 1, C, $))), this.scrollbar && (C ? (P = this.top - F, E = this.left - R + (G || !W.opposite ? 0 : (W.titleOffset || 0) + W.axisTitleMargin), R = z + 2 * F) : (P = this.top + (G ? this.height : -R), E = this.left - F), this.scrollbar.position(E, P, m, R), this.scrollbar.setRange(this.zoomedMin / (z || 1), this.zoomedMax / (z || 1))), this.rendered = !0, this.isDirty = !1, N(this, "afterRender");
        }
        addMouseEvents() {
          let r = this, g = r.chart, d = g.container, M = [], H, A;
          r.mouseMoveHandler = H = function(D) {
            r.onMouseMove(D);
          }, r.mouseUpHandler = A = function(D) {
            r.onMouseUp(D);
          }, (M = r.getPartsEvents("mousedown")).push(f(g.renderTo, "mousemove", H), f(d.ownerDocument, "mouseup", A), f(g.renderTo, "touchmove", H), f(d.ownerDocument, "touchend", A)), M.concat(r.getPartsEvents("touchstart")), r.eventsToUnbind = M, r.series && r.series[0] && M.push(f(r.series[0].xAxis, "foundExtremes", function() {
            g.navigator.modifyNavigatorAxisExtremes();
          }));
        }
        getPartsEvents(r) {
          let g = this, d = [];
          return ["shades", "handles"].forEach(function(M) {
            g[M].forEach(function(H, A) {
              d.push(f(H.element, r, function(D) {
                g[M + "Mousedown"](D, A);
              }));
            });
          }), d;
        }
        shadesMousedown(r, g) {
          var F;
          r = ((F = this.chart.pointer) == null ? void 0 : F.normalize(r)) || r;
          let d = this.chart, M = this.xAxis, H = this.zoomedMin, A = this.size, D = this.range, W = this.left, G = r.chartX, it, C, k, L;
          d.inverted && (G = r.chartY, W = this.top), g === 1 ? (this.grabbedCenter = G, this.fixedWidth = D, this.dragOffset = G - H) : (L = G - W - D / 2, g === 0 ? L = Math.max(0, L) : g === 2 && L + D >= A && (L = A - D, this.reversedExtremes ? (L -= D, C = this.getUnionExtremes().dataMin) : it = this.getUnionExtremes().dataMax), L !== H && (this.fixedWidth = D, l((k = M.navigatorAxis.toFixedRange(L, L + D, C, it)).min) && N(this, "setRange", { min: Math.min(k.min, k.max), max: Math.max(k.min, k.max), redraw: !0, eventArguments: { trigger: "navigator" } })));
        }
        handlesMousedown(r, g) {
          var A;
          r = ((A = this.chart.pointer) == null ? void 0 : A.normalize(r)) || r;
          let d = this.chart, M = d.xAxis[0], H = this.reversedExtremes;
          g === 0 ? (this.grabbedLeft = !0, this.otherHandlePos = this.zoomedMax, this.fixedExtreme = H ? M.min : M.max) : (this.grabbedRight = !0, this.otherHandlePos = this.zoomedMin, this.fixedExtreme = H ? M.max : M.min), d.setFixedRange(void 0);
        }
        onMouseMove(r) {
          var it;
          let g = this, d = g.chart, M = g.navigatorSize, H = g.range, A = g.dragOffset, D = d.inverted, W = g.left, G;
          (!r.touches || r.touches[0].pageX !== 0) && (G = (r = ((it = d.pointer) == null ? void 0 : it.normalize(r)) || r).chartX, D && (W = g.top, G = r.chartY), g.grabbedLeft ? (g.hasDragged = !0, g.render(0, 0, G - W, g.otherHandlePos)) : g.grabbedRight ? (g.hasDragged = !0, g.render(0, 0, g.otherHandlePos, G - W)) : g.grabbedCenter && (g.hasDragged = !0, G < A ? G = A : G > M + A - H && (G = M + A - H), g.render(0, 0, G - A, G - A + H)), g.hasDragged && g.scrollbar && u(g.scrollbar.options.liveRedraw, !y && !this.chart.boosted) && (r.DOMType = r.type, setTimeout(function() {
            g.onMouseUp(r);
          }, 0)));
        }
        onMouseUp(r) {
          let g, d, M, H, A, D, W = this.chart, G = this.xAxis, it = this.scrollbar, C = r.DOMEvent || r, k = W.inverted, L = this.rendered && !this.hasDragged ? "animate" : "attr";
          (this.hasDragged && (!it || !it.hasDragged) || r.trigger === "scrollbar") && (M = this.getUnionExtremes(), this.zoomedMin === this.otherHandlePos ? H = this.fixedExtreme : this.zoomedMax === this.otherHandlePos && (A = this.fixedExtreme), this.zoomedMax === this.size && (A = this.reversedExtremes ? M.dataMin : M.dataMax), this.zoomedMin === 0 && (H = this.reversedExtremes ? M.dataMax : M.dataMin), l((D = G.navigatorAxis.toFixedRange(this.zoomedMin, this.zoomedMax, H, A)).min) && N(this, "setRange", { min: Math.min(D.min, D.max), max: Math.max(D.min, D.max), redraw: !0, animation: !this.hasDragged && null, eventArguments: { trigger: "navigator", triggerOp: "navigator-drag", DOMEvent: C } })), r.DOMType !== "mousemove" && r.DOMType !== "touchmove" && (this.grabbedLeft = this.grabbedRight = this.grabbedCenter = this.fixedWidth = this.fixedExtreme = this.otherHandlePos = this.hasDragged = this.dragOffset = null), this.navigatorEnabled && T(this.zoomedMin) && T(this.zoomedMax) && (d = Math.round(this.zoomedMin), g = Math.round(this.zoomedMax), this.shades && this.drawMasks(d, g, k, L), this.outline && this.drawOutline(d, g, k, L), this.navigatorOptions.handles.enabled && Object.keys(this.handles).length === this.handles.length && (this.drawHandle(d, 0, k, L), this.drawHandle(g, 1, k, L)));
        }
        removeEvents() {
          this.eventsToUnbind && (this.eventsToUnbind.forEach(function(r) {
            r();
          }), this.eventsToUnbind = void 0), this.removeBaseSeriesEvents();
        }
        removeBaseSeriesEvents() {
          let r = this.baseSeries || [];
          this.navigatorEnabled && r[0] && (this.navigatorOptions.adaptToUpdatedData !== !1 && r.forEach(function(g) {
            c(g, "updatedData", this.updatedDataHandler);
          }, this), r[0].xAxis && c(r[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
        }
        getXAxisOffsets() {
          return this.chart.inverted ? [this.scrollButtonSize, 0, -this.scrollButtonSize, 0] : [0, -this.scrollButtonSize, 0, this.scrollButtonSize];
        }
        init(r) {
          var m;
          let g = r.options, d = g.navigator || {}, M = d.enabled, H = g.scrollbar || {}, A = H.enabled, D = M && d.height || 0, W = A && H.height || 0, G = H.buttonsEnabled && W || 0;
          this.handles = [], this.shades = [], this.chart = r, this.setBaseSeries(), this.height = D, this.scrollbarHeight = W, this.scrollButtonSize = G, this.scrollbarEnabled = A, this.navigatorEnabled = M, this.navigatorOptions = d, this.scrollbarOptions = H, this.setOpposite();
          let it = this, C = it.baseSeries, k = r.xAxis.length, L = r.yAxis.length, F = C && C[0] && C[0].xAxis || r.xAxis[0] || { options: {} };
          if (r.isDirtyBox = !0, it.navigatorEnabled) {
            let E = this.getXAxisOffsets();
            it.xAxis = new U(r, o({ breaks: F.options.breaks, ordinal: F.options.ordinal, overscroll: F.options.overscroll }, d.xAxis, { type: "datetime", yAxis: (m = d.yAxis) == null ? void 0 : m.id, index: k, isInternal: !0, offset: 0, keepOrdinalPadding: !0, startOnTick: !1, endOnTick: !1, minPadding: F.options.ordinal ? 0 : F.options.minPadding, maxPadding: F.options.ordinal ? 0 : F.options.maxPadding, zoomEnabled: !1 }, r.inverted ? { offsets: E, width: D } : { offsets: E, height: D }), "xAxis"), it.yAxis = new U(r, o(d.yAxis, { alignTicks: !1, offset: 0, index: L, isInternal: !0, reversed: u(d.yAxis && d.yAxis.reversed, r.yAxis[0] && r.yAxis[0].reversed, !1), zoomEnabled: !1 }, r.inverted ? { width: D } : { height: D }), "yAxis"), C || d.series.data ? it.updateNavigatorSeries(!1) : r.series.length === 0 && (it.unbindRedraw = f(r, "beforeRedraw", function() {
              r.series.length > 0 && !it.series && (it.setBaseSeries(), it.unbindRedraw());
            })), it.reversedExtremes = r.inverted && !it.xAxis.reversed || !r.inverted && it.xAxis.reversed, it.renderElements(), it.addMouseEvents();
          } else it.xAxis = { chart: r, navigatorAxis: { fake: !0 }, translate: function(E, P) {
            let R = r.xAxis[0], z = R.getExtremes(), $ = R.len - 2 * G, et = t("min", R.options.min, z.dataMin), rt = t("max", R.options.max, z.dataMax) - et;
            return P ? E * rt / $ + et : $ * (E - et) / rt;
          }, toPixels: function(E) {
            return this.translate(E);
          }, toValue: function(E) {
            return this.translate(E, !0);
          } }, it.xAxis.navigatorAxis.axis = it.xAxis, it.xAxis.navigatorAxis.toFixedRange = J.prototype.toFixedRange.bind(it.xAxis.navigatorAxis);
          if (r.options.scrollbar.enabled) {
            let E = o(r.options.scrollbar, { vertical: r.inverted });
            !T(E.margin) && it.navigatorEnabled && (E.margin = r.inverted ? -3 : 3), r.scrollbar = it.scrollbar = new tt(r.renderer, E, r), f(it.scrollbar, "changed", function(P) {
              let R = it.size, z = R * this.to, $ = R * this.from;
              it.hasDragged = it.scrollbar.hasDragged, it.render(0, 0, $, z), this.shouldUpdateExtremes(P.DOMType) && setTimeout(function() {
                it.onMouseUp(P);
              });
            });
          }
          it.addBaseSeriesEvents(), it.addChartEvents();
        }
        setOpposite() {
          let r = this.navigatorOptions, g = this.navigatorEnabled, d = this.chart;
          this.opposite = u(r.opposite, !!(!g && d.inverted));
        }
        getUnionExtremes(r) {
          let g, d = this.chart.xAxis[0], M = this.xAxis, H = M.options, A = d.options;
          return r && d.dataMin === null || (g = { dataMin: u(H && H.min, t("min", A.min, d.dataMin, M.dataMin, M.min)), dataMax: u(H && H.max, t("max", A.max, d.dataMax, M.dataMax, M.max)) }), g;
        }
        setBaseSeries(r, g) {
          let d = this.chart, M = this.baseSeries = [];
          r = r || d.options && d.options.navigator.baseSeries || (d.series.length ? v(d.series, (H) => !H.options.isInternal).index : 0), (d.series || []).forEach((H, A) => {
            !H.options.isInternal && (H.options.showInNavigator || (A === r || H.options.id === r) && H.options.showInNavigator !== !1) && M.push(H);
          }), this.xAxis && !this.xAxis.navigatorAxis.fake && this.updateNavigatorSeries(!0, g);
        }
        updateNavigatorSeries(r, g) {
          var k, L;
          let d = this, M = d.chart, H = d.baseSeries, A = { enableMouseTracking: !1, index: null, linkedTo: null, group: "nav", padXAxis: !1, xAxis: (k = this.navigatorOptions.xAxis) == null ? void 0 : k.id, yAxis: (L = this.navigatorOptions.yAxis) == null ? void 0 : L.id, showInLegend: !1, stacking: void 0, isInternal: !0, states: { inactive: { opacity: 1 } } }, D = d.series = (d.series || []).filter((F) => {
            let m = F.baseSeries;
            return !(0 > H.indexOf(m)) || (m && (c(m, "updatedData", d.updatedDataHandler), delete m.navigatorSeries), F.chart && F.destroy(), !1);
          }), W, G, it = d.navigatorOptions.series, C;
          H && H.length && H.forEach((F) => {
            let m = F.navigatorSeries, E = a({ color: F.color, visible: F.visible }, B(it) ? O.navigator.series : it);
            if (m && d.navigatorOptions.adaptToUpdatedData === !1) return;
            A.name = "Navigator " + H.length, C = (W = F.options || {}).navigatorOptions || {}, E.dataLabels = e(E.dataLabels), (G = o(W, A, E, C)).pointRange = u(E.pointRange, C.pointRange, O.plotOptions[G.type || "line"].pointRange);
            let P = C.data || E.data;
            d.hasNavigatorData = d.hasNavigatorData || !!P, G.data = P || W.data && W.data.slice(0), m && m.options ? m.update(G, g) : (F.navigatorSeries = M.initSeries(G), M.setSortedData(), F.navigatorSeries.baseSeries = F, D.push(F.navigatorSeries));
          }), (it.data && !(H && H.length) || B(it)) && (d.hasNavigatorData = !1, (it = e(it)).forEach((F, m) => {
            A.name = "Navigator " + (D.length + 1), (G = o(O.navigator.series, { color: M.series[m] && !M.series[m].options.isInternal && M.series[m].color || M.options.colors[m] || M.options.colors[0] }, A, F)).data = F.data, G.data && (d.hasNavigatorData = !0, D.push(M.initSeries(G)));
          })), r && this.addBaseSeriesEvents();
        }
        addBaseSeriesEvents() {
          let r = this, g = r.baseSeries || [];
          g[0] && g[0].xAxis && g[0].eventsToUnbind.push(f(g[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes)), g.forEach((d) => {
            d.eventsToUnbind.push(f(d, "show", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(!0, !1);
            })), d.eventsToUnbind.push(f(d, "hide", function() {
              this.navigatorSeries && this.navigatorSeries.setVisible(!1, !1);
            })), this.navigatorOptions.adaptToUpdatedData !== !1 && d.xAxis && d.eventsToUnbind.push(f(d, "updatedData", this.updatedDataHandler)), d.eventsToUnbind.push(f(d, "remove", function() {
              g && n(g, d), this.navigatorSeries && (n(r.series, this.navigatorSeries), l(this.navigatorSeries.options) && this.navigatorSeries.remove(!1), delete this.navigatorSeries);
            }));
          });
        }
        getBaseSeriesMin(r) {
          return this.baseSeries.reduce(function(g, d) {
            return Math.min(g, d.xData && d.xData.length ? d.xData[0] : g);
          }, r);
        }
        modifyNavigatorAxisExtremes() {
          let r = this.xAxis;
          if (r.getExtremes !== void 0) {
            let g = this.getUnionExtremes(!0);
            g && (g.dataMin !== r.min || g.dataMax !== r.max) && (r.min = g.dataMin, r.max = g.dataMax);
          }
        }
        modifyBaseAxisExtremes() {
          var m;
          let r, g, d = this.chart.navigator, M = this.getExtremes(), H = M.min, A = M.max, D = M.dataMin, W = M.dataMax, G = A - H, it = d.stickToMin, C = d.stickToMax, k = u((m = this.ordinal) == null ? void 0 : m.convertOverscroll(this.options.overscroll), 0), L = d.series && d.series[0], F = !!this.setExtremes;
          !(this.eventArgs && this.eventArgs.trigger === "rangeSelectorButton") && (it && (r = (g = D) + G), C && (r = W + k, it || (g = Math.max(D, r - G, d.getBaseSeriesMin(L && L.xData ? L.xData[0] : -Number.MAX_VALUE)))), F && (it || C) && T(g) && (this.min = this.userMin = g, this.max = this.userMax = r)), d.stickToMin = d.stickToMax = null;
        }
        updatedDataHandler() {
          let r = this.chart.navigator, g = this.navigatorSeries, d = r.reversedExtremes ? Math.round(r.zoomedMin) === 0 : Math.round(r.zoomedMax) >= Math.round(r.size);
          r.stickToMax = u(this.chart.options.navigator && this.chart.options.navigator.stickToMax, d), r.stickToMin = r.shouldStickToMin(this, r), g && !r.hasNavigatorData && (g.options.pointStart = this.xData[0], g.setData(this.options.data, !1, null, !1));
        }
        shouldStickToMin(r, g) {
          let d = g.getBaseSeriesMin(r.xData[0]), M = r.xAxis, H = M.max, A = M.min, D = M.options.range;
          return !!(T(H) && T(A)) && (D && H - d > 0 ? H - d < D : A <= d);
        }
        addChartEvents() {
          this.eventsToUnbind || (this.eventsToUnbind = []), this.eventsToUnbind.push(f(this.chart, "redraw", function() {
            let r = this.navigator, g = r && (r.baseSeries && r.baseSeries[0] && r.baseSeries[0].xAxis || this.xAxis[0]);
            g && r.render(g.min, g.max);
          }), f(this.chart, "getMargins", function() {
            let r = this.navigator, g = r.opposite ? "plotTop" : "marginBottom";
            this.inverted && (g = r.opposite ? "marginRight" : "plotLeft"), this[g] = (this[g] || 0) + (r.navigatorEnabled || !this.inverted ? r.height + r.scrollbarHeight : 0) + r.navigatorOptions.margin;
          }), f(h, "setRange", function(r) {
            this.chart.xAxis[0].setExtremes(r.min, r.max, r.redraw, r.animation, r.eventArguments);
          }));
        }
        destroy() {
          this.removeEvents(), this.xAxis && (n(this.chart.xAxis, this.xAxis), n(this.chart.axes, this.xAxis)), this.yAxis && (n(this.chart.yAxis, this.yAxis), n(this.chart.axes, this.yAxis)), (this.series || []).forEach((r) => {
            r.destroy && r.destroy();
          }), ["series", "xAxis", "yAxis", "shades", "outline", "scrollbarTrack", "scrollbarRifles", "scrollbarGroup", "scrollbar", "navigatorGroup", "rendered"].forEach((r) => {
            this[r] && this[r].destroy && this[r].destroy(), this[r] = null;
          }), [this.handles].forEach((r) => {
            p(r);
          }), this.navigatorEnabled = !1;
        }
      }
      return h;
    }), ot(i, "Accessibility/Components/NavigatorComponent.js", [i["Accessibility/AccessibilityComponent.js"], i["Accessibility/Utils/Announcer.js"], i["Accessibility/KeyboardNavigationHandler.js"], i["Stock/Navigator/Navigator.js"], i["Core/Animation/AnimationUtilities.js"], i["Core/Templating.js"], i["Core/Utilities.js"], i["Accessibility/Utils/HTMLUtilities.js"], i["Accessibility/Utils/ChartUtilities.js"]], function(U, _, K, Z, J, q, tt, X, I) {
      let { animObject: O } = J, { format: y } = q, { clamp: w, pick: f, syncTimeout: x } = tt, { getFakeMouseEvent: s } = X, { getAxisRangeDescription: l, fireEventOnWrappedOrUnwrappedElement: p } = I;
      return class extends U {
        init() {
          let n = this.chart, a = this;
          this.announcer = new _(n, "polite"), this.addEvent(Z, "afterRender", function() {
            this.chart === a.chart && this.chart.renderer && x(() => {
              a.proxyProvider.updateGroupProxyElementPositions("navigator"), a.updateHandleValues();
            }, O(f(this.chart.renderer.globalAnimation, !0)).duration);
          });
        }
        onChartUpdate() {
          var N, B, T;
          let n = this.chart, a = n.options, v = a.navigator;
          if (v.enabled && ((N = v.accessibility) != null && N.enabled)) {
            let o = a.accessibility.landmarkVerbosity, u = (B = a.lang.accessibility) == null ? void 0 : B.navigator.groupLabel;
            this.proxyProvider.removeGroup("navigator"), this.proxyProvider.addGroup("navigator", "div", { role: o === "all" ? "region" : "group", "aria-label": y(u, { chart: n }, n) });
            let c = (T = a.lang.accessibility) == null ? void 0 : T.navigator.handleLabel;
            [0, 1].forEach((e) => {
              let t = this.getHandleByIx(e);
              if (t) {
                let h = this.proxyProvider.addProxyElement("navigator", { click: t }, "input", { type: "range", "aria-label": y(c, { handleIx: e, chart: n }, n) });
                this[e ? "maxHandleProxy" : "minHandleProxy"] = h.innerElement, h.innerElement.style.pointerEvents = "none", h.innerElement.oninput = () => this.updateNavigator();
              }
            }), this.updateHandleValues();
          } else this.proxyProvider.removeGroup("navigator");
        }
        getNavigatorHandleNavigation(n) {
          let a = this, v = this.chart, N = n ? this.maxHandleProxy : this.minHandleProxy, B = this.keyCodes;
          return new K(v, { keyCodeMap: [[[B.left, B.right, B.up, B.down], function(T) {
            if (N) {
              let o = T === B.left || T === B.up ? -1 : 1;
              N.value = "" + w(parseFloat(N.value) + o, 0, 100), a.updateNavigator(() => {
                let u = a.getHandleByIx(n);
                u && v.setFocusToElement(u, N);
              });
            }
            return this.response.success;
          }]], init: () => {
            v.setFocusToElement(this.getHandleByIx(n), N);
          }, validate: () => {
            var T;
            return !!(this.getHandleByIx(n) && N && ((T = v.options.navigator.accessibility) != null && T.enabled));
          } });
        }
        getKeyboardNavigation() {
          return [this.getNavigatorHandleNavigation(0), this.getNavigatorHandleNavigation(1)];
        }
        destroy() {
          this.updateNavigatorThrottleTimer && clearTimeout(this.updateNavigatorThrottleTimer), this.proxyProvider.removeGroup("navigator"), this.announcer && this.announcer.destroy();
        }
        updateHandleValues() {
          let n = this.chart.navigator;
          if (n && this.minHandleProxy && this.maxHandleProxy) {
            let a = n.size;
            this.minHandleProxy.value = "" + Math.round(n.zoomedMin / a * 100), this.maxHandleProxy.value = "" + Math.round(n.zoomedMax / a * 100);
          }
        }
        getHandleByIx(n) {
          let a = this.chart.navigator;
          return a && a.handles && a.handles[n];
        }
        updateNavigator(n) {
          this.updateNavigatorThrottleTimer && clearTimeout(this.updateNavigatorThrottleTimer), this.updateNavigatorThrottleTimer = setTimeout(((a) => {
            var T;
            let v = this.chart, { navigator: N, pointer: B } = v;
            if (N && B && this.minHandleProxy && this.maxHandleProxy) {
              let o = B.getChartPosition(), u = parseFloat(this.minHandleProxy.value) / 100 * N.size, c = parseFloat(this.maxHandleProxy.value) / 100 * N.size;
              [[0, "mousedown", N.zoomedMin], [0, "mousemove", u], [0, "mouseup", u], [1, "mousedown", N.zoomedMax], [1, "mousemove", c], [1, "mouseup", c]].forEach(([h, b, r]) => {
                var d;
                let g = (d = this.getHandleByIx(h)) == null ? void 0 : d.element;
                g && p(g, s(b, { x: o.left + N.left + r, y: o.top + N.top }, g));
              }), a && a();
              let e = (T = v.options.lang.accessibility) == null ? void 0 : T.navigator.changeAnnouncement, t = l(v.xAxis[0]);
              this.announcer.announce(y(e, { axisRangeDescription: t, chart: v }, v));
            }
          }).bind(this, n), 20);
        }
      };
    }), ot(i, "Accessibility/Components/SeriesComponent/SeriesDescriber.js", [i["Accessibility/Components/AnnotationsA11y.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Core/Templating.js"], i["Accessibility/Utils/HTMLUtilities.js"], i["Core/Utilities.js"]], function(U, _, K, Z, J) {
      let { getPointAnnotationTexts: q } = U, { getAxisDescription: tt, getSeriesFirstPointElement: X, getSeriesA11yElement: I, unhideChartElementFromAT: O } = _, { format: y, numberFormat: w } = K, { reverseChildNodes: f, stripHTMLTagsFromString: x } = Z, { find: s, isNumber: l, isString: p, pick: n, defined: a } = J;
      function v(u) {
        let c = u.chart.options.accessibility.series.pointDescriptionEnabledThreshold;
        return !!(c !== !1 && u.points && u.points.length >= +c);
      }
      function N(u, c) {
        let e = u.series, t = e.chart, h = t.options.accessibility.point || {}, b = e.options.accessibility && e.options.accessibility.point || {}, r = e.tooltipOptions || {}, g = t.options.lang;
        return l(c) ? w(c, b.valueDecimals || h.valueDecimals || r.valueDecimals || -1, g.decimalPoint, g.accessibility.thousandsSep || g.thousandsSep) : c;
      }
      function B(u, c) {
        let e = u[c];
        return u.chart.langFormat("accessibility.series." + c + "Description", { name: tt(e), series: u });
      }
      function T(u) {
        let c = u.series, e = c.chart.series.length > 1 || c.options.name, t = function(g) {
          let d = g.series, M = d.chart, H = d.options.accessibility, A = H && H.point && H.point.valueDescriptionFormat || M.options.accessibility.point.valueDescriptionFormat, D = n(d.xAxis && d.xAxis.options.accessibility && d.xAxis.options.accessibility.enabled, !M.angular && d.type !== "flowmap"), W = D ? function(G) {
            let it = function(F) {
              let m = F.series, E = m.chart, P = m.options.accessibility && m.options.accessibility.point || {}, R = E.options.accessibility.point || {}, z = m.xAxis && m.xAxis.dateTime;
              if (z) {
                let $ = z.getXDateFormat(F.x || 0, E.options.tooltip.dateTimeLabelFormats), et = P.dateFormatter && P.dateFormatter(F) || R.dateFormatter && R.dateFormatter(F) || P.dateFormat || R.dateFormat || $;
                return E.time.dateFormat(et, F.x || 0, void 0);
              }
            }(G), C = (G.series.xAxis || {}).categories && a(G.category) && ("" + G.category).replace("<br/>", " "), k = a(G.id) && 0 > ("" + G.id).indexOf("highcharts-"), L = "x, " + G.x;
            return G.name || it || C || (k ? G.id : L);
          }(g) : "";
          return y(A, { point: g, index: a(g.index) ? g.index + 1 : "", xDescription: W, value: function(G) {
            let it = G.series, C = it.chart.options.accessibility.point || {}, k = it.chart.options.accessibility && it.chart.options.accessibility.point || {}, L = it.tooltipOptions || {}, F = k.valuePrefix || C.valuePrefix || L.valuePrefix || "", m = k.valueSuffix || C.valueSuffix || L.valueSuffix || "", E = G.value !== void 0 ? "value" : "y", P = N(G, G[E]);
            return G.isNull ? it.chart.langFormat("accessibility.series.nullPointValue", { point: G }) : it.pointArrayMap ? function(R, z, $) {
              let et = z || "", rt = $ || "", nt = function(dt) {
                let ct = N(R, n(R[dt], R.options[dt]));
                return ct !== void 0 ? dt + ": " + et + ct + rt : ct;
              };
              return R.series.pointArrayMap.reduce(function(dt, ct) {
                let V = nt(ct);
                return V ? dt + (dt.length ? ", " : "") + V : dt;
              }, "");
            }(G, F, m) : F + P + m;
          }(g), separator: D ? ", " : "" }, M);
        }(u), h = u.options && u.options.accessibility && u.options.accessibility.description, b = e ? " " + c.name + "." : "", r = function(g) {
          let d = g.series.chart, M = q(g);
          return M.length ? d.langFormat("accessibility.series.pointAnnotationsDescription", { point: g, annotations: M }) : "";
        }(u);
        return u.accessibility = u.accessibility || {}, u.accessibility.valueDescription = t, t + (h ? " " + h : "") + b + (r ? " " + r : "");
      }
      function o(u) {
        let c = u.chart, e = c.types || [], t = function(D) {
          let W = (D.options.accessibility || {}).description;
          return W && D.chart.langFormat("accessibility.series.description", { description: W, series: D }) || "";
        }(u), h = function(D) {
          return c[D] && c[D].length > 1 && u[D];
        }, b = u.index + 1, r = B(u, "xAxis"), g = B(u, "yAxis"), d = { seriesNumber: b, series: u, chart: c }, M = e.length > 1 ? "Combination" : "", H = c.langFormat("accessibility.series.summary." + u.type + M, d) || c.langFormat("accessibility.series.summary.default" + M, d), A = (h("yAxis") ? " " + g + "." : "") + (h("xAxis") ? " " + r + "." : "");
        return y(n(u.options.accessibility && u.options.accessibility.descriptionFormat, c.options.accessibility.series.descriptionFormat, ""), { seriesDescription: H, authorDescription: t ? " " + t : "", axisDescription: A, series: u, chart: c, seriesNumber: b }, void 0);
      }
      return { defaultPointDescriptionFormatter: T, defaultSeriesDescriptionFormatter: o, describeSeries: function(u) {
        let c = u.chart, e = X(u), t = I(u), h = c.is3d && c.is3d();
        t && (t.lastChild !== e || h || f(t), function(b) {
          let r = function(M) {
            let H = M.options.accessibility || {};
            return !v(M) && !H.exposeAsGroupOnly;
          }(b), g = function(M) {
            let H = M.chart.options.accessibility.keyboardNavigation.seriesNavigation;
            return !!(M.points && (M.points.length < +H.pointNavigationEnabledThreshold || H.pointNavigationEnabledThreshold === !1));
          }(b), d = b.chart.options.accessibility.point.describeNull;
          (r || g) && b.points.forEach((M) => {
            let H = M.graphic && M.graphic.element || function(D) {
              let W = D.series, G = W && W.chart, it = W && W.is("sunburst"), C = D.isNull, k = G && G.options.accessibility.point.describeNull;
              return C && !it && k;
            }(M) && function(D) {
              let W = D.series, G = function(F) {
                let m = F.index;
                return F.series && F.series.data && a(m) && s(F.series.data, function(E) {
                  return !!(E && E.index !== void 0 && E.index > m && E.graphic && E.graphic.element);
                }) || null;
              }(D), it = G && G.graphic, C = it ? it.parentGroup : W.graph || W.group, k = G ? { x: n(D.plotX, G.plotX, 0), y: n(D.plotY, G.plotY, 0) } : { x: n(D.plotX, 0), y: n(D.plotY, 0) }, L = function(F, m) {
                let E = F.series.chart.renderer.rect(m.x, m.y, 1, 1);
                return E.attr({ class: "highcharts-a11y-mock-point", fill: "none", opacity: 0, "fill-opacity": 0, "stroke-opacity": 0 }), E;
              }(D, k);
              if (C && C.element) return D.graphic = L, D.hasMockGraphic = !0, L.add(C), C.element.insertBefore(L.element, it ? it.element : null), L.element;
            }(M), A = M.options && M.options.accessibility && M.options.accessibility.enabled === !1;
            if (H) {
              if (M.isNull && !d) {
                H.setAttribute("aria-hidden", !0);
                return;
              }
              H.setAttribute("tabindex", "-1"), b.chart.styledMode || (H.style.outline = "none"), r && !A ? function(D, W) {
                var L, F, m;
                let G = D.series, it = ((L = G.options.accessibility) == null ? void 0 : L.point) || {}, C = G.chart.options.accessibility.point || {}, k = x(p(it.descriptionFormat) && y(it.descriptionFormat, D, G.chart) || ((F = it.descriptionFormatter) == null ? void 0 : F.call(it, D)) || p(C.descriptionFormat) && y(C.descriptionFormat, D, G.chart) || ((m = C.descriptionFormatter) == null ? void 0 : m.call(C, D)) || T(D), G.chart.renderer.forExport);
                W.setAttribute("role", "img"), W.setAttribute("aria-label", k);
              }(M, H) : H.setAttribute("aria-hidden", !0);
            }
          });
        }(u), O(c, t), function(b) {
          let r = b.chart, g = r.options.chart, d = g.options3d && g.options3d.enabled, M = r.series.length > 1, H = r.options.accessibility.series.describeSingleSeries, A = (b.options.accessibility || {}).exposeAsGroupOnly;
          return !(d && M) && (M || H || A || v(b));
        }(u) ? function(b, r) {
          let g = b.options.accessibility || {}, d = b.chart.options.accessibility, M = d.landmarkVerbosity;
          g.exposeAsGroupOnly ? r.setAttribute("role", "img") : M === "all" ? r.setAttribute("role", "region") : r.setAttribute("role", "group"), r.setAttribute("tabindex", "-1"), b.chart.styledMode || (r.style.outline = "none"), r.setAttribute("aria-label", x(d.series.descriptionFormatter && d.series.descriptionFormatter(b) || o(b), b.chart.renderer.forExport));
        }(u, t) : t.removeAttribute("aria-label"));
      } };
    }), ot(i, "Accessibility/Components/SeriesComponent/NewDataAnnouncer.js", [i["Core/Globals.js"], i["Core/Utilities.js"], i["Accessibility/Utils/Announcer.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Accessibility/Utils/EventProvider.js"], i["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]], function(U, _, K, Z, J, q) {
      let { composed: tt } = U, { addEvent: X, defined: I, pushUnique: O } = _, { getChartTitle: y } = Z, { defaultPointDescriptionFormatter: w, defaultSeriesDescriptionFormatter: f } = q;
      function x(l) {
        return !!l.options.accessibility.announceNewData.enabled;
      }
      class s {
        constructor(p) {
          this.dirty = { allSeries: {} }, this.lastAnnouncementTime = 0, this.chart = p;
        }
        init() {
          let p = this.chart, n = p.options.accessibility.announceNewData.interruptUser ? "assertive" : "polite";
          this.lastAnnouncementTime = 0, this.dirty = { allSeries: {} }, this.eventProvider = new J(), this.announcer = new K(p, n), this.addEventListeners();
        }
        destroy() {
          this.eventProvider.removeAddedEvents(), this.announcer.destroy();
        }
        addEventListeners() {
          let p = this, n = this.chart, a = this.eventProvider;
          a.addEvent(n, "afterApplyDrilldown", function() {
            p.lastAnnouncementTime = 0;
          }), a.addEvent(n, "afterAddSeries", function(v) {
            p.onSeriesAdded(v.series);
          }), a.addEvent(n, "redraw", function() {
            p.announceDirtyData();
          });
        }
        onSeriesAdded(p) {
          x(this.chart) && (this.dirty.hasDirty = !0, this.dirty.allSeries[p.name + p.index] = p, this.dirty.newSeries = I(this.dirty.newSeries) ? void 0 : p);
        }
        announceDirtyData() {
          let p = this.chart, n = this;
          if (p.options.accessibility.announceNewData && this.dirty.hasDirty) {
            let a = this.dirty.newPoint;
            a && (a = function(v) {
              let N = v.series.data.filter((B) => v.x === B.x && v.y === B.y);
              return N.length === 1 ? N[0] : v;
            }(a)), this.queueAnnouncement(Object.keys(this.dirty.allSeries).map((v) => n.dirty.allSeries[v]), this.dirty.newSeries, a), this.dirty = { allSeries: {} };
          }
        }
        queueAnnouncement(p, n, a) {
          let v = this.chart.options.accessibility.announceNewData;
          if (v.enabled) {
            let N = +/* @__PURE__ */ new Date(), B = N - this.lastAnnouncementTime, T = Math.max(0, v.minAnnounceInterval - B), o = function(c, e) {
              let t = (c || []).concat(e || []).reduce((h, b) => (h[b.name + b.index] = b, h), {});
              return Object.keys(t).map((h) => t[h]);
            }(this.queuedAnnouncement && this.queuedAnnouncement.series, p), u = this.buildAnnouncementMessage(o, n, a);
            u && (this.queuedAnnouncement && clearTimeout(this.queuedAnnouncementTimer), this.queuedAnnouncement = { time: N, message: u, series: o }, this.queuedAnnouncementTimer = setTimeout(() => {
              this && this.announcer && (this.lastAnnouncementTime = +/* @__PURE__ */ new Date(), this.announcer.announce(this.queuedAnnouncement.message), delete this.queuedAnnouncement, delete this.queuedAnnouncementTimer);
            }, T));
          }
        }
        buildAnnouncementMessage(p, n, a) {
          let v = this.chart, N = v.options.accessibility.announceNewData;
          if (N.announcementFormatter) {
            let u = N.announcementFormatter(p, n, a);
            if (u !== !1) return u.length ? u : null;
          }
          let B = U.charts && U.charts.length > 1 ? "Multiple" : "Single", T = n ? "newSeriesAnnounce" + B : a ? "newPointAnnounce" + B : "newDataAnnounce", o = y(v);
          return v.langFormat("accessibility.announceNewData." + T, { chartTitle: o, seriesDesc: n ? f(n) : null, pointDesc: a ? w(a) : null, point: a, series: n });
        }
      }
      return function(l) {
        function p(a) {
          var B;
          let v = this.chart, N = (B = v.accessibility) == null ? void 0 : B.components.series.newDataAnnouncer;
          N && N.chart === v && x(v) && (N.dirty.newPoint = I(N.dirty.newPoint) ? void 0 : a.point);
        }
        function n() {
          var N;
          let a = this.chart, v = (N = a.accessibility) == null ? void 0 : N.components.series.newDataAnnouncer;
          v && v.chart === a && x(a) && (v.dirty.hasDirty = !0, v.dirty.allSeries[this.name + this.index] = this);
        }
        l.compose = function(a) {
          O(tt, "A11y.NDA") && (X(a, "addPoint", p), X(a, "updatedData", n));
        };
      }(s || (s = {})), s;
    }), ot(i, "Accessibility/ProxyElement.js", [i["Core/Globals.js"], i["Core/Utilities.js"], i["Accessibility/Utils/EventProvider.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Accessibility/Utils/HTMLUtilities.js"]], function(U, _, K, Z, J) {
      let { doc: q } = U, { attr: tt, css: X, merge: I } = _, { fireEventOnWrappedOrUnwrappedElement: O } = Z, { cloneMouseEvent: y, cloneTouchEvent: w, getFakeMouseEvent: f, removeElement: x } = J;
      return class {
        constructor(s, l, p = "button", n, a) {
          this.chart = s, this.target = l, this.eventProvider = new K();
          let v = this.innerElement = q.createElement(p), N = this.element = n ? q.createElement(n) : v;
          s.styledMode || this.hideElementVisually(v), n && (n !== "li" || s.styledMode || (N.style.listStyle = "none"), N.appendChild(v), this.element = N), this.updateTarget(l, a);
        }
        click() {
          let s = this.getTargetPosition();
          s.x += s.width / 2, s.y += s.height / 2;
          let l = f("click", s);
          O(this.target.click, l);
        }
        updateTarget(s, l) {
          this.target = s, this.updateCSSClassName();
          let p = l || {};
          Object.keys(p).forEach((a) => {
            p[a] === null && delete p[a];
          });
          let n = this.getTargetAttr(s.click, "aria-label");
          tt(this.innerElement, I(n ? { "aria-label": n } : {}, p)), this.eventProvider.removeAddedEvents(), this.addProxyEventsToElement(this.innerElement, s.click), this.refreshPosition();
        }
        refreshPosition() {
          let s = this.getTargetPosition();
          X(this.innerElement, { width: (s.width || 1) + "px", height: (s.height || 1) + "px", left: (Math.round(s.x) || 0) + "px", top: (Math.round(s.y) || 0) + "px" });
        }
        remove() {
          this.eventProvider.removeAddedEvents(), x(this.element);
        }
        updateCSSClassName() {
          let s = (v) => v.indexOf("highcharts-no-tooltip") > -1, l = this.chart.legend, p = l.group && l.group.div, n = s(p && p.className || ""), a = s(this.getTargetAttr(this.target.click, "class") || "");
          this.innerElement.className = n || a ? "highcharts-a11y-proxy-element highcharts-no-tooltip" : "highcharts-a11y-proxy-element";
        }
        addProxyEventsToElement(s, l) {
          ["click", "touchstart", "touchend", "touchcancel", "touchmove", "mouseover", "mouseenter", "mouseleave", "mouseout"].forEach((p) => {
            let n = p.indexOf("touch") === 0;
            this.eventProvider.addEvent(s, p, (a) => {
              let v = n ? w(a) : y(a);
              l && O(l, v), a.stopPropagation(), n || a.preventDefault();
            }, { passive: !1 });
          });
        }
        hideElementVisually(s) {
          X(s, { borderWidth: 0, backgroundColor: "transparent", cursor: "pointer", outline: "none", opacity: 1e-3, filter: "alpha(opacity=1)", zIndex: 999, overflow: "hidden", padding: 0, margin: 0, display: "block", position: "absolute", "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)" });
        }
        getTargetPosition() {
          let s = this.target.click, l = s.element ? s.element : s, p = this.target.visual || l, n = this.chart.renderTo, a = this.chart.pointer;
          if (n && (p != null && p.getBoundingClientRect) && a) {
            let v = p.getBoundingClientRect(), N = a.getChartPosition();
            return { x: (v.left - N.left) / N.scaleX, y: (v.top - N.top) / N.scaleY, width: v.right / N.scaleX - v.left / N.scaleX, height: v.bottom / N.scaleY - v.top / N.scaleY };
          }
          return { x: 0, y: 0, width: 1, height: 1 };
        }
        getTargetAttr(s, l) {
          return s.element ? s.element.getAttribute(l) : s.getAttribute(l);
        }
      };
    }), ot(i, "Accessibility/ProxyProvider.js", [i["Core/Globals.js"], i["Core/Utilities.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Accessibility/Utils/DOMElementProvider.js"], i["Accessibility/Utils/HTMLUtilities.js"], i["Accessibility/ProxyElement.js"]], function(U, _, K, Z, J, q) {
      let { doc: tt } = U, { attr: X, css: I } = _, { unhideChartElementFromAT: O } = K, { removeChildNodes: y } = J;
      return class {
        constructor(w) {
          this.chart = w, this.domElementProvider = new Z(), this.groups = {}, this.groupOrder = [], this.beforeChartProxyPosContainer = this.createProxyPosContainer("before"), this.afterChartProxyPosContainer = this.createProxyPosContainer("after"), this.update();
        }
        addProxyElement(w, f, x = "button", s) {
          let l = this.groups[w];
          if (!l) throw Error("ProxyProvider.addProxyElement: Invalid group key " + w);
          let p = l.type === "ul" || l.type === "ol" ? "li" : void 0, n = new q(this.chart, f, x, p, s);
          return l.proxyContainerElement.appendChild(n.element), l.proxyElements.push(n), n;
        }
        addGroup(w, f = "div", x) {
          let s, l = this.groups[w];
          if (l) return l.groupElement;
          let p = this.domElementProvider.createElement(f);
          return x && x.role && f !== "div" ? (s = this.domElementProvider.createElement("div")).appendChild(p) : s = p, s.className = "highcharts-a11y-proxy-group highcharts-a11y-proxy-group-" + w.replace(/\W/g, "-"), this.groups[w] = { proxyContainerElement: p, groupElement: s, type: f, proxyElements: [] }, X(s, x || {}), f === "ul" && p.setAttribute("role", "list"), this.afterChartProxyPosContainer.appendChild(s), this.updateGroupOrder(this.groupOrder), s;
        }
        updateGroupAttrs(w, f) {
          let x = this.groups[w];
          if (!x) throw Error("ProxyProvider.updateGroupAttrs: Invalid group key " + w);
          X(x.groupElement, f);
        }
        updateGroupOrder(w) {
          if (this.groupOrder = w.slice(), this.isDOMOrderGroupOrder()) return;
          let f = w.indexOf("series"), x = f > -1 ? w.slice(0, f) : w, s = f > -1 ? w.slice(f + 1) : [], l = tt.activeElement;
          ["before", "after"].forEach((p) => {
            let n = this[p === "before" ? "beforeChartProxyPosContainer" : "afterChartProxyPosContainer"];
            y(n), (p === "before" ? x : s).forEach((a) => {
              let v = this.groups[a];
              v && n.appendChild(v.groupElement);
            });
          }), (this.beforeChartProxyPosContainer.contains(l) || this.afterChartProxyPosContainer.contains(l)) && l && l.focus && l.focus();
        }
        clearGroup(w) {
          let f = this.groups[w];
          if (!f) throw Error("ProxyProvider.clearGroup: Invalid group key " + w);
          y(f.proxyContainerElement);
        }
        removeGroup(w) {
          let f = this.groups[w];
          f && (this.domElementProvider.removeElement(f.groupElement), f.groupElement !== f.proxyContainerElement && this.domElementProvider.removeElement(f.proxyContainerElement), delete this.groups[w]);
        }
        update() {
          this.updatePosContainerPositions(), this.updateGroupOrder(this.groupOrder), this.updateProxyElementPositions();
        }
        updateProxyElementPositions() {
          Object.keys(this.groups).forEach(this.updateGroupProxyElementPositions.bind(this));
        }
        updateGroupProxyElementPositions(w) {
          let f = this.groups[w];
          f && f.proxyElements.forEach((x) => x.refreshPosition());
        }
        destroy() {
          this.domElementProvider.destroyCreatedElements();
        }
        createProxyPosContainer(w) {
          let f = this.domElementProvider.createElement("div");
          return f.setAttribute("aria-hidden", "false"), f.className = "highcharts-a11y-proxy-container" + (w ? "-" + w : ""), I(f, { top: "0", left: "0" }), this.chart.styledMode || (f.style.whiteSpace = "nowrap", f.style.position = "absolute"), f;
        }
        getCurrentGroupOrderInDOM() {
          let w = (l) => {
            let p = Object.keys(this.groups), n = p.length;
            for (; n--; ) {
              let a = p[n], v = this.groups[a];
              if (v && l === v.groupElement) return a;
            }
          }, f = (l) => {
            let p = [], n = l.children;
            for (let a = 0; a < n.length; ++a) {
              let v = w(n[a]);
              v && p.push(v);
            }
            return p;
          }, x = f(this.beforeChartProxyPosContainer), s = f(this.afterChartProxyPosContainer);
          return x.push("series"), x.concat(s);
        }
        isDOMOrderGroupOrder() {
          let w = this.getCurrentGroupOrderInDOM(), f = this.groupOrder.filter((s) => s === "series" || !!this.groups[s]), x = w.length;
          if (x !== f.length) return !1;
          for (; x--; ) if (w[x] !== f[x]) return !1;
          return !0;
        }
        updatePosContainerPositions() {
          let w = this.chart;
          if (w.renderer.forExport) return;
          let f = w.renderer.box;
          w.container.insertBefore(this.afterChartProxyPosContainer, f.nextSibling), w.container.insertBefore(this.beforeChartProxyPosContainer, f), O(this.chart, this.afterChartProxyPosContainer), O(this.chart, this.beforeChartProxyPosContainer);
        }
      };
    }), ot(i, "Accessibility/Components/RangeSelectorComponent.js", [i["Accessibility/AccessibilityComponent.js"], i["Accessibility/Utils/Announcer.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Accessibility/KeyboardNavigationHandler.js"], i["Core/Utilities.js"]], function(U, _, K, Z, J) {
      let { unhideChartElementFromAT: q, getAxisRangeDescription: tt } = K, { addEvent: X, attr: I } = J;
      class O extends U {
        init() {
          let w = this.chart;
          this.announcer = new _(w, "polite");
        }
        onChartUpdate() {
          let w = this.chart, f = this, x = w.rangeSelector;
          x && (this.updateSelectorVisibility(), this.setDropdownAttrs(), x.buttons && x.buttons.length && x.buttons.forEach((s) => {
            f.setRangeButtonAttrs(s);
          }), x.maxInput && x.minInput && ["minInput", "maxInput"].forEach(function(s, l) {
            let p = x[s];
            p && (q(w, p), f.setRangeInputAttrs(p, "accessibility.rangeSelector." + (l ? "max" : "min") + "InputLabel"));
          }));
        }
        updateSelectorVisibility() {
          let w = this.chart, f = w.rangeSelector, x = f && f.dropdown, s = f && f.buttons || [], l = (p) => p.setAttribute("aria-hidden", !0);
          f && f.hasVisibleDropdown && x ? (q(w, x), s.forEach((p) => l(p.element))) : (x && l(x), s.forEach((p) => q(w, p.element)));
        }
        setDropdownAttrs() {
          let w = this.chart, f = w.rangeSelector && w.rangeSelector.dropdown;
          if (f) {
            let x = w.langFormat("accessibility.rangeSelector.dropdownLabel", { rangeTitle: w.options.lang.rangeSelectorZoom });
            f.setAttribute("aria-label", x), f.setAttribute("tabindex", -1);
          }
        }
        setRangeButtonAttrs(w) {
          I(w.element, { tabindex: -1, role: "button" });
        }
        setRangeInputAttrs(w, f) {
          let x = this.chart;
          I(w, { tabindex: -1, "aria-label": x.langFormat(f, { chart: x }) });
        }
        onButtonNavKbdArrowKey(w, f) {
          let x = w.response, s = this.keyCodes, l = this.chart, p = l.options.accessibility.keyboardNavigation.wrapAround, n = f === s.left || f === s.up ? -1 : 1;
          return l.highlightRangeSelectorButton(l.highlightedRangeSelectorItemIx + n) ? x.success : p ? (w.init(n), x.success) : x[n > 0 ? "next" : "prev"];
        }
        onButtonNavKbdClick(w) {
          let f = w.response, x = this.chart;
          return x.oldRangeSelectorItemState !== 3 && this.fakeClickEvent(x.rangeSelector.buttons[x.highlightedRangeSelectorItemIx].element), f.success;
        }
        onAfterBtnClick() {
          let w = this.chart, f = tt(w.xAxis[0]), x = w.langFormat("accessibility.rangeSelector.clickButtonAnnouncement", { chart: w, axisRangeDescription: f });
          x && this.announcer.announce(x);
        }
        onInputKbdMove(w) {
          let f = this.chart, x = f.rangeSelector, s = f.highlightedInputRangeIx = (f.highlightedInputRangeIx || 0) + w;
          if (s > 1 || s < 0) {
            if (f.accessibility) return f.accessibility.keyboardNavigation.exiting = !0, f.accessibility.keyboardNavigation.tabindexContainer.focus(), f.accessibility.keyboardNavigation.move(w);
          } else if (x) {
            let l = x[s ? "maxDateBox" : "minDateBox"], p = x[s ? "maxInput" : "minInput"];
            l && p && f.setFocusToElement(l, p);
          }
          return !0;
        }
        onInputNavInit(w) {
          let f = this, x = this.chart, s = w > 0 ? 0 : 1, l = x.rangeSelector, p = l && l[s ? "maxDateBox" : "minDateBox"], n = l && l.minInput, a = l && l.maxInput;
          if (x.highlightedInputRangeIx = s, p && n && a) {
            x.setFocusToElement(p, s ? a : n), this.removeInputKeydownHandler && this.removeInputKeydownHandler();
            let v = (T) => {
              (T.which || T.keyCode) === this.keyCodes.tab && f.onInputKbdMove(T.shiftKey ? -1 : 1) && (T.preventDefault(), T.stopPropagation());
            }, N = X(n, "keydown", v), B = X(a, "keydown", v);
            this.removeInputKeydownHandler = () => {
              N(), B();
            };
          }
        }
        onInputNavTerminate() {
          let w = this.chart.rangeSelector || {};
          w.maxInput && w.hideInput("max"), w.minInput && w.hideInput("min"), this.removeInputKeydownHandler && (this.removeInputKeydownHandler(), delete this.removeInputKeydownHandler);
        }
        initDropdownNav() {
          let w = this.chart, f = w.rangeSelector, x = f && f.dropdown;
          f && x && (w.setFocusToElement(f.buttonGroup, x), this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeDropdownKeydownHandler = X(x, "keydown", (s) => {
            let l = (s.which || s.keyCode) === this.keyCodes.tab, p = w.accessibility;
            l && (s.preventDefault(), s.stopPropagation(), p && (p.keyboardNavigation.tabindexContainer.focus(), p.keyboardNavigation.move(s.shiftKey ? -1 : 1)));
          }));
        }
        getRangeSelectorButtonNavigation() {
          let w = this.chart, f = this.keyCodes, x = this;
          return new Z(w, { keyCodeMap: [[[f.left, f.right, f.up, f.down], function(s) {
            return x.onButtonNavKbdArrowKey(this, s);
          }], [[f.enter, f.space], function() {
            return x.onButtonNavKbdClick(this);
          }]], validate: function() {
            return !!(w.rangeSelector && w.rangeSelector.buttons && w.rangeSelector.buttons.length);
          }, init: function(s) {
            let l = w.rangeSelector;
            if (l && l.hasVisibleDropdown) x.initDropdownNav();
            else if (l) {
              let p = l.buttons.length - 1;
              w.highlightRangeSelectorButton(s > 0 ? 0 : p);
            }
          }, terminate: function() {
            x.removeDropdownKeydownHandler && (x.removeDropdownKeydownHandler(), delete x.removeDropdownKeydownHandler);
          } });
        }
        getRangeSelectorInputNavigation() {
          let w = this.chart, f = this;
          return new Z(w, { keyCodeMap: [], validate: function() {
            return !!(w.rangeSelector && w.rangeSelector.inputGroup && w.rangeSelector.inputGroup.element.style.visibility !== "hidden" && w.options.rangeSelector.inputEnabled !== !1 && w.rangeSelector.minInput && w.rangeSelector.maxInput);
          }, init: function(x) {
            f.onInputNavInit(x);
          }, terminate: function() {
            f.onInputNavTerminate();
          } });
        }
        getKeyboardNavigation() {
          return [this.getRangeSelectorButtonNavigation(), this.getRangeSelectorInputNavigation()];
        }
        destroy() {
          this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeInputKeydownHandler && this.removeInputKeydownHandler(), this.announcer && this.announcer.destroy();
        }
      }
      return function(y) {
        function w(x) {
          let s = this.rangeSelector && this.rangeSelector.buttons || [], l = this.highlightedRangeSelectorItemIx, p = this.rangeSelector && this.rangeSelector.selected;
          return l !== void 0 && s[l] && l !== p && s[l].setState(this.oldRangeSelectorItemState || 0), this.highlightedRangeSelectorItemIx = x, !!s[x] && (this.setFocusToElement(s[x].box, s[x].element), x !== p && (this.oldRangeSelectorItemState = s[x].state, s[x].setState(1)), !0);
        }
        function f() {
          let x = this.chart.accessibility;
          if (x && x.components.rangeSelector) return x.components.rangeSelector.onAfterBtnClick();
        }
        y.compose = function(x, s) {
          let l = x.prototype;
          l.highlightRangeSelectorButton || (l.highlightRangeSelectorButton = w, X(s, "afterBtnClick", f));
        };
      }(O || (O = {})), O;
    }), ot(i, "Accessibility/Components/SeriesComponent/ForcedMarkers.js", [i["Core/Globals.js"], i["Core/Utilities.js"]], function(U, _) {
      var K;
      let { composed: Z } = U, { addEvent: J, merge: q, pushUnique: tt } = _;
      return function(X) {
        function I(l) {
          q(!0, l, { marker: { enabled: !0, states: { normal: { opacity: 0 } } } });
        }
        function O(l) {
          return l.marker.states && l.marker.states.normal && l.marker.states.normal.opacity;
        }
        function y(l) {
          return !!(l._hasPointMarkers && l.points && l.points.length);
        }
        function w() {
          this.chart.styledMode && (this.markerGroup && this.markerGroup[this.a11yMarkersForced ? "addClass" : "removeClass"]("highcharts-a11y-markers-hidden"), y(this) && this.points.forEach((l) => {
            l.graphic && (l.graphic[l.hasForcedA11yMarker ? "addClass" : "removeClass"]("highcharts-a11y-marker-hidden"), l.graphic[l.hasForcedA11yMarker === !1 ? "addClass" : "removeClass"]("highcharts-a11y-marker-visible"));
          }));
        }
        function f(l) {
          this.resetA11yMarkerOptions = q(l.options.marker || {}, this.userOptions.marker || {});
        }
        function x() {
          let l = this.options;
          (function(p) {
            let n = p.chart.options.accessibility.enabled, a = (p.options.accessibility && p.options.accessibility.enabled) !== !1;
            return n && a && function(v) {
              let N = v.chart.options.accessibility;
              return v.points.length < N.series.pointDescriptionEnabledThreshold || N.series.pointDescriptionEnabledThreshold === !1;
            }(p);
          })(this) ? (l.marker && l.marker.enabled === !1 && (this.a11yMarkersForced = !0, I(this.options)), y(this) && function(p) {
            let n = p.points.length;
            for (; n--; ) {
              let a = p.points[n], v = a.options, N = a.hasForcedA11yMarker;
              if (delete a.hasForcedA11yMarker, v.marker) {
                let B = N && O(v) === 0;
                v.marker.enabled && !B ? (q(!0, v.marker, { states: { normal: { opacity: O(v) || 1 } } }), a.hasForcedA11yMarker = !1) : v.marker.enabled === !1 && (I(v), a.hasForcedA11yMarker = !0);
              }
            }
          }(this)) : this.a11yMarkersForced && (delete this.a11yMarkersForced, function(p) {
            let n = p.resetA11yMarkerOptions;
            if (n) {
              let a = n.states && n.states.normal && n.states.normal.opacity;
              p.userOptions && p.userOptions.marker && (p.userOptions.marker.enabled = !0), p.update({ marker: { enabled: n.enabled, states: { normal: { opacity: a } } } });
            }
          }(this), delete this.resetA11yMarkerOptions);
        }
        function s() {
          this.boosted && this.a11yMarkersForced && (q(!0, this.options, { marker: { enabled: !1 } }), delete this.a11yMarkersForced);
        }
        X.compose = function(l) {
          tt(Z, "A11y.FM") && (J(l, "afterSetOptions", f), J(l, "render", x), J(l, "afterRender", w), J(l, "renderCanvas", s));
        };
      }(K || (K = {})), K;
    }), ot(i, "Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js", [i["Core/Series/Point.js"], i["Core/Series/Series.js"], i["Core/Series/SeriesRegistry.js"], i["Core/Globals.js"], i["Core/Utilities.js"], i["Accessibility/KeyboardNavigationHandler.js"], i["Accessibility/Utils/EventProvider.js"], i["Accessibility/Utils/ChartUtilities.js"]], function(U, _, K, Z, J, q, tt, X) {
      let { seriesTypes: I } = K, { doc: O } = Z, { defined: y, fireEvent: w } = J, { getPointFromXY: f, getSeriesFromName: x, scrollAxisToPoint: s } = X;
      function l(T) {
        let o = T.index, u = T.series.points, c = u.length;
        if (u[o] === T) return o;
        for (; c--; ) if (u[c] === T) return c;
      }
      function p(T) {
        let o = T.chart.options.accessibility.keyboardNavigation.seriesNavigation, u = T.options.accessibility || {}, c = u.keyboardNavigation;
        return c && c.enabled === !1 || u.enabled === !1 || T.options.enableMouseTracking === !1 || !T.visible || o.pointNavigationEnabledThreshold && +o.pointNavigationEnabledThreshold <= T.points.length;
      }
      function n(T) {
        let o = T.series.chart.options.accessibility, u = T.options.accessibility && T.options.accessibility.enabled === !1;
        return T.isNull && o.keyboardNavigation.seriesNavigation.skipNullPoints || T.visible === !1 || T.isInside === !1 || u || p(T.series);
      }
      function a(T) {
        let o = T.series || [], u = o.length;
        for (let c = 0; c < u; ++c) if (!p(o[c])) {
          let e = function(t) {
            let h = t.points || [], b = h.length;
            for (let r = 0; r < b; ++r) if (!n(h[r])) return h[r];
            return null;
          }(o[c]);
          if (e) return e;
        }
        return null;
      }
      function v(T) {
        let o = T.series.length, u = !1;
        for (; o-- && (T.highlightedPoint = T.series[o].points[T.series[o].points.length - 1], !(u = T.series[o].highlightNextValidPoint())); ) ;
        return u;
      }
      function N(T) {
        delete T.highlightedPoint;
        let o = a(T);
        return !!o && o.highlight();
      }
      class B {
        constructor(o, u) {
          this.keyCodes = u, this.chart = o;
        }
        init() {
          let o = this, u = this.chart, c = this.eventProvider = new tt();
          c.addEvent(_, "destroy", function() {
            return o.onSeriesDestroy(this);
          }), c.addEvent(u, "afterApplyDrilldown", function() {
            (function(e) {
              let t = a(e);
              t && t.highlight(!1);
            })(this);
          }), c.addEvent(u, "drilldown", function(e) {
            let t = e.point, h = t.series;
            o.lastDrilledDownPoint = { x: t.x, y: t.y, seriesName: h ? h.name : "" };
          }), c.addEvent(u, "drillupall", function() {
            setTimeout(function() {
              o.onDrillupAll();
            }, 10);
          }), c.addEvent(U, "afterSetState", function() {
            let e = this.graphic && this.graphic.element, t = O.activeElement, h = t && t.getAttribute("class"), b = h && h.indexOf("highcharts-a11y-proxy-element") > -1;
            u.highlightedPoint === this && t !== e && !b && e && e.focus && e.focus();
          });
        }
        onDrillupAll() {
          let o, u = this.lastDrilledDownPoint, c = this.chart, e = u && x(c, u.seriesName);
          u && e && y(u.x) && y(u.y) && (o = f(e, u.x, u.y)), o = o || a(c), c.container && c.container.focus(), o && o.highlight && o.highlight(!1);
        }
        getKeyboardNavigationHandler() {
          let o = this, u = this.keyCodes, c = this.chart, e = c.inverted;
          return new q(c, { keyCodeMap: [[e ? [u.up, u.down] : [u.left, u.right], function(t) {
            return o.onKbdSideways(this, t);
          }], [e ? [u.left, u.right] : [u.up, u.down], function(t) {
            return o.onKbdVertical(this, t);
          }], [[u.enter, u.space], function(t, h) {
            var r;
            let b = c.highlightedPoint;
            if (b) {
              let { plotLeft: g, plotTop: d } = this.chart, { plotX: M = 0, plotY: H = 0 } = b;
              h = { ...h, chartX: g + M, chartY: d + H, point: b, target: ((r = b.graphic) == null ? void 0 : r.element) || h.target }, w(b.series, "click", h), b.firePointEvent("click", h);
            }
            return this.response.success;
          }], [[u.home], function() {
            return N(c), this.response.success;
          }], [[u.end], function() {
            return v(c), this.response.success;
          }], [[u.pageDown, u.pageUp], function(t) {
            return c.highlightAdjacentSeries(t === u.pageDown), this.response.success;
          }]], init: function() {
            return o.onHandlerInit(this);
          }, validate: function() {
            return !!a(c);
          }, terminate: function() {
            return o.onHandlerTerminate();
          } });
        }
        onKbdSideways(o, u) {
          let c = this.keyCodes, e = u === c.right || u === c.down;
          return this.attemptHighlightAdjacentPoint(o, e);
        }
        onHandlerInit(o) {
          let u = this.chart;
          return u.options.accessibility.keyboardNavigation.seriesNavigation.rememberPointFocus && u.highlightedPoint ? u.highlightedPoint.highlight() : N(u), o.response.success;
        }
        onKbdVertical(o, u) {
          let c = this.chart, e = this.keyCodes, t = u === e.down || u === e.right, h = c.options.accessibility.keyboardNavigation.seriesNavigation;
          if (h.mode && h.mode === "serialize") return this.attemptHighlightAdjacentPoint(o, t);
          let b = c.highlightedPoint && c.highlightedPoint.series.keyboardMoveVertical ? "highlightAdjacentPointVertical" : "highlightAdjacentSeries";
          return c[b](t), o.response.success;
        }
        onHandlerTerminate() {
          let o = this.chart, u = o.options.accessibility.keyboardNavigation;
          o.tooltip && o.tooltip.hide(0);
          let c = o.highlightedPoint && o.highlightedPoint.series;
          c && c.onMouseOut && c.onMouseOut(), o.highlightedPoint && o.highlightedPoint.onMouseOut && o.highlightedPoint.onMouseOut(), u.seriesNavigation.rememberPointFocus || delete o.highlightedPoint;
        }
        attemptHighlightAdjacentPoint(o, u) {
          let c = this.chart, e = c.options.accessibility.keyboardNavigation.wrapAround;
          return c.highlightAdjacentPoint(u) || e && (u ? N(c) : v(c)) ? o.response.success : o.response[u ? "next" : "prev"];
        }
        onSeriesDestroy(o) {
          let u = this.chart;
          u.highlightedPoint && u.highlightedPoint.series === o && (delete u.highlightedPoint, u.focusElement && u.focusElement.removeFocusBorder());
        }
        destroy() {
          this.eventProvider.removeAddedEvents();
        }
      }
      return function(T) {
        function o(h) {
          let b, r, g = this.series, d = this.highlightedPoint, M = d && l(d) || 0, H = d && d.series.points || [], A = this.series && this.series[this.series.length - 1], D = A && A.points && A.points[A.points.length - 1];
          if (!g[0] || !g[0].points) return !1;
          if (d) {
            if (b = g[d.series.index + (h ? 1 : -1)], (r = H[M + (h ? 1 : -1)]) || !b || (r = b.points[h ? 0 : b.points.length - 1]), !r) return !1;
          } else r = h ? g[0].points[0] : D;
          return n(r) ? (p(b = r.series) ? this.highlightedPoint = h ? b.points[b.points.length - 1] : b.points[0] : this.highlightedPoint = r, this.highlightAdjacentPoint(h)) : r.highlight();
        }
        function u(h) {
          let b = this.highlightedPoint, r = 1 / 0, g;
          return !!(y(b.plotX) && y(b.plotY)) && (this.series.forEach((d) => {
            p(d) || d.points.forEach((M) => {
              if (!y(M.plotY) || !y(M.plotX) || M === b) return;
              let H = M.plotY - b.plotY, A = Math.abs(M.plotX - b.plotX), D = Math.abs(H) * Math.abs(H) + A * A * 4;
              d.yAxis && d.yAxis.reversed && (H *= -1), !(H <= 0 && h || H >= 0 && !h || D < 5 || n(M)) && D < r && (r = D, g = M);
            });
          }), !!g && g.highlight());
        }
        function c(h) {
          let b, r, g, d = this.highlightedPoint, M = this.series && this.series[this.series.length - 1], H = M && M.points && M.points[M.points.length - 1];
          return this.highlightedPoint ? !!((b = this.series[d.series.index + (h ? -1 : 1)]) && (r = function(A, D, W, G) {
            let it = 1 / 0, C, k, L, F = D.points.length, m = (E) => !(y(E.plotX) && y(E.plotY));
            if (!m(A)) {
              for (; F--; ) !m(C = D.points[F]) && (L = (A.plotX - C.plotX) * (A.plotX - C.plotX) * 4 + (A.plotY - C.plotY) * (A.plotY - C.plotY) * 1) < it && (it = L, k = F);
              return y(k) ? D.points[k] : void 0;
            }
          }(d, b))) && (p(b) ? (r.highlight(), (g = this.highlightAdjacentSeries(h)) ? g : (d.highlight(), !1)) : (r.highlight(), r.series.highlightNextValidPoint())) : (b = h ? this.series && this.series[0] : M, !!(r = h ? b && b.points && b.points[0] : H) && r.highlight());
        }
        function e(h = !0) {
          var d, M;
          let b = this.series.chart, r = (M = (d = b.tooltip) == null ? void 0 : d.label) == null ? void 0 : M.element;
          !this.isNull && h ? this.onMouseOver() : b.tooltip && b.tooltip.hide(0), s(this), this.graphic && (b.setFocusToElement(this.graphic), !h && b.focusElement && b.focusElement.removeFocusBorder()), b.highlightedPoint = this;
          let g = r == null ? void 0 : r.getBoundingClientRect().top;
          if (r && g && g < 0) {
            let H = window.scrollY;
            window.scrollTo({ behavior: "smooth", top: H + g });
          }
          return this;
        }
        function t() {
          let h = this.chart.highlightedPoint, b = (h && h.series) === this ? l(h) : 0, r = this.points, g = r.length;
          if (r && g) {
            for (let d = b; d < g; ++d) if (!n(r[d])) return r[d].highlight();
            for (let d = b; d >= 0; --d) if (!n(r[d])) return r[d].highlight();
          }
          return !1;
        }
        T.compose = function(h, b, r) {
          let g = h.prototype, d = b.prototype, M = r.prototype;
          g.highlightAdjacentPoint || (g.highlightAdjacentPoint = o, g.highlightAdjacentPointVertical = u, g.highlightAdjacentSeries = c, d.highlight = e, M.keyboardMoveVertical = !0, ["column", "gantt", "pie"].forEach((H) => {
            I[H] && (I[H].prototype.keyboardMoveVertical = !1);
          }), M.highlightNextValidPoint = t);
        };
      }(B || (B = {})), B;
    }), ot(i, "Accessibility/Components/SeriesComponent/SeriesComponent.js", [i["Accessibility/AccessibilityComponent.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Accessibility/Components/SeriesComponent/ForcedMarkers.js"], i["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"], i["Accessibility/Components/SeriesComponent/SeriesDescriber.js"], i["Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js"]], function(U, _, K, Z, J, q) {
      let { hideSeriesFromAT: tt } = _, { describeSeries: X } = J;
      return class extends U {
        static compose(I, O, y) {
          Z.compose(y), K.compose(y), q.compose(I, O, y);
        }
        init() {
          this.newDataAnnouncer = new Z(this.chart), this.newDataAnnouncer.init(), this.keyboardNavigation = new q(this.chart, this.keyCodes), this.keyboardNavigation.init(), this.hideTooltipFromATWhenShown(), this.hideSeriesLabelsFromATWhenShown();
        }
        hideTooltipFromATWhenShown() {
          let I = this;
          this.chart.tooltip && this.addEvent(this.chart.tooltip.constructor, "refresh", function() {
            this.chart === I.chart && this.label && this.label.element && this.label.element.setAttribute("aria-hidden", !0);
          });
        }
        hideSeriesLabelsFromATWhenShown() {
          this.addEvent(this.chart, "afterDrawSeriesLabels", function() {
            this.series.forEach(function(I) {
              I.labelBySeries && I.labelBySeries.attr("aria-hidden", !0);
            });
          });
        }
        onChartRender() {
          this.chart.series.forEach(function(I) {
            (I.options.accessibility && I.options.accessibility.enabled) !== !1 && I.visible && I.getPointsCollection().length !== 0 ? X(I) : tt(I);
          });
        }
        getKeyboardNavigation() {
          return this.keyboardNavigation.getKeyboardNavigationHandler();
        }
        destroy() {
          this.newDataAnnouncer.destroy(), this.keyboardNavigation.destroy();
        }
      };
    }), ot(i, "Accessibility/Components/ZoomComponent.js", [i["Accessibility/AccessibilityComponent.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Accessibility/Utils/HTMLUtilities.js"], i["Accessibility/KeyboardNavigationHandler.js"], i["Core/Utilities.js"]], function(U, _, K, Z, J) {
      let { unhideChartElementFromAT: q } = _, { getFakeMouseEvent: tt } = K, { attr: X, pick: I } = J;
      return class extends U {
        constructor() {
          super(...arguments), this.focusedMapNavButtonIx = -1;
        }
        init() {
          let O = this, y = this.chart;
          this.proxyProvider.addGroup("zoom", "div"), ["afterShowResetZoom", "afterApplyDrilldown", "drillupall"].forEach((w) => {
            O.addEvent(y, w, function() {
              O.updateProxyOverlays();
            });
          });
        }
        onChartUpdate() {
          let O = this.chart, y = this;
          O.mapNavigation && O.mapNavigation.navButtons.forEach((w, f) => {
            q(O, w.element), y.setMapNavButtonAttrs(w.element, "accessibility.zoom.mapZoom" + (f ? "Out" : "In"));
          });
        }
        setMapNavButtonAttrs(O, y) {
          let w = this.chart;
          X(O, { tabindex: -1, role: "button", "aria-label": w.langFormat(y, { chart: w }) });
        }
        onChartRender() {
          this.updateProxyOverlays();
        }
        updateProxyOverlays() {
          let O = this.chart;
          if (this.proxyProvider.clearGroup("zoom"), O.resetZoomButton && this.createZoomProxyButton(O.resetZoomButton, "resetZoomProxyButton", O.langFormat("accessibility.zoom.resetZoomButton", { chart: O })), O.drillUpButton && O.breadcrumbs && O.breadcrumbs.list) {
            let y = O.breadcrumbs.list[O.breadcrumbs.list.length - 1];
            this.createZoomProxyButton(O.drillUpButton, "drillUpProxyButton", O.langFormat("accessibility.drillUpButton", { chart: O, buttonText: O.breadcrumbs.getButtonText(y) }));
          }
        }
        createZoomProxyButton(O, y, w) {
          this[y] = this.proxyProvider.addProxyElement("zoom", { click: O }, "button", { "aria-label": w, tabindex: -1 });
        }
        getMapZoomNavigation() {
          let O = this.keyCodes, y = this.chart, w = this;
          return new Z(y, { keyCodeMap: [[[O.up, O.down, O.left, O.right], function(f) {
            return w.onMapKbdArrow(this, f);
          }], [[O.tab], function(f, x) {
            return w.onMapKbdTab(this, x);
          }], [[O.space, O.enter], function() {
            return w.onMapKbdClick(this);
          }]], validate: function() {
            return !!(y.mapView && y.mapNavigation && y.mapNavigation.navButtons.length);
          }, init: function(f) {
            return w.onMapNavInit(f);
          } });
        }
        onMapKbdArrow(O, y) {
          let w = this.chart, f = this.keyCodes, x = w.container, s = y === f.up || y === f.down, l = y === f.left || y === f.up ? 1 : -1, p = (s ? w.plotHeight : w.plotWidth) / 10 * l, n = 10 * Math.random(), a = { x: x.offsetLeft + w.plotLeft + w.plotWidth / 2 + n, y: x.offsetTop + w.plotTop + w.plotHeight / 2 + n }, v = s ? { x: a.x, y: a.y + p } : { x: a.x + p, y: a.y };
          return [tt("mousedown", a), tt("mousemove", v), tt("mouseup", v)].forEach((N) => x.dispatchEvent(N)), O.response.success;
        }
        onMapKbdTab(O, y) {
          let w = this.chart, f = O.response, x = y.shiftKey, s = x && !this.focusedMapNavButtonIx || !x && this.focusedMapNavButtonIx;
          if (w.mapNavigation.navButtons[this.focusedMapNavButtonIx].setState(0), s) return w.mapView && w.mapView.zoomBy(), f[x ? "prev" : "next"];
          this.focusedMapNavButtonIx += x ? -1 : 1;
          let l = w.mapNavigation.navButtons[this.focusedMapNavButtonIx];
          return w.setFocusToElement(l.box, l.element), l.setState(2), f.success;
        }
        onMapKbdClick(O) {
          let y = this.chart.mapNavigation.navButtons[this.focusedMapNavButtonIx].element;
          return this.fakeClickEvent(y), O.response.success;
        }
        onMapNavInit(O) {
          let y = this.chart, w = y.mapNavigation.navButtons[0], f = y.mapNavigation.navButtons[1], x = O > 0 ? w : f;
          y.setFocusToElement(x.box, x.element), x.setState(2), this.focusedMapNavButtonIx = O > 0 ? 0 : 1;
        }
        simpleButtonNavigation(O, y, w) {
          let f = this.keyCodes, x = this, s = this.chart;
          return new Z(s, { keyCodeMap: [[[f.tab, f.up, f.down, f.left, f.right], function(l, p) {
            let n = l === f.tab && p.shiftKey || l === f.left || l === f.up;
            return this.response[n ? "prev" : "next"];
          }], [[f.space, f.enter], function() {
            return I(w(this, s), this.response.success);
          }]], validate: function() {
            return s[O] && s[O].box && x[y].innerElement;
          }, init: function() {
            s.setFocusToElement(s[O].box, x[y].innerElement);
          } });
        }
        getKeyboardNavigation() {
          return [this.simpleButtonNavigation("resetZoomButton", "resetZoomProxyButton", function(O, y) {
            y.zoomOut();
          }), this.simpleButtonNavigation("drillUpButton", "drillUpProxyButton", function(O, y) {
            return y.drillUp(), O.response.prev;
          }), this.getMapZoomNavigation()];
        }
      };
    }), ot(i, "Accessibility/HighContrastMode.js", [i["Core/Globals.js"]], function(U) {
      let { doc: _, isMS: K, win: Z } = U;
      return { isHighContrastModeActive: function() {
        let J = /(Edg)/.test(Z.navigator.userAgent);
        if (Z.matchMedia && J) return Z.matchMedia("(-ms-high-contrast: active)").matches;
        if (K && Z.getComputedStyle) {
          let q = _.createElement("div");
          q.style.backgroundImage = "url(data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==)", _.body.appendChild(q);
          let tt = (q.currentStyle || Z.getComputedStyle(q)).backgroundImage;
          return _.body.removeChild(q), tt === "none";
        }
        return Z.matchMedia && Z.matchMedia("(forced-colors: active)").matches;
      }, setHighContrastTheme: function(J) {
        var X;
        J.highContrastModeActive = !0;
        let q = J.options.accessibility.highContrastTheme;
        J.update(q, !1);
        let tt = ((X = q.colors) == null ? void 0 : X.length) > 1;
        J.series.forEach(function(I) {
          let O = q.plotOptions[I.type] || {}, y = tt && I.colorIndex !== void 0 ? q.colors[I.colorIndex] : O.color || "window", w = { color: O.color || "windowText", colors: tt ? q.colors : [O.color || "windowText"], borderColor: O.borderColor || "window", fillColor: y };
          I.update(w, !1), I.points && I.points.forEach(function(f) {
            f.options && f.options.color && f.update({ color: O.color || "windowText", borderColor: O.borderColor || "window" }, !1);
          });
        }), J.redraw();
      } };
    }), ot(i, "Accessibility/HighContrastTheme.js", [], function() {
      return { chart: { backgroundColor: "window" }, title: { style: { color: "windowText" } }, subtitle: { style: { color: "windowText" } }, colorAxis: { minColor: "windowText", maxColor: "windowText", stops: [], dataClasses: [] }, colors: ["windowText"], xAxis: { gridLineColor: "windowText", labels: { style: { color: "windowText" } }, lineColor: "windowText", minorGridLineColor: "windowText", tickColor: "windowText", title: { style: { color: "windowText" } } }, yAxis: { gridLineColor: "windowText", labels: { style: { color: "windowText" } }, lineColor: "windowText", minorGridLineColor: "windowText", tickColor: "windowText", title: { style: { color: "windowText" } } }, tooltip: { backgroundColor: "window", borderColor: "windowText", style: { color: "windowText" } }, plotOptions: { series: { lineColor: "windowText", fillColor: "window", borderColor: "windowText", edgeColor: "windowText", borderWidth: 1, dataLabels: { connectorColor: "windowText", color: "windowText", style: { color: "windowText", textOutline: "none" } }, marker: { lineColor: "windowText", fillColor: "windowText" } }, pie: { color: "window", colors: ["window"], borderColor: "windowText", borderWidth: 1 }, boxplot: { fillColor: "window" }, candlestick: { lineColor: "windowText", fillColor: "window" }, errorbar: { fillColor: "window" } }, legend: { backgroundColor: "window", itemStyle: { color: "windowText" }, itemHoverStyle: { color: "windowText" }, itemHiddenStyle: { color: "#555" }, title: { style: { color: "windowText" } } }, credits: { style: { color: "windowText" } }, drilldown: { activeAxisLabelStyle: { color: "windowText" }, activeDataLabelStyle: { color: "windowText" } }, navigation: { buttonOptions: { symbolStroke: "windowText", theme: { fill: "window" } } }, rangeSelector: { buttonTheme: { fill: "window", stroke: "windowText", style: { color: "windowText" }, states: { hover: { fill: "window", stroke: "windowText", style: { color: "windowText" } }, select: { fill: "#444", stroke: "windowText", style: { color: "windowText" } } } }, inputBoxBorderColor: "windowText", inputStyle: { backgroundColor: "window", color: "windowText" }, labelStyle: { color: "windowText" } }, navigator: { handles: { backgroundColor: "window", borderColor: "windowText" }, outlineColor: "windowText", maskFill: "transparent", series: { color: "windowText", lineColor: "windowText" }, xAxis: { gridLineColor: "windowText" } }, scrollbar: { barBackgroundColor: "#444", barBorderColor: "windowText", buttonArrowColor: "windowText", buttonBackgroundColor: "window", buttonBorderColor: "windowText", rifleColor: "windowText", trackBackgroundColor: "window", trackBorderColor: "windowText" } };
    }), ot(i, "Accessibility/Options/A11yDefaults.js", [], function() {
      return { accessibility: { enabled: !0, screenReaderSection: { beforeChartFormat: "<{headingTagName}>{chartTitle}</{headingTagName}><div>{typeDescription}</div><div>{chartSubtitle}</div><div>{chartLongdesc}</div><div>{playAsSoundButton}</div><div>{viewTableButton}</div><div>{xAxisDescription}</div><div>{yAxisDescription}</div><div>{annotationsTitle}{annotationsList}</div>", afterChartFormat: "{endOfChartMarker}", axisRangeDateFormat: "%Y-%m-%d %H:%M:%S" }, series: { descriptionFormat: "{seriesDescription}{authorDescription}{axisDescription}", describeSingleSeries: !1, pointDescriptionEnabledThreshold: 200 }, point: { valueDescriptionFormat: "{xDescription}{separator}{value}.", describeNull: !0 }, landmarkVerbosity: "all", linkedDescription: '*[data-highcharts-chart="{index}"] + .highcharts-description', highContrastMode: "auto", keyboardNavigation: { enabled: !0, focusBorder: { enabled: !0, hideBrowserFocusOutline: !0, style: { color: "#334eff", lineWidth: 2, borderRadius: 3 }, margin: 2 }, order: ["series", "zoom", "rangeSelector", "navigator", "legend", "chartMenu"], wrapAround: !0, seriesNavigation: { skipNullPoints: !0, pointNavigationEnabledThreshold: !1, rememberPointFocus: !1 } }, announceNewData: { enabled: !1, minAnnounceInterval: 5e3, interruptUser: !1 } }, legend: { accessibility: { enabled: !0, keyboardNavigation: { enabled: !0 } } }, exporting: { accessibility: { enabled: !0 } }, navigator: { accessibility: { enabled: !0 } } };
    }), ot(i, "Accessibility/Options/LangDefaults.js", [], function() {
      return { accessibility: { defaultChartTitle: "Chart", chartContainerLabel: "{title}. Highcharts interactive chart.", svgContainerLabel: "Interactive chart", drillUpButton: "{buttonText}", credits: "Chart credits: {creditsStr}", thousandsSep: ",", svgContainerTitle: "", graphicContainerLabel: "", screenReaderSection: { beforeRegionLabel: "", afterRegionLabel: "", annotations: { heading: "Chart annotations summary", descriptionSinglePoint: "{annotationText}. Related to {annotationPoint}", descriptionMultiplePoints: "{annotationText}. Related to {annotationPoint}{#each additionalAnnotationPoints}, also related to {this}{/each}", descriptionNoPoints: "{annotationText}" }, endOfChartMarker: "End of interactive chart." }, sonification: { playAsSoundButtonText: "Play as sound, {chartTitle}", playAsSoundClickAnnouncement: "Play" }, legend: { legendLabelNoTitle: "Toggle series visibility, {chartTitle}", legendLabel: "Chart legend: {legendTitle}", legendItem: "Show {itemName}" }, zoom: { mapZoomIn: "Zoom chart", mapZoomOut: "Zoom out chart", resetZoomButton: "Reset zoom" }, rangeSelector: { dropdownLabel: "{rangeTitle}", minInputLabel: "Select start date.", maxInputLabel: "Select end date.", clickButtonAnnouncement: "Viewing {axisRangeDescription}" }, navigator: { handleLabel: "{#eq handleIx 0}Start, percent{else}End, percent{/eq}", groupLabel: "Axis zoom", changeAnnouncement: "{axisRangeDescription}" }, table: { viewAsDataTableButtonText: "View as data table, {chartTitle}", tableSummary: "Table representation of chart." }, announceNewData: { newDataAnnounce: "Updated data for chart {chartTitle}", newSeriesAnnounceSingle: "New data series: {seriesDesc}", newPointAnnounceSingle: "New data point: {pointDesc}", newSeriesAnnounceMultiple: "New data series in chart {chartTitle}: {seriesDesc}", newPointAnnounceMultiple: "New data point in chart {chartTitle}: {pointDesc}" }, seriesTypeDescriptions: { boxplot: "Box plot charts are typically used to display groups of statistical data. Each data point in the chart can have up to 5 values: minimum, lower quartile, median, upper quartile, and maximum.", arearange: "Arearange charts are line charts displaying a range between a lower and higher value for each point.", areasplinerange: "These charts are line charts displaying a range between a lower and higher value for each point.", bubble: "Bubble charts are scatter charts where each data point also has a size value.", columnrange: "Columnrange charts are column charts displaying a range between a lower and higher value for each point.", errorbar: "Errorbar series are used to display the variability of the data.", funnel: "Funnel charts are used to display reduction of data in stages.", pyramid: "Pyramid charts consist of a single pyramid with item heights corresponding to each point value.", waterfall: "A waterfall chart is a column chart where each column contributes towards a total end value." }, chartTypes: { emptyChart: "Empty chart", mapTypeDescription: "Map of {mapTitle} with {numSeries} data series.", unknownMap: "Map of unspecified region with {numSeries} data series.", combinationChart: "Combination chart with {numSeries} data series.", defaultSingle: "Chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.", defaultMultiple: "Chart with {numSeries} data series.", splineSingle: "Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.", splineMultiple: "Line chart with {numSeries} lines.", lineSingle: "Line chart with {numPoints} data {#eq numPoints 1}point{else}points{/eq}.", lineMultiple: "Line chart with {numSeries} lines.", columnSingle: "Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.", columnMultiple: "Bar chart with {numSeries} data series.", barSingle: "Bar chart with {numPoints} {#eq numPoints 1}bar{else}bars{/eq}.", barMultiple: "Bar chart with {numSeries} data series.", pieSingle: "Pie chart with {numPoints} {#eq numPoints 1}slice{else}slices{/eq}.", pieMultiple: "Pie chart with {numSeries} pies.", scatterSingle: "Scatter chart with {numPoints} {#eq numPoints 1}point{else}points{/eq}.", scatterMultiple: "Scatter chart with {numSeries} data series.", boxplotSingle: "Boxplot with {numPoints} {#eq numPoints 1}box{else}boxes{/eq}.", boxplotMultiple: "Boxplot with {numSeries} data series.", bubbleSingle: "Bubble chart with {numPoints} {#eq numPoints 1}bubbles{else}bubble{/eq}.", bubbleMultiple: "Bubble chart with {numSeries} data series." }, axis: { xAxisDescriptionSingular: "The chart has 1 X axis displaying {names[0]}. {ranges[0]}", xAxisDescriptionPlural: "The chart has {numAxes} X axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.", yAxisDescriptionSingular: "The chart has 1 Y axis displaying {names[0]}. {ranges[0]}", yAxisDescriptionPlural: "The chart has {numAxes} Y axes displaying {#each names}{#unless @first},{/unless}{#if @last} and{/if} {this}{/each}.", timeRangeDays: "Data range: {range} days.", timeRangeHours: "Data range: {range} hours.", timeRangeMinutes: "Data range: {range} minutes.", timeRangeSeconds: "Data range: {range} seconds.", rangeFromTo: "Data ranges from {rangeFrom} to {rangeTo}.", rangeCategories: "Data range: {numCategories} categories." }, exporting: { chartMenuLabel: "Chart menu", menuButtonLabel: "View chart menu, {chartTitle}" }, series: { summary: { default: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", defaultCombination: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", line: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", lineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", spline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", splineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", column: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", columnCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", bar: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", barCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#eq series.points.length 1}bar{else}bars{/eq}.", pie: "{series.name}, pie {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.", pieCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Pie with {series.points.length} {#eq series.points.length 1}slice{else}slices{/eq}.", scatter: "{series.name}, scatter plot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.", scatterCombination: "{series.name}, series {seriesNumber} of {chart.series.length}, scatter plot with {series.points.length} {#eq series.points.length 1}point{else}points{/eq}.", boxplot: "{series.name}, boxplot {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.", boxplotCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Boxplot with {series.points.length} {#eq series.points.length 1}box{else}boxes{/eq}.", bubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.", bubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.", map: "{series.name}, map {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.", mapCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Map with {series.points.length} {#eq series.points.length 1}area{else}areas{/eq}.", mapline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", maplineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#eq series.points.length 1}point{else}points{/eq}.", mapbubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}.", mapbubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#eq series.points.length 1}bubble{else}bubbles{/eq}." }, description: "{description}", xAxisDescription: "X axis, {name}", yAxisDescription: "Y axis, {name}", nullPointValue: "No value", pointAnnotationsDescription: "{#each annotations}Annotation: {this}{/each}" } } };
    }), ot(i, "Accessibility/Options/DeprecatedOptions.js", [i["Core/Utilities.js"]], function(U) {
      let { error: _, pick: K } = U;
      function Z(q, tt, X) {
        let I = q, O, y = 0;
        for (; y < tt.length - 1; ++y) I = I[O = tt[y]] = K(I[O], {});
        I[tt[tt.length - 1]] = X;
      }
      function J(q, tt, X, I) {
        function O(f, x) {
          return x.reduce(function(s, l) {
            return s[l];
          }, f);
        }
        let y = O(q.options, tt), w = O(q.options, X);
        Object.keys(I).forEach(function(f) {
          let x = y[f];
          x !== void 0 && (Z(w, I[f], x), _(32, !1, q, { [tt.join(".") + "." + f]: X.join(".") + "." + I[f].join(".") }));
        });
      }
      return function(q) {
        (function(tt) {
          let X = tt.options.chart, I = tt.options.accessibility || {};
          ["description", "typeDescription"].forEach(function(O) {
            X[O] && (I[O] = X[O], _(32, !1, tt, { [`chart.${O}`]: `use accessibility.${O}` }));
          });
        })(q), function(tt) {
          tt.axes.forEach(function(X) {
            let I = X.options;
            I && I.description && (I.accessibility = I.accessibility || {}, I.accessibility.description = I.description, _(32, !1, tt, { "axis.description": "use axis.accessibility.description" }));
          });
        }(q), q.series && function(tt) {
          let X = { description: ["accessibility", "description"], exposeElementToA11y: ["accessibility", "exposeAsGroupOnly"], pointDescriptionFormatter: ["accessibility", "point", "descriptionFormatter"], skipKeyboardNavigation: ["accessibility", "keyboardNavigation", "enabled"], "accessibility.pointDescriptionFormatter": ["accessibility", "point", "descriptionFormatter"] };
          tt.series.forEach(function(I) {
            Object.keys(X).forEach(function(O) {
              let y = I.options[O];
              O === "accessibility.pointDescriptionFormatter" && (y = I.options.accessibility && I.options.accessibility.pointDescriptionFormatter), y !== void 0 && (Z(I.options, X[O], O === "skipKeyboardNavigation" ? !y : y), _(32, !1, tt, { [`series.${O}`]: "series." + X[O].join(".") }));
            });
          });
        }(q), J(q, ["accessibility"], ["accessibility"], { pointDateFormat: ["point", "dateFormat"], pointDateFormatter: ["point", "dateFormatter"], pointDescriptionFormatter: ["point", "descriptionFormatter"], pointDescriptionThreshold: ["series", "pointDescriptionEnabledThreshold"], pointNavigationThreshold: ["keyboardNavigation", "seriesNavigation", "pointNavigationEnabledThreshold"], pointValueDecimals: ["point", "valueDecimals"], pointValuePrefix: ["point", "valuePrefix"], pointValueSuffix: ["point", "valueSuffix"], screenReaderSectionFormatter: ["screenReaderSection", "beforeChartFormatter"], describeSingleSeries: ["series", "describeSingleSeries"], seriesDescriptionFormatter: ["series", "descriptionFormatter"], onTableAnchorClick: ["screenReaderSection", "onViewDataTableClick"], axisRangeDateFormat: ["screenReaderSection", "axisRangeDateFormat"] }), J(q, ["accessibility", "keyboardNavigation"], ["accessibility", "keyboardNavigation", "seriesNavigation"], { skipNullPoints: ["skipNullPoints"], mode: ["mode"] }), J(q, ["lang", "accessibility"], ["lang", "accessibility"], { legendItem: ["legend", "legendItem"], legendLabel: ["legend", "legendLabel"], mapZoomIn: ["zoom", "mapZoomIn"], mapZoomOut: ["zoom", "mapZoomOut"], resetZoomButton: ["zoom", "resetZoomButton"], screenReaderRegionLabel: ["screenReaderSection", "beforeRegionLabel"], rangeSelectorButton: ["rangeSelector", "buttonText"], rangeSelectorMaxInput: ["rangeSelector", "maxInputLabel"], rangeSelectorMinInput: ["rangeSelector", "minInputLabel"], svgContainerEnd: ["screenReaderSection", "endOfChartMarker"], viewAsDataTable: ["table", "viewAsDataTableButtonText"], tableSummary: ["table", "tableSummary"] });
      };
    }), ot(i, "Accessibility/Accessibility.js", [i["Core/Defaults.js"], i["Core/Globals.js"], i["Core/Utilities.js"], i["Accessibility/Utils/HTMLUtilities.js"], i["Accessibility/A11yI18n.js"], i["Accessibility/Components/ContainerComponent.js"], i["Accessibility/FocusBorder.js"], i["Accessibility/Components/InfoRegionsComponent.js"], i["Accessibility/KeyboardNavigation.js"], i["Accessibility/Components/LegendComponent.js"], i["Accessibility/Components/MenuComponent.js"], i["Accessibility/Components/NavigatorComponent.js"], i["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"], i["Accessibility/ProxyProvider.js"], i["Accessibility/Components/RangeSelectorComponent.js"], i["Accessibility/Components/SeriesComponent/SeriesComponent.js"], i["Accessibility/Components/ZoomComponent.js"], i["Accessibility/HighContrastMode.js"], i["Accessibility/HighContrastTheme.js"], i["Accessibility/Options/A11yDefaults.js"], i["Accessibility/Options/LangDefaults.js"], i["Accessibility/Options/DeprecatedOptions.js"]], function(U, _, K, Z, J, q, tt, X, I, O, y, w, f, x, s, l, p, n, a, v, N, B) {
      let { defaultOptions: T } = U, { doc: o } = _, { addEvent: u, extend: c, fireEvent: e, merge: t } = K, { removeElement: h } = Z;
      class b {
        constructor(g) {
          this.init(g);
        }
        init(g) {
          if (this.chart = g, !o.addEventListener) {
            this.zombie = !0, this.components = {}, g.renderTo.setAttribute("aria-hidden", !0);
            return;
          }
          B(g), this.proxyProvider = new x(this.chart), this.initComponents(), this.keyboardNavigation = new I(g, this.components);
        }
        initComponents() {
          let g = this.chart, d = this.proxyProvider, M = g.options.accessibility;
          this.components = { container: new q(), infoRegions: new X(), legend: new O(), chartMenu: new y(), rangeSelector: new s(), series: new l(), zoom: new p(), navigator: new w() }, M.customComponents && c(this.components, M.customComponents);
          let H = this.components;
          this.getComponentOrder().forEach(function(A) {
            H[A].initBase(g, d), H[A].init();
          });
        }
        getComponentOrder() {
          return this.components ? this.components.series ? ["series"].concat(Object.keys(this.components).filter((g) => g !== "series")) : Object.keys(this.components) : [];
        }
        update() {
          let g = this.components, d = this.chart, M = d.options.accessibility;
          e(d, "beforeA11yUpdate"), d.types = this.getChartTypes();
          let H = M.keyboardNavigation.order;
          this.proxyProvider.updateGroupOrder(H), this.getComponentOrder().forEach(function(A) {
            g[A].onChartUpdate(), e(d, "afterA11yComponentUpdate", { name: A, component: g[A] });
          }), this.keyboardNavigation.update(H), !d.highContrastModeActive && M.highContrastMode !== !1 && (n.isHighContrastModeActive() || M.highContrastMode === !0) && n.setHighContrastTheme(d), e(d, "afterA11yUpdate", { accessibility: this });
        }
        destroy() {
          let g = this.chart || {}, d = this.components;
          Object.keys(d).forEach(function(M) {
            d[M].destroy(), d[M].destroyBase();
          }), this.proxyProvider && this.proxyProvider.destroy(), g.announcerContainer && h(g.announcerContainer), this.keyboardNavigation && this.keyboardNavigation.destroy(), g.renderTo && g.renderTo.setAttribute("aria-hidden", !0), g.focusElement && g.focusElement.removeFocusBorder();
        }
        getChartTypes() {
          let g = {};
          return this.chart.series.forEach(function(d) {
            g[d.type] = 1;
          }), Object.keys(g);
        }
      }
      return function(r) {
        function g() {
          this.accessibility && this.accessibility.destroy();
        }
        function d() {
          this.a11yDirty && this.renderTo && (delete this.a11yDirty, this.updateA11yEnabled());
          let D = this.accessibility;
          D && !D.zombie && (D.proxyProvider.updateProxyElementPositions(), D.getComponentOrder().forEach(function(W) {
            D.components[W].onChartRender();
          }));
        }
        function M(D) {
          let W = D.options.accessibility;
          W && (W.customComponents && (this.options.accessibility.customComponents = W.customComponents, delete W.customComponents), t(!0, this.options.accessibility, W), this.accessibility && this.accessibility.destroy && (this.accessibility.destroy(), delete this.accessibility)), this.a11yDirty = !0;
        }
        function H() {
          let D = this.accessibility, W = this.options.accessibility, G = this.renderer.boxWrapper.element, it = this.title;
          if (W && W.enabled) D && !D.zombie ? D.update() : (this.accessibility = D = new r(this), D && !D.zombie && D.update(), G.getAttribute("role") === "img" && G.removeAttribute("role"));
          else if (D) D.destroy && D.destroy(), delete this.accessibility;
          else {
            this.renderTo.setAttribute("role", "img"), this.renderTo.setAttribute("aria-hidden", !1), this.renderTo.setAttribute("aria-label", (it && it.element.textContent || "").replace(/</g, "&lt;")), G.setAttribute("aria-hidden", !0);
            let C = document.getElementsByClassName("highcharts-description")[0];
            C && (C.setAttribute("aria-hidden", !1), C.classList.remove("highcharts-linked-description"));
          }
        }
        function A() {
          this.series.chart.accessibility && (this.series.chart.a11yDirty = !0);
        }
        r.i18nFormat = J.i18nFormat, r.compose = function(D, W, G, it, C, k) {
          I.compose(D), f.compose(it), O.compose(D, W), y.compose(D), l.compose(D, G, it), J.compose(D), tt.compose(D, C), k && s.compose(D, k);
          let L = D.prototype;
          L.updateA11yEnabled || (L.updateA11yEnabled = H, u(D, "destroy", g), u(D, "render", d), u(D, "update", M), ["addSeries", "init"].forEach((F) => {
            u(D, F, function() {
              this.a11yDirty = !0;
            });
          }), ["afterApplyDrilldown", "drillupall"].forEach((F) => {
            u(D, F, function() {
              let m = this.accessibility;
              m && !m.zombie && m.update();
            });
          }), u(G, "update", A), ["update", "updatedData", "remove"].forEach((F) => {
            u(it, F, function() {
              this.chart.accessibility && (this.chart.a11yDirty = !0);
            });
          }));
        };
      }(b || (b = {})), t(!0, T, v, { accessibility: { highContrastTheme: a }, lang: N }), b;
    }), ot(i, "masters/modules/accessibility.src.js", [i["Core/Globals.js"], i["Accessibility/Accessibility.js"], i["Accessibility/AccessibilityComponent.js"], i["Accessibility/Utils/ChartUtilities.js"], i["Accessibility/Utils/HTMLUtilities.js"], i["Accessibility/KeyboardNavigationHandler.js"], i["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]], function(U, _, K, Z, J, q, tt) {
      return U.i18nFormat = _.i18nFormat, U.A11yChartUtilities = Z, U.A11yHTMLUtilities = J, U.AccessibilityComponent = K, U.KeyboardNavigationHandler = q, U.SeriesAccessibilityDescriber = tt, _.compose(U.Chart, U.Legend, U.Point, U.Series, U.SVGElement, U.RangeSelector), U;
    });
  });
})(Yi);
var Ds = Yi.exports;
const Is = /* @__PURE__ */ Xi(Ds);
var $i = typeof global == "object" && global && global.Object === Object && global, js = typeof self == "object" && self && self.Object === Object && self, Ht = $i || js || Function("return this")(), Zt = Ht.Symbol, Vi = Object.prototype, Ns = Vi.hasOwnProperty, Bs = Vi.toString, oe = Zt ? Zt.toStringTag : void 0;
function Rs(S) {
  var j = Ns.call(S, oe), i = S[oe];
  try {
    S[oe] = void 0;
    var ot = !0;
  } catch {
  }
  var U = Bs.call(S);
  return ot && (j ? S[oe] = i : delete S[oe]), U;
}
var zs = Object.prototype, Fs = zs.toString;
function Hs(S) {
  return Fs.call(S);
}
var Us = "[object Null]", Gs = "[object Undefined]", bi = Zt ? Zt.toStringTag : void 0;
function ie(S) {
  return S == null ? S === void 0 ? Gs : Us : bi && bi in Object(S) ? Rs(S) : Hs(S);
}
function Jt(S) {
  return S != null && typeof S == "object";
}
var Ws = "[object Symbol]";
function $e(S) {
  return typeof S == "symbol" || Jt(S) && ie(S) == Ws;
}
function qi(S, j) {
  for (var i = -1, ot = S == null ? 0 : S.length, U = Array(ot); ++i < ot; )
    U[i] = j(S[i], i, S);
  return U;
}
var Bt = Array.isArray, yi = Zt ? Zt.prototype : void 0, xi = yi ? yi.toString : void 0;
function Ki(S) {
  if (typeof S == "string")
    return S;
  if (Bt(S))
    return qi(S, Ki) + "";
  if ($e(S))
    return xi ? xi.call(S) : "";
  var j = S + "";
  return j == "0" && 1 / S == -1 / 0 ? "-0" : j;
}
function Ft(S) {
  var j = typeof S;
  return S != null && (j == "object" || j == "function");
}
function Ve(S) {
  return S;
}
var Xs = "[object AsyncFunction]", _s = "[object Function]", Ys = "[object GeneratorFunction]", $s = "[object Proxy]";
function qe(S) {
  if (!Ft(S))
    return !1;
  var j = ie(S);
  return j == _s || j == Ys || j == Xs || j == $s;
}
var Be = Ht["__core-js_shared__"], vi = function() {
  var S = /[^.]+$/.exec(Be && Be.keys && Be.keys.IE_PROTO || "");
  return S ? "Symbol(src)_1." + S : "";
}();
function Vs(S) {
  return !!vi && vi in S;
}
var qs = Function.prototype, Ks = qs.toString;
function se(S) {
  if (S != null) {
    try {
      return Ks.call(S);
    } catch {
    }
    try {
      return S + "";
    } catch {
    }
  }
  return "";
}
var Zs = /[\\^$.*+?()[\]{}|]/g, Js = /^\[object .+?Constructor\]$/, Qs = Function.prototype, tr = Object.prototype, er = Qs.toString, ir = tr.hasOwnProperty, sr = RegExp(
  "^" + er.call(ir).replace(Zs, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function rr(S) {
  if (!Ft(S) || Vs(S))
    return !1;
  var j = qe(S) ? sr : Js;
  return j.test(se(S));
}
function or(S, j) {
  return S == null ? void 0 : S[j];
}
function re(S, j) {
  var i = or(S, j);
  return rr(i) ? i : void 0;
}
var He = re(Ht, "WeakMap"), wi = Object.create, nr = /* @__PURE__ */ function() {
  function S() {
  }
  return function(j) {
    if (!Ft(j))
      return {};
    if (wi)
      return wi(j);
    S.prototype = j;
    var i = new S();
    return S.prototype = void 0, i;
  };
}();
function ar(S, j, i) {
  switch (i.length) {
    case 0:
      return S.call(j);
    case 1:
      return S.call(j, i[0]);
    case 2:
      return S.call(j, i[0], i[1]);
    case 3:
      return S.call(j, i[0], i[1], i[2]);
  }
  return S.apply(j, i);
}
function lr(S, j) {
  var i = -1, ot = S.length;
  for (j || (j = Array(ot)); ++i < ot; )
    j[i] = S[i];
  return j;
}
var hr = 800, cr = 16, dr = Date.now;
function ur(S) {
  var j = 0, i = 0;
  return function() {
    var ot = dr(), U = cr - (ot - i);
    if (i = ot, U > 0) {
      if (++j >= hr)
        return arguments[0];
    } else
      j = 0;
    return S.apply(void 0, arguments);
  };
}
function pr(S) {
  return function() {
    return S;
  };
}
var ye = function() {
  try {
    var S = re(Object, "defineProperty");
    return S({}, "", {}), S;
  } catch {
  }
}(), gr = ye ? function(S, j) {
  return ye(S, "toString", {
    configurable: !0,
    enumerable: !1,
    value: pr(j),
    writable: !0
  });
} : Ve, fr = ur(gr), mr = 9007199254740991, br = /^(?:0|[1-9]\d*)$/;
function ke(S, j) {
  var i = typeof S;
  return j = j == null ? mr : j, !!j && (i == "number" || i != "symbol" && br.test(S)) && S > -1 && S % 1 == 0 && S < j;
}
function Ke(S, j, i) {
  j == "__proto__" && ye ? ye(S, j, {
    configurable: !0,
    enumerable: !0,
    value: i,
    writable: !0
  }) : S[j] = i;
}
function de(S, j) {
  return S === j || S !== S && j !== j;
}
var yr = Object.prototype, xr = yr.hasOwnProperty;
function Zi(S, j, i) {
  var ot = S[j];
  (!(xr.call(S, j) && de(ot, i)) || i === void 0 && !(j in S)) && Ke(S, j, i);
}
function vr(S, j, i, ot) {
  var U = !i;
  i || (i = {});
  for (var _ = -1, K = j.length; ++_ < K; ) {
    var Z = j[_], J = void 0;
    J === void 0 && (J = S[Z]), U ? Ke(i, Z, J) : Zi(i, Z, J);
  }
  return i;
}
var Ci = Math.max;
function wr(S, j, i) {
  return j = Ci(j === void 0 ? S.length - 1 : j, 0), function() {
    for (var ot = arguments, U = -1, _ = Ci(ot.length - j, 0), K = Array(_); ++U < _; )
      K[U] = ot[j + U];
    U = -1;
    for (var Z = Array(j + 1); ++U < j; )
      Z[U] = ot[U];
    return Z[j] = i(K), ar(S, this, Z);
  };
}
function Cr(S, j) {
  return fr(wr(S, j, Ve), S + "");
}
var kr = 9007199254740991;
function Ze(S) {
  return typeof S == "number" && S > -1 && S % 1 == 0 && S <= kr;
}
function Ae(S) {
  return S != null && Ze(S.length) && !qe(S);
}
function Ar(S, j, i) {
  if (!Ft(i))
    return !1;
  var ot = typeof j;
  return (ot == "number" ? Ae(i) && ke(j, i.length) : ot == "string" && j in i) ? de(i[j], S) : !1;
}
function Sr(S) {
  return Cr(function(j, i) {
    var ot = -1, U = i.length, _ = U > 1 ? i[U - 1] : void 0, K = U > 2 ? i[2] : void 0;
    for (_ = S.length > 3 && typeof _ == "function" ? (U--, _) : void 0, K && Ar(i[0], i[1], K) && (_ = U < 3 ? void 0 : _, U = 1), j = Object(j); ++ot < U; ) {
      var Z = i[ot];
      Z && S(j, Z, ot, _);
    }
    return j;
  });
}
var Tr = Object.prototype;
function Je(S) {
  var j = S && S.constructor, i = typeof j == "function" && j.prototype || Tr;
  return S === i;
}
function Mr(S, j) {
  for (var i = -1, ot = Array(S); ++i < S; )
    ot[i] = j(i);
  return ot;
}
var Er = "[object Arguments]";
function ki(S) {
  return Jt(S) && ie(S) == Er;
}
var Ji = Object.prototype, Pr = Ji.hasOwnProperty, Lr = Ji.propertyIsEnumerable, xe = ki(/* @__PURE__ */ function() {
  return arguments;
}()) ? ki : function(S) {
  return Jt(S) && Pr.call(S, "callee") && !Lr.call(S, "callee");
};
function Or() {
  return !1;
}
var Qi = typeof exports == "object" && exports && !exports.nodeType && exports, Ai = Qi && typeof module == "object" && module && !module.nodeType && module, Dr = Ai && Ai.exports === Qi, Si = Dr ? Ht.Buffer : void 0, Ir = Si ? Si.isBuffer : void 0, ve = Ir || Or, jr = "[object Arguments]", Nr = "[object Array]", Br = "[object Boolean]", Rr = "[object Date]", zr = "[object Error]", Fr = "[object Function]", Hr = "[object Map]", Ur = "[object Number]", Gr = "[object Object]", Wr = "[object RegExp]", Xr = "[object Set]", _r = "[object String]", Yr = "[object WeakMap]", $r = "[object ArrayBuffer]", Vr = "[object DataView]", qr = "[object Float32Array]", Kr = "[object Float64Array]", Zr = "[object Int8Array]", Jr = "[object Int16Array]", Qr = "[object Int32Array]", to = "[object Uint8Array]", eo = "[object Uint8ClampedArray]", io = "[object Uint16Array]", so = "[object Uint32Array]", Mt = {};
Mt[qr] = Mt[Kr] = Mt[Zr] = Mt[Jr] = Mt[Qr] = Mt[to] = Mt[eo] = Mt[io] = Mt[so] = !0;
Mt[jr] = Mt[Nr] = Mt[$r] = Mt[Br] = Mt[Vr] = Mt[Rr] = Mt[zr] = Mt[Fr] = Mt[Hr] = Mt[Ur] = Mt[Gr] = Mt[Wr] = Mt[Xr] = Mt[_r] = Mt[Yr] = !1;
function ro(S) {
  return Jt(S) && Ze(S.length) && !!Mt[ie(S)];
}
function oo(S) {
  return function(j) {
    return S(j);
  };
}
var ts = typeof exports == "object" && exports && !exports.nodeType && exports, le = ts && typeof module == "object" && module && !module.nodeType && module, no = le && le.exports === ts, Re = no && $i.process, Ti = function() {
  try {
    var S = le && le.require && le.require("util").types;
    return S || Re && Re.binding && Re.binding("util");
  } catch {
  }
}(), Mi = Ti && Ti.isTypedArray, Qe = Mi ? oo(Mi) : ro, ao = Object.prototype, lo = ao.hasOwnProperty;
function es(S, j) {
  var i = Bt(S), ot = !i && xe(S), U = !i && !ot && ve(S), _ = !i && !ot && !U && Qe(S), K = i || ot || U || _, Z = K ? Mr(S.length, String) : [], J = Z.length;
  for (var q in S)
    (j || lo.call(S, q)) && !(K && // Safari 9 has enumerable `arguments.length` in strict mode.
    (q == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    U && (q == "offset" || q == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    _ && (q == "buffer" || q == "byteLength" || q == "byteOffset") || // Skip index properties.
    ke(q, J))) && Z.push(q);
  return Z;
}
function is(S, j) {
  return function(i) {
    return S(j(i));
  };
}
var ho = is(Object.keys, Object), co = Object.prototype, uo = co.hasOwnProperty;
function po(S) {
  if (!Je(S))
    return ho(S);
  var j = [];
  for (var i in Object(S))
    uo.call(S, i) && i != "constructor" && j.push(i);
  return j;
}
function ss(S) {
  return Ae(S) ? es(S) : po(S);
}
function go(S) {
  var j = [];
  if (S != null)
    for (var i in Object(S))
      j.push(i);
  return j;
}
var fo = Object.prototype, mo = fo.hasOwnProperty;
function bo(S) {
  if (!Ft(S))
    return go(S);
  var j = Je(S), i = [];
  for (var ot in S)
    ot == "constructor" && (j || !mo.call(S, ot)) || i.push(ot);
  return i;
}
function ti(S) {
  return Ae(S) ? es(S, !0) : bo(S);
}
var yo = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, xo = /^\w*$/;
function ei(S, j) {
  if (Bt(S))
    return !1;
  var i = typeof S;
  return i == "number" || i == "symbol" || i == "boolean" || S == null || $e(S) ? !0 : xo.test(S) || !yo.test(S) || j != null && S in Object(j);
}
var he = re(Object, "create");
function vo() {
  this.__data__ = he ? he(null) : {}, this.size = 0;
}
function wo(S) {
  var j = this.has(S) && delete this.__data__[S];
  return this.size -= j ? 1 : 0, j;
}
var Co = "__lodash_hash_undefined__", ko = Object.prototype, Ao = ko.hasOwnProperty;
function So(S) {
  var j = this.__data__;
  if (he) {
    var i = j[S];
    return i === Co ? void 0 : i;
  }
  return Ao.call(j, S) ? j[S] : void 0;
}
var To = Object.prototype, Mo = To.hasOwnProperty;
function Eo(S) {
  var j = this.__data__;
  return he ? j[S] !== void 0 : Mo.call(j, S);
}
var Po = "__lodash_hash_undefined__";
function Lo(S, j) {
  var i = this.__data__;
  return this.size += this.has(S) ? 0 : 1, i[S] = he && j === void 0 ? Po : j, this;
}
function ee(S) {
  var j = -1, i = S == null ? 0 : S.length;
  for (this.clear(); ++j < i; ) {
    var ot = S[j];
    this.set(ot[0], ot[1]);
  }
}
ee.prototype.clear = vo;
ee.prototype.delete = wo;
ee.prototype.get = So;
ee.prototype.has = Eo;
ee.prototype.set = Lo;
function Oo() {
  this.__data__ = [], this.size = 0;
}
function Se(S, j) {
  for (var i = S.length; i--; )
    if (de(S[i][0], j))
      return i;
  return -1;
}
var Do = Array.prototype, Io = Do.splice;
function jo(S) {
  var j = this.__data__, i = Se(j, S);
  if (i < 0)
    return !1;
  var ot = j.length - 1;
  return i == ot ? j.pop() : Io.call(j, i, 1), --this.size, !0;
}
function No(S) {
  var j = this.__data__, i = Se(j, S);
  return i < 0 ? void 0 : j[i][1];
}
function Bo(S) {
  return Se(this.__data__, S) > -1;
}
function Ro(S, j) {
  var i = this.__data__, ot = Se(i, S);
  return ot < 0 ? (++this.size, i.push([S, j])) : i[ot][1] = j, this;
}
function Xt(S) {
  var j = -1, i = S == null ? 0 : S.length;
  for (this.clear(); ++j < i; ) {
    var ot = S[j];
    this.set(ot[0], ot[1]);
  }
}
Xt.prototype.clear = Oo;
Xt.prototype.delete = jo;
Xt.prototype.get = No;
Xt.prototype.has = Bo;
Xt.prototype.set = Ro;
var ce = re(Ht, "Map");
function zo() {
  this.size = 0, this.__data__ = {
    hash: new ee(),
    map: new (ce || Xt)(),
    string: new ee()
  };
}
function Fo(S) {
  var j = typeof S;
  return j == "string" || j == "number" || j == "symbol" || j == "boolean" ? S !== "__proto__" : S === null;
}
function Te(S, j) {
  var i = S.__data__;
  return Fo(j) ? i[typeof j == "string" ? "string" : "hash"] : i.map;
}
function Ho(S) {
  var j = Te(this, S).delete(S);
  return this.size -= j ? 1 : 0, j;
}
function Uo(S) {
  return Te(this, S).get(S);
}
function Go(S) {
  return Te(this, S).has(S);
}
function Wo(S, j) {
  var i = Te(this, S), ot = i.size;
  return i.set(S, j), this.size += i.size == ot ? 0 : 1, this;
}
function _t(S) {
  var j = -1, i = S == null ? 0 : S.length;
  for (this.clear(); ++j < i; ) {
    var ot = S[j];
    this.set(ot[0], ot[1]);
  }
}
_t.prototype.clear = zo;
_t.prototype.delete = Ho;
_t.prototype.get = Uo;
_t.prototype.has = Go;
_t.prototype.set = Wo;
var Xo = "Expected a function";
function ii(S, j) {
  if (typeof S != "function" || j != null && typeof j != "function")
    throw new TypeError(Xo);
  var i = function() {
    var ot = arguments, U = j ? j.apply(this, ot) : ot[0], _ = i.cache;
    if (_.has(U))
      return _.get(U);
    var K = S.apply(this, ot);
    return i.cache = _.set(U, K) || _, K;
  };
  return i.cache = new (ii.Cache || _t)(), i;
}
ii.Cache = _t;
var _o = 500;
function Yo(S) {
  var j = ii(S, function(ot) {
    return i.size === _o && i.clear(), ot;
  }), i = j.cache;
  return j;
}
var $o = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Vo = /\\(\\)?/g, qo = Yo(function(S) {
  var j = [];
  return S.charCodeAt(0) === 46 && j.push(""), S.replace($o, function(i, ot, U, _) {
    j.push(U ? _.replace(Vo, "$1") : ot || i);
  }), j;
});
function Ko(S) {
  return S == null ? "" : Ki(S);
}
function Me(S, j) {
  return Bt(S) ? S : ei(S, j) ? [S] : qo(Ko(S));
}
function ue(S) {
  if (typeof S == "string" || $e(S))
    return S;
  var j = S + "";
  return j == "0" && 1 / S == -1 / 0 ? "-0" : j;
}
function si(S, j) {
  j = Me(j, S);
  for (var i = 0, ot = j.length; S != null && i < ot; )
    S = S[ue(j[i++])];
  return i && i == ot ? S : void 0;
}
function Zo(S, j, i) {
  var ot = S == null ? void 0 : si(S, j);
  return ot === void 0 ? i : ot;
}
function rs(S, j) {
  for (var i = -1, ot = j.length, U = S.length; ++i < ot; )
    S[U + i] = j[i];
  return S;
}
var ri = is(Object.getPrototypeOf, Object), Jo = "[object Object]", Qo = Function.prototype, tn = Object.prototype, os = Qo.toString, en = tn.hasOwnProperty, sn = os.call(Object);
function rn(S) {
  if (!Jt(S) || ie(S) != Jo)
    return !1;
  var j = ri(S);
  if (j === null)
    return !0;
  var i = en.call(j, "constructor") && j.constructor;
  return typeof i == "function" && i instanceof i && os.call(i) == sn;
}
function on() {
  this.__data__ = new Xt(), this.size = 0;
}
function nn(S) {
  var j = this.__data__, i = j.delete(S);
  return this.size = j.size, i;
}
function an(S) {
  return this.__data__.get(S);
}
function ln(S) {
  return this.__data__.has(S);
}
var hn = 200;
function cn(S, j) {
  var i = this.__data__;
  if (i instanceof Xt) {
    var ot = i.__data__;
    if (!ce || ot.length < hn - 1)
      return ot.push([S, j]), this.size = ++i.size, this;
    i = this.__data__ = new _t(ot);
  }
  return i.set(S, j), this.size = i.size, this;
}
function zt(S) {
  var j = this.__data__ = new Xt(S);
  this.size = j.size;
}
zt.prototype.clear = on;
zt.prototype.delete = nn;
zt.prototype.get = an;
zt.prototype.has = ln;
zt.prototype.set = cn;
var ns = typeof exports == "object" && exports && !exports.nodeType && exports, Ei = ns && typeof module == "object" && module && !module.nodeType && module, dn = Ei && Ei.exports === ns, Pi = dn ? Ht.Buffer : void 0;
Pi && Pi.allocUnsafe;
function un(S, j) {
  return S.slice();
}
function pn(S, j) {
  for (var i = -1, ot = S == null ? 0 : S.length, U = 0, _ = []; ++i < ot; ) {
    var K = S[i];
    j(K, i, S) && (_[U++] = K);
  }
  return _;
}
function as() {
  return [];
}
var gn = Object.prototype, fn = gn.propertyIsEnumerable, Li = Object.getOwnPropertySymbols, ls = Li ? function(S) {
  return S == null ? [] : (S = Object(S), pn(Li(S), function(j) {
    return fn.call(S, j);
  }));
} : as, mn = Object.getOwnPropertySymbols, bn = mn ? function(S) {
  for (var j = []; S; )
    rs(j, ls(S)), S = ri(S);
  return j;
} : as;
function hs(S, j, i) {
  var ot = j(S);
  return Bt(S) ? ot : rs(ot, i(S));
}
function Oi(S) {
  return hs(S, ss, ls);
}
function yn(S) {
  return hs(S, ti, bn);
}
var Ue = re(Ht, "DataView"), Ge = re(Ht, "Promise"), We = re(Ht, "Set"), Di = "[object Map]", xn = "[object Object]", Ii = "[object Promise]", ji = "[object Set]", Ni = "[object WeakMap]", Bi = "[object DataView]", vn = se(Ue), wn = se(ce), Cn = se(Ge), kn = se(We), An = se(He), Vt = ie;
(Ue && Vt(new Ue(new ArrayBuffer(1))) != Bi || ce && Vt(new ce()) != Di || Ge && Vt(Ge.resolve()) != Ii || We && Vt(new We()) != ji || He && Vt(new He()) != Ni) && (Vt = function(S) {
  var j = ie(S), i = j == xn ? S.constructor : void 0, ot = i ? se(i) : "";
  if (ot)
    switch (ot) {
      case vn:
        return Bi;
      case wn:
        return Di;
      case Cn:
        return Ii;
      case kn:
        return ji;
      case An:
        return Ni;
    }
  return j;
});
var we = Ht.Uint8Array;
function Sn(S) {
  var j = new S.constructor(S.byteLength);
  return new we(j).set(new we(S)), j;
}
function Tn(S, j) {
  var i = Sn(S.buffer);
  return new S.constructor(i, S.byteOffset, S.length);
}
function Mn(S) {
  return typeof S.constructor == "function" && !Je(S) ? nr(ri(S)) : {};
}
var En = "__lodash_hash_undefined__";
function Pn(S) {
  return this.__data__.set(S, En), this;
}
function Ln(S) {
  return this.__data__.has(S);
}
function Ce(S) {
  var j = -1, i = S == null ? 0 : S.length;
  for (this.__data__ = new _t(); ++j < i; )
    this.add(S[j]);
}
Ce.prototype.add = Ce.prototype.push = Pn;
Ce.prototype.has = Ln;
function On(S, j) {
  for (var i = -1, ot = S == null ? 0 : S.length; ++i < ot; )
    if (j(S[i], i, S))
      return !0;
  return !1;
}
function Dn(S, j) {
  return S.has(j);
}
var In = 1, jn = 2;
function cs(S, j, i, ot, U, _) {
  var K = i & In, Z = S.length, J = j.length;
  if (Z != J && !(K && J > Z))
    return !1;
  var q = _.get(S), tt = _.get(j);
  if (q && tt)
    return q == j && tt == S;
  var X = -1, I = !0, O = i & jn ? new Ce() : void 0;
  for (_.set(S, j), _.set(j, S); ++X < Z; ) {
    var y = S[X], w = j[X];
    if (ot)
      var f = K ? ot(w, y, X, j, S, _) : ot(y, w, X, S, j, _);
    if (f !== void 0) {
      if (f)
        continue;
      I = !1;
      break;
    }
    if (O) {
      if (!On(j, function(x, s) {
        if (!Dn(O, s) && (y === x || U(y, x, i, ot, _)))
          return O.push(s);
      })) {
        I = !1;
        break;
      }
    } else if (!(y === w || U(y, w, i, ot, _))) {
      I = !1;
      break;
    }
  }
  return _.delete(S), _.delete(j), I;
}
function Nn(S) {
  var j = -1, i = Array(S.size);
  return S.forEach(function(ot, U) {
    i[++j] = [U, ot];
  }), i;
}
function Bn(S) {
  var j = -1, i = Array(S.size);
  return S.forEach(function(ot) {
    i[++j] = ot;
  }), i;
}
var Rn = 1, zn = 2, Fn = "[object Boolean]", Hn = "[object Date]", Un = "[object Error]", Gn = "[object Map]", Wn = "[object Number]", Xn = "[object RegExp]", _n = "[object Set]", Yn = "[object String]", $n = "[object Symbol]", Vn = "[object ArrayBuffer]", qn = "[object DataView]", Ri = Zt ? Zt.prototype : void 0, ze = Ri ? Ri.valueOf : void 0;
function Kn(S, j, i, ot, U, _, K) {
  switch (i) {
    case qn:
      if (S.byteLength != j.byteLength || S.byteOffset != j.byteOffset)
        return !1;
      S = S.buffer, j = j.buffer;
    case Vn:
      return !(S.byteLength != j.byteLength || !_(new we(S), new we(j)));
    case Fn:
    case Hn:
    case Wn:
      return de(+S, +j);
    case Un:
      return S.name == j.name && S.message == j.message;
    case Xn:
    case Yn:
      return S == j + "";
    case Gn:
      var Z = Nn;
    case _n:
      var J = ot & Rn;
      if (Z || (Z = Bn), S.size != j.size && !J)
        return !1;
      var q = K.get(S);
      if (q)
        return q == j;
      ot |= zn, K.set(S, j);
      var tt = cs(Z(S), Z(j), ot, U, _, K);
      return K.delete(S), tt;
    case $n:
      if (ze)
        return ze.call(S) == ze.call(j);
  }
  return !1;
}
var Zn = 1, Jn = Object.prototype, Qn = Jn.hasOwnProperty;
function ta(S, j, i, ot, U, _) {
  var K = i & Zn, Z = Oi(S), J = Z.length, q = Oi(j), tt = q.length;
  if (J != tt && !K)
    return !1;
  for (var X = J; X--; ) {
    var I = Z[X];
    if (!(K ? I in j : Qn.call(j, I)))
      return !1;
  }
  var O = _.get(S), y = _.get(j);
  if (O && y)
    return O == j && y == S;
  var w = !0;
  _.set(S, j), _.set(j, S);
  for (var f = K; ++X < J; ) {
    I = Z[X];
    var x = S[I], s = j[I];
    if (ot)
      var l = K ? ot(s, x, I, j, S, _) : ot(x, s, I, S, j, _);
    if (!(l === void 0 ? x === s || U(x, s, i, ot, _) : l)) {
      w = !1;
      break;
    }
    f || (f = I == "constructor");
  }
  if (w && !f) {
    var p = S.constructor, n = j.constructor;
    p != n && "constructor" in S && "constructor" in j && !(typeof p == "function" && p instanceof p && typeof n == "function" && n instanceof n) && (w = !1);
  }
  return _.delete(S), _.delete(j), w;
}
var ea = 1, zi = "[object Arguments]", Fi = "[object Array]", me = "[object Object]", ia = Object.prototype, Hi = ia.hasOwnProperty;
function sa(S, j, i, ot, U, _) {
  var K = Bt(S), Z = Bt(j), J = K ? Fi : Vt(S), q = Z ? Fi : Vt(j);
  J = J == zi ? me : J, q = q == zi ? me : q;
  var tt = J == me, X = q == me, I = J == q;
  if (I && ve(S)) {
    if (!ve(j))
      return !1;
    K = !0, tt = !1;
  }
  if (I && !tt)
    return _ || (_ = new zt()), K || Qe(S) ? cs(S, j, i, ot, U, _) : Kn(S, j, J, i, ot, U, _);
  if (!(i & ea)) {
    var O = tt && Hi.call(S, "__wrapped__"), y = X && Hi.call(j, "__wrapped__");
    if (O || y) {
      var w = O ? S.value() : S, f = y ? j.value() : j;
      return _ || (_ = new zt()), U(w, f, i, ot, _);
    }
  }
  return I ? (_ || (_ = new zt()), ta(S, j, i, ot, U, _)) : !1;
}
function oi(S, j, i, ot, U) {
  return S === j ? !0 : S == null || j == null || !Jt(S) && !Jt(j) ? S !== S && j !== j : sa(S, j, i, ot, oi, U);
}
var ra = 1, oa = 2;
function na(S, j, i, ot) {
  var U = i.length, _ = U;
  if (S == null)
    return !_;
  for (S = Object(S); U--; ) {
    var K = i[U];
    if (K[2] ? K[1] !== S[K[0]] : !(K[0] in S))
      return !1;
  }
  for (; ++U < _; ) {
    K = i[U];
    var Z = K[0], J = S[Z], q = K[1];
    if (K[2]) {
      if (J === void 0 && !(Z in S))
        return !1;
    } else {
      var tt = new zt(), X;
      if (!(X === void 0 ? oi(q, J, ra | oa, ot, tt) : X))
        return !1;
    }
  }
  return !0;
}
function ds(S) {
  return S === S && !Ft(S);
}
function aa(S) {
  for (var j = ss(S), i = j.length; i--; ) {
    var ot = j[i], U = S[ot];
    j[i] = [ot, U, ds(U)];
  }
  return j;
}
function us(S, j) {
  return function(i) {
    return i == null ? !1 : i[S] === j && (j !== void 0 || S in Object(i));
  };
}
function la(S) {
  var j = aa(S);
  return j.length == 1 && j[0][2] ? us(j[0][0], j[0][1]) : function(i) {
    return i === S || na(i, S, j);
  };
}
function ha(S, j) {
  return S != null && j in Object(S);
}
function ca(S, j, i) {
  j = Me(j, S);
  for (var ot = -1, U = j.length, _ = !1; ++ot < U; ) {
    var K = ue(j[ot]);
    if (!(_ = S != null && i(S, K)))
      break;
    S = S[K];
  }
  return _ || ++ot != U ? _ : (U = S == null ? 0 : S.length, !!U && Ze(U) && ke(K, U) && (Bt(S) || xe(S)));
}
function da(S, j) {
  return S != null && ca(S, j, ha);
}
var ua = 1, pa = 2;
function ga(S, j) {
  return ei(S) && ds(j) ? us(ue(S), j) : function(i) {
    var ot = Zo(i, S);
    return ot === void 0 && ot === j ? da(i, S) : oi(j, ot, ua | pa);
  };
}
function fa(S) {
  return function(j) {
    return j == null ? void 0 : j[S];
  };
}
function ma(S) {
  return function(j) {
    return si(j, S);
  };
}
function ba(S) {
  return ei(S) ? fa(ue(S)) : ma(S);
}
function ya(S) {
  return typeof S == "function" ? S : S == null ? Ve : typeof S == "object" ? Bt(S) ? ga(S[0], S[1]) : la(S) : ba(S);
}
function xa(S) {
  return function(j, i, ot) {
    for (var U = -1, _ = Object(j), K = ot(j), Z = K.length; Z--; ) {
      var J = K[++U];
      if (i(_[J], J, _) === !1)
        break;
    }
    return j;
  };
}
var va = xa();
function Xe(S, j, i) {
  (i !== void 0 && !de(S[j], i) || i === void 0 && !(j in S)) && Ke(S, j, i);
}
function wa(S) {
  return Jt(S) && Ae(S);
}
function _e(S, j) {
  if (!(j === "constructor" && typeof S[j] == "function") && j != "__proto__")
    return S[j];
}
function Ca(S) {
  return vr(S, ti(S));
}
function ka(S, j, i, ot, U, _, K) {
  var Z = _e(S, i), J = _e(j, i), q = K.get(J);
  if (q) {
    Xe(S, i, q);
    return;
  }
  var tt = _ ? _(Z, J, i + "", S, j, K) : void 0, X = tt === void 0;
  if (X) {
    var I = Bt(J), O = !I && ve(J), y = !I && !O && Qe(J);
    tt = J, I || O || y ? Bt(Z) ? tt = Z : wa(Z) ? tt = lr(Z) : O ? (X = !1, tt = un(J)) : y ? (X = !1, tt = Tn(J)) : tt = [] : rn(J) || xe(J) ? (tt = Z, xe(Z) ? tt = Ca(Z) : (!Ft(Z) || qe(Z)) && (tt = Mn(J))) : X = !1;
  }
  X && (K.set(J, tt), U(tt, J, ot, _, K), K.delete(J)), Xe(S, i, tt);
}
function ps(S, j, i, ot, U) {
  S !== j && va(j, function(_, K) {
    if (U || (U = new zt()), Ft(_))
      ka(S, j, K, i, ps, ot, U);
    else {
      var Z = ot ? ot(_e(S, K), _, K + "", S, j, U) : void 0;
      Z === void 0 && (Z = _), Xe(S, K, Z);
    }
  }, ti);
}
var Aa = Sr(function(S, j, i, ot) {
  ps(S, j, i, ot);
});
function Sa(S, j, i, ot) {
  if (!Ft(S))
    return S;
  j = Me(j, S);
  for (var U = -1, _ = j.length, K = _ - 1, Z = S; Z != null && ++U < _; ) {
    var J = ue(j[U]), q = i;
    if (J === "__proto__" || J === "constructor" || J === "prototype")
      return S;
    if (U != K) {
      var tt = Z[J];
      q = void 0, q === void 0 && (q = Ft(tt) ? tt : ke(j[U + 1]) ? [] : {});
    }
    Zi(Z, J, q), Z = Z[J];
  }
  return S;
}
function Ta(S, j, i) {
  for (var ot = -1, U = j.length, _ = {}; ++ot < U; ) {
    var K = j[ot], Z = si(S, K);
    i(Z, K) && Sa(_, Me(K, S), Z);
  }
  return _;
}
function Ma(S, j) {
  if (S == null)
    return {};
  var i = qi(yn(S), function(ot) {
    return [ot];
  });
  return j = ya(j), Ta(S, i, function(ot, U) {
    return j(ot, U[0]);
  });
}
var qt = /* @__PURE__ */ ((S) => (S.CIRCLE = "circle", S.TRIANGLE = "triangle", S.SQUARE = "square", S.DIAMOND = "diamond", S.TRIANGLE_DOWN = "triangle-down", S))(qt || {}), ae = /* @__PURE__ */ ((S) => (S.SINGLE_LINE = "single-line", S.MULTI_LINE = "multi-line", S.MULTI_LEVEL = "multi-level", S))(ae || {}), Kt = /* @__PURE__ */ ((S) => (S.LINE = "line", S.BAR = "bar", S.COLUMN = "column", S.SCATTER = "scatter", S.PIE = "pie", S.GAUGE = "gauge", S.AREA = "area", S.MAP = "map", S))(Kt || {}), Ea = /* @__PURE__ */ ((S) => (S.HORIZONTAL = "horizontal", S.VERTICAL = "vertical", S))(Ea || {}), gs = /* @__PURE__ */ ((S) => (S[S.HEIGHT = 480] = "HEIGHT", S))(gs || {}), Wt = /* @__PURE__ */ ((S) => (S.STANDARD = "standard-set", S.EXTENDED = "extended-set", S))(Wt || {});
const Ui = " ";
function Pa(S, j = Ui) {
  return typeof j != "string" && (j = Ui), S == null ? void 0 : S.split(j).map((i) => i.trim());
}
var fs = /* @__PURE__ */ ((S) => (S.HORIZONTAL = "row", S.VERTICAL = "column", S))(fs || {}), ms = /* @__PURE__ */ ((S) => (S.CENTER = "center", S.LEFT = "left", S.RIGHT = "right", S))(ms || {}), bs = /* @__PURE__ */ ((S) => (S.BOTTOM = "bottom", S.TOP = "top", S.MIDDLE = "middle", S))(bs || {});
bs.TOP, ms.CENTER, fs.HORIZONTAL;
const La = `<svg height="12" width="12" viewbox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <circle stroke-width="0" cx="6" cy="6" r="2" />
</svg>
`, Oa = `<svg height="12" width="12" viewbox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <circle stroke-width="0" cx="6" cy="6" r="6" />
</svg>
`, Da = `<svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <rect y="5" width="7" height="7" transform="rotate(-45 0 5)"/>
</svg>
`, Ia = `<svg height="10" width="10" viewbox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <rect width="10" height="10"/>
</svg>
`, ja = `<svg width="10" height="8" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <path d="M10 0L5 8L6.99382e-07 -8.74228e-07L10 0Z"/>
</svg>
`, Na = `<svg width="10" height="8" viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg" class="beacon-legend-item__icon">
    <path d="M0 8L5 0L10 8H0Z"/>
</svg>
`;
ne` <beacon-table id="datatable">
  <table>
    <thead>
      <tr>
        <th>Year</th>
        <th>Company A</th>
        <th>Company B</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th>2016</th>
        <td>30386</td>
        <td>28504</td>
      </tr>
      <tr>
        <th>2017</th>
        <td>29173</td>
        <td>27460</td>
      </tr>
      <tr>
        <th>2018</th>
        <td>28430</td>
        <td>26690</td>
      </tr>
      <tr>
        <th>2019</th>
        <td>28042</td>
        <td>26453</td>
      </tr>
      <tr>
        <th>2020</th>
        <td>27063</td>
        <td>25916</td>
      </tr>
      <tr>
        <th>2021</th>
        <td>28684</td>
        <td>27376</td>
      </tr>
    </tbody>
  </table>
</beacon-table>`;
const $t = {
  multiLevel: La,
  circle: Oa,
  triangle: Na,
  square: Ia,
  diamond: Da,
  triangleDown: ja
};
function Ba(S) {
  const j = [...Object.values(qt)], i = S % j.length;
  return j[i];
}
function Fe(S, j, i) {
  if (j)
    return $t.multiLevel;
  const ot = [
    Kt.LINE,
    Kt.SCATTER,
    Kt.AREA
  ];
  if (i && ot.includes(i))
    switch (Ba(S)) {
      case qt.CIRCLE:
        return $t.circle;
      case qt.TRIANGLE:
        return $t.triangle;
      case qt.SQUARE:
        return $t.square;
      case qt.DIAMOND:
        return $t.diamond;
      case qt.TRIANGLE_DOWN:
        return $t.triangleDown;
      default:
        return $t.circle;
    }
  else
    return $t.circle;
}
const be = Ye`[beacon-tag-name$=chart] [slot=title]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-loose-50)}[beacon-tag-name$=chart] [slot=subtitle],[beacon-tag-name$=chart] [slot=caption]{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-loose-300)}.highcharts-tooltip-container{z-index:1200!important}.highcharts-tooltip-container svg{max-inline-size:unset}.beacon-chart-tooltip{background-color:var(--beacon-system-color-background-1);color:var(--beacon-system-color-text-standard);fill:var(--beacon-system-color-background-1)}.beacon-chart-tooltip .highcharts-color-0{fill:var(--beacon-system-color-data-viz-0);stroke:var(--beacon-system-color-data-viz-0)}.beacon-chart-tooltip .highcharts-color-1{fill:var(--beacon-system-color-data-viz-1);stroke:var(--beacon-system-color-data-viz-1)}.beacon-chart-tooltip .highcharts-color-2{fill:var(--beacon-system-color-data-viz-2);stroke:var(--beacon-system-color-data-viz-2)}.beacon-chart-tooltip .highcharts-color-3{fill:var(--beacon-system-color-data-viz-3);stroke:var(--beacon-system-color-data-viz-3)}.beacon-chart-tooltip .highcharts-color-4{fill:var(--beacon-system-color-data-viz-4);stroke:var(--beacon-system-color-data-viz-4)}.beacon-chart-tooltip .highcharts-color-5{fill:var(--beacon-system-color-data-viz-5);stroke:var(--beacon-system-color-data-viz-5)}.beacon-chart-tooltip .highcharts-color-6{fill:var(--beacon-system-color-data-viz-6);stroke:var(--beacon-system-color-data-viz-6)}.beacon-chart-tooltip .highcharts-color-7{fill:var(--beacon-system-color-data-viz-7);stroke:var(--beacon-system-color-data-viz-7)}.beacon-chart-tooltip .highcharts-color-8{fill:var(--beacon-system-color-data-viz-8);stroke:var(--beacon-system-color-data-viz-8)}.beacon-chart-tooltip .highcharts-color-9{fill:var(--beacon-system-color-data-viz-9);stroke:var(--beacon-system-color-data-viz-9)}.beacon-chart-tooltip .highcharts-color-10{fill:var(--beacon-system-color-data-viz-10);stroke:var(--beacon-system-color-data-viz-10)}.beacon-chart-tooltip .highcharts-color-11{fill:var(--beacon-system-color-data-viz-11);stroke:var(--beacon-system-color-data-viz-11)}.beacon-chart-tooltip.area.single-series-chart:not(.stacked-chart) .beacon-chart-tooltip__point.highcharts-color-0.negative{fill:var(--beacon-reference-palette-functional-red-3);stroke:var(--beacon-reference-palette-functional-red-3)}.beacon-chart-tooltip.area.single-series-chart:not(.stacked-chart) .beacon-chart-tooltip__point.highcharts-color-0.positive{fill:var(--beacon-reference-palette-functional-green-3);stroke:var(--beacon-reference-palette-functional-green-3)}.beacon-chart-tooltip__title{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}.beacon-chart-tooltip__point,.beacon-chart-tooltip-point__label{align-items:center;display:flex}.beacon-chart-tooltip__point{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);gap:var(--beacon-reference-space-3)}.beacon-chart-tooltip__point:not(:first-of-type){margin-block-start:var(--beacon-reference-space-3)}.beacon-chart-tooltip__separator{border:0;border-block-start-color:var(--beacon-system-color-icon-primary-inactive);border-block-start-style:solid;border-block-start-width:var(--beacon-system-width-border-mini)}.beacon-chart-tooltip__point--multi-level .beacon-legend-item__icon{fill:var(--beacon-system-color-icon-primary-inactive)}.beacon-chart-tooltip__footer,.beacon-chart-tooltip__additional-content{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);margin-block-start:var(--beacon-reference-space-3)}.beacon-chart-tooltip-point__label{gap:var(--beacon-reference-space-4)}.beacon-chart-tooltip__point-value{font-weight:var(--beacon-system-font-weight-bold)}`, Ra = Ye`*{margin:0;padding:0}:host{--component-background-color: transparent;--component-gap-space: var(--beacon-system-space-micro-jumbo);background-color:var(--component-background-color)}.base{padding-block:var(--beacon-reference-space-3)}.chart{block-size:var(--beacon-custom-chart-container-size-block, auto)}.header{margin-block-end:var(--component-gap-space);padding-inline:var(--beacon-reference-space-5)}.caption{margin-block-start:var(--component-gap-space);padding-inline:var(--beacon-reference-space-5)}.highcharts-background{fill:var(--component-background-color)}.highcharts-focus-border{stroke:var(--beacon-system-color-border-focus-outer);stroke-width:var(--beacon-system-width-border-jumbo)}.highcharts-container{color:inherit;font-family:inherit}.highcharts-container :not(.highcharts-tooltip,.highcharts-tooltip-box,.highcharts-button)>text{fill:currentcolor}.highcharts-legend-item .highcharts-focus-border{display:none}.highcharts-legend-navigation{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);color:var(--beacon-system-color-text-standard)}.highcharts-legend-nav-active{fill:var(--beacon-system-color-icon-secondary)}.highcharts-legend-nav-inactive{fill:var(--beacon-system-color-icon-secondary-inactive)}.beacon-legend-item{--background-color: var(--beacon-system-color-background-1);--legend-item-padding: var(--beacon-system-space-cell-contained);font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-300);align-items:center;background-color:var(--background-color);border-color:transparent;border-radius:var(--beacon-system-radius-corner-standard);border-style:solid;border-width:var(--beacon-system-width-border-normal, 2px);display:flex;gap:var(--beacon-reference-space-3);padding:var(--legend-item-padding)}.beacon-legend-item .beacon-legend-item__label{align-items:center;display:flex;gap:var(--beacon-reference-space-4)}.beacon-legend-item.beacon-legend-item--hover{--background-color: var(--beacon-system-color-background-secondary-hover);border-color:var(--beacon-system-color-border-secondary)}.beacon-legend-item.beacon-legend-item--hover .beacon-legend-item__label-text{text-decoration:underline}.beacon-legend-item.beacon-legend-item--focus{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;z-index:1}.beacon-legend-item.beacon-legend-item--focus:not(dialog){position:relative}.beacon-legend-item .beacon-legend-item__value{font-weight:var(--beacon-system-font-weight-bold)}.highcharts-legend-item-hidden *{text-decoration:none}.highcharts-legend-item-hidden .beacon-legend-item{--background-color: transparent}.highcharts-legend-item-hidden .beacon-legend-item.beacon-legend-item--hover{--background-color: var(--beacon-system-color-background-secondary-hover);border-color:var(--beacon-system-color-border-secondary)}.static-legend .highcharts-legend{pointer-events:none}.static-legend .highcharts-a11y-proxy-group-legend button{cursor:default;pointer-events:none}.static-legend .beacon-legend-item{--background-color: transparent;--legend-item-padding: 0;border-radius:0}.static-legend[legend-layout*=horizontal] .highcharts-legend-item:not(:last-of-type) .beacon-legend-item{border-inline-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0);padding-inline-end:var(--beacon-system-space-micro-jumbo)}.static-legend[legend-layout*=horizontal] .highcharts-legend-item:not(:first-of-type) .beacon-legend-item:not(.beacon-legend-item--0){padding-inline-start:var(--beacon-system-space-micro-jumbo)}.static-legend[legend-layout*=vertical] .highcharts-legend-item:not(:last-of-type) .beacon-legend-item{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-0);padding-block-end:var(--beacon-system-space-micro-normal)}.static-legend[legend-layout*=vertical] .highcharts-legend-item:not(:first-of-type) .beacon-legend-item:not(.beacon-legend-item--0){padding-block-start:var(--beacon-system-space-micro-normal)}.static-legend[legend-layout*=vertical] .beacon-legend-item{min-block-size:var(--beacon-reference-space-10)}@media (width >= 640px){.static-legend[legend-layout*=vertical] .beacon-legend-item{min-block-size:var(--beacon-reference-space-11)}}@media (width >= 960px){.static-legend[legend-layout*=vertical] .beacon-legend-item{min-block-size:var(--beacon-reference-space-12)}}@media (width >= 1280px){.static-legend[legend-layout*=vertical] .beacon-legend-item{min-block-size:var(--beacon-reference-space-13)}}.highcharts-color-0{fill:var(--beacon-system-color-data-viz-0);stroke:var(--beacon-system-color-data-viz-0)}.highcharts-color-1{fill:var(--beacon-system-color-data-viz-1);stroke:var(--beacon-system-color-data-viz-1)}.highcharts-color-2{fill:var(--beacon-system-color-data-viz-2);stroke:var(--beacon-system-color-data-viz-2)}.highcharts-color-3{fill:var(--beacon-system-color-data-viz-3);stroke:var(--beacon-system-color-data-viz-3)}.highcharts-color-4{fill:var(--beacon-system-color-data-viz-4);stroke:var(--beacon-system-color-data-viz-4)}.highcharts-color-5{fill:var(--beacon-system-color-data-viz-5);stroke:var(--beacon-system-color-data-viz-5)}.highcharts-color-6{fill:var(--beacon-system-color-data-viz-6);stroke:var(--beacon-system-color-data-viz-6)}.highcharts-color-7{fill:var(--beacon-system-color-data-viz-7);stroke:var(--beacon-system-color-data-viz-7)}.highcharts-color-8{fill:var(--beacon-system-color-data-viz-8);stroke:var(--beacon-system-color-data-viz-8)}.highcharts-color-9{fill:var(--beacon-system-color-data-viz-9);stroke:var(--beacon-system-color-data-viz-9)}.highcharts-color-10{fill:var(--beacon-system-color-data-viz-10);stroke:var(--beacon-system-color-data-viz-10)}.highcharts-color-11{fill:var(--beacon-system-color-data-viz-11);stroke:var(--beacon-system-color-data-viz-11)}.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}`;
var za = Object.defineProperty, Fa = Object.getOwnPropertyDescriptor, Ot = (S, j, i, ot) => {
  for (var U = ot > 1 ? void 0 : ot ? Fa(j, i) : j, _ = S.length - 1, K; _ >= 0; _--)
    (K = S[_]) && (U = (ot ? K(j, i, U) : K(U)) || U);
  return ot && U && za(j, i, U), U;
};
const Ha = ["top", "middle", "bottom"], Ua = ["center", "right"], Ga = ["horizontal", "vertical"];
function Wa(S) {
  return typeof S.legendWidth == "number";
}
function Xa(S) {
  return typeof S.maxLegendWidth == "number";
}
function Gi(S) {
  return S.a11yProxyElement !== void 0;
}
function Wi(S) {
  return S.a11yProxyElement !== void 0;
}
var At;
const Lt = (At = class extends ks {
  constructor() {
    super(...arguments), this.resetSpacing = !0, this._type = Kt.LINE, this.series = [], this.options = {}, this.staticLegend = !1, this.disableLegend = !1, this.hideLegendMetric = !1, this.legendLayout = At.defaultLegendLayout, this.tooltipTitle = "", this.tooltipFooter = "", this.tooltipVariant = ae.SINGLE_LINE, this.disableMarkers = !1, this.percentage = !1, this.decimal = !1, this.decimalPlaces = 1, this.chart = null, this.filteredOptions = {}, this.colorOrder = Wt.STANDARD;
  }
  static get styles() {
    return [super.styles, Os, Ra];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, be];
  }
  /**
   * The type of chart being rendered. Follows Highcharts chart types.
   * @abstract
   */
  get type() {
    return this._type;
  }
  /**
   * Local options defined on the component-level.
   * @abstract
   */
  get localComponentOptions() {
    return {};
  }
  /**
   * This getter ensures that the chart type is included in the series data
   * when it's passed to highcharts. This ensures that data passed to highcharts
   * is type-safe for users in TS contexts.
   */
  get seriesWithChartType() {
    return this.series.map((j) => ({
      ...j,
      type: this.type
    }));
  }
  /**
   * Global chart options applicable to all charts.
   */
  get chartOptions() {
    const j = this.hideLegendMetric, i = this.percentage, ot = this.decimal, U = this.decimalPlaces, _ = this.type, K = this.addBeaconModeToTooltipContainer.bind(this);
    return {
      accessibility: {
        linkedDescription: this.linkedDescriptionNode
      },
      chart: {
        animation: !1,
        colorCount: 12,
        events: {
          /**
           * @this Chart
           *
           * On redraw, we assign styles and classes to the legend items so they can match our design spec.
           * Since we use custom HTML in the formatter, this is not captured on a persistant basis by Highcharts.
           */
          redraw() {
            var Z, J, q;
            if ("hasLoaded" in this && this.hasLoaded) {
              const tt = (q = (J = (Z = this.userOptions) == null ? void 0 : Z.plotOptions) == null ? void 0 : J.custom) == null ? void 0 : q.host;
              if (tt && tt.staticLegend)
                return !1;
              const { allItems: X } = this.legend;
              X.forEach((I) => {
                if (I instanceof te.Point && Gi(I) || I instanceof te.Series && Wi(I)) {
                  const {
                    a11yProxyElement: {
                      target: { visual: O }
                    }
                  } = I;
                  if (tt == null || tt.style.setProperty(
                    "--legend-max-width",
                    O.style.getPropertyValue("width")
                  ), O.dataset.beaconRedrawEvent !== "attached") {
                    const y = O.firstElementChild;
                    O.addEventListener(
                      "mouseover",
                      (w) => {
                        y == null || y.classList.add(
                          "beacon-legend-item--hover"
                        ), (!w.x || !w.y) && (y == null || y.classList.add(
                          "beacon-legend-item--focus"
                        ));
                      }
                    ), O.addEventListener("mouseout", () => {
                      X.forEach((w) => {
                        var f;
                        if (w instanceof te.Point && Gi(w) || w instanceof te.Series && Wi(w)) {
                          const {
                            a11yProxyElement: {
                              target: { visual: x }
                            }
                          } = w;
                          (f = x == null ? void 0 : x.firstElementChild) == null || f.classList.remove(
                            "beacon-legend-item--hover",
                            "beacon-legend-item--focus"
                          );
                        }
                      });
                    });
                  }
                  O.dataset.beaconRedrawEvent = "attached", At.setLegendWidthVariable(this);
                }
              });
            }
            this.reflow();
          }
        },
        // Highcharts default is 400
        // Previous version of Charts didn't take Legend height into account
        // We increase the default height to counteract a possible squished chart
        height: gs.HEIGHT,
        styledMode: !0,
        type: this.type
      },
      credits: {
        enabled: !1
      },
      legend: {
        accessibility: {
          keyboardNavigation: {
            enabled: !this.staticLegend
          }
        },
        align: "center",
        alignColumns: !1,
        enabled: !this.disableLegend,
        labelFormatter() {
          return At.legendItemHTML(
            this,
            j,
            i,
            _,
            ot,
            U
          );
        },
        itemDistance: parseFloat(gi) * 16,
        itemMarginBottom: parseFloat(gi) * 16,
        itemMarginTop: 0,
        layout: this.legendLayout.direction,
        navigation: {
          enabled: !1
        },
        symbolRadius: 0,
        symbolPadding: 0,
        symbolWidth: 0,
        useHTML: !0,
        verticalAlign: "bottom",
        width: "100%",
        events: {
          /**
           * @this Series
           *
           * We reverse click interaction on legend items. Instead of toggling off, we toggle isolation and "on" state.
           */
          itemClick: function(Z) {
            var O, y, w;
            Z.preventDefault();
            const { chart: J } = this, q = (w = (y = (O = J == null ? void 0 : J.userOptions) == null ? void 0 : O.plotOptions) == null ? void 0 : y.custom) == null ? void 0 : w.host;
            if (q && q.staticLegend)
              return !1;
            const { series: tt } = J, X = tt.filter((f) => f.visible).length === tt.length, I = tt.find(
              (f) => Z.legendItem instanceof te.Series && f.name === Z.legendItem.name
            );
            I && (tt.length > 1 && X ? tt.forEach((f) => {
              Z.legendItem instanceof te.Series && f.update(
                {
                  visible: f.name === Z.legendItem.name
                },
                !1
              );
            }) : I.update(
              {
                visible: !I.visible
              },
              !1
            ), J.redraw(), J.reflow());
          }
        }
      },
      plotOptions: {
        custom: {
          host: this
        }
      },
      responsive: {
        rules: [
          {
            condition: {
              minWidth: parseInt(vs, 10)
            },
            chartOptions: {
              legend: {
                align: this.legendLayout.horizontal,
                // center, right
                verticalAlign: At.setLegendVerticalAlignment(
                  this.legendLayout
                ),
                width: At.setLegendWidth(this.legendLayout)
              }
            }
          }
        ]
      },
      series: this.seriesWithChartType,
      subtitle: {
        text: void 0
      },
      symbols: [...Object.values(qt)],
      title: {
        text: void 0
      },
      tooltip: {
        borderRadius: parseFloat(xs) * 16,
        className: this.getTooltipClasses(),
        footerFormat: At.tooltipFooterHTML(
          At.tooltipFooterContentHTML(this.tooltipFooter)
        ),
        headerFormat: At.tooltipHeaderHTML(this.tooltipTitle),
        outside: !0,
        padding: At.tooltipPadding(this.tooltipVariant),
        pointFormatter() {
          return K(), At.tooltipPointHTML(
            this,
            this.series.name,
            this.y,
            !1,
            _
          );
        },
        shadow: {
          color: ys
        },
        shared: this.tooltipVariant === ae.MULTI_LINE,
        useHTML: !0
      }
    };
  }
  /**
   * Adds a beacon mode class to the Highcharts tooltip container.
   */
  addBeaconModeToTooltipContainer() {
    const j = this.closest('[class*="beacon-on"]');
    setTimeout(() => {
      const i = document.querySelector(
        ".highcharts-tooltip-container"
      );
      if (i && j) {
        const ot = Array.from(i.classList).find(
          (_) => _.startsWith("beacon-on")
        ), U = Array.from(
          j.classList
        ).find((_) => _.startsWith("beacon-on"));
        ot !== U && (ot && i.classList.remove(ot), U && i.classList.add(U));
      }
    }, 0);
  }
  /** Parses the legend layout from a string of options. */
  static createLegendLayout(j) {
    if (!j)
      return this.defaultLegendLayout;
    const i = Pa(j);
    if (!i)
      return this.defaultLegendLayout;
    const ot = i.find(
      (K) => Ha.includes(K)
    ) || this.defaultLegendLayout.vertical, U = i.find(
      (K) => Ua.includes(K)
    ) || this.defaultLegendLayout.horizontal;
    let _ = i.find(
      (K) => Ga.includes(K)
    ) || this.defaultLegendLayout.direction;
    return i.includes("row") ? _ = "horizontal" : i.includes("column") && (_ = "vertical"), {
      vertical: ot,
      horizontal: U,
      direction: _
    };
  }
  /**
   * Sets a CSS variable on the host that helps control the width of the legend items in a vertical state.
   *
   * Takes into account the active and max widths of the Legend, as well as what direction the Legend is in.
   */
  static setLegendWidthVariable(j, i = !1) {
    var I, O, y, w, f, x, s, l;
    const ot = (O = (I = j.legend) == null ? void 0 : I.options) == null ? void 0 : O.layout, U = (w = (y = j.legend) == null ? void 0 : y.options) == null ? void 0 : w.align, _ = Wa(j.legend) ? j.legend.legendWidth : 0, K = Xa(j.legend) ? (f = j.legend) == null ? void 0 : f.maxLegendWidth : 0, Z = Math.min(K, _), J = (l = (s = (x = j.userOptions) == null ? void 0 : x.plotOptions) == null ? void 0 : s.custom) == null ? void 0 : l.host, q = J == null ? void 0 : J.style.getPropertyValue("--legend-width");
    i && (J == null || J.style.removeProperty("--legend-width"));
    let tt = "auto", X;
    ot === "vertical" && (X = Z, q && (J == null || J.style.setProperty("--legend-width", X + "px")), q && U === "right" ? tt = q : tt = X ? X + "px" : "auto"), J == null || J.style.setProperty("--legend-width", tt);
  }
  /** HTML for the Legend label. */
  static legendItemHTML(j, i, ot, U, _, K) {
    var tt, X;
    const { name: Z, index: J } = j;
    let q = "";
    if (U === Kt.GAUGE && !i) {
      const I = ((tt = j == null ? void 0 : j.data[0]) == null ? void 0 : tt.y) != null && j.yAxis.userOptions.min != null ? j.data[0].y - j.yAxis.userOptions.min : (X = j == null ? void 0 : j.data[0]) == null ? void 0 : X.y, O = j.yAxis.userOptions.max != null && j.yAxis.userOptions.min != null ? j.yAxis.userOptions.max - j.yAxis.userOptions.min : j.yAxis.userOptions.max;
      q = `<span class="beacon-legend-item__value">${At.percentageFormatter(ot, I, O, _, K)}</span>`;
    }
    return U === Kt.PIE && !i && (q = `<span class="beacon-legend-item__value">${At.percentageFormatter(ot, j.y, j.total, _, K)}</span>`), U === Kt.MAP && !i && (q = `<span class="beacon-legend-item__value">${j.value}</span>`), `
      <div class="beacon-legend-item beacon-legend-item--${J}" style="inline-size: var(--legend-width); max-inline-size: var(--legend-max-width, none);">
        <div class="beacon-legend-item__label">
          ${Fe(J, !1, U)}
          <span class="beacon-legend-item__label-text">${Z}</span>${q}
        </div>
      </div>
    `;
  }
  /** Forces Legend vertical alignment if necessary, but otherwise will return the requested value. */
  static setLegendVerticalAlignment({
    horizontal: j,
    vertical: i
  }) {
    return j === "center" ? "bottom" : i;
  }
  /** Set the width of the Legend which depends on both alignment and direction. */
  static setLegendWidth({
    horizontal: j,
    vertical: i,
    direction: ot
  }) {
    if (ot === "horizontal" && i !== "middle")
      return "100%";
    if (ot === "vertical")
      return j === "center" ? "100%" : "33%";
  }
  /** HTML classes for the tooltip's elements. */
  getTooltipClasses() {
    return `beacon-chart-tooltip ${this.tooltipVariant} ${this.colorOrder}`.trim();
  }
  /** Sets the padding on the Tooltip based on variant. */
  static tooltipPadding(j) {
    const i = parseFloat(ws), ot = parseFloat(
      Cs
    );
    let U = i;
    return j !== ae.SINGLE_LINE && (U = i + ot), U * 16;
  }
  /**
   * HTML for the chart tooltip point.
   *
   * Can be used as a helper method for overrides to the point formatter.
   *
   * @example
   * ```ts
   * // Format the value before passing it to the tooltip.
   *
   * const options = {
   *   tooltip: {
   *    pointFormatter() {
   *      const { y } = this;
   *      const percentage = y / 100;
   *
   *      return BeaconChartBase.tooltipPointHTML(this, this.series.name, percentage);
   *    }
   *   }
   * }
   * ```
   */
  static tooltipPointHTML(j, i, ot, U, _) {
    let K;
    return ot && Number(ot) < 0 ? K = "negative" : K = "positive", `
      <div class="beacon-chart-tooltip__point highcharts-color-${j.colorIndex} ${K}">
        <div class="beacon-chart-tooltip-point__label">
          ${U ? "" : Fe(j.colorIndex || 0, !1, _)}
          <span class="beacon-chart-tooltip-point__label-text">${i}</span>
        </div>
        ${ot ? `<div class="beacon-chart-tooltip__point-value">${ot}</div>` : ""}
      </div>
    `;
  }
  /** HTML for the Tooltip Title (Header). */
  static tooltipHeaderHTML(j) {
    return j ? `<div class="beacon-chart-tooltip__title">${j}</div>` : "";
  }
  /** HTML for the Tooltip's additional content slot (Footer). */
  static tooltipFooterContentHTML(j) {
    return j ? `<div class="beacon-chart-tooltip__additional-content">${j}</div>` : "";
  }
  /** HTML for the Tooltip footer that can include both multi-level content and the additional slot content. */
  static tooltipFooterHTML(j, i) {
    return !j && !i ? "" : `
      <div class="beacon-chart-tooltip__footer">
        ${i ? `<hr class="beacon-chart-tooltip__separator"/>${i}` : ""}
        ${j || ""}
      </div>
    `;
  }
  /** HTML for the Tooltip Point belonging to multi-level tooltips. */
  static multiLevelTooltipPointHTML(j, i, ot) {
    return `
      <div class="beacon-chart-tooltip__point beacon-chart-tooltip__point--multi-level">
        <div class="beacon-chart-tooltip-point__label">
          ${ot ? "" : Fe(0, !0)}
          <span class="beacon-chart-tooltip-point__label-text">${j}</span>
        </div>
        ${i ? `<div class="beacon-chart-tooltip__point-value">${i}</div>` : ""}
      </div>
    `;
  }
  /** Modify user-supplied options by filtering out keys not leveraged or not accessible by our component. */
  static filterChartOptions(j) {
    return Ma(j, (i, ot) => !this.disallowedChartOptions.includes(ot));
  }
  /** Merge all possible chart options into a single object. */
  static createChartOptions(...j) {
    return Aa(
      {},
      ...j,
      function(i, ot) {
        if (Bt(i))
          return i.concat(ot);
      }
    );
  }
  /** Update Highcharts accessibility data when the caption changes. */
  handleCaptionSlotchange() {
    var j;
    (j = this.chart) == null || j.update({
      accessibility: {
        linkedDescription: this.linkedDescriptionNode
      }
    });
  }
  /**
   * Apply modifications and modules to the Highcharts package.
   *
   * @todo Exhaust any options for API-styling before DOM manipulation. Keep in mind the symbol is separate from the button of the text label.
   */
  initializeHighcharts(j) {
    j.AST.allowedAttributes.push("transform", "viewbox", "viewBox", "xmlns"), Is(j), j.addEvent(j.Legend, "afterRender", function() {
      "hasLoaded" in this.chart && this.chart.hasLoaded && (this.chart.reflow(), At.setLegendWidthVariable(this.chart));
    }), j.addEvent(j.Chart, "load", this.onChartLoad), j.addEvent(j.Chart, "redraw", this.onChartRedraw);
  }
  /**
   * Callback when Highcharts initially loads the chart.
   * @abstract
   */
  onChartLoad(j) {
  }
  /**
   * Callback when Highcharts redraws an existing chart.
   * @abstract
   */
  onChartRedraw(j) {
  }
  /**
   * Calculates total series for use in chart modifications or restrictions.
   *
   * Calculation of the series length may vary by type of chart.
   */
  calculateSeriesLength(j) {
    var i;
    return (i = j.series) == null ? void 0 : i.length;
  }
  /** Determines the color order by length of series in the chart. */
  static calculateColorOrder(j) {
    return typeof j == "number" && j > 6 ? Wt.EXTENDED : Wt.STANDARD;
  }
  /** Sets the class related to the color order on the host component. */
  applyColorOrder(j) {
    var i;
    switch (j) {
      case Wt.EXTENDED:
        this.classList.toggle(Wt.EXTENDED, !0);
        break;
      case Wt.STANDARD:
      default:
        this.classList.toggle(Wt.STANDARD, !0);
        break;
    }
    (i = this.chart) == null || i.update({
      tooltip: {
        className: this.getTooltipClasses()
      }
    });
  }
  setChart() {
    try {
      return this.chart = this.createChart(), this.chart;
    } catch (j) {
      return console.error(j), this.chart;
    }
  }
  setFilteredOptions() {
    this.filteredOptions = At.filterChartOptions(this.options);
  }
  createChart() {
    const j = At.createChartOptions(
      this.chartOptions,
      this.localComponentOptions,
      this.filteredOptions
    );
    return mi.chart(this.chartContainer, j);
  }
  updateChart(j) {
    var i;
    (i = this.chart) == null || i.update(j, !0, !0), this.improveChartAccessibility();
  }
  static percentageFormatter(j, i, ot, U, _) {
    let K;
    return j && i != null && ot != null ? K = `${(100 * (i / (ot || 100))).toFixed(U ? _ : 0)}%` : i != null ? K = `${Math.round(i)}` : K = "N/A", K;
  }
  /* Since we are rendering highcharts tooltip outside of the shadow DOM, we need to append the lightDOM styles to body.
   */
  static appendLightDOMStyles() {
    var i;
    if (!document.getElementById("beacon-chart-light-DOM-styles")) {
      const ot = document.createElement("style");
      ot.id = "beacon-chart-light-DOM-styles", ot.textContent = be == null ? void 0 : be.toString(), (i = document == null ? void 0 : document.body) == null || i.append(ot);
    }
  }
  renderTitle() {
    return ne`<div class="title" id="title">
      <slot name="title" ${Ne({ container: ".header" })}></slot>
    </div>`;
  }
  renderSubTitle() {
    return ne`<div class="subtitle" id="subtitle">
      <slot name="subtitle" ${Ne({ container: ".header" })}></slot>
    </div>`;
  }
  renderHeader() {
    return ne`<div class="header">
      <div class="header-text">
        ${this.renderTitle()} ${this.renderSubTitle()}
      </div>
      <div class="menu"></div>
    </div>`;
  }
  chartBaseInit() {
    this.initializeHighcharts(mi), At.appendLightDOMStyles();
  }
  chartLoaded() {
    var j;
    this.setChart(), (j = this.chart) == null || j.reflow();
  }
  /**
   * Removes tab sequential navigation for a button element rendered from HighChart Accessibility module when using the Export Data HighCharts module.
   * We have a github issue open with HighCharts (https://github.com/highcharts/highcharts/issues/22682).
   * TODO: Remove when HighCharts fixes issue
   */
  improveChartAccessibility() {
    var i;
    const j = (i = this.chartContainer) == null ? void 0 : i.querySelector(
      "[id^=hc-linkto-highcharts-data-table-]"
    );
    j == null || j.setAttribute("tabindex", "-1"), j == null || j.setAttribute("aria-expanded", "false");
  }
  willUpdate(j) {
    var Z;
    (Z = super.willUpdate) == null || Z.call(this, j);
    const i = this.hideLegendMetric, ot = this.percentage, U = this.decimal, _ = this.decimalPlaces, K = this.type;
    if (this.chart) {
      if (j.has("chart")) {
        const { chartHeight: J, chartWidth: q, plotHeight: tt, plotWidth: X } = this.chart;
        this.chartSize = {
          chartHeight: J,
          chartWidth: q,
          plotHeight: tt,
          plotWidth: X
        };
      }
      j.has("series") && this.updateChart({ series: this.seriesWithChartType }), this.seriesLength = this.calculateSeriesLength(this.chart), this.colorOrder = At.calculateColorOrder(this.seriesLength), this.applyColorOrder(this.colorOrder), this.chart.reflow();
    }
    j.has("options") && this.options && (this.setFilteredOptions(), this.updateChart(this.filteredOptions)), j.has("legendLayout") && this.legendLayout && this.updateChart({
      legend: {
        align: this.legendLayout.horizontal,
        layout: this.legendLayout.direction,
        labelFormatter() {
          return At.legendItemHTML(
            this,
            i,
            ot,
            K,
            U,
            _
          );
        },
        verticalAlign: At.setLegendVerticalAlignment(
          this.legendLayout
        ),
        width: At.setLegendWidth(this.legendLayout)
      }
    }), (j.has("hideLegendMetric") || j.has("percentage") || j.has("decimal") || j.has("decimalPlaces")) && this.updateChart({
      legend: {
        labelFormatter() {
          return At.legendItemHTML(
            this,
            i,
            ot,
            K,
            U,
            _
          );
        }
      }
    }), j.has("disableLegend") && this.updateChart({
      legend: { enabled: !this.disableLegend }
    }), j.has("tooltipTitle") && this.updateChart({
      tooltip: {
        headerFormat: At.tooltipHeaderHTML(this.tooltipTitle)
      }
    }), j.has("tooltipFooter") && this.updateChart({
      tooltip: {
        footerFormat: At.tooltipFooterHTML(this.tooltipFooter)
      }
    }), j.has("tooltipVariant") && this.tooltipVariant && this.updateChart({
      tooltip: {
        padding: At.tooltipPadding(this.tooltipVariant),
        shared: this.tooltipVariant === ae.MULTI_LINE
      }
    });
  }
  render() {
    const j = {
      chart: !0,
      "highcharts-light": !0,
      "static-legend": this.staticLegend
    };
    j["chart--" + this.type] = !0;
    const i = {
      caption: !0
    };
    return ne`
      <figure class="base">
        ${this.renderHeader()}
        <!-- Force Highcharts light theme -->
        <div
          role="region"
          class=${fi(j)}
          legend-layout="${Object.values(this.legendLayout).join(" ")}"
          aria-labelledby="title"
          aria-describedby="subtitle"></div>
        <figcaption class=${fi(i)}>
          <slot
            name="caption"
            @slotchange=${this.handleCaptionSlotchange}
            ${Ne({ useParent: !0 })}></slot>
        </figcaption>
      </figure>
    `;
  }
}, At.nestedComponents = [Ps], At.disallowedChartOptions = [
  "colors",
  "title",
  "caption",
  "subtitle"
], At.defaultLegendLayout = {
  direction: "horizontal",
  horizontal: "center",
  vertical: "bottom"
}, At);
Ot([
  jt({
    type: Array
  })
], Lt.prototype, "series", 2);
Ot([
  jt({
    type: Object
  })
], Lt.prototype, "options", 2);
Ot([
  jt({ attribute: "static-legend", type: Boolean, reflect: !0 })
], Lt.prototype, "staticLegend", 2);
Ot([
  jt({ attribute: "disable-legend", type: Boolean })
], Lt.prototype, "disableLegend", 2);
Ot([
  jt({ attribute: "hide-legend-metric", type: Boolean })
], Lt.prototype, "hideLegendMetric", 2);
Ot([
  jt({
    attribute: "legend-layout",
    converter: (S) => Lt.createLegendLayout(S)
  })
], Lt.prototype, "legendLayout", 2);
Ot([
  jt({ attribute: "tooltip-title" })
], Lt.prototype, "tooltipTitle", 2);
Ot([
  jt({ attribute: "tooltip-footer" })
], Lt.prototype, "tooltipFooter", 2);
Ot([
  jt({ attribute: "tooltip-variant" })
], Lt.prototype, "tooltipVariant", 2);
Ot([
  jt({ attribute: "disable-markers", type: Boolean })
], Lt.prototype, "disableMarkers", 2);
Ot([
  jt({ type: Boolean })
], Lt.prototype, "percentage", 2);
Ot([
  jt({ type: Boolean })
], Lt.prototype, "decimal", 2);
Ot([
  jt({ attribute: "decimal-places", type: Number })
], Lt.prototype, "decimalPlaces", 2);
Ot([
  As()
], Lt.prototype, "chart", 2);
Ot([
  Es('[slot="caption"]')
], Lt.prototype, "linkedDescriptionNode", 2);
Ot([
  Ss(".chart")
], Lt.prototype, "chartContainer", 2);
Ot([
  Ts
], Lt.prototype, "chartBaseInit", 1);
Ot([
  Ms
], Lt.prototype, "chartLoaded", 1);
let tl = Lt;
export {
  tl as B,
  Kt as C,
  gs as D,
  mi as H,
  Ea as a,
  Xi as g,
  te as h,
  Pa as s
};
